/* eslint-disable no-undef */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React, { CSSProperties } from 'react';
import theme from '../../styles/theme';

const getViewBox = (name: string) => {
  switch (name) {
    case 'star':
      return '0 0 32 32';
    case 'alertCirc':
      return '0 0 24 24';
    case 'announcements':
      return '0 0 26 21';
    case 'examCancel':
      return '0 0 39 43';
    case 'patient':
      return '0 0 38 37';
    case 'solicitation':
      return '0 0 32 39';
    case 'schedule':
      return '0 0 38 37';
    case 'unit':
      return '0 0 28 39';
    case 'anamaliaVascular':
      return '0 0 97 86';
    case 'formacaoLinfatica':
      return '0 0 96 67';
    case 'hemangioma':
      return '0 0 99 94';
    case 'linfangioma':
      return '0 0 97 100';
    case 'tumorVascular':
      return '0 0 96 111';
    case 'acupuntura':
      return '0 0 96 62';
    case 'alergologia':
      return '0 0 96 74';
    case 'angiologia':
      return '0 0 109 96';
    case 'cardiologia':
      return '0 0 80 98';
    case 'cinicaMedica':
      return '0 0 96 96';
    case 'cirurgia':
      return '0 0 103 99';
    case 'cirurgiaPedriatrica':
      return '0 0 99 91';
    case 'cirurgiaRobotica':
      return '0 0 86 99';
    case 'clinicadaDor':
      return '0 0 128 128';
    case 'dermatologia':
      return '0 0 99 77';
    case 'endrocrinologia':
      return '0 0 97 75';
    case 'fisiatria':
      return '0 0 88 98';
    case 'fisioterapia':
      return '0 0 100 89';
    case 'fonologia':
      return '0 0 91 96';
    case 'gastroenterologia':
      return '0 0 94 94';
    case 'generico':
      return '0 0 86 97';
    case 'genetica':
      return '0 0 102 101';
    case 'geriatria':
      return '0 0 97 98';
    case 'ginecologia':
      return '0 0 99 83';
    case 'hematologia':
      return '0 0 89 100';
    case 'imunologia':
      return '0 0 63 96';
    case 'infectologia':
      return '0 0 98 100';
    case 'mastologia':
      return '0 0 97 95';
    case 'medicinadoAdolescente':
      return '0 0 96 68';
    case 'medicinaEsportiva':
      return '0 0 97 97';
    case 'medicinaReprodutiva':
      return '0 0 100 88';
    case 'nefrologia':
      return '0 0 97 85';
    case 'neurologia':
      return '0 0 98 88';
    case 'nutricao':
      return '0 0 98 88';
    case 'nutrologia':
      return '0 0 97 97';
    case 'obstetrica':
      return '0 0 99 99';
    case 'oftalmologia':
      return '0 0 95 75';
    case 'oncologia':
      return '0 0 69 97';
    case 'ortopedia':
      return '0 0 79 99';
    case 'otorrinolaringologia':
      return '0 0 70 99';
    case 'pediatria':
      return '0 0 62 96';
    case 'pneumologia':
      return '0 0 96 90';
    case 'portalSaber':
      return '0 0 32 32';
    case 'proctologia':
      return '0 0 92 97';
    case 'psicologia':
      return '0 0 87 96';
    case 'psiquiatria':
      return '0 0 64 96';
    case 'quickAccess':
      return '0 0 21 20';
    case 'reumatologia':
      return '0 0 98 98';
    case 'transplante':
      return '0 0 95 83';
    case 'utologia':
      return '0 0 92 100';
    case 'artroRM':
      return '0 0 98 99';
    case 'audiometria':
      return '0 0 68 96';
    case 'bioimpedancia':
      return '0 0 92 98';
    case 'biopsia':
      return '0 0 98 82';
    case 'broncoscopia':
      return '0 0 95 74';
    case 'cardiologicos':
      return '0 0 97 81';
    case 'denssiometriaOssea':
      return '0 0 98 62';
    case 'ecoDoppler':
      return '0 0 91 93';
    case 'eletroneurofisiologia':
      return '0 0 95 99';
    case 'endoscopia':
      return '0 0 98 78';
    case 'espirometria':
      return '0 0 96 79';
    case 'hermodinamica':
      return '0 0 98 80';
    case 'mamografiaDigital':
      return '0 0 128 128';
    case 'medFetal':
      return '0 0 101 100';
    case 'medicinaNuclear':
      return '0 0 96 99';
    case 'medSono':
      return '0 0 96 97';
    case 'noUser':
      return '0 0 164 164';
    case 'otorrino':
      return '0 0 95 88';
    case 'raioX':
      return '0 0 97 98';
    case 'ressonancia':
      return '0 0 87 99';
    case 'tomografia':
      return '0 0 84 99';
    case 'ultrasonografia':
      return '0 0 98 66';
    case 'urodinamica':
      return '0 0 98 93';
    case 'vascular':
      return '0 0 136 136';
    case 'cases':
      return '0 0 98 84';
    case 'centerSearch':
      return '0 0 95 95';
    case 'graduation':
      return '0 0 102 58';
    case 'dorNumber':
      return '0 0 98 91';
    case 'infra':
      return '0 0 80 96';
    case 'inovation':
      return '0 0 94 96';
    case 'openTalks':
      return '0 0 94 88';
    case 'papers':
      return '0 0 96 93';
    case 'posGraduation':
      return '0 0 101 97';
    case 'research':
      return '0 0 102 93';
    case 'specialization':
      return '0 0 70 98';
    case 'studentPortal':
      return '0 0 86 98';
    case 'teacher':
      return '0 0 100 81';
    case 'themes':
      return '0 0 81 100';
    case 'units':
      return '0 0 60 98';
    case 'voluntary':
      return '0 0 98 90';
    case 'benefits':
      return '0 0 39 37';
    case 'vacation':
      return '0 0 38 37';
    case 'request':
      return '0 0 30 37';
    case 'apresentation':
      return '0 0 97 98';
    case 'assembly':
      return '0 0 89 98';
    case 'dfs':
      return '0 0 97 98';
    case 'financial':
      return '0 0 98 98';
    case 'solicitacoes':
      return '0 0 78 99';
    case 'result':
      return '0 0 98 86';
    case 'ri':
      return '0 0 98 98';
    case 'riXls':
      return '0 0 84 84';
    case 'sustainability':
      return '0 0 98 98';
    case 'talkWith':
      return '0 0 98 82';
    case 'facebook':
      return '0 0 12 22';
    case 'facebookOutline':
      return '0 0 10 20';
    case 'google':
      return '0 0 22 22';
    case 'googleOutline':
      return '0 0 20 20';
    case 'instagram':
      return '0 0 22 22';
    case 'instagramOutline':
      return '0 0 20 20';
    case 'linkedin':
      return '0 0 22 22';
    case 'linkedinOutline':
      return '0 0 20 20';
    case 'share':
      return '0 0 22 20';
    case 'twitter':
      return '0 0 22 18';
    case 'twitterOutline':
      return '0 0 20 16';
    case 'whatsapp':
      return '0 0 20 20';
    case 'whatsappOutline':
      return '0 0 22 22';
    case 'youtube':
      return '0 0 128 128';
    case 'youtubeOutline':
      return '0 0 20 14';
    case 'acharMedico':
      return '0 0 101 10';
    case 'agendamento':
      return '0 0 97 97';
    case 'bemEstar':
      return '0 0 91 97';
    case 'cobertura':
      return '0 0 93 93';
    case 'comunicacaoInterna':
      return '0 0 98 80';
    case 'emergencia':
      return '0 0 80 96';
    case 'especialidades':
      return '0 0 70 98';
    case 'exame':
      return '0 0 97 97';
    case 'exameDownload':
      return '0 0 75 99';
    case 'exameImagem':
      return '0 0 75 99';
    case 'exameResultado':
      return '0 0 75 99';
    case 'financeiro':
      return '0 0 98 98';
    case 'historico':
      return '0 0 98 72';
    case 'internacao':
      return '0 0 98 78';
    case 'laudo':
      return '0 0 76 112';
    case 'maternidade':
      return '0 0 76 98';
    case 'medico':
      return '0 0 98 98';
    case 'paciente':
      return '0 0 98 98';
    case 'plano':
      return '0 0 94 67';
    case 'redeDor':
      return '0 0 94 94';
    case 'riProduto':
      return '0 0 98 98';
    case 'unidade':
      return '0 0 60 98';
    case 'wallet':
      return '0 0 98 84';
    case '360':
      return '0 0 22 21';
    case 'alert':
      return '0 0 20 22';
    case 'alertCircle':
      return '0 0 22 22';
    case 'cancelCircle':
      return '4 4 22 22';
    case 'alertTri':
      return '0 0 64 64';
    case 'alertTriBlockedAccess':
      return '0 0 45 37';
    case 'alertTriInfo':
      return '0 0 22 22';
    case 'appointment':
      return '0 0 22 22';
    case 'arrowDown':
      return '0 0 22 22';
    case 'arrowLeft':
      return '0 0 22 22';
    case 'arrowRight':
      return '0 0 22 22';
    case 'arrowUp':
      return '0 0 22 22';
    case 'attachment':
      return '0 0 20 22';
    case 'avatarMan':
      return '0 0 22 22';
    case 'avatarWomen':
      return '0 0 22 22';
    case 'biometry':
      return '0 0 25 25';
    case 'blood':
      return '0 0 17 20';
    case 'calendar':
      return '0 0 22 22';
    case 'camera':
      return '0 0 22 23';
    case 'card':
      return '4 8 40 32';
    case 'chatCircle':
      return '0 0 22 22';
    case 'check':
      return '0 0 22 16';
    case 'checkBadge':
      return '0 0 24 24';
    case 'checkCircle':
      return '0 0 25 24';
    case 'checkHard':
      return '0 0 22 14';
    case 'circleChevronDown':
      return '0 0 22 22';
    case 'circleChevronLeft':
      return '0 0 22 22';
    case 'circleChevronRight':
      return '0 0 22 22';
    case 'circleChevronUp':
      return '0 0 22 22';
    case 'close':
      return '0 0 20 20';
    case 'closeStrong':
      return '0 0 25 25';
    case 'clockDisabled':
      return '0 0 17 17';
    case 'collapse':
      return '0 0 14 22';
    case 'dateRange':
      return '0 0 22 14';
    case 'delete':
      return '0 0 22 24';
    case 'download':
      return '0 0 18 22';
    case 'duplicate':
      return '0 0 22 22';
    case 'edit':
      return '0 0 22 22';
    case 'en':
      return '0 0 22 22';
    case 'exit':
      return '0 0 22 22';
    case 'expand':
      return '0 0 14 22';
    case 'externalLink':
      return '0 0 22 22';
    case 'iconFerias':
      return '0 0 24 25';
    case 'iconPng':
      return '0 0 24 24';
    case 'iconJpg':
      return '0 0 24 24';
    case 'iconBmp':
      return '0 0 24 24';
    case 'iconPdf':
      return '0 0 24 24';
    case 'filter':
      return '0 0 22 22';
    case 'fullscreen':
      return '0 0 22 22';
    case 'galery':
      return '0 0 22 22';
    case 'geoTag':
      return '0 0 22 22';
    case 'headset':
      return '0 0 22 22';
    case 'height':
      return '0 0 22 22';
    case 'heightPerson':
      return '0 0 23 22';
    case 'helpCircle':
      return '0 0 22 22';
    case 'helpSquare':
      return '0 0 22 22';
    case 'home':
      return '0 0 22 22';
    case 'menuCard':
      return '0 0 32 32';
    case 'info':
      return '0 0 32 32';
    case 'infoOutline':
      return '0 0 20 24';
    case 'key':
      return '0 0 22 22';
    case 'language':
      return '0 0 22 22';
    case 'languageOutline':
      return '0 0 22 22';
    case 'link':
      return '0 0 22 22';
    case 'list':
      return '0 0 22 22';
    case 'listHorizontal':
      return '0 0 22 22';
    case 'listOutline':
      return '0 0 22 22';
    case 'location':
      return '0 0 16 22';
    case 'lock':
      return '0 0 14 22';
    case 'login':
      return '0 0 22 22';
    case 'mail':
      return '0 0 22 18';
    case 'mailInput':
      return '0 0 22 18';
    case 'menu':
      return '0 0 22 20';
    case 'menuOutline':
      return '0 0 6 22';
    case 'minus':
      return '0 0 22 20';
    case 'minusCircle':
      return '0 0 22 22';
    case 'minusSquare':
      return '0 0 22 22';
    case 'news':
      return '0 0 22 22';
    case 'npsDeslike':
      return '0 0 16 22';
    case 'npsHate':
      return '0 0 16 22';
    case 'npsLike':
      return '0 0 16 22';
    case 'npsLove':
      return '0 0 16 22';
    case 'npsNeutral':
      return '0 0 16 22';
    case 'order':
      return '0 0 18 22';
    case 'pcd':
      return '0 0 18 25';
    case 'pdf':
      return '0 0 22 22';
    case 'plus':
      return '0 0 22 22';
    case 'plusCircle':
      return '0 0 22 22';
    case 'plusSquare':
      return '0 0 22 22';
    case 'print':
      return '0 0 22 22';
    case 'profile':
      return '0 0 22 22';
    case 'profileOutline':
      return '0 0 22 22';
    case 'pt':
      return '0 0 22 22';
    case 'pullDownG':
      return '0 0 22 12';
    case 'pullDownP':
      return '0 0 12 7';
    case 'reload':
      return '0 0 20 22';
    case 'search':
      return '0 0 22 22';
    case 'setting':
      return '0 0 22 22';
    case 'sharing':
      return '0 0 21 20';
    case 'stakeholder':
      return '0 0 21 24';
    case 'subItem':
      return '0 0 22 21';
    case 'team':
      return '0 0 23 19';
    case 'teamRemove':
      return '0 0 48 48';
    case 'telephone':
      return '0 0 22 22';
    case 'telephoneAlert':
      return '0 0 43 42';
    case 'time':
      return '0 0 22 22';
    case 'unlink':
      return '0 0 22 22';
    case 'unlock':
      return '0 0 14 22';
    case 'upload':
      return '0 0 18 22';
    case 'uploadArchive':
      return '0 0 22 23';
    case 'vacancies':
      return '0 0 32 32';
    case 'viewFalse':
      return '0 0 22 17';
    case 'viewTrue':
      return '0 0 22 14';
    case 'volume':
      return '0 0 21 19';
    case 'weight':
      return '0 0 22 22';
    case 'xls':
      return '0 0 22 22';
    case 'zooIn':
      return '0 0 22 22';
    case 'zoomOut':
      return '0 0 22 22';
    case 'logoRedeDorSaoLuiz':
      return '0 0 77 48';
    case 'logoRedeDor':
      return '0 0 47 12';
    case 'downloadSquare':
      return '0 0 32 29';
    case 'browser':
      return '0 0 33 33';
    case 'logoRhDigitalSmall':
      return '0 0 70 62';
    case 'logoRhDigitalDefault':
      return '0 0 207 38';
    case 'shareiOS':
      return '0 0 16 16';
    case 'file':
      return '0 0 187 99';
    case 'doc':
      return '0 0 187 99';
    case 'wifiConnection':
      return '0 0 64 64';
    case 'hour':
      return '0 0 65 64';
    case 'secure':
      return '0 0 64 64';
    case 'photoDoc':
      return '0 0 134 89';
    case 'photoDocSmall':
      return '0 0 136 89.09';
    case 'photoSelf':
      return '0 0 139 89';
    case 'iconPortalToKnow':
      return '0 0 29 18';
    case 'conversation':
      return '0 0 16 16';
    case 'questionMark':
      return '0 0 32 32';
    default:
      return '0 0 38 38';
  }
};

const getPath = (
  name: string,
  color: string,
  strokeWidth = 1.5,
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGPathElement>,
) => {
  switch (name) {
    case 'star':
      return (
        <path
          {...props}
          d="M16 5.33333L19.2303 12.0064L26.6667 12.9727L21.2267 18.0631L22.5924 25.3333L16 21.8064L9.40764 25.3333L10.7733 18.0631L5.33333 12.9727L12.7697 12.0064L16 5.33333Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      );
    case 'alertCirc':
      return (
        <>
          <path
            {...props}
            d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.9819 16.6029V16.0219"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.9819 13.1531V8.13818"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'announcements':
      return (
        <>
          <path
            {...props}
            d="M9.27734 12.7999C9.27734 12.7999 13.5654 12.877 18.7841 17.5072V0.800049C13.9975 5.4302 9.27734 5.50737 9.27734 5.50737"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.52661 12.9153L6.21909 20.0534H9.14425L7.54871 13.0696"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.3767 5.70093C22.108 6.58837 22.5402 7.82308 22.5402 9.13496C22.5402 10.4854 22.0748 11.7201 21.3435 12.6076"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.1719 3.80957C24.3021 5.19862 25.0001 7.08926 25.0001 9.13425C25.0001 11.1792 24.302 13.0699 23.2051 14.4589"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M4.45735 5.35278C2.62912 5.35278 1.1333 7.08909 1.1333 9.17266C1.1333 11.2562 2.62912 12.9925 4.45735 12.9925H7.58195V5.35278H4.45735Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'conditions':
      return (
        <>
          <path
            {...props}
            d="M29.7056 6H35.2C36.19 6 37 6.675 37 7.5V30.9061M8.2944 6H2.8C1.81 6 1 6.675 1 7.5V35.5C1 36.325 1.81 37 2.8 37H35.2C36.19 37 37 36.325 37 35.5V29.0311"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.845 3H22.285C21.895 3 21.535 2.78 21.28 2.4C20.725 1.54 19.915 1 19 1C18.085 1 17.275 1.54 16.72 2.4C16.48 2.78 16.105 3 15.73 3H14.17C13.525 3 13 3.7 13 4.56V7.46C13 8.32 13.525 9 14.17 9H23.845C24.49 9 25 8.3 25 7.46V4.56C25 3.7 24.475 3 23.845 3Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'exam':
      return (
        <>
          <path
            {...props}
            d="M30.816 15.6618L11.5797 34.8922C8.97992 37.492 4.94756 37.716 2.61303 35.3815C0.284394 33.0528 0.502519 29.0146 3.10233 26.4147L22.3386 7.17847"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.559 8.08595L22.2207 6.74773C21.5723 6.09925 21.5723 5.0322 22.2207 4.38372L22.4448 4.1597C23.0932 3.51122 24.1603 3.51122 24.8088 4.1597L33.8403 13.1913C34.4888 13.8397 34.4888 14.9068 33.8403 15.5553L33.6163 15.7793C32.9678 16.4278 31.9008 16.4278 31.2523 15.7793L31.0283 15.5553"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.3531 21.1177L15.8236 21.1177"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.1883 5.35661L30.539 1L37.0002 7.46122L32.5847 11.8768"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'examCancel':
      return (
        <>
          <path
            {...props}
            d="M30.816 15.6618L11.5797 34.8922C8.97992 37.492 4.94756 37.716 2.61303 35.3815C0.284394 33.0528 0.502519 29.0146 3.10233 26.4147L22.3386 7.17847"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.559 8.41261L22.2207 7.07439C21.5723 6.42591 21.5723 5.35886 22.2207 4.71038L22.4448 4.48636C23.0932 3.83788 24.1603 3.83788 24.8088 4.48636L33.8403 13.5179C34.4888 14.1664 34.4888 15.2334 33.8403 15.8819L33.6163 16.1059C32.9678 16.7544 31.9008 16.7544 31.2523 16.1059L31.0283 15.8819"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.3531 21.1177L15.8236 21.1177"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.1883 5.35661L30.539 1L37.0002 7.46122L32.5847 11.8768"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.7279 30.2427L26.2426 38.728"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.7279 38.728L26.2426 30.2427"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'examOk':
      return (
        <>
          <path
            {...props}
            d="M30.816 15.6618L11.5797 34.8922C8.97992 37.492 4.94756 37.716 2.61303 35.3815C0.284394 33.0528 0.502519 29.0146 3.10233 26.4147L22.3386 7.17847"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.559 8.08595L22.2207 6.74773C21.5723 6.09925 21.5723 5.0322 22.2207 4.38372L22.4448 4.1597C23.0932 3.51122 24.1603 3.51122 24.8088 4.1597L33.8403 13.1913C34.4888 13.8397 34.4888 14.9068 33.8403 15.5553L33.6163 15.7793C32.9678 16.4278 31.9008 16.4278 31.2523 15.7793L31.0283 15.5553"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.3531 21.1177L15.8236 21.1177"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.1883 5.35661L30.539 1L37.0002 7.46122L32.5847 11.8768"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'patient':
      return (
        <>
          <path
            {...props}
            d="M21.8708 20.3066V23.575L32.7449 27.7884C35.3074 28.7052 37 30.997 37 33.5533V36.0001"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 35.9998V33.5706C1 31.0055 2.62098 28.7049 5.07946 27.7969L15.4087 23.6364V19.6785L15.0215 19.4141C13.0763 18.1447 11.8065 15.9851 11.8065 13.5346V8.05182C11.8065 4.15569 15.0305 1 19.0109 1C22.9913 1 26.2152 4.15569 26.2152 8.05182V13.5346C26.2152 16.6395 24.1677 19.2742 21.3216 20.2163C20.6588 20.3968 19.8889 20.758 19.3333 20.758"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8.77783 35.9993L8.77783 33.7412"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.8889 35.9993L29.8889 33.7412"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'solicitation':
      return (
        <>
          <path
            {...props}
            d="M31 26V1H26C26 1 21.5833 6.5 19.5 9C17.4167 11.5 14.5 11.5 12.5 9C10.5 6.5 6 1 6 1H1V26H6C6 26 11.5 33 13 35C14.5 37 17.5 37 19 35C20.5 33 26 26 26 26H31Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 19H22"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'schedule':
      return (
        <>
          <path
            {...props}
            d="M1 12L37 12"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 1V5"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M28 1V5"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5.79144 3.02066H2.60428C1.72727 3.02066 1 3.70257 1 4.54978V34.4502C1 35.2974 1.70588 36 2.60428 36H35.3957C36.2727 36 37 35.3181 37 34.4502V29.873M32.2086 3H35.3957C36.2941 3 37 3.70257 37 4.54978V32.1616"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="25"
            y="18"
            width="6"
            height="6"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 3L23 3"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'scheduleAlert':
      return (
        <>
          <path
            {...props}
            d="M1 12L31 12"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.0932 4H34.9215C36.0653 4 37 4.94319 37 6.09375V34.8962C37 36.0468 36.0653 37 34.9215 37H3.07849C1.93632 37 1 36.0468 1 34.8962V6.09375C1 4.94319 1.93632 4 3.07849 4H8.79599"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.7178 4H28.5426"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.911 4H18.7342"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 25L19 17"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 32L19 30"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'scheduleCancel':
      return (
        <>
          <path
            {...props}
            d="M1 12L31 12"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.0932 4H34.9215C36.0653 4 37 4.94319 37 6.09375V34.8962C37 36.0468 36.0653 37 34.9215 37H3.07849C1.93632 37 1 36.0468 1 34.8962V6.09375C1 4.94319 1.93632 4 3.07849 4H8.79599"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.7178 4H28.5426"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.911 4H18.7342"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.2426 20.2427L14.7574 28.728"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.2426 28.728L14.7574 20.2427"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'scheduleOk':
      return (
        <>
          <path
            {...props}
            d="M1 12L31 12"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.0932 4H34.9215C36.0653 4 37 4.94319 37 6.09375V34.8962C37 36.0468 36.0653 37 34.9215 37H3.07849C1.93632 37 1 36.0468 1 34.8962V6.09375C1 4.94319 1.93632 4 3.07849 4H8.79599"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.7178 4H28.5426"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.911 4H18.7342"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 1V7.84918"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.0001 20L17.0723 28.4L13 24.1693"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'unit':
      return (
        <>
          <path
            {...props}
            d="M27 14.5633C27 14.5733 27 14.5733 27 14.5833V14.5433C27 14.5533 27 14.5633 27 14.5633ZM14 1.58325C6.82 1.58325 1 7.38325 1 14.5633C1 24.5133 10.73 26.7433 14 37.5833C17.26 26.7533 26.98 24.4933 27 14.5633C26.99 7.39325 21.17 1.58325 14 1.58325Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 9V21"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20 15L8 15"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'anamaliaVascular':
      return (
        <>
          <path
            {...props}
            d="M50.1428 21.9614C52.315 19.5302 54.8469 17.5738 57.9973 16.9121C62.2843 16.0058 66.7294 17.8111 70.2826 20.3718C75.929 24.4429 80.0792 30.5352 81.7911 37.282C83.503 44.0289 84.1503 52.8328 78.8924 57.3859C70.1963 64.9095 60.8097 71.6348 50.8837 77.4322C46.791 79.8274 42.54 82.0859 37.9367 83.2152C33.3261 84.3445 28.2767 84.2581 24.0474 82.1075C19.818 79.9497 16.6316 75.4829 16.8042 70.7429C16.8977 68.2542 17.84 65.9741 19.1491 63.8378"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.8391 11.9129C59.7739 8.10072 62.0469 3.97925 66.0461 2.49034C69.8151 1.09494 74.476 2.77805 76.4756 6.26656C78.4752 9.75506 77.5761 14.6318 74.4616 17.1708"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M83.0283 15.0708C84.6107 16.3152 85.5817 18.437 85.107 20.3935C84.5891 22.5369 82.6039 23.9539 80.7625 25.1695"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M89.9837 24.7882C90.8756 26.6008 90.8037 28.8521 89.7895 30.6C88.7537 32.3838 86.9196 33.5274 85.1429 34.5704"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M92.9399 33.1964C93.6736 34.2681 94.0692 35.606 93.8678 36.8935C93.6304 38.4184 92.6019 39.7275 91.3503 40.641C90.0988 41.5472 88.6386 42.1155 87.2001 42.6621"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M94.6806 42.8132C95.1121 44.0864 94.9611 45.5465 94.2922 46.7117C93.5729 47.9561 92.3141 48.8192 90.9691 49.3227C89.624 49.8334 88.1855 50.0204 86.7541 50.1858"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M28.4706 24.8873C29.5931 24.5062 30.7503 24.2429 31.9144 24.0974C34.0138 23.8272 36.141 23.9311 38.199 24.4023C39.5709 24.7141 40.9082 25.1922 42.1831 25.8297C44.1718 26.8205 46.0079 28.1924 47.56 29.9663C49.1676 31.7886 50.3386 33.8396 51.0592 36.0153C52.1124 39.1125 52.2856 42.4385 51.5927 45.5981C50.8097 49.1596 48.932 52.5063 45.9941 55.0977C43.4996 57.3012 40.5548 58.6731 37.5061 59.2344C36.8963 59.3521 36.2866 59.4353 35.6699 59.4838C34.3672 59.5877 33.0576 59.5462 31.7688 59.366C27.6877 58.8048 23.7866 56.8438 20.8557 53.5249C17.4466 49.6585 16.0262 44.725 16.5043 39.9717C16.726 37.7337 17.3635 35.5303 18.4167 33.5001C19.4006 31.6154 20.7379 29.8693 22.4286 28.3865C22.9552 27.9222 23.4956 27.4926 24.0569 27.1046"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.2299 22.3583C21.6387 21.998 21.6802 21.3744 21.3199 20.9656L17.4813 16.635L14.5157 13.2814L10.1435 8.35484C8.90318 6.95518 6.33945 7.05911 4.30925 8.70129C4.16374 8.81215 4.02516 8.93687 3.88658 9.06159L3.83115 9.1101C1.90489 10.9186 1.44757 13.4823 2.70172 14.8958L7.04621 19.7946L10.0187 23.1413L13.8574 27.4719L13.8921 27.5066C14.2524 27.9154 14.876 27.95 15.2779 27.5967L15.7698 27.1601L20.5924 22.9127L21.2299 22.3583Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.1231 27.0077L18.0147 29.1626"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.4191 23.0511L20.4261 23.058L24.0153 27.1461"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M35.7438 31.6664C35.7312 31.6539 35.718 31.6408 35.7044 31.6272C35.1625 31.0857 33.8188 29.743 31.6575 30.0439L31.6567 30.044C29.5114 30.3435 28.0811 31.694 27.5998 33.4362C27.1579 35.0359 27.5615 36.7919 28.5629 38.0673L28.5633 38.0678C29.6537 39.4556 29.6464 40.1826 29.6195 40.3457C29.6052 40.4321 29.5755 40.4878 29.4442 40.5282C29.4087 40.5391 29.3451 40.5554 29.1876 40.5937L29.171 40.5977C29.0364 40.6305 28.8548 40.6746 28.661 40.7287C28.2612 40.8404 27.7215 41.0173 27.1834 41.3264C26.6339 41.6419 26.0465 42.118 25.6139 42.8374C25.1749 43.5673 24.974 44.4176 25.0027 45.3482L35.7438 31.6664ZM35.7438 31.6664C36.6769 30.9875 37.7259 30.6216 38.8049 30.6937C39.9363 30.7692 40.876 31.3134 41.5206 32.0485C42.6931 33.3857 43.0591 35.6041 41.7907 37.3322M35.7438 31.6664L41.7907 37.3322M41.7907 37.3322C42.6375 37.8689 43.6884 38.822 43.9571 40.6142L43.9575 40.6169C44.131 41.7854 43.7666 42.8588 43.0117 43.7052L41.7907 37.3322ZM28.966 51.2003C31.1241 52.3405 34.1513 52.5109 36.3274 49.9994L25.0027 45.3493C25.0811 47.902 26.9216 50.1202 28.966 51.2003ZM36.3278 49.999C36.6877 49.5837 36.9414 49.0931 37.1167 48.7105C37.3031 48.3039 37.4684 47.8663 37.609 47.4807C37.6644 47.3289 37.7152 47.1887 37.7621 47.0592C37.9947 46.4172 38.1311 46.0407 38.2507 45.8394L36.5312 44.8183L38.25 45.8404C38.6038 45.2456 38.8722 45.0393 38.9961 44.9647C39.1081 44.8972 39.228 44.8592 39.4636 44.8439C39.601 44.835 39.741 44.8353 39.9611 44.8359L39.973 44.836C40.1638 44.8365 40.4482 44.8373 40.739 44.8097C41.3973 44.747 42.2843 44.5207 43.0111 43.7058L36.3278 49.999ZM40.6184 36.6892C40.6185 36.6892 40.6215 36.6911 40.6269 36.6951C40.6209 36.6912 40.6182 36.6892 40.6184 36.6892Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'formacaoLinfatica':
      return (
        <>
          <path
            {...props}
            d="M48.8926 45.2155C58.0496 44.7801 65.1197 37.0039 64.6843 27.847C64.2489 18.6901 56.4727 11.6199 47.3158 12.0553C38.1589 12.4908 31.0887 20.2669 31.5241 29.4238C31.9596 38.5808 39.7357 45.6509 48.8926 45.2155Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M94.0009 28.6367C85.5918 40.0241 76.3908 46.5526 68.4493 50.2918"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M94.0009 28.6438C73.4226 0.777051 48.1019 2.00811 48.1019 2.00811C48.1019 2.00811 22.7812 0.777051 2.19586 28.6438"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 29.1124C8.76384 35.8903 9.35139 47.1167 15.9683 54.0414C28.6077 67.2683 52.4735 67.2683 64.3295 59.875"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.5348 64.4495C45.4089 60.7074 43.4155 57.1121 40.4147 54.8668C37.414 52.6215 33.483 51.7262 29.7759 52.2578C26.0687 52.7894 22.6063 54.6989 20.0323 57.4269"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.3219 52.0899C32.4478 49.1382 30.6781 46.2914 28.195 44.6896C25.7119 43.0808 22.6203 42.6052 19.6825 42.8919C16.7377 43.1787 13.9119 44.172 11.191 45.3261"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'hemangioma':
      return (
        <>
          <path
            {...props}
            d="M38.9058 13.3408C25.1448 16.6845 14.1175 27.179 10.1792 40.6542L10.2796 40.4843C5.91659 40.3144 2.20994 44.4149 2.00916 49.666C1.80067 54.9093 5.17526 59.2878 9.53829 59.4654L9.5074 59.3959C13.0364 77.5971 29.06 91.2499 48.2959 91.2499C67.5782 91.2499 83.6404 77.4427 87.1154 59.1643L87.1385 59.2801C91.4166 58.9944 94.6908 54.8398 94.4901 49.666C94.2816 44.4149 90.5826 40.3144 86.2196 40.4843L86.1887 40.5075C85.3996 37.7699 84.3249 35.1615 82.9988 32.715M44.8055 27.8199C53.5547 23.9588 53.5702 13.1171 53.5702 12.6458L53.6011 12.5686C56.8808 12.9994 60.03 13.8256 62.9988 14.9994"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.5738 71.0812C38.5738 71.0812 46.8906 65.8301 57.8252 71.0812"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="30.8872"
            cy="48.3671"
            r="3.30469"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="63.9341"
            cy="48.3671"
            r="3.30469"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M83.2582 21.9695C83.5415 22.804 83.7372 23.6641 83.8454 24.5295C84.0463 26.0902 83.969 27.6714 83.6188 29.2012C83.387 30.2211 83.0316 31.2152 82.5577 32.1629C81.8212 33.6412 80.8013 35.0062 79.4827 36.1599C78.1281 37.3549 76.6034 38.2254 74.9861 38.7611C72.6837 39.544 70.2113 39.6728 67.8626 39.1577C65.2151 38.5756 62.7272 37.1798 60.8008 34.9958C59.1629 33.1416 58.143 30.9525 57.7258 28.6862C57.6383 28.2329 57.5765 27.7796 57.5404 27.3212C57.4631 26.3528 57.4941 25.3794 57.628 24.4213C58.0452 21.3875 59.5029 18.4876 61.9701 16.3088C64.8442 13.7747 68.5116 12.7187 72.045 13.0742C73.7087 13.239 75.3466 13.7129 76.8558 14.4958C78.2568 15.2272 79.5548 16.2213 80.6571 17.4781C81.0022 17.8695 81.3215 18.2713 81.61 18.6885"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M85.1383 16.587C85.4061 16.8909 85.8697 16.9218 86.1736 16.6539L89.3928 13.8004L91.8858 11.5959L95.548 8.34574C96.5885 7.42375 96.5112 5.51796 95.2905 4.00879C95.2081 3.90062 95.1153 3.79761 95.0226 3.69459L94.9866 3.65338C93.6422 2.22147 91.7364 1.88151 90.6857 2.8138L87.0441 6.04334L84.5563 8.25302L81.337 11.1066L81.3113 11.1323C81.0074 11.4001 80.9816 11.8637 81.2443 12.1625L81.5688 12.5282L84.7262 16.1131L85.1383 16.587Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.6821 12.7909L80.0802 14.197"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M84.6232 15.9843L84.6181 15.9895L81.5791 18.6576"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M76.9946 31.6931C76.9946 31.6931 77.6261 26.5372 72.8196 24.4617"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M74.7397 25.2263C75.8813 23.7884 76.0592 21.6547 75.1636 20.0522C74.2679 18.4497 72.3585 17.4818 70.5316 17.6986"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.2711 20.3493C61.6382 19.8656 63.2328 20.0491 64.4584 20.84C65.6798 21.6235 66.5119 22.9965 66.6444 24.4383"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M72.4988 30.7922C72.4988 29.4085 71.3779 28.2922 69.9988 28.2922C68.615 28.2922 67.4988 29.4131 67.4988 30.7922C67.4988 32.1714 68.6196 33.2922 69.9988 33.2922C71.3779 33.2922 72.4988 32.176 72.4988 30.7922Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'linfangioma':
      return (
        <>
          <path
            {...props}
            d="M38.9058 12.3408C25.1448 15.6845 14.1175 26.179 10.1792 39.6542L10.2796 39.4843C5.91659 39.3144 2.20994 43.4149 2.00916 48.666C1.80067 53.9093 5.17526 58.2878 9.53829 58.4654L9.50741 58.3959C13.0364 76.5971 29.06 90.2499 48.2959 90.2499C52.9258 90.2499 57.37 89.4539 61.4988 87.9911M44.8055 26.8199C53.5547 22.9588 53.5702 12.1171 53.5702 11.6458L53.6011 11.5686C56.8808 11.9994 60.03 12.8256 62.9988 13.9994C66.8321 15.0455 76.1987 20.0533 82.9988 31.715C84.3249 34.1615 85.3996 36.7699 86.1887 39.5075L86.2196 39.4843C90.5826 39.3144 94.2816 43.4149 94.4901 48.666C94.6908 53.8398 91.4166 57.9944 87.1385 58.2801L87.1154 58.1643C85.9793 64.1398 83.4981 69.6374 79.9988 74.331"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.5738 70.0812C38.5738 70.0812 46.8906 64.8301 57.8252 70.0812"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="30.8872"
            cy="47.3671"
            r="3.30469"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="63.9341"
            cy="47.3671"
            r="3.30469"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.6613 81.9688C62.6613 81.9688 65.7936 86.1126 70.6906 84.2607"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68.7791 85.0469C68.959 86.874 70.3152 88.5308 72.0733 89.0593C73.8314 89.5877 75.8765 88.9551 77.0384 87.5287"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82.5669 78.4878C81.9211 79.7862 80.6477 80.7634 79.217 81.0476C77.7945 81.3341 76.2417 80.9264 75.1437 79.9826"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M79.6728 75.0023C81.365 76.0176 82.7806 77.4346 83.7944 79.1277C84.8082 80.8208 85.3887 82.7378 85.4847 84.7089C85.5806 86.68 85.1889 88.6443 84.3444 90.4279C83.4998 92.2114 82.2284 93.7592 80.6428 94.934C79.0572 96.1088 77.2064 96.8745 75.2542 97.1632C73.302 97.4518 71.3087 97.2546 69.451 96.5889C67.5932 95.9232 65.9283 94.8097 64.6037 93.3469C63.2791 91.8841 62.3358 90.1172 61.8571 88.2027"
            stroke={color}
            strokeWidth="4"
          />
        </>
      );
    case 'tumorVascular':
      return (
        <>
          <path
            {...props}
            d="M21 52.5C23.5 62.5 27.4677 69.7736 32.5 74.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19.7341 32.7878C18.1965 36.7732 18.1555 41.0533 19.1054 45.1962"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8.08905 41.0026C8.62893 37.9831 9.29866 34.9687 9.87272 32"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.014 66.2413C10.4399 64.4418 9.77705 62.6575 9.03215 60.8936C7.19381 56.5575 6.86578 52.0232 7.22115 47.433"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.071 100.544C13.8433 92.7559 14.4241 84.9378 13.4401 77.1704C13.2077 75.3049 12.8797 73.4444 12.4696 71.5991"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.3586 62.7214C46.1285 67.7895 43.6341 72.7102 40.0326 77.2547C36.8138 81.3162 32.7134 84.9661 29.5561 89.048C24.7929 95.1988 21.2392 101.98 21 109"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29 68C31.4177 66.9562 33.3809 65.8823 34.848 64.7933C37.958 62.4967 38.6606 60.1314 37.4208 57.7879L37.0075 57"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.4085 51.6776C20.6226 49.1207 22.0372 46.3096 24.2719 44.2762"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.22115 47.433C6.38057 44.6931 4.37139 42.8377 2 40.6519"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.4696 71.5992C10.8431 69.027 7.72686 67.0953 4.08435 66.2413"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M72.0058 34.0877C72.4677 35.4484 72.7869 36.8511 72.9633 38.2621C73.2909 40.8071 73.1649 43.3857 72.5937 45.8803C72.2157 47.5434 71.6362 49.1645 70.8634 50.71C69.6623 53.1206 67.9993 55.3464 65.849 57.2278C63.64 59.1765 61.1538 60.596 58.5164 61.4695C54.7619 62.7462 50.7302 62.9562 46.9001 62.1163C42.5829 61.1671 38.526 58.8909 35.3847 55.3296C32.7137 52.3058 31.0506 48.7361 30.3703 45.0404C30.2275 44.3013 30.1267 43.5621 30.0679 42.8146C29.9419 41.2355 29.9923 39.648 30.2107 38.0858C30.891 33.1385 33.268 28.4097 37.2913 24.8568C41.9781 20.7243 47.9585 19.0025 53.7204 19.582C56.4334 19.8508 59.1044 20.6235 61.5654 21.9002C63.85 23.0929 65.9666 24.714 67.7641 26.7635C68.3269 27.4018 68.8476 28.057 69.318 28.7373"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M75.0716 25.3104C75.5083 25.8059 76.2643 25.8563 76.7598 25.4196L82.0094 20.7663L86.0747 17.1714L92.0466 11.8715C93.7433 10.368 93.6173 7.26022 91.6267 4.79922C91.4923 4.62283 91.3411 4.45484 91.1899 4.28686L91.1311 4.21966C88.9389 1.88465 85.8311 1.33029 84.1177 2.85057L78.1793 8.11695L74.1225 11.7203L68.8729 16.3735L68.8309 16.4155C68.3353 16.8523 68.2933 17.6082 68.7217 18.0954L69.2508 18.6917L74.3996 24.5376L75.0716 25.3104Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69.4356 19.1201L66.8234 21.4131"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M74.2316 24.3276L74.2232 24.336L69.2676 28.6869"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.7916 49.9438C61.7916 49.9438 62.8214 41.5361 54.9834 38.1517"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M58.1147 39.3985C59.9762 37.0537 60.2663 33.5744 58.8058 30.9612C57.3453 28.3479 54.2316 26.7696 51.2525 27.1231"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.5208 31.4456C36.7502 30.6568 39.3505 30.9561 41.3491 32.2458C43.3407 33.5235 44.6977 35.7624 44.9137 38.1135"
            stroke={color}
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54.4604 48.4748C54.4604 46.2183 52.6327 44.398 50.3837 44.398C48.1272 44.398 46.3069 46.2258 46.3069 48.4748C46.3069 50.7238 48.1347 52.5515 50.3837 52.5515C52.6327 52.5515 54.4604 50.7313 54.4604 48.4748Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'acupuntura':
      return (
        <>
          <path
            {...props}
            d="M48.0914 38.1079C52.6834 38.1079 57.1683 37.7927 61.5029 37.1921M2.18286 25.728C8.15788 29.5378 15.1367 32.6132 22.8159 34.7459M94 25.728C87.3627 29.9601 79.4867 33.2861 70.7878 35.4201M28.49 36.1215C32.3125 36.9175 36.2782 37.4867 40.354 37.8064"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.8303 58.3758C35.6535 58.9004 28.7051 58.3887 22.2153 56.9966C14.7542 55.3961 7.89924 52.6318 2 48.9409"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="43.449"
            y="5.09497"
            width="6.18992"
            height="18.5698"
            rx="3.09496"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.5439 23.6647V44.2978"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="67.177"
            y="2"
            width="6.18992"
            height="18.5698"
            rx="3.09496"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70.272 20.5698V41.2028"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="19.7209"
            y="2"
            width="6.18992"
            height="18.5698"
            rx="3.09496"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M22.8159 20.5698V41.2028"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'alergologia':
      return (
        <>
          <path
            {...props}
            d="M94 32C94 46.36 73.4 58 48 58C22.6 58 2 46.36 2 32"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 46C2 60.36 22.6 72 48 72C73.4 72 94 60.36 94 46V28C94 13.64 73.4 2 48 2C22.6 2 2 13.64 2 28V46Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M85.96 27.32C77.68 20.48 63.76 16 48 16C32.24 16 18.32 20.48 10.04 27.32"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33 46C39.0751 46 44 43.5376 44 40.5C44 37.4624 39.0751 35 33 35C26.9249 35 22 37.4624 22 40.5C22 43.5376 26.9249 46 33 46Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66 46C69.866 46 73 44.2091 73 42C73 39.7909 69.866 38 66 38C62.134 38 59 39.7909 59 42C59 44.2091 62.134 46 66 46Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M50.5 30C53.5376 30 56 28.6569 56 27C56 25.3431 53.5376 24 50.5 24C47.4624 24 45 25.3431 45 27C45 28.6569 47.4624 30 50.5 30Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'angiologia':
      return (
        <>
          <path
            {...props}
            d="M97.7415 31.165C97.7415 31.165 92.3158 42.6177 75.8652 55.6185C74.9517 56.34 58.9674 68.9232 58.3784 69.4008C57.5333 70.0846 57.0302 71.1033 57.0223 72.1888C56.9921 76.2544 55.8444 86.37 45.128 85.8691L42.0804 85.516C37.2426 84.9555 32.3424 85.7229 27.907 87.7361L22.7346 90.0833C19.3147 91.6354 15.6393 92.4264 11.9553 92.4464C8.58626 92.4653 7.35464 88.0246 10.2663 86.3276C12.2768 85.1561 14.0184 84.107 14.5106 83.7135C14.723 83.5432 21 78.9999 24 76.9999"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M22.2734 78.1259C25.7674 75.6333 29.9758 72.6392 33.899 69.8514C42.2423 63.9217 49.3093 56.3823 54.6829 47.6753L65.4051 30.8833M82.8771 1.99997L72.7938 18.1209"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="44.7122"
            y="9.98322"
            width="5.9196"
            height="17.7588"
            rx="2.9598"
            transform="rotate(-54.5322 44.7122 9.98322)"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.8931 17.8773L76.9636 29.3267"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cardiologia':
      return (
        <>
          <path
            d="M20 37.4116C12.345 32.1375 13 21 18 16C18 8.99999 2.26341 9.80245 3 14.5C3.73659 19.1975 6.21461 28.6671 4.77052 36.9673C3.38745 44.9242 -4.80928 63.4027 15.7741 73.7225C24.3979 88.5457 49.7813 94.4225 65.829 95.9574C70.0393 96.3613 73.8631 93.8571 74.7173 90.2017C76.9139 80.6494 79.7818 71.5818 76.5478 63.12C73.9037 56.2335 61.9646 47.1254 59.6052 45.3886C56.7354 43.2761 55.0899 39.9158 56.3509 36.9471C59.2533 36.9471 64.4256 36.8461 65.4426 36.8259C66.846 36.7855 67.8833 34.2611 67.7613 31.2116C67.6392 28.1622 66.8533 25.3147 64.9951 25.3147C64.3646 25.3348 58.0935 25.3147 53.6661 25.3147C46.5867 25.3147 41.7098 25.7388 39.1439 29.6566C37.4383 32.2609 37.293 34.1508 37.293 37.4116C27.84 37.4116 20 44.5 21.0216 55.5872"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M53.3814 25.0255C52.6667 22.4907 50.803 17.9546 50.803 17.9546C50.803 17.9546 52.16 16.9142 54.6934 14.3794C57.2267 11.8446 50.1334 4.24015 47.6 6.268C45.0667 8.29584 44.56 8.8028 42.7224 10.7827C41.1591 10.116 38.6822 9.73218 37.3219 9.59076C37.3219 7.78887 37.3625 6.91217 37.3422 4.05526C37.3219 1.19834 24.4857 1.19837 24.9372 4.82296C25.3067 7.78888 25.8134 9.30972 25.8134 10.7827C22.504 11.51 18.72 13.8724 16.6934 17.9546"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cinicaMedica':
      return (
        <>
          <path
            {...props}
            d="M48.0001 12C50.7615 12 53.0001 9.76142 53.0001 7C53.0001 4.23858 50.7615 2 48.0001 2C45.2386 2 43.0001 4.23858 43.0001 7C43.0001 9.76142 45.2386 12 48.0001 12Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70 18H84C86.2 18 88 16.2 88 14C88 11.8 86.2 10 84 10H80H90C92.2 10 94 8.2 94 6V2H71.8C66 2 60.8 5.6 58.6 11L56 18H40L37.4 11C35.4 5.6 30.2 2 24.2 2H2V6C2 8.2 3.8 10 6 10H16H12C9.8 10 8 11.8 8 14C8 16.2 9.8 18 12 18H26"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48 14V94"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.8 63.4C58.8 63.4 67.6 54.6 67.6 43.6C67.6 36 63.4 29.4 57 26"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.6 26C32.4 29.4 28 36 28 43.6C28 50.4 31.4 56.6 36.8 60"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.8 63.4C41.8 63.4 36.8 68.2 36.8 74.4C36.8 80.4 41.8 85.4 47.8 85.4C53.8 85.4 58.8 80.4 58.8 74.4C58.8 72.2 58.2 70 57 68.2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cirurgia':
      return (
        <>
          <path
            {...props}
            d="M97.4955 4.91082C93.4462 0.861545 86.6468 1.06401 82.3613 5.34949L24.6591 63.0517L51.2493 65.8693L97.0737 20.045C101.342 15.7595 101.545 8.9601 97.4955 4.91082Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.3857 65.8356L32.2425 80.9677C27.1466 86.0598 20.7701 89.6812 13.7865 91.4494L2 94.4337L25.5364 70.8972"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.7129 96.5764H65.6074"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.6018 55.6618L59.8541 57.2815"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.211 47.9682L67.4802 49.5879"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.9553 40.2914L75.2076 41.9112"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cirurgiaPedriatrica':
      return (
        <>
          <path
            {...props}
            d="M49.3363 58.3851C34.54 58.3851 22.5421 46.4256 22.5421 31.6764C22.5421 29.5397 22.8399 27.492 23.2864 25.5037C17.7788 24.465 13.6108 19.6575 13.6108 13.8706C13.6108 7.31207 18.9398 2 25.5193 2C30.1636 2 34.1232 4.6412 36.0881 8.49913C39.9881 6.2734 44.5133 4.96764 49.3363 4.96764C54.189 4.96764 58.6844 6.2734 62.5844 8.49913C64.5791 4.6412 68.5387 2 73.1532 2C79.7327 2 85.0617 7.31207 85.0617 13.8706C85.0617 19.6575 80.8938 24.465 75.3861 25.5037C75.8624 27.492 76.1304 29.5397 76.1304 31.6764C76.1304 34.9072 75.5547 38.0041 74.5 40.8708C73.5396 43.4814 72.1819 45.9011 70.5 48.057C67.7568 51.5733 64.1512 54.3881 60 56.1856"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49.3363 37.6117V44.4823"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.2905 37.6117H49.3363H45.382"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37.4278 25.741V31.6763"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.2448 25.741V31.6763"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.8593 52.717C82.3526 58.7116 94.0229 73.5498 97 81.4734"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.1407 52.717C16.6474 58.7116 4.97712 73.5498 2 81.4734"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43 46C43 52.2153 56 53.1032 56 46"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.164 55.3452V66.5635"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.164 66.5635C39.6046 68.8071 42.4181 75.5381 42.4181 77.7817C42.4181 80.0254 41.6584 84.3332 39.6046 89H36.791"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.164 66.5635C22.7234 68.8071 19.9099 75.5381 19.9099 77.7817C19.9099 80.0254 20.6695 84.3332 22.7234 89H25.5369"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.2036 55.3452V68.4332"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.2035 85.2606C70.3472 85.2606 73.7063 81.9122 73.7063 77.7817C73.7063 73.6513 70.3472 70.3029 66.2035 70.3029C62.0599 70.3029 58.7008 73.6513 58.7008 77.7817C58.7008 81.9122 62.0599 85.2606 66.2035 85.2606Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cirurgiaRobotica':
      return (
        <>
          <path
            {...props}
            d="M19.35 71.0457L6.45001 96.8805"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.772 79.076L40.85 96.8805"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.7961 54.0455C43.1729 52.5217 52.0079 58.898 53.5297 68.2874C55.0515 77.6768 48.6838 86.5237 39.307 88.0476C29.9302 89.5714 21.0952 83.1951 19.5734 73.8057C18.7739 68.8728 20.152 64.0897 23 60.4395"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.1 71.0457C30.1 74.6195 32.981 77.5044 36.55 77.5044C40.119 77.5044 43 74.6195 43 71.0457C43 67.4719 40.119 64.587 36.55 64.587C33.0025 64.587 30.1 67.4719 30.1 71.0457Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.1 27.9877C79.0371 27.9877 83.85 23.1682 83.85 17.2232C83.85 11.2781 79.0371 6.45868 73.1 6.45868C67.163 6.45868 62.35 11.2781 62.35 17.2232C62.35 23.1682 67.163 27.9877 73.1 27.9877Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.15002 17.2232C2.15002 25.5549 8.87952 32.2935 17.2 32.2935C25.5205 32.2935 32.25 25.5549 32.25 17.2232C32.25 8.89147 25.5205 2.15289 17.2 2.15289C8.87952 2.15289 2.15002 8.89147 2.15002 17.2232Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M64.5 10.7645H53.75L51.6 8.61157H30.1"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63 21.529H53.75L51.6 23.6819H32.25"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.20349 22.7777L20.0165 66.2878"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.1 25.8348L50.826 61.4438"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.65 25.8348V32.2935L64.5 34.4464V47.3638L66.65 49.5167V53.8225L70.95 58.1283H75.25L79.55 53.8225V49.5167L81.7 47.3638V34.4464L79.55 32.2935V25.8348"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82 69.9582L79.0349 77L76 75L76 66.5L73.5 64L71 66.5L71 75L67.9651 77L65 69.9582L67.125 67.7665L67.125 63.3833L71.375 59L75.625 59L79.875 63.3833L79.875 67.7665L82 69.9582Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'clinicadaDor':
      return (
        <>
          <path
            {...props}
            d="M77 108.954C80.0477 109.85 82.6935 111.174 85.2264 113.218"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M50.8212 57.7479L53.6285 59.4085L62.6474 61.7904C63.8145 62.1149 64.8261 61.6418 65.3095 60.5818C65.7928 59.5217 65.2679 58.2442 64.2079 57.7608L54.9299 54.0496L47.8961 47.6934C46.0453 45.9843 45.5272 43.3257 47.0774 41.3678C47.6125 40.5736 48.5724 39.8347 49.7429 39.4686L60.16 38.4045C65.5843 37.2095 65.1733 34.392 65.1733 34.392L57.4734 33.8228L52.2182 33.0531C52.2182 33.0531 40.5474 29.8081 34.4428 28.928C32.1604 28.5449 22.4061 20.2843 20.5 19"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M64.0287 61.7972C65.0888 62.2806 65.7207 63.3992 65.5032 64.4075C65.3928 65.2569 64.54 65.837 63.4765 66.0443C59.6542 65.5473 55.7248 65.2091 52.0613 64.8192C50.5248 64.0147 48.9882 63.2103 47.6105 62.5129"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.5552 65.9236C60.5552 65.9236 61.4012 66.7246 61.1837 67.7328C61.0733 68.5822 60.4863 69.1105 59.6887 69.266C56.6606 69.3041 53.6324 69.3423 50.4973 69.5393L43.7157 65.8935C43.0803 65.4654 42.1757 65.7796 41.8546 66.2561C41.4265 66.8915 41.5819 67.6891 42.2173 68.1172L48.3015 73.1407L51.9582 74.9118C52.7005 75.1811 53.0148 76.0857 52.7455 76.8281C52.4762 77.5705 51.6234 78.1506 50.7222 77.7743L45.1527 76.1C44.835 75.8859 44.5691 75.9377 44.2515 75.7237L38.6922 71.9777C36.7861 70.6933 35.0941 69.0913 33.668 67.4375L24.5346 55.9712L19.2753 45.2677L17.1655 42.2293"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M91.3888 99.6957C99.578 95.714 106.008 88.2951 108.785 79.623L95.3462 68.0158L98.2121 62.2502C98.4727 61.7405 98.221 61.1178 97.6782 60.937L84.2557 56.5655L79.8678 52.7627C72.5907 46.4561 64.2136 44.6145 55.5 47M34.5906 70.3218C33.5 73 33 83 44 92"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M109.635 98.138L103.062 91.5616"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'dermatologia':
      return (
        <>
          <path
            {...props}
            d="M47.5052 40.7685L47.5054 40.7678C50.5249 25.1303 57.6935 10.6227 66.6152 2.00165C66.6269 2.0009 66.6405 2.00034 66.6559 2.0001C66.7778 1.99824 66.9362 2.02132 67.1011 2.07188C66.8486 2.51005 66.5909 2.95577 66.3291 3.40865C63.7785 7.82092 60.8351 12.9127 58.4227 18.3232C55.6092 24.6335 53.4375 31.5433 53.4375 38.5736C53.4375 43.2855 54.7006 46.4954 55.7835 49.1904L55.7882 49.2022C56.8644 51.8805 57.6511 53.8384 57.4041 56.5412C57.3986 56.6017 57.3958 56.6625 57.3958 56.7232C57.3958 61.8111 53.6817 65.613 49.5 65.613C45.3162 65.613 41.6042 61.827 41.6042 56.7232C41.6042 53.8285 42.6196 51.512 43.9296 49.0543C44.1194 48.6983 44.3192 48.3338 44.5239 47.9603C45.6752 45.8602 46.981 43.4783 47.5052 40.7685ZM66.561 2.00794C66.5552 2.00987 66.552 2.01051 66.5519 2.01035C66.5518 2.01019 66.5547 2.00922 66.561 2.00794Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M97 36.8859H65.8479C64.3042 36.8859 62.8396 37.5937 61.9885 38.7734C60.5833 40.6973 60.8802 43.2201 62.5427 44.9624C65.5115 48.0479 67.3125 52.0589 67.3125 56.8504C67.3125 61.2835 65.7509 65.347 63.1574 68.5M49.5 75C39.6635 75 31.6875 66.869 31.6875 56.8504C31.6875 52.0771 33.5083 48.0479 36.4573 44.9624C38.1396 43.2201 38.4167 40.7154 37.0115 38.7734C36.1406 37.5937 34.6958 36.8859 33.1521 36.8859H2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'endrocrinologia':
      return (
        <>
          <path
            {...props}
            d="M84.8989 10.8038C84.8989 25.8928 75.9848 38.8838 63.2237 44.6397"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M84.8989 1.99994V10.8038C84.8989 22.8803 79.1153 33.5044 70.2808 40.2555V63.3058L94.8928 72.2975"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 72.2976L26.4529 63.3328V40.2824C17.6183 33.5314 11.8347 22.9073 11.8347 10.8307C11.8347 10.8307 11.8347 7.81213 11.8347 3.32703"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.0791 64.4892C43.4852 62.9023 45.5281 61.9071 47.7831 61.9071C50.0382 61.9071 52.081 62.9292 53.4871 64.4892C56.0871 62.6602 57.785 59.6209 57.785 56.1782C57.785 52.7354 56.0871 49.6961 53.4871 47.8671C52.081 49.454 50.0382 50.4492 47.7831 50.4492C45.5281 50.4492 43.4852 49.4271 42.0791 47.8671C39.4792 49.6961 37.7812 52.7354 37.7812 56.1782C37.7812 59.6209 39.5057 62.6602 42.0791 64.4892Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.6363 38.9293H52.9566"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.6363 64.4892V69.9223"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.9565 64.4892V69.9223"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.96224 12.9354C5.56482 12.9354 2 9.37057 2 4.97314"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M94.8928 5.0109C94.8928 9.40833 91.328 12.9731 86.9306 12.9731"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'fisiatria':
      return (
        <>
          <path
            {...props}
            d="M53.6759 9.92017C52.1873 11.3791 35.6 27.6364 32.6228 30.5543C25.1797 37.8492 28.157 49.7295 25.1797 52.6474"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.7089 51.6053C28.157 51.6053 26.243 51.8137 25.1797 52.8558"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.1798 52.6475L3.48865 73.9069"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.7899 24.7184L49.2101 34.9313"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.7063 24.7184C78.5569 23.8847 78.5569 22.6342 77.7063 21.8004L58.1417 2.62528C57.2911 1.79157 56.0152 1.79157 55.1645 2.62528C53.4633 4.29268 53.6759 9.92018 53.6759 9.92018L60.9063 17.0067"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.8202 30.5543C61.3316 32.0133 44.7443 48.2705 41.7671 51.1885C34.324 58.4834 37.3013 70.3636 34.324 73.2816"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.7063 45.3525C76.2177 46.8115 59.6304 63.0687 56.6532 65.9867C49.2101 73.2816 37.0886 70.3636 34.1114 73.2816"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.1114 73.2816L12.4203 94.541"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.7216 45.3525L62.8203 60.1508"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M85.362 40.9757L67.2861 23.2595C66.4355 22.4258 65.1595 22.4258 64.3089 23.2595C62.6076 24.9269 62.8203 30.5544 62.8203 30.5544L77.919 45.3526C77.919 45.3526 83.8734 45.5611 85.362 43.8937C86.2127 43.0599 86.2127 41.8094 85.362 40.9757Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 72.4479L4.97722 75.3658"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.9316 93.0821L14.1215 96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'fisioterapia':
      return (
        <>
          <path
            {...props}
            d="M71.5571 58C71.7688 53.9778 72.0706 54.8224 72.2823 50.8002C72.494 45.5079 73.1291 36.405 73.5525 33.653C73.5525 33.653 73.9759 27.9373 73.9759 25.6087C73.9759 23.0683 70.5888 21.7982 69.1069 23.9151C68.8952 24.1268 68.8952 24.3385 68.6835 24.7619C68.0485 26.2437 67.8368 27.7256 67.6251 29.2074C67.2017 31.5361 66.5666 36.6167 66.1432 38.9454C65.9315 39.7921 65.0847 40.4272 64.0262 40.0038C63.3912 39.5804 62.9678 38.9454 62.9678 38.0986L64.0262 10.7901C64.0262 8.67314 62.121 6.76788 60.0041 7.19127C58.3105 7.40296 57.252 8.88483 57.252 10.5784L56.617 32.5945C56.617 33.653 55.5585 34.4998 54.7117 34.2881C53.8649 34.0764 53.2299 33.4413 53.2299 32.5945C52.5948 22.6449 52.5948 15.4473 52.3831 10.3667C52.1714 7.82635 52.5403 4.69355 50 3C47.8831 1.51814 45.8206 2.11063 44.5504 4.22757C43.9153 5.28604 43.7036 6.76788 43.7036 8.03805L44.3387 31.7478C44.3387 33.0179 43.0685 33.8647 42.0101 33.653C41.375 33.4413 40.7399 32.8062 40.7399 32.1712C40.5282 28.7841 39.6814 19.6812 39.0464 15.024C38.8347 12.6953 36.7177 9.73161 34.3891 10.7901C31.2137 12.0602 31.8487 16.9292 32.0604 19.6812C32.2721 22.4332 32.2721 25.1853 32.4838 27.7256"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.4839 48V52.0704C32.4839 53.5522 31.8489 54.8224 30.7904 55.6692C29.7319 56.516 28.2501 56.516 26.7682 56.0926L25.7097 55.6692C24.863 55.2458 24.0162 54.8224 23.1694 54.399C21.6876 53.3406 19.1472 51.8587 15.9718 51.4353C14.49 51.2236 11.3145 50.8002 9.83268 52.7055C9.1976 53.5522 8.9859 54.6107 8.9859 55.4575C11.3145 56.516 14.2783 58.2095 17.0303 60.5381C19.3589 62.4434 21.2642 64.3486 22.9577 66.0422C25.2863 69.0059 27.1916 71.9696 28.6735 75.3567C30.7904 80.014 35.236 82.9777 40.3166 83.1894C40.5283 83.1894 40.9517 83.1894 41.1634 83.1894"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.8126 59.9031C32.484 57.7862 29.7319 56.7277 28.2501 56.3043"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.27008 17.5643C11.3145 13.7538 18.0887 8.03808 26.133 3.8042L38.5 4.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 35.7701C7.08065 35.135 11.1028 37.887 15.3367 39.7923C15.9718 40.004 16.6069 40.2156 17.4536 40.4273C22.1109 41.6975 26.9799 40.6391 31.6371 41.9092C35.2359 42.756 38.4113 44.6613 41.7985 46.1431C42.2218 46.3548 42.8569 42.9677 42.8569 42.5443C42.8569 38.7338 38.4113 37.2519 35.4476 35.7701C33.5424 34.7116 31.4255 33.8648 29.5202 32.8064C29.0968 32.5947 28.8851 32.1713 28.6734 31.9596C28.25 31.5362 28.0383 31.1128 27.8267 30.4777C27.4033 29.2076 27.4033 27.7257 28.0383 26.6672"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M91.335 86.1532L97.4741 57.7862C97.6858 56.9395 97.4741 55.881 97.0507 55.2459L90.9116 45.9314L85.1959 42.9677"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M72.7058 48.0483L76.5163 54.6109L75.0345 64.1371C74.3994 66.4657 72.2824 68.1593 69.9538 68.1593C69.3187 68.1593 68.8953 67.9476 68.2603 67.9476C67.8369 67.7359 67.4135 67.5242 67.2018 67.3125C65.5082 65.8307 63.8147 64.1371 62.1211 62.6552C59.7925 60.3266 56.8288 56.7278 53.0183 57.998C52.5949 58.2096 49.6312 59.6915 50.0546 60.1149C52.5949 62.8669 55.5586 65.4072 57.6756 68.5827C60.4276 72.8165 61.2744 77.6855 64.2381 81.9194C64.6615 82.5545 65.0849 83.1896 65.7199 83.613C66.7784 84.8831 68.0486 85.9416 69.107 87"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M76.5571 45.5L82.2321 50.5885L84.7724 58.6328C84.7724 58.6328 85.1958 59.4796 85.8309 59.6913"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.1293 37.8869L87.3128 47.8365L90.0649 54.6108C90.0649 54.6108 90.6999 55.8809 91.5467 56.516"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.609 65.1954C45.1856 64.3486 44.9739 63.5018 44.7622 62.4434C44.1271 57.151 47.7259 52.4937 53.0183 51.8586C55.5586 51.4352 58.0989 52.282 60.0042 53.7639"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'fonologia':
      return (
        <>
          <path
            {...props}
            d="M78.0847 54.5448C84.9674 50.1297 89.3735 42.2746 88.975 33.5294C88.38 20.4615 77.2858 10.3507 64.1951 10.9447C51.1045 11.5387 40.9761 22.6136 41.5711 35.6814C42.0012 45.1335 48.1757 53.0145 56.3764 56.4415V66.5061C56.3745 66.5043 74.6851 56.7265 78.0847 54.5448Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M74.4708 36.131C75.2764 35.9836 75.8097 35.2122 75.6621 34.408C75.5144 33.6038 74.7417 33.0714 73.9361 33.2188C73.1305 33.3662 72.5972 34.1376 72.7449 34.9418C72.8925 35.746 73.6653 36.2784 74.4708 36.131Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.5392 36.1311C66.3447 35.9837 66.8781 35.2123 66.7304 34.4081C66.5827 33.6039 65.81 33.0715 65.0044 33.2189C64.1988 33.3663 63.6655 34.1377 63.8132 34.9419C63.9608 35.7461 64.7336 36.2785 65.5392 36.1311Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.6083 36.1337C57.4137 35.9854 57.9462 35.2134 57.7976 34.4094C57.649 33.6054 56.8757 33.0739 56.0703 33.2222C55.2649 33.3705 54.7324 34.1425 54.881 34.9465C55.0295 35.7505 55.8029 36.2821 56.6083 36.1337Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.7611 94V77.1517"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.7295 73.8283C29.7948 77.6514 19.3178 77.6514 10.3832 73.8283L10.4147 54.8705L3.76185 53.1515C3.16867 53.0053 2.84243 52.3669 3.07599 51.8025L8.93173 37.9168V31.7178C8.93173 16.2777 20.595 2.95818 36.0361 2.05147C43.0355 1.64067 49.5345 3.71132 54.7378 7.46587C56.28 8.57798 57.7073 9.83813 58.9994 11.226"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.3746 93.8908V73.7947"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'gastroenterologia':
      return (
        <>
          <path
            {...props}
            d="M25.4783 2C25.4783 13.1717 31.3283 22.9348 40.1327 28.4717C43.1261 30.35 45.0435 33.5391 45.0435 37.0804V37.2174V48.9565C45.0435 57.6043 38.0392 64.6087 29.3914 64.6087H22.1327C20.4305 64.6087 18.787 65.0978 17.3979 65.9391L13.0153 63.2C11.4501 62.2217 9.72831 61.5174 7.94788 61.1065"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.3978 21.9761L42.813 20.8413C38.5283 17.6521 35.3391 13.0543 34.0087 7.71301"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 68.5218C5.11087 68.5218 8.14348 69.4022 10.7652 71.0457L13.4065 72.7087C13.3087 75.2522 14.3652 77.7174 16.3022 79.3804C25.7717 87.4804 37.863 92 50.4043 92H51.3239C57.4674 92 63.6109 90.8065 69.1478 88.1261C83.5087 81.2 92 66.9957 92 51.9109V37.9609C92 25.1848 82.1196 14.1892 69.3435 13.7587C63.1217 13.5435 57.4087 15.7544 53.1043 19.5109"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'generico':
      return (
        <>
          <path
            {...props}
            d="M83.7718 64.7382C83.7718 71.8817 78.026 77.6275 70.8825 77.6275C63.7391 77.6275 57.9932 71.8817 57.9932 64.7382C57.9932 57.5947 63.7391 51.8489 70.8825 51.8489C78.026 51.8489 83.7718 57.5947 83.7718 64.7382Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.0545 6.50336H56.5956C60.7885 6.50336 64.0497 9.91979 64.0497 13.9574V31.5055C64.0497 36.6301 62.1861 40.5124 57.9932 43.3077L38.5817 56.6629"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.8992 2V11.007"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M28.7982 6.50336H20.4124C16.2195 6.50336 12.9584 9.91979 12.9584 13.9574V31.5055C12.9584 36.6301 14.8219 40.5124 19.0148 43.3077L38.4264 56.6629"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M28.9536 2V11.007"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.3463 81.8204C57.0615 82.9074 61.8756 74.0557 61.8756 74.0557"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.4266 56.8182V81.0439C38.4266 92.5355 27.4008 96.4178 17.7726 94.5543C7.98921 92.8461 1.15634 86.0132 2.24338 79.3357C3.48573 72.6581 12.3374 68.7758 22.1208 70.6393H22.2761C24.2949 71.1052 27.5561 72.0369 30.5066 74.6769"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M72.5909 64.7382C72.5909 65.6699 71.8144 66.4464 70.8827 66.4464C69.9509 66.4464 69.1744 65.6699 69.1744 64.7382C69.1744 63.8064 69.9509 63.0299 70.8827 63.0299C71.8144 63.0299 72.5909 63.8064 72.5909 64.7382Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'genetica':
      return (
        <>
          <path
            {...props}
            d="M35.8267 35.1733L66.2323 65.5789"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41.9008 74.7076C44.1945 81.4444 43.9714 87.8398 38.1495 93.6616L34.0589 97.7523"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.2192 42.8225L58.5843 70.1875"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8.24939 62.7506L38.655 93.1562"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.8986 58.1432L43.2636 85.5082"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M75.361 41.2474C82.0977 43.5411 88.4931 43.3181 94.315 37.4962L98.4056 33.4056"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54.7806 31.4222C48.0439 29.1285 41.6484 29.3516 35.8266 35.1734C30.0048 40.9952 29.7817 47.3907 32.0754 54.1274"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68 3L63.9094 7.09061C55.1919 15.8081 59.045 25.82 65.0631 36.3424C71.0813 46.8649 74.9497 56.8615 66.2169 65.5943C57.4841 74.327 47.4875 70.4587 36.9651 64.4405C26.4426 58.4223 16.446 54.554 7.71326 63.2867L3.65328 67.3467"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.4757 30.566L70.8407 57.9311"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63.4038 7.59607L93.8094 38.0017"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M58.7964 15.2454L86.1614 42.6104"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'geriatria':
      return (
        <>
          <path
            {...props}
            d="M70.3311 8.76733C70.3311 8.76733 70.3311 15.9532 70.3311 17.8753C70.3311 19.7973 71.7402 21.5523 77.1279 24.6025C82.5157 27.6528 86.4944 34.2547 86.4944 38.7256C86.4944 38.7256 86.4944 39.7341 86.4944 44.2468"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.0632 65.0916C27.0632 58.3643 27.0632 33.0848 27.0632 33.0848C27.0632 21.803 34.5232 21.803 34.5232 14.2818C34.5232 11.4823 34.5232 3.00005 34.5232 3.00005"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.5189 70.7115L62.5189 66.9509"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.3081 70.7323L51.3288 66.9509"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.1181 70.7323L40.1181 66.9718"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.0631 65.0915C27.0631 71.192 34.8132 74.1587 40.1181 70.7324C41.2371 73.6991 48.0754 75.1615 51.3081 70.7324C53.1731 74.493 60.0114 74.2005 62.4981 70.7324C66.7254 74.9944 75.5531 72.6127 75.5531 65.0915L75.5323 40.6685"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.4465 96V48.855V48.855C20.9517 48.855 16.4973 53.3094 16.4973 58.8042V96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M76.1928 48.855V48.855C84.435 48.855 91.1166 55.5366 91.1166 63.7788V89.1851C91.1166 91.8409 88.9637 93.9939 86.3078 93.9939V93.9939C83.652 93.9939 81.499 91.8409 81.499 89.1851V66.1983C81.499 63.2677 79.1233 60.892 76.1928 60.892V60.892"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'ginecologia':
      return (
        <>
          <path
            {...props}
            d="M14.2747 26.9474H9.22042C5.23887 26.9474 2 23.6835 2 19.6711C2 15.6587 5.23887 12.3948 9.22042 12.3948H33.0478C39.8762 12.3948 45.4256 17.9871 45.4256 24.8685V51.3335C45.4256 53.6619 43.5483 55.5329 41.2584 55.5329C38.9479 55.5329 37.0912 53.6411 37.0912 51.3335V49.8158L35.3377 44.3066C31.0261 34.2237 28.8187 31.6874 28.8187 20.7106"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37.0706 49.8158V62.2271C37.0706 66.3226 38.2671 70.335 40.5364 73.7653L45.3225 81"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.2747 39.4211C17.6928 39.4211 20.4637 36.6288 20.4637 33.1843C20.4637 29.7398 17.6928 26.9474 14.2747 26.9474C10.8567 26.9474 8.08582 29.7398 8.08582 33.1843C8.08582 36.6288 10.8567 39.4211 14.2747 39.4211Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M84.7253 26.9474H89.7796C93.7612 26.9474 97 23.6835 97 19.6711C97 15.6587 93.7612 12.3948 89.7796 12.3948H65.9523C59.1238 12.3948 53.5744 17.9871 53.5744 24.8685V51.3335C53.5744 53.6619 55.4517 55.5329 57.7416 55.5329C60.0521 55.5329 61.9088 53.6411 61.9088 51.3335V49.8158L63.6624 44.3066C67.9533 34.2237 70.1607 31.6874 70.1607 20.7106"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.9295 49.8158V62.2271C61.9295 66.3226 60.7329 70.335 58.4637 73.7653L53.6776 81"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M84.7253 39.4211C88.1434 39.4211 90.9142 36.6288 90.9142 33.1843C90.9142 29.7398 88.1434 26.9474 84.7253 26.9474C81.3073 26.9474 78.5364 29.7398 78.5364 33.1843C78.5364 36.6288 81.3073 39.4211 84.7253 39.4211Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.278 12.3947C73.7503 12.3947 70.2845 11.5839 67.1488 10.0247C65.6016 9.25552 64.2194 8.17447 62.899 7.07263C60.7742 5.24316 56.0293 2 49.4484 2C42.8675 2 38.1227 5.24316 35.9772 7.05184C34.6569 8.17447 33.2747 9.23473 31.7275 10.0039C28.5918 11.5839 25.1466 12.3947 21.6189 12.3947"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'hematologia':
      return (
        <>
          <path
            {...props}
            d="M49.7671 45.7006C33.1071 26.3372 31.4594 19.2795 31.2763 18.3746C31.0932 19.2795 29.6286 26.3372 12.9686 45.7006C-6.62063 68.5024 4.36399 98 31.0932 98H31.4594C52.0237 98 63.3593 80.2985 58.4025 61.7209"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.5317 70.493C15.5317 70.493 15.7148 78.9985 23.404 83.3417"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.7294 15.9344C73.3079 6.16223 72.3925 2.5429 72.3925 2C72.3925 2.5429 71.4771 5.98127 63.0556 15.9344C53.1694 27.5163 58.6617 42.3556 72.2094 42.5366H72.3925C85.9402 42.3556 91.6156 27.5163 81.7294 15.9344Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'imunologia':
      return (
        <>
          <path
            {...props}
            d="M28 37.5C20 43 16.1827 52.8272 16.1827 59.358C16.1827 73.5556 28.238 85.1975 42.988 85.1975C46.3918 85.1975 49.7957 84.6296 52.774 83.4938V70.4321"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.4519 31.9568C8.52404 39.7654 2 51.5494 2 64.8951C2 76.1111 6.53846 86.3333 14.0553 94H60.0072"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.8903 14.3936L21.1187 20.2336L37.7367 56.6513L50.5083 50.8112L33.8903 14.3936Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.0889 9.66667L25.4014 2L17.1755 5.83333L22.5 17.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.7692 48L46.5337 42.179"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.3582 69.8642H61"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M39.4423 70.1481V84.6296"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'infectologia':
      return (
        <>
          <path
            {...props}
            d="M32.0903 68.4502C35.7224 65.8741 37.0631 60.8385 35.0004 57.3791C33.136 53.8837 28.5177 53.2843 24.8857 55.8605C21.2536 58.4366 20.1113 63.4362 21.9756 66.9316"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.6197 71C53.8693 69.7053 54 68.3682 54 67.0006C54 55.28 44.4767 45.8791 33 46.0012C21.4012 46.0012 12 55.4021 12 67.0006C12 78.5991 21.4012 88 33 88C40.137 88 46.442 84.4406 50.2366 79"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33 36V45"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33 89.0001V98.0001"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M64 67H55"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 67H2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54 46L49 51"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 83.0001L12 88.0001"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 46L17 51"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49 83.0001L54 88.0001"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.8375 22.9225C75.4537 14.6357 65.7234 9.64323 55.5879 10.5654C51.5255 10.9351 46.8816 15.571 47.3094 21.1328C47.7372 26.6946 52.1118 30.8338 57.1174 30.4488C64.2086 29.9033 70.5405 35.8501 71.1394 43.6366C71.5672 49.1983 75.9418 53.3376 80.9474 52.9525C85.9529 52.5675 89.643 47.8079 89.2151 42.2461C88.9268 38.4972 88.0759 34.9216 86.7661 31.6118"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82.4768 56.4714L81.9207 52.8777"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.5241 39.7326L69.2677 37.4865"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.374 33.7858L58.2404 30.5022"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.491 15.1325L47.9404 16.6085"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.4117 6.54385L61.7426 10.5729"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82.2202 16.769L79.0863 19.6675"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M92.0602 35.5934L88.3381 36.2993"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.587 20.2409C62.3949 17.743 60.2142 15.8739 57.7163 16.066C55.2185 16.2582 53.3493 18.4388 53.5415 20.9367C53.7336 23.4346 55.9143 25.3037 58.4122 25.1116C58.7813 25.0832 59.1367 25.0114 59.4738 24.9015"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'mastologia':
      return (
        <>
          <path
            {...props}
            d="M54.5 81C47.5 89.5 38.5 91 38.5 91"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.8859 90.9706C27.8597 90.9706 27.8335 90.9706 27.7812 90.9706C26.9695 90.9442 26.1578 90.8385 25.3461 90.7065C25.3199 90.7065 25.2676 90.7065 25.2414 90.6801C14.4016 88.3557 8.92937 82.5449 6.25871 78.0811C2.98583 72.6137 2.33125 66.5916 3.09056 62.9466C2.5669 61.9957 1.54576 60.0676 2.22652 57.9017C2.90728 55.7623 4.87101 54.7586 8.06533 54.9171C10.0029 53.7285 11.1287 52.8569 12.6735 51.6947C13.0139 51.4306 13.3805 51.1401 13.7732 50.8495C29.2998 39.0694 40.0348 27.4213 44.7739 17.1996"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M76.2721 2C76.2721 2.26413 76.2721 10.0417 76.2721 10.3059C76.2721 13.3169 76.2721 16.1695 77.7907 17.9127C78.8119 19.1013 80.1472 19.8673 81.5611 20.6597C82.687 21.2936 83.8652 21.9539 84.9649 22.8784C91.3274 28.1609 94.1289 37.4318 94.6526 44.352C95.2286 52.0909 94.9668 64.6634 94.7312 74.7531C94.6002 81.3563 94.705 98.1102 94.7312 91.4733"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.1071 24.4102C67.3699 19.8144 73.7586 18.6522 81.5873 20.8445"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54.273 30.9711C54.7181 30.4429 62.7145 24.0283 63.5 23.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'medicinadoAdolescente':
      return (
        <>
          <path
            {...props}
            d="M30.7017 42.4745C35.1922 42.4745 38.8325 38.8503 38.8325 34.3796C38.8325 29.9089 35.1922 26.2847 30.7017 26.2847C26.2112 26.2847 22.5709 29.9089 22.5709 34.3796C22.5709 38.8503 26.2112 42.4745 30.7017 42.4745Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.30938 28.9499C4.70355 38.0567 2.93511 50.3063 2.24399 54.6168C1.20732 60.9916 3.64655 63.9057 6.30938 64.7354C8.97222 65.5652 13.932 64.8569 16.4729 60.688C17.8754 58.644 21.5486 52.4665 23.5 48.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.7344 10.095H63.2249"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.8325 34.3796H55.0941"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.5056 24.261V12.1187"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.4074 18.1899H24.6036"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33 25.5381C34.1321 23.3295 34.7672 20.8313 34.7672 18.1898C34.7672 9.24495 27.4902 2 18.5057 2C9.52113 2 2.24408 9.24495 2.24408 18.1898C2.24408 27.1347 9.52113 34.3796 18.5057 34.3796C19.5254 34.3796 20.5287 34.2817 21.5 34.1014"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.1472 34.3796C57.1472 38.852 60.7857 42.4745 65.2779 42.4745C69.7702 42.4745 73.4087 38.852 73.4087 34.3796C73.4087 29.9072 69.7702 26.2847 65.2779 26.2847C60.7857 26.2645 57.1472 29.8869 57.1472 34.3796Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M89.6907 28.9499C91.2965 38.0567 93.065 50.3063 93.7561 54.6168C94.7928 60.9916 92.3535 63.9057 89.6907 64.7354C87.0279 65.5652 82.0681 64.8569 79.5272 60.688C78.1246 58.644 73.9514 52.4665 72 48.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.4537 24.261V20.2136"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.4537 16.1661V12.1187"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M75.421 18.1899H71.3557"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M79.4865 18.1899H83.5519"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.9806 25.5C61.8606 23.3008 61.2328 20.8161 61.2328 18.1898C61.2328 9.24495 68.5099 2 77.4944 2C86.4789 2 93.756 9.24495 93.756 18.1898C93.756 27.1347 86.4789 34.3796 77.4944 34.3796C76.4747 34.3796 75.4713 34.2817 74.5 34.1014"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'medicinaEsportiva':
      return (
        <>
          <path
            {...props}
            d="M70 7.23119C68.8603 6.63899 67.6928 6.09237 66.5 5.59378C60.9635 3.27952 54.8818 2 48.4995 2C22.8773 2 2 22.8776 2 48.5C2 74.1224 22.8773 95 48.4995 95C74.2799 95 94.9991 74.1224 94.9991 48.5C95.0749 36.2163 90.316 25.0231 82.5 16.6981C81.7894 15.9413 81.0536 15.2081 80.2938 14.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.4193 29.2738V14.733L32.4516 5.36224"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.0323 42.6837L17.7742 37.6752L14.2258 18.6105"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.7742 37.6752L3.41937 50.4388"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.9678 64.4949L29.2258 74.9966L10.3549 72.5731"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.2258 74.9966L36.8065 92.6071"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.4194 14.733L64.5484 5.36224"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.9678 42.6837L79.2258 37.6752L82.7742 18.6105"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M79.2258 37.6752L93.5807 50.4388"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.871 64.4949L67.7742 74.9966L86.4839 72.5731"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67.7742 74.9966L60.0322 92.6071"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.9677 64.4949L30.0322 42.6837L48.4193 29.2738L66.9677 42.6837L59.8709 64.4949H36.9677Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'medicinaReprodutiva':
      return (
        <>
          <path
            {...props}
            d="M18.02 58.3328C14.3562 48.6204 14.2485 37.4998 18.6665 27.2096C27.6464 6.08775 51.9638 -3.66082 72.9407 5.36563C93.9176 14.3921 103.652 38.8357 94.6359 59.9215C85.6561 81.0073 61.3387 90.7919 40.3618 81.7655C35.7641 79.7797 31.7412 77.0717 28.2929 73.8222"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.734 41.6159C36.9136 39.63 37.4165 37.6081 38.2785 35.6584C42.6248 25.4405 54.4063 20.7106 64.5715 25.0794C74.7367 29.4482 79.4421 41.2909 75.0959 51.5089C72.1146 58.5495 65.6132 62.9544 58.537 63.6404"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M55.2683 45.0459C58.3215 48.2232 57.208 54.289 52.7899 58.5856C48.3718 62.8822 42.3015 63.7848 39.2483 60.5714C36.1952 57.3941 37.3087 51.3283 41.7267 47.0317C46.1448 42.7351 52.1793 41.8686 55.2683 45.0459Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 84.5095C2 84.5095 12.1652 90.2865 13.0272 79.0937C13.0272 79.0937 13.7815 64.4347 20.3907 64.5069C20.3907 64.5069 23.372 63.9653 27.6823 66.2761C27.6823 66.2761 33.2498 69.7423 38.5659 61.3657"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'nefrologia':
      return (
        <>
          <path
            {...props}
            d="M58 36C55.2345 36 53 38.8562 53 42.3911V83"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M39 36C41.7655 36 44 38.8562 44 42.3911V83"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.8894 64.8573C30.9186 65.6338 28.7486 66.0554 26.4901 66.0554C12.9607 66.0554 2 55.0726 2 41.516V27.5378C2 13.4266 13.4036 2 27.4865 2H31.1179C38.2701 2 44.0715 7.81313 44.0715 14.9797C44.0715 22.1463 38.2701 28.1147 31.1179 28.1147H31.9815C35.8565 28.1147 39.0008 31.2653 39.0008 35.1482C39.0008 39.031 35.8565 42.1816 31.9815 42.1816H30.9851"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37 36H13"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82 36H58"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M64.177 64.8573C66.1478 65.6338 68.2956 66.0554 70.5542 66.0554C84.0614 66.0554 95 55.0726 95 41.516V27.5378C95 13.4266 83.5964 2 69.5578 2H65.9263C58.7963 2 52.9949 7.81313 52.9949 14.9797C52.9949 22.1463 58.7742 28.1147 65.9263 28.1147H65.0628C61.1877 28.1147 58.0656 31.2653 58.0656 35.1482C58.0656 39.031 61.2099 42.1816 65.0628 42.1816H66.0592"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'neurologia':
      return (
        <>
          <path
            {...props}
            d="M26.2947 48.6753L19.9578 48.7768C10.0982 48.9391 2 40.9637 2 31.0604V30.4516C2 26.3726 3.35645 22.5777 5.84666 19.554C5.92764 19.4525 6.00862 19.3713 6.06936 19.2698C12.6087 11.3147 21.4762 5.79488 31.2751 3.37994"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.7068 67.1628C79.2571 73.0074 73.4871 77.0864 66.7858 77.0864C57.8373 77.0864 50.5894 69.8213 50.5894 60.8515"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.2757 40.5579C30.7689 40.5579 26.2947 36.073 26.2947 30.5532"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.4666 60.8515L41.3169 62.5562C44.8599 69.6792 47.1476 77.3299 48.0789 85.2038"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.206 85.2038C59.7809 81.5916 59.0925 78.0402 58.1207 74.5497"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.663 40.5579H36.4175C30.8297 40.5579 26.2947 45.1036 26.2947 50.7047C26.2947 56.3057 30.8297 60.8515 36.4175 60.8515H54.6385C54.6385 60.8515 58.0802 63.1447 61.2993 65.3161C64.8827 67.7107 69.0736 68.9689 73.3656 68.9689C85.3915 68.9689 95.1296 59.2077 95.1296 47.1736V42.9728C95.1296 39.462 94.5223 35.9512 93.3683 32.6434C92.0523 28.9093 90.0277 25.4594 87.4161 22.4763L86.8087 21.7863C76.7062 9.26511 61.5017 2 45.447 2H45.1838C40.1629 2 35.7089 5.28757 34.2512 10.1174"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.7507 46.7474C44.212 43.1149 40.6083 40.5579 36.4175 40.5579C30.8297 40.5579 26.2947 45.1036 26.2947 50.7047C26.2947 56.3057 30.8297 60.8515 36.4175 60.8515"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M87.0314 38.5285C91.5057 38.5285 95.1296 42.1611 95.1296 46.646"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'nutricao':
      return (
        <>
          <path
            {...props}
            d="M54.4146 25.0755H63.1181"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70.0808 9.23553L49.1924 30.3555"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.3773 9.23553V18.0355"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.7482 51.28H24.6291C12.0574 51.28 2 41.1111 2 28.4V16.08H14.1849C26.7567 16.08 36.8141 26.2489 36.8141 38.96V44.4356"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.15625 23.12L30.0447 44.24"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.6663 23.12V31.3333"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.6291 38.96H16.119"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M74.5292 37.5911C86.9076 42.8711 93.6769 56.56 90.0021 70.0533C86.1339 83.7422 72.0149 92.3467 58.2827 89.2178C43.1966 85.8933 34.1062 70.4444 38.1679 55.5822C41.2625 44.24 50.933 36.4178 61.9575 35.6356C63.118 35.44 64.2784 35.0489 65.4389 34.4622C72.4017 30.5511 77.237 23.12 77.237 14.32V2H65.0521C52.2869 2 42.2295 12.1689 42.2295 24.88V46"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.4921 32.1156L81.2987 32.3112C76.0766 35.44 71.8215 39.7423 68.7269 45.2178"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.73642 90.0001C12.941 90.0001 15.5388 87.3735 15.5388 84.1334C15.5388 80.8933 12.941 78.2667 9.73642 78.2667C6.53188 78.2667 3.93408 80.8933 3.93408 84.1334C3.93408 87.3735 6.53188 90.0001 9.73642 90.0001Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.4315 90.0001C33.636 90.0001 36.2338 87.3735 36.2338 84.1334C36.2338 80.8933 33.636 78.2667 30.4315 78.2667C27.2269 78.2667 24.6292 80.8933 24.6292 84.1334C24.6292 87.3735 27.2269 90.0001 30.4315 90.0001Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.3741 81.2C23.5787 81.2 26.1765 78.5734 26.1765 75.3333C26.1765 72.0933 23.5787 69.4667 20.3741 69.4667C17.1696 69.4667 14.5718 72.0933 14.5718 75.3333C14.5718 78.5734 17.1696 81.2 20.3741 81.2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.9789 78.2667C35.1834 78.2667 37.7812 75.6401 37.7812 72.4C37.7812 69.1599 35.1834 66.5333 31.9789 66.5333C28.7743 66.5333 26.1765 69.1599 26.1765 72.4C26.1765 75.6401 28.7743 78.2667 31.9789 78.2667Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 90H90.9692"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'nutrologia':
      return (
        <>
          <path
            {...props}
            d="M85.7326 44.4565H2C2 64.0674 14.1304 81.4543 31.5174 88.1261V95H65.6848V88.1261C82.8696 81.4543 95 64.0674 95 44.4565V41.8282"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.5327 86.7109H67.9087"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.037 35.3587C20.6 31.5174 18.174 26.2609 18.174 20.8022V6.44781H29.9C35.1566 6.44781 39.8066 8.26738 43.6479 11.3"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M35.3588 7.05481C36.9762 5.43742 38.9979 4.0222 41.424 3.2135C47.287 0.989592 53.7566 2.60698 58.0022 6.44829"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.4782 32.3261V28.2826C46.4782 13.7261 58.2043 2 72.7608 2H86.913V18.1739C86.913 32.7304 69.1217 44.4565 54.5652 44.4565"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.3672 37.8359V39.4356"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M78.8261 10.0869L54.5652 34.3478"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68.7173 10.0869V20.1956"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.2392 12.1088L40.4131 28.2827"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M28.2825 24.2392H36.3695"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.2609 42.4348C26.2609 35.7631 20.8022 30.3044 14.1304 30.3044C7.4587 30.3044 2 35.7631 2 42.4348V44.4566"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M95 42.4348C95 35.7631 89.5413 30.3044 82.8696 30.3044"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70.7391 28.2825H60.6304"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.6929 60.546H52.5479V53.4011H45.403V60.546H38.258V67.691H45.403V74.8359H52.5479V67.691H59.6929V60.546Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'obstetrica':
      return (
        <>
          <path
            {...props}
            d="M89.582 75C94.2786 67.633 97 58.8843 97 49.5C97 23.2665 75.7335 2 49.5 2C23.2665 2 2 23.2665 2 49.5C2 75.7335 23.2665 97 49.5 97C60.1933 97 70.0612 93.4665 78 87.5035"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.0891 49.3587L23.1248 64.355C21.7451 66.4544 20.9786 68.8538 20.9786 71.2532C20.9786 78.3015 26.8039 84 34.0088 84C34.1621 84 34.1621 84 34.3154 84C49.0319 84 63.1352 78.3015 73.7127 68.4039L74.7857 67.3542C77.5451 65.5547 79.3846 62.5554 79.3846 59.2562C79.3846 53.8576 74.939 49.5087 69.4204 49.5087H51.7912"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M64.8214 60.4559H51.178C46.4258 60.4559 42.5934 56.7069 42.5934 52.0581C42.5934 47.4092 46.4258 43.6602 51.178 43.6602H52.4044"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M79.3846 58.5064V50.8583C79.3846 47.859 79.9978 44.8598 81.5307 42.1605C83.217 39.3112 84.1368 35.8621 83.9835 32.4129C83.5236 23.1152 75.5522 15.3172 66.0478 15.0173C55.4703 14.5674 46.7324 22.9653 46.7324 33.3127C46.7324 35.8621 47.3456 38.4114 48.2654 40.5109"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68.6538 34.5124C71.2599 34.5124 73.2527 36.4619 73.2527 39.0113C73.2527 41.5606 71.2599 43.5101 68.6538 43.5101"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.5934 51.0082V48.009C42.5934 44.7098 39.8341 42.0105 36.4615 42.0105H24.1978"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41.0604 69.0037L42.8999 67.2042C45.0461 65.1047 46.4257 62.5553 46.8856 59.856"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.1978 42.0105C24.1978 39.4611 22.2049 37.5116 19.5989 37.5116C16.9929 37.5116 15 39.4611 15 42.0105V43.5101C15 47.859 18.0659 51.4581 22.2049 52.3579"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.4615 15.0175L33.3956 18.0168C29.5632 21.7658 30.6362 27.9143 35.3884 30.3137C39.834 32.5631 41.0604 38.1117 37.9945 42.0108V42.1607"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'oftalmologia':
      return (
        <>
          <path
            {...props}
            d="M47.5 9.86841C35.4271 9.86841 24.1458 17.9605 20.7812 30.1974C16.625 44.8026 25.3333 60.1974 39.9792 64.1447C54.625 68.2895 70.0625 59.6052 74.0208 45C75.2083 40.4605 75.4062 35.921 74.4167 31.7763"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63.3333 27.8289C63.3333 31.1842 60.5625 33.75 57.1979 33.5526C53.8333 33.5526 51.2604 30.7894 51.4583 27.4342C51.4583 24.0789 54.2292 21.5131 57.5937 21.7105C60.7604 21.7105 63.3333 24.4737 63.3333 27.8289Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.1771 39.671C58.1875 45.3947 53.2396 49.5394 47.3021 49.3421C40.7708 49.1447 35.625 43.8157 35.625 37.3026C35.8229 31.5789 39.9792 26.8421 45.3229 25.8552"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.25 6.51317C63.9271 3.55264 56.0104 1.97369 47.5 1.97369C29.0938 1.97369 12.8646 9.67106 1.97919 21.5132"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M93.0208 21.5131C90.0521 18.3552 86.6875 15.3947 83.125 12.8289"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.5 73.0263C72.6405 73.0263 93.0209 58.8879 93.0209 41.4474C93.0209 24.0068 72.6405 9.86841 47.5 9.86841C22.3596 9.86841 1.97919 24.0068 1.97919 41.4474C1.97919 58.8879 22.3596 73.0263 47.5 73.0263Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'oncologia':
      return (
        <>
          <path
            {...props}
            d="M47.7813 50.7761C58.25 36.3484 57.9375 27.0959 57.9375 27.0959C57.9375 1.06334 34.5001 2.00428 34.5001 2.00428C34.5001 2.00428 11.0626 1.06334 11.0626 27.0959C11.0626 27.0959 10.7501 37.4462 23.0938 53.1284L58.5625 95L67 73.6721L29.0313 28.8209C29.0313 28.8209 22.7813 21.9207 26.8438 18.6275C26.8438 18.6275 29.5001 16.5888 34.5001 16.5888C39.5001 16.5888 42.1563 18.6275 42.1563 18.6275C46.2188 21.9207 39.9688 28.8209 39.9688 28.8209L34.5001 35.2506"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.6875 56.4216L2 73.5153L10.4375 95L29.8125 72.2607"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'ortopedia':
      return (
        <>
          <path
            {...props}
            d="M28.937 13.7959C10.5682 17.6553 1.78734 34.9928 2.00391 49.0053C2.2255 62.4824 8.77987 72.6198 17.5 79.0178"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49.6488 85.0855C63.5682 80.573 76.6804 68.1636 76.9954 49.0053C77.1894 37.498 71.2891 23.7484 59 17.0623"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49.4519 97C49.4519 91.5573 49.4519 83.3833 49.4519 75.2292C49.4519 70.8552 51.5979 67.6292 53.4485 64.3438C54.8464 61.85 56.1655 59.4948 56.1655 57.8521C56.1655 55.3188 49.57 51.4792 39.6276 51.4792C29.6852 51.4792 23.1094 55.3188 23.1094 57.8521C23.1094 59.4948 24.4285 61.85 25.8263 64.3438C27.677 67.6292 29.7639 70.8552 29.7639 75.2292C29.7639 82.0177 29.7639 91.8542 29.7639 97"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49.4519 2C49.4519 5.99792 48.94 16.9823 49.4519 21.574C50.1016 27.5115 56.8939 30.3417 56.8939 34.775C56.8939 41.524 53.7439 43.1271 49.885 43.1271C46.4396 43.1271 39.096 40.9104 36.4775 41.8406C33.7212 42.8302 32.0477 43.5625 28.8386 43.5625C25.2357 43.5625 22.381 41.8208 22.381 34.7948C22.381 30.3615 29.0945 27.5312 29.7639 21.5937C30.2758 16.9823 29.7639 6.29479 29.7639 2.01979"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.3248 34.9136C41.3995 37.8823 41.0845 40.2375 36.4381 41.8604"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'otorrinolaringologia':
      return (
        <>
          <path
            {...props}
            d="M19.7583 2C19.7583 2 19.4336 8.77401 27.8763 17.6447L66.8426 65.8693C66.8426 65.8693 70.0898 74.0948 65.7061 83.772C65.7061 83.772 48.2545 94.9033 39 97"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.04261 66.0305C-3.62143 75.2239 4.65891 87.4816 4.65891 87.4816C12.1274 101.03 24.3044 89.2557 24.3044 89.2557C39.2415 76.1916 47.8465 79.9011 47.8465 79.9011C47.8465 79.9011 50.769 81.1914 49.3078 84.4171"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'pediatria':
      return (
        <>
          <path
            {...props}
            d="M44.7421 76.6239L2 41.1898V72.3119C2 84.0817 11.6084 93.7115 23.3782 93.7115H38.6004C50.3702 93.7115 60 84.0817 60 72.3119V23.3996C60 11.6298 50.3702 2 38.6004 2H23.3782C11.6084 2 2 11.6298 2 23.3996V32.8939"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M35.3762 60.642L59.9501 41.6855"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.549 42.0172L11.3552 48.7367"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.8947 42.2063L50.3488 49.1505"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.5631 10.7525C20.2075 12.2968 15.1144 17.1438 13.2954 23.3675L13.3418 23.2891C11.3266 23.2106 9.61466 25.1045 9.52193 27.5297C9.42563 29.9515 10.9842 31.9737 12.9994 32.0558L12.9851 32.0237C14.615 40.4301 22.0157 46.7359 30.9001 46.7359C39.8059 46.7359 47.2244 40.3588 48.8294 31.9167L48.8401 31.9702C50.816 31.8382 52.3282 29.9194 52.2355 27.5297C52.1392 25.1045 50.4308 23.2106 48.4157 23.2891L48.4014 23.2998C46.4255 16.4448 40.5727 11.3445 33.3504 10.3958L33.3361 10.4315C33.3361 10.6491 33.329 15.6565 29.288 17.4398"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.4098 36.3427C26.4098 36.3427 30.251 38.768 35.3013 36.3427"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="22.8596"
            cy="26.9298"
            r="1.52632"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="38.1228"
            cy="26.9298"
            r="1.52632"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'pneumologia':
      return (
        <>
          <path
            {...props}
            d="M52 2V24.0229C52 27.3464 54.68 30.0292 58 30.0292H68"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60 40.0355H27"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37.88 40.9205L42.76 50.8709C43.58 52.5326 44 54.3746 44 56.2365V73.4144C44 79.4607 39.5 84.566 33.5 85.3268L12.44 87.9896C6.68 87.9896 2 83.3247 2 77.5387V59.4198C2 43.6634 14.76 12.1105 30.5 12.1105H30.62C33.94 12.1105 36.62 14.7933 36.62 18.1168V30.0292"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M58.12 40.9205L53.24 50.8708C52.42 52.5326 52 54.3745 52 56.2164V73.3943C52 79.4406 56.5 84.5459 62.5 85.3067L83.56 87.9895C89.32 87.9895 94 83.3046 94 77.5386V59.4198C94 43.6633 81.24 12.0905 65.5 12.0905H65.38C62.06 12.0905 59.38 14.7732 59.38 18.0967V30.0291"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37 30.0292H38C41.32 30.0292 44 27.3464 44 24.0229V2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'portalSaber':
      return (
        <>
          <path
            {...props}
            stroke={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8654 8.76926C15.955 8.74365 16.0499 8.74358 16.1395 8.76904L28.3867 12.2493C28.6017 12.3103 28.75 12.5067 28.75 12.7302V20.4697C28.75 20.7458 28.5261 20.9697 28.25 20.9697C27.9739 20.9697 27.75 20.7458 27.75 20.4697V13.461L16.1571 17.2206C16.0566 17.2532 15.9484 17.2531 15.848 17.2204L3.59511 13.2284C3.38609 13.1603 3.24607 12.9636 3.25008 12.7438C3.2541 12.524 3.4012 12.3326 3.61256 12.2722L15.8654 8.76926ZM26.6025 12.7818L16.0033 9.76991L5.45985 12.7842L16.0032 16.2192L26.6025 12.7818Z"
            fill="white"
          />
          <path
            {...props}
            stroke={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.6208 14.2603C22.8969 14.2603 23.1208 14.4842 23.1208 14.7603V20.3673C23.1208 20.5047 23.0643 20.636 22.9645 20.7304C21.326 22.2817 18.7674 23.25 15.9971 23.25C13.2263 23.25 10.6741 22.2814 9.03043 20.731C8.93028 20.6366 8.87351 20.505 8.87351 20.3673V17.3022C8.87351 17.0261 9.09737 16.8022 9.37351 16.8022C9.64965 16.8022 9.87351 17.0261 9.87351 17.3022V20.1467C11.3121 21.4164 13.5331 22.25 15.9971 22.25C18.4618 22.25 20.6875 21.4161 22.1208 20.1473V14.7603C22.1208 14.4842 22.3446 14.2603 22.6208 14.2603Z"
            fill="white"
          />
        </>
      );
    case 'proctologia':
      return (
        <>
          <path
            {...props}
            d="M77.2956 22.2083C76.5269 24.8556 77.2956 32.3125 77.2956 32.3125C77.2956 37.89 72.7644 42.4167 67.1813 42.4167C67.1813 42.4167 55.1654 43.811 46.9526 42.4167C38.7398 41.0223 24.7011 42.4167 24.7011 42.4167C20.2305 42.4167 16.6096 38.7994 16.6096 34.3333C16.6096 34.3333 15.8409 30.9181 16.6096 26.25C17.3783 21.5819 20.2305 18.1667 24.7011 18.1667C24.7011 18.1667 33.4196 17.3987 36.8383 18.1667C40.2569 18.9346 46.9526 18.1667 46.9526 18.1667C50.3106 18.1667 53.0212 15.4587 53.0212 12.1042C53.0212 12.1042 52.5155 5.37479 53.0212 2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.1584 20.1875C65.1584 20.1875 64.3088 5.53646 65.1584 2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67.1813 54.5417H75.2728C83.1013 54.5417 89.4328 48.2165 89.4328 40.3958C89.4328 40.3958 88.2596 34.3333 89.4328 30.2917C90.6061 26.25 89.4328 20.1875 89.4328 20.1875C89.4328 15.7215 86.1558 11.599 81.3414 12.1042C76.5269 12.6094 73.2499 12.1042 73.2499 12.1042C68.7794 12.1042 65.1584 15.7215 65.1584 20.1875V22.2083C65.1584 26.6744 61.5375 30.2917 57.0669 30.2917C57.0669 30.2917 47.074 31.1808 40.884 30.2917C34.694 29.4025 26.7239 30.2917 26.7239 30.2917"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.5867 74.75C15.0924 71.9613 14.5867 64.6459 14.5867 64.6459C14.5867 59.0684 19.118 54.5417 24.7011 54.5417C24.7011 54.5417 35.1593 53.8748 44.9297 54.5417C54.7002 55.2086 67.1813 54.5417 67.1813 54.5417C71.6518 54.5417 75.2728 58.159 75.2728 62.625C75.2728 62.625 74.8884 65.0298 75.2728 66.6667C75.6571 68.3036 75.2728 70.7084 75.2728 70.7084C75.2728 75.1744 71.6518 78.7917 67.1813 78.7917C67.1813 78.7917 62.2455 77.7813 57.0669 78.7917C51.8884 79.8021 44.9297 78.7917 44.9297 78.7917C41.5718 78.7917 38.8611 81.4996 38.8611 84.8542C38.8611 84.8542 37.607 92.1898 38.8611 94.9584"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.7239 76.7708C26.7239 76.7708 25.7125 90.169 26.7239 94.9584"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.7011 42.4167H16.6096C8.7811 42.4167 2.44953 48.7419 2.44953 56.5625C2.44953 56.5625 1.43809 62.625 2.44953 66.6667C3.46096 70.7083 2.44953 76.7708 2.44953 76.7708C2.44953 81.2369 6.07046 84.8542 10.541 84.8542C10.541 84.8542 13.1505 84.1873 14.5867 84.8542C16.023 85.5211 18.6325 84.8542 18.6325 84.8542C23.103 84.8542 26.7239 81.2369 26.7239 76.7708V74.75C26.7239 70.284 30.3449 66.6667 34.8154 66.6667C34.8154 66.6667 45.9412 65.3127 50.9983 66.6667C56.0555 68.0206 65.1584 66.6667 65.1584 66.6667"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'psicologia':
      return (
        <>
          <path
            {...props}
            d="M23.7611 94V77.1517"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.7295 73.8283C29.7948 77.6514 19.3178 77.6514 10.3832 73.8283L10.4147 54.8705L3.76185 53.1515C3.16867 53.0053 2.84243 52.3669 3.07599 51.8025L8.93173 37.9168V31.7178C8.93173 16.2777 20.595 2.95818 36.0361 2.05147C43.0355 1.64067 49.5345 3.71132 54.7378 7.46587C56.28 8.57798 57.7073 9.83813 58.9994 11.226"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.3746 93.8908V71.7947"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69.438 21.7215L60.7165 13L52.0937 21.6228C53.838 21.6557 55.5494 22.3468 56.8987 23.6633C59.6304 26.3949 59.6304 30.8709 56.8987 33.6025C54.1671 36.3342 49.6911 36.3342 46.9595 33.6025C45.6101 32.2532 44.8861 28.8633 44.8861 28.8633L36 37.7165L44.7215 46.438C42.8785 46.4051 40.9696 47.0633 39.5544 48.4785C36.7899 51.2101 36.8228 55.6861 39.5544 58.4177C42.2861 61.1494 46.762 61.1494 49.4937 58.4177C50.9089 57.0025 51.6 55.1266 51.5342 53.2506L59.9924 61.7089L68.9114 52.7899C67.1671 52.757 65.4228 52.0658 64.1063 50.7494C61.3418 48.0177 61.3418 43.5418 64.1063 40.8101C66.838 38.0785 71.3139 38.0785 74.0456 40.8101C75.362 42.1595 76.0532 43.8709 76.0861 45.6152L84.7089 36.9924L76.2835 28.5671C78.1595 28.6329 80.0354 27.9418 81.4506 26.5266C84.1823 23.7949 84.1823 19.319 81.4506 16.5873C78.9823 14.119 75.0987 13.8557 72.3342 15.8633"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'psiquiatria':
      return (
        <>
          <path
            {...props}
            d="M23.7611 94V77.1517"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.7295 73.8283C29.7948 77.6514 19.3178 77.6514 10.3832 73.8283L10.4147 54.8705L3.76185 53.1515C3.16867 53.0053 2.84243 52.3669 3.07599 51.8025L8.93173 37.9168V31.7178C8.93173 16.2777 20.595 2.95818 36.0361 2.05147C43.0355 1.64067 49.5345 3.71132 54.7378 7.46587C56.28 8.57798 57.7073 9.83813 58.9994 11.226"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.3746 93.8908V71.7947"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.3876 33.878L26.4173 33.9256C21.7959 34.0017 18 30.2634 18 25.6215V25.3361C18 23.4242 18.6358 21.6454 19.803 20.2281C19.841 20.1805 19.879 20.1425 19.9074 20.0949C22.501 15.762 27.1291 13.7788 31.7221 12.6469"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M55.3608 44.6518C54.2125 47.3913 51.508 49.3032 48.3669 49.3032C44.1725 49.3032 40.7752 45.8979 40.7752 41.6935"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.0304 39.5854L36.4289 40.3844C38.0896 43.7232 39.162 47.3093 39.5985 51"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.2169 57.7668L47.1209 57.1293C46.7242 54.4674 46.9164 51.96 47.6942 49.7093"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.6221 30.0731H34.1324C31.5133 30.0731 29.3876 32.2039 29.3876 34.8292C29.3876 37.4546 31.5133 39.5853 34.1324 39.5853H42.6731C42.6731 39.5853 44.2864 40.6602 45.7952 41.678C47.4749 42.8005 49.4392 43.3902 51.4511 43.3902C57.0879 43.3902 61.6524 38.8148 61.6524 33.1741V31.2051C61.6524 29.5595 61.3678 27.9139 60.8268 26.3634C60.21 24.6132 59.2611 22.9961 58.0369 21.5978L57.7522 21.2744C53.0169 15.4054 45.8901 12 38.3648 12H38.2414C35.888 12 33.8003 13.541 33.117 15.8049"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'quickAccess':
      return (
        <>
          <path
            {...props}
            d="M20.0343 6.11652C16.9623 6.04633 12.5 6.189 10 6.189C3 6.18908 3.37273 15.2419 10.5408 15.4045"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.5 2.1001H1V19.1001H18V13.1001"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 1.1001L20 6.1001L15 10.1001"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'reumatologia':
      return (
        <>
          <path
            {...props}
            d="M2 82.5647L22.153 62.4116C23.8384 60.7263 24.0045 56.5485 23.8859 54.151C23.5773 47.7419 27.6364 44.5137 29.298 43.3268C32.4076 41.0955 37.7247 41.048 40.8818 44.2051C44.751 48.0743 44.3949 51.0652 45.653 52.3232C46.9111 53.5813 49.902 53.2015 53.7712 57.0945C56.9283 60.2515 56.8808 65.5687 54.6495 68.6783C53.4626 70.3399 50.2581 74.4227 43.8252 74.0904C41.4278 73.9717 37.2737 74.1141 35.5646 75.8232L15.4354 96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82.5646 2L64.097 20.4677C62.4116 22.153 58.2338 22.3192 55.8364 22.2005C49.4273 21.8919 46.199 25.951 45.0121 27.6126C42.7808 30.7222 42.7333 36.0394 45.8904 39.1965C49.7596 43.0657 52.7505 42.7096 54.0086 43.9677C55.2667 45.2258 54.8869 48.2167 58.7798 52.0859C61.9369 55.2429 67.254 55.1954 70.3636 52.9641C72.0252 51.7773 76.1081 48.5727 75.7758 42.1399C75.6571 39.7424 75.7995 35.5884 77.5086 33.8793L95.9763 15.4116"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.097 40.5969L5.34698 35.5646L18.7823 28.8469L15.4354 15.4353L28.847 18.7823L35.5647 5.34692L40.597 17.0969"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.3792 80.8792L62.4353 92.6292L69.1292 79.2176L82.5646 82.5646L79.2176 69.1292L92.6292 62.4353L80.8792 57.3792"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'transplante':
      return (
        <>
          <path
            {...props}
            d="M81.1304 13.9711V15.9426H69.2609V13.9711H25.7391V15.9426H13.8696V13.9711H5.95652C3.78043 13.9711 2 15.7454 2 17.914V77.0571C2 79.2257 3.78043 81 5.95652 81H89.0435C91.2196 81 93 79.2257 93 77.0571V17.914C93 15.7454 91.2196 13.9711 89.0435 13.9711H81.1304Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.5 48H28"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66 48H84.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63.3053 13.8286V2H31.6531V13.8286"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M50.6444 44.2315V37.9134H44.314V44.2315H37.9835V50.5496H44.314V56.8677H50.6444V50.5496H56.9748V44.2315H50.6444Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.4792 65.8461C57.6918 65.8461 65.9707 57.5833 65.9707 47.3906C65.9707 37.1979 57.6918 28.9351 47.4792 28.9351C37.2666 28.9351 28.9877 37.1979 28.9877 47.3906C28.9877 57.5833 37.2666 65.8461 47.4792 65.8461Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'urologia':
      return (
        <>
          <path
            {...props}
            d="M54.4885 33.9584C51.8911 33.9584 49.7924 36.0571 49.7924 38.6545V68.4936"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.7221 33.9584C39.3195 33.9584 41.4182 36.0571 41.4182 38.6545V68.4936"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.9871 60.8676C29.1377 61.5949 27.1013 61.9897 24.9819 61.9897C12.2857 61.9897 2 51.704 2 39.0079V25.9169C2 12.7013 12.7013 2 25.9169 2H29.3247C36.0364 2 41.4806 7.44417 41.4806 14.1559C41.4806 20.8676 36.0364 26.4572 29.3247 26.4572H30.1351C33.7715 26.4572 36.7221 29.4078 36.7221 33.0442C36.7221 36.6806 33.7715 39.6312 30.1351 39.6312H29.2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.348 60.8676C62.1973 61.5949 64.2129 61.9897 66.3324 61.9897C79.0077 61.9897 89.2727 51.704 89.2727 39.0079V25.9169C89.2727 12.7013 78.5714 2 65.3973 2H61.9895C55.2986 2 49.8544 7.44417 49.8544 14.1559C49.8544 20.8676 55.2778 26.4572 61.9895 26.4572H61.1791C57.5428 26.4572 54.6129 29.4078 54.6129 33.0442C54.6129 36.6806 57.5635 39.6312 61.1791 39.6312H62.1142"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49.7922 97.5845V92.7014C54.6338 90.9975 58.1039 86.3845 58.1039 80.9611C58.1039 74.0832 52.5143 68.4935 45.6363 68.4935C38.7584 68.4935 33.1688 74.0832 33.1688 80.9611C33.1688 86.3845 36.6389 90.9975 41.4805 92.7014V97.5845"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'artroRM':
      return (
        <>
          <path
            {...props}
            d="M17.2535 82C46.8174 82 92.9565 82 92.9565 82C94.0804 82 96 80.6673 96 79.0385V7.96154C96 6.33269 94.0804 5 92.9565 5H5.04348C3.91957 5 2 6.33269 2 7.96154V79.0385C2 80.6673 3.91957 82 5.04348 82H10"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 71H20"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27 71H29"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73 14L80 14"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M87 14H88"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 68V93.375C2 95.3688 3.91957 97 5.04348 97H92.9565C94.0804 97 96 95.3688 96 93.375V68"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.9539 81.6645L43.9575 64.8791C43.9578 63.5209 42.3417 61.7709 41.328 60.8529C38.6218 58.3954 38.9572 55.4589 39.1487 54.3111C39.5031 52.159 41.6269 49.9969 44.1711 49.9963C47.2892 49.9957 48.3506 51.344 49.3645 51.3438C50.3783 51.3436 51.4307 49.9852 54.5584 49.9941C57.1026 49.9935 59.2255 52.1547 59.5789 54.3066C59.77 55.4544 60.1232 58.3907 57.3968 60.8494C56.3827 61.7678 54.7659 63.4994 54.7656 64.8767L54.7812 81.6621"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.0303 5.33603L44.0303 24.4769C44.0303 25.818 42.4342 27.5463 41.4331 28.4529C38.7604 30.8801 39.091 33.7795 39.2798 34.9128C39.6293 37.0378 41.7259 39.1722 44.2381 39.1722C47.3169 39.1722 48.3653 37.8406 49.3664 37.8406C50.3674 37.8406 51.4063 39.1817 54.4946 39.1722C57.0068 39.1722 59.1034 37.0378 59.4528 34.9128C59.6417 33.7795 59.9912 30.8801 57.2996 28.4529C56.2985 27.5463 54.7024 25.8369 54.7024 24.4769L54.7024 5.33603"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.8035 39C67.6808 39.7956 69 41.6754 69 43.8677C69 46.3613 67.2934 48.4506 65 49"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.1965 49C30.3192 48.2044 29 46.3246 29 44.1323C29 41.6387 30.7066 39.5494 33 39"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'audiometria':
      return (
        <>
          <path
            {...props}
            d="M3.37302 42.7407C3.37302 42.7407 -3.83774 17.6464 14.7901 6.89169C14.7901 6.89169 33.7183 -4.31115 51.1443 7.19043C51.1443 7.19043 74.4291 21.3807 61.2094 47.5206C61.2094 47.5206 58.6555 52.1511 54.8999 55.4373C54.8999 55.4373 47.0883 63.354 45.8865 75.453C45.8865 75.453 45.8865 91.2864 30.7138 93.0788C30.7138 93.0788 18.8461 96.0662 15.2407 79.3367"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.0973 37.6621C53.0973 37.6621 57.7542 23.7706 43.6332 15.5552C43.6332 15.5552 31.9157 8.3854 22.9022 15.854C22.9022 15.854 15.2408 22.1275 16.8933 31.8367C16.8933 31.8367 18.095 48.1181 25.456 36.3178C25.456 36.3178 32.0659 25.115 40.6287 38.2596C40.6287 38.2596 45.5861 46.3257 36.4224 49.0143C36.4224 49.0143 28.6107 52.1511 28.9112 64.8477C29.0614 69.1794 21.4 73.0631 19.7475 64.8477C18.5457 59.1716 18.6959 57.8272 18.6959 57.8272"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'bioimpedancia':
      return (
        <>
          <path
            {...props}
            d="M73.4473 22.7815H79.4782C85.4936 22.7815 89.7661 27.6839 88.964 33.6878L82.3162 84.1545C81.5296 90.1429 75.9614 95.0608 69.946 95.0608H22.0386C16.0231 95.0608 10.455 90.1584 9.66838 84.1545L3.02056 33.6878C2.23393 27.6994 6.50642 22.7815 12.5064 22.7815H18.2905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.9923 94.6729V62.373"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.1054 23.1694C66.1054 34.3394 57.0977 43.3995 45.9923 43.3995C34.8869 43.3995 25.8792 34.3394 25.8792 23.1694C25.8792 11.9994 34.8869 2.93924 45.9923 2.93924C57.0977 2.93924 66.1054 11.9994 66.1054 23.1694Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.6658 24.3484L54.1671 15.8778"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.1131 54.9525C24.1131 55.7794 23.44 56.4525 22.6131 56.4525C21.7862 56.4525 21.1131 55.7794 21.1131 54.9525C21.1131 54.1256 21.7862 53.4525 22.6131 53.4525C23.4593 53.4525 24.1131 54.1256 24.1131 54.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.1131 54.9525C34.1131 55.7794 33.44 56.4525 32.6131 56.4525C31.7862 56.4525 31.1131 55.7794 31.1131 54.9525C31.1131 54.1256 31.7862 53.4525 32.6131 53.4525C33.4593 53.4525 34.1131 54.1256 34.1131 54.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.1131 67.9525C24.1131 68.7794 23.44 69.4525 22.6131 69.4525C21.7862 69.4525 21.1131 68.7794 21.1131 67.9525C21.1131 67.1256 21.7862 66.4525 22.6131 66.4525C23.4593 66.4525 24.1131 67.1256 24.1131 67.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.1131 67.9525C34.1131 68.7794 33.44 69.4525 32.6131 69.4525C31.7862 69.4525 31.1131 68.7794 31.1131 67.9525C31.1131 67.1256 31.7862 66.4525 32.6131 66.4525C33.4593 66.4525 34.1131 67.1256 34.1131 67.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.1131 80.9525C24.1131 81.7794 23.44 82.4525 22.6131 82.4525C21.7862 82.4525 21.1131 81.7794 21.1131 80.9525C21.1131 80.1256 21.7862 79.4525 22.6131 79.4525C23.4593 79.4525 24.1131 80.1256 24.1131 80.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.1131 80.9525C34.1131 81.7794 33.44 82.4525 32.6131 82.4525C31.7862 82.4525 31.1131 81.7794 31.1131 80.9525C31.1131 80.1256 31.7862 79.4525 32.6131 79.4525C33.4593 79.4525 34.1131 80.1256 34.1131 80.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.1131 54.9525C61.1131 55.7794 60.44 56.4525 59.6131 56.4525C58.7862 56.4525 58.1131 55.7794 58.1131 54.9525C58.1131 54.1256 58.7862 53.4525 59.6131 53.4525C60.4593 53.4525 61.1131 54.1256 61.1131 54.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.1131 54.9525C71.1131 55.7794 70.44 56.4525 69.6131 56.4525C68.7862 56.4525 68.1131 55.7794 68.1131 54.9525C68.1131 54.1256 68.7862 53.4525 69.6131 53.4525C70.4593 53.4525 71.1131 54.1256 71.1131 54.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.1131 67.9525C61.1131 68.7794 60.44 69.4525 59.6131 69.4525C58.7862 69.4525 58.1131 68.7794 58.1131 67.9525C58.1131 67.1256 58.7862 66.4525 59.6131 66.4525C60.4593 66.4525 61.1131 67.1256 61.1131 67.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.1131 67.9525C71.1131 68.7794 70.44 69.4525 69.6131 69.4525C68.7862 69.4525 68.1131 68.7794 68.1131 67.9525C68.1131 67.1256 68.7862 66.4525 69.6131 66.4525C70.4593 66.4525 71.1131 67.1256 71.1131 67.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.1131 80.9525C61.1131 81.7794 60.44 82.4525 59.6131 82.4525C58.7862 82.4525 58.1131 81.7794 58.1131 80.9525C58.1131 80.1256 58.7862 79.4525 59.6131 79.4525C60.4593 79.4525 61.1131 80.1256 61.1131 80.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.1131 80.9525C71.1131 81.7794 70.44 82.4525 69.6131 82.4525C68.7862 82.4525 68.1131 81.7794 68.1131 80.9525C68.1131 80.1256 68.7862 79.4525 69.6131 79.4525C70.4593 79.4525 71.1131 80.1256 71.1131 80.9525Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'biopsia':
      return (
        <>
          <path
            {...props}
            d="M95.9462 24.8367H93.2352C86.4988 24.8367 74.9155 15.4898 74.9155 15.4898"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62 36.9633C62 40.9837 59.7792 43.2041 55.7127 43.2041H37.8859C32.2791 43.2041 28.9314 45.898 28.9314 50.3469C28.9314 54.7959 32.6282 57.4898 36.0991 57.4898H45.0741H55.8359C60.498 61.5714 66.1459 63.6123 71.9786 63.6123H79.0025C81.4876 63.6123 83.9521 63.2653 86.314 62.5918C88.6964 61.9184 91.1609 61.5714 93.6254 61.5714H95.9668"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49.921 43.2041L80.1116 9.7347C81.9394 7.71429 81.6108 4.57144 79.4133 2.95919C77.5033 1.55103 74.8334 1.81633 73.2314 3.55103L36.4482 43.2653"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M28.993 51.3878L3.05377 79.4694C15.0703 81.4678 23.5721 77.2285 28.9608 72.9506C31.0704 71.2758 31.9877 68.5683 31.7332 65.8868L31.5191 63.6327L37.0438 57.5102"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.6184 56.1225C22.3388 55.8367 19.8331 54.7551 17.9026 51.9184C20.593 47.4694 32.505 26.9796 32.505 26.9796L52.5909 13C54.4804 11.6939 56.8217 11.2245 59.0603 11.7143L64.5234 12.9184"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3 80L40 80"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.7093 79.9388H63.9782"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M76.1933 79.9388H86.4622"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.4404 57.4898V59.9388C38.4404 62.4082 40.5147 63.6123 43.4927 63.6123C46.4707 63.6123 48.7093 62.3878 48.7093 59.9388V57.4898"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M58.9782 59.8571V59.9388C58.9782 62.4082 56.9039 63.6122 53.9259 63.6122C50.9479 63.6122 48.7093 62.3878 48.7093 59.9388"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'broncoscopia':
      return (
        <>
          <path
            {...props}
            d="M29.3434 41.0243L42.8109 33.5196C42.8109 33.5196 47.5721 31.2 51.6531 33.5196L65.2566 41.1607"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.1973 2C52.1973 2 51.6531 16.0542 51.6531 18.2374C51.6531 20.4206 52.0612 24.2411 59.9513 27.9252L69.3377 33.2467"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.4028 2C42.4028 2 42.9469 16.0542 42.9469 18.2374C42.9469 20.4206 42.5388 24.2411 34.6488 27.9252L25.2624 33.2467"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M35.0569 11.8243C32.2002 9.64112 27.9831 8.27663 22.6777 11.9607C22.6777 11.9607 -1.40042 28.7439 2.40856 66.5402C2.40856 66.5402 2.68062 71.9981 8.80219 71.4523L34.6488 64.6299C34.6488 64.6299 41.8586 62.5832 42.4028 53.3047V33.7925"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.5431 11.8243C62.3999 9.64112 66.6169 8.27663 71.9223 11.9607C71.9223 11.9607 96.0004 28.7439 92.1915 66.5402C92.1915 66.5402 91.9194 71.9981 85.7978 71.4523L59.9512 64.6299C59.9512 64.6299 52.7414 62.5832 52.1973 53.3047V33.7925"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cardiologicos':
      return (
        <>
          <path
            {...props}
            d="M22.4644 51.1169L50.33 79L88.1259 41.1793C97.1653 32.1202 97.3091 17.4441 88.4421 8.57221C79.5751 -0.299676 64.931 -0.155652 55.9059 8.88906L50.33 14.4772L44.754 8.88906C35.7146 -0.170054 21.0704 -0.314079 12.2035 8.57221C4.93171 15.8598 3.72453 27.0649 8.52448 35.8504"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 43.5413H28.0548L34.2343 35.1591L42.9145 52.8452L51.2641 25.5815L57.7742 43.6709H68.1214"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'denssiometriaOssea':
      return (
        <>
          <path
            d="M49.0743 11.3747V2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.3742 13.9432L34.6607 6.75159"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.7745 13.9432L63.3582 6.75159"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.1775 32.5642L70.7598 43.7369C70.5001 43.9937 70.3702 44.2505 70.1105 44.5074C67.1239 48.6169 68.0329 54.2674 72.1882 57.3495C76.3435 60.3032 82.057 59.4042 85.1735 55.2947C86.9914 52.7263 87.381 49.5158 86.3421 46.819C89.3287 46.9474 92.3154 45.6632 94.1333 43.0947C97.1199 38.9853 96.2109 33.3347 92.0557 30.2526C87.9004 27.299 82.1868 28.1979 79.0704 32.3074C78.8107 32.5642 78.6808 32.9495 78.4211 33.2063L62.8388 22.0337L63.3582 29.2253L54.5282 26.9137L55.1775 32.5642Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.0503 22.8042L19.4679 33.9768C19.3381 33.5916 19.0784 33.3347 18.8187 33.0779C15.8321 28.9684 9.98868 28.0695 5.83339 31.0231C1.6781 33.9768 0.769135 39.7558 3.75575 43.8653C5.57369 46.4337 8.5603 47.7179 11.5469 47.5895C10.5081 50.4147 10.8976 53.4968 12.7156 56.0653C15.7022 60.1747 21.5456 61.0737 25.7009 58.12C29.8562 55.1663 30.7651 49.3874 27.7785 45.2779C27.6487 45.021 27.3889 44.7642 27.1292 44.5074L42.7116 33.3347L38.4264 30.5095L43.7504 23.5747L35.0503 22.8042Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'ecoDoppler':
      return (
        <>
          <path
            {...props}
            d="M51.5 65.7391L40.107 54.3461L33.4724 54.508C31.5573 54.5547 29.7066 53.8144 28.352 52.4598L26.5496 50.6574C24.6404 48.7482 24.0118 45.9077 25.3164 43.5439C26.8596 40.7477 29.443 36.8141 33.4104 32.8466C37.3779 28.8792 41.3116 26.2957 44.1077 24.7526C46.4716 23.448 49.312 24.0766 51.2212 25.9858L53.0236 27.7882C54.3782 29.1428 55.1185 30.9934 55.0718 32.9086L54.91 39.5432L70.187 54.8202C74.0875 58.7207 73.9301 65.1753 69.8346 69.2707C67.1167 71.9886 63.3598 72.9722 60 72.1864"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.1704 71.6066L78.2206 78.6568C82.6304 83.0666 79.5072 90.6066 73.2709 90.6066H8.67038"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54.1704 37.6066L47.1704 44.6066"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.958 31.9139C18.0807 24.4811 24.2075 18.3543 31.6645 18.2074"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5.48258 32.8955C5.73465 18.0232 18.0232 5.73464 32.8955 5.48257"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'eletroneurofisiologia':
      return (
        <>
          <path
            {...props}
            d="M34.554 27.2432C27.5851 27.2432 22.0099 21.668 22.0099 14.699C22.0099 7.73005 27.5851 2.15488 34.554 2.15488C41.523 2.15488 47.0982 7.73005 47.0982 14.699"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.0982 84.3887C46.9433 88.4153 44.9301 92.4418 41.0584 94.6099C35.1735 98.1718 27.5851 96.1586 24.0231 90.4285C21.0807 85.6277 21.855 79.5879 25.5718 75.7162L32.5408 68.1278"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67.5405 74.6322L68.4697 75.7162C72.0316 79.5879 72.806 85.6277 70.0184 90.4285C66.4565 96.3134 58.868 98.1718 52.9831 94.6099C49.2663 92.2869 47.2531 88.4153 47.0982 84.2339V14.5442C47.0982 7.57518 52.6734 2 59.6424 2C62.4299 2 65.6821 3.23893 67.8503 5.09732"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.5764 15.938C11.1693 17.7964 8.072 21.8229 10.395 30.8051C10.395 30.8051 -7.41461 46.2917 8.84633 62.088C8.84633 62.088 4.20035 82.995 22.0099 84.079"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.0009 6.49109C46.7885 8.65921 47.408 12.8406 45.085 15.7831C42.9169 18.5706 38.7355 19.1901 35.793 16.8671"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.3462 39.013C22.7843 38.0838 20.6161 34.5219 21.5453 31.1148C22.4745 27.5529 26.0365 25.3848 29.4435 26.314"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.6336 42.8846C43.846 40.2519 39.3549 40.5617 37.0319 43.3492C37.0319 43.3492 26.9656 59.3004 19.3772 59.3004"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.116 79.5879C39.3549 77.2649 42.2973 76.3357 44.6203 77.7295C46.3239 78.6587 47.2531 80.3622 47.0982 82.0658"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.9259 70.4508L27.8949 72.9287"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.4348 46.1368C16.4348 46.1368 22.9391 49.2341 27.5851 54.1898"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.8547 20.8937C62.1202 19.6547 67.5405 22.4423 69.5538 27.2432"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70.1733 66.4243C70.483 69.8313 68.7795 73.5481 65.5273 75.8711C63.2043 77.7295 60.4167 78.5038 57.784 78.1941"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.9389 65.6499C56.7 63.3269 52.3637 62.3977 50.0407 63.7915C48.3372 64.7207 46.9434 66.4243 47.0983 68.1278"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M83.8015 30.6502C83.8015 30.6502 101.611 46.1368 85.3502 61.9332C85.3502 61.9332 89.9962 82.8401 72.1866 83.9241"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.7177 52.6412C47.7177 52.6412 60.2619 56.0483 65.6822 46.4466"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.5848 50.6279C62.5848 50.6279 70.9476 57.2872 77.7617 49.8536"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.5007 20.2742C63.0494 15.1636 67.6954 11.4468 73.2705 11.4468C79.9298 11.4468 85.505 16.8671 85.505 23.6813C85.505 26.1591 84.7306 28.3272 83.6466 30.3405"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.408 30.8051C47.408 30.8051 54.2221 36.5351 58.7132 36.5351"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M83.8015 30.6502C83.8015 30.6502 81.014 28.3272 79.775 27.7078"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'endoscopia':
      return (
        <>
          <path
            {...props}
            d="M3.5 40C2.675 40 2 39.3423 2 38.5385V3.46154C2 2.65769 2.675 2 3.5 2H69.5C70.325 2 71 2.65769 71 3.46154V38.5385C71 39.3423 70.325 40 69.5 40H10.2606"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 38V50.25C2 51.2125 2.675 52 3.5 52H69.5C70.325 52 71 51.2125 71 50.25V38"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M83 13L81.2381 13C79.029 13 77.2381 14.7909 77.2381 17L77.2381 37C77.2381 39.2091 75.4472 41 73.2381 41L72 41"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="36.5"
            cy="21.5"
            r="18.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="36.5"
            cy="21.5"
            r="6.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M83 9H84.3411C88.7976 9 92.1195 13.1091 91.1857 17.4667L87 37H83V9Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M93.2494 21L95.8437 23.5943L88.5943 30.8437L92.519 21.7303L93.2494 21Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M85 37V53.8182C85 58.2365 81.4183 61.8182 77 61.8182H9.09091C5.17471 61.8182 2 64.9929 2 68.9091V68.9091C2 72.8253 5.17471 76 9.09091 76H85"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'espirometria':
      return (
        <>
          <rect
            x="7"
            y="7"
            width="22"
            height="65"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="37"
            y="7"
            width="22"
            height="65"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="67"
            y="7"
            width="22"
            height="65"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="2"
            y="72"
            width="92"
            height="5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="2"
            y="2"
            width="92"
            height="5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="7"
            y="55"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="7"
            y="39"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="7"
            y="23"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="37"
            y="55"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="37"
            y="39"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="37"
            y="23"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="67"
            y="55"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="67"
            y="39"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="67"
            y="23"
            width="7"
            height="1"
            rx="0.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="18"
            cy="57"
            r="11"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="48"
            cy="40"
            r="11"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="78"
            cy="23"
            r="11"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'hemodinamica':
      return (
        <>
          <path
            {...props}
            d="M8.5354 14.0792V69.7036"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M89.4645 14.0792V69.7036"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4.62 20.4698H18.2586"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M79.7413 20.4698H93.3799"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.1025 20.4698H43.6581"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54.3273 20.4698H68.8829"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.2019 2H32.4357"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.608 7.90347V55.6184C18.608 58.1976 21.0824 60.3183 23.8189 60.3183C26.5553 60.3183 29.0298 58.2119 29.0298 55.6184V2.3009"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.6953 28.8808H28.9279"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.3831 2H57.6169"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.7891 7.90347V55.6184C43.7891 58.1976 46.2636 60.3183 49 60.3183C51.7365 60.3183 54.2109 58.2119 54.2109 55.6184V2.3009"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.8909 28.8808H54.1235"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.5788 2H82.8126"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68.9848 7.90347V55.6184C68.9848 58.1976 71.4592 60.3183 74.1957 60.3183C76.9322 60.3183 79.4066 58.2119 79.4066 55.6184V2.3009"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69.0721 28.8808H79.3047"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 78V70.0618H96V78"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'mamografiaDigital':
      return (
        <>
          <path
            {...props}
            d="M51.8387 91.957C57.8602 99.2688 65.6022 100.559 65.6022 100.559"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M74.7326 100.534C74.7551 100.534 74.7776 100.534 74.8227 100.534C75.5209 100.511 76.2191 100.42 76.9173 100.307C76.9398 100.307 76.9849 100.307 77.0074 100.284C86.3319 98.2845 91.0392 93.286 93.3366 89.4462C96.152 84.743 96.7151 79.5626 96.0619 76.4272C96.5123 75.6092 97.3907 73.9506 96.8051 72.0875C96.2195 70.2472 94.5303 69.3838 91.7825 69.5201C90.1158 68.4977 89.1473 67.7479 87.8185 66.7482C87.5257 66.521 87.2103 66.271 86.8725 66.0211C84.6602 64.3426 80.9814 61.6672 79 60M60.2052 37.0749C61.3141 39.4666 62.1488 41.4491 64 44"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.11 24C33.11 24.2272 33.11 30.9176 33.11 31.1448C33.11 33.735 33.11 36.1888 31.8037 37.6884C30.9253 38.7108 29.7766 39.3697 28.5603 40.0513C27.5918 40.5966 26.5783 41.1647 25.6323 41.9599C20.1592 46.504 17.7493 54.479 17.2988 60.4318C16.8033 67.089 17.0285 77.904 17.2313 86.5833C17.3439 92.2635 17.2538 106.675 17.2313 100.966"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.2949 43.2776C40.7678 39.3242 35.2722 38.3245 28.5378 40.2103"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M110 52H54V59H110"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.6 17H90.4L96 31H68L73.6 17Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82 39L82 45"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M110 17L54 17"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82 61L82 68"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82 78L82 84"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82 94L82 100"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M110 101H54V108H110"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'medFetal':
      return (
        <>
          <path
            {...props}
            d="M43.4252 46.6924C43.4252 46.6924 40.521 36.8504 43.2639 29.5092C45.9664 22.1681 37.8588 20.1109 32.0101 23.5798C26.9277 26.6454 17.9328 24.8303 15.7546 16.4C7.28403 25.0723 2 36.9311 2 50C2 76.5008 23.4992 98 50 98C76.5412 98 98.0403 76.5008 98.0403 50C98.0403 23.4992 76.5412 2 50 2C39.5126 2 29.7916 5.3479 21.9261 11.0756"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M39.916 54.6387C43.0622 55.042 45.1597 54.8807 48.4269 53.1059"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.0134 59.6403L36.8101 50C35.0756 47.2168 33.0185 46.9345 33.0185 46.9345L22.6118 44.7563C19.7882 44.1109 17.0454 45.563 16.4 48.3866C15.7546 51.2101 17.5698 53.7109 20.3933 54.3563L28.5815 56.2924C28.8235 73.516 40.4 74.8874 45.6034 75.1698C64.3193 76.0975 66.8605 55.1227 66.8605 55.1227C73.0319 54.7193 78.3563 50.9277 79.9698 45.2C82.0672 37.7378 78.437 29.9126 70.1277 27.7345C63.8353 26.121 56.9782 29.3479 52.4605 37.6168C50.484 41.2067 50 45.684 52.8639 49.1529C53.6303 50.0807 54.4773 50.9277 55.4454 51.6538"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'medicinaNuclear':
      return (
        <>
          <path
            {...props}
            d="M59 46.3333H51.6667V39H44.3333V46.3333H37V53.6667H44.3333V61H51.6667V53.6667H59V46.3333Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.0001 48C9.47614 38.6886 4.73666 30.394 7.58293 25.504C9.93293 21.4485 17.4938 21.0093 27.5652 23.5714"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M90.008 67.669C90.6941 69.9383 90.6357 71.9148 89.7307 73.4814C85.9211 80.0404 68.4639 77.1562 48.8611 67.3177"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.9621 36.3088C67.8655 42.736 76.9444 49.9685 82.8705 56.5421"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.3598 57.5999C17.5165 50.3128 27.728 42.0863 40.2054 34.9506C63.5652 21.5731 85.9858 17.0281 90.2791 24.7849C93.8691 31.2613 83.7434 44.2286 66.7509 56.1126M5.12853 68.7655C4.84529 70.4471 5.02418 71.947 5.72482 73.2045C9.15181 79.3867 24.0394 77.7754 41.7289 70.1244"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42 4.52016C43.7481 2.88863 45.6268 2.01459 47.5873 2.00002C52.9458 1.98546 57.7653 8.59899 61 19"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61 80.4082C57.917 90.5533 53.3004 96.9854 48.1567 97C38.7479 97.0292 31.0803 75.7304 31.0004 49.4467C30.9685 36.4071 32.8055 24.5956 35.8087 16"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.0733 10.0728C44.0733 13.5133 41.3 16.295 37.8699 16.295C34.4397 16.295 31.6664 13.5133 31.6664 10.0728C31.6664 6.63222 34.4397 3.85049 37.8699 3.85049C41.3 3.85049 44.0733 6.64686 44.0733 10.0728Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.4068 63.2223C14.4068 66.6628 11.6335 69.4445 8.20342 69.4445C4.77329 69.4445 2 66.6628 2 63.2223C2 59.7817 4.77329 57 8.20342 57C11.6335 57 14.4068 59.7817 14.4068 63.2223Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M93.1755 61.9592C93.1755 65.3997 90.4022 68.1814 86.972 68.1814C83.5419 68.1814 80.7686 65.3997 80.7686 61.9592C80.7686 58.5186 83.5419 55.7369 86.972 55.7369C90.4022 55.7369 93.1755 58.5186 93.1755 61.9592Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'medSono':
      return (
        <>
          <path
            {...props}
            d="M27.1277 6.76355C22.9993 8.98654 19.0297 11.6859 15.6952 15.1791C-2.56506 33.4394 -2.56506 62.9734 15.6952 81.2336C33.9554 99.4939 63.4894 99.4939 81.7497 81.2336C85.2429 77.7404 88.1011 73.9295 90.1653 69.8011"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.1277 6.76355C17.9182 24.3887 20.7763 46.6185 35.5433 61.3855C50.3103 76.1525 72.5402 79.0106 90.1653 69.8011"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.817 2H67.7766L46.9758 27.088H67.7766"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M78.7327 27.2468H93.8173L78.8915 45.0307H93.6585"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.6617 41.3786H67.3003L56.8205 54.0814H67.1415"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'noUser':
      return (
        <>
          <circle cx="82.2857" cy="71.7144" r="41.4286" fill="#0166B3" />
          <circle
            cx="82.2857"
            cy="71.7144"
            r="39.9286"
            stroke="white"
            strokeWidth="3"
          />
          <path
            {...props}
            d="M104.029 81.7466H64.1487V90.5604H104.029V81.7466Z"
            stroke="white"
          />
          <path
            {...props}
            d="M64.1487 56.0905H74.6497C77.5586 56.0905 79.7984 56.8759 81.3401 58.4467C82.6491 59.7556 83.3181 61.53 83.3181 63.7408V63.799C83.3181 65.6606 82.8527 67.2023 81.9509 68.3659C81.0492 69.5294 79.8566 70.4021 78.4021 70.9547L84.0162 79.2159H78.0822L73.1662 71.7983H69.1811V79.1868H64.1487V56.0905ZM74.3007 67.2896C75.5515 67.2896 76.5114 66.9987 77.1804 66.4169C77.8495 65.8352 78.1694 65.0498 78.1694 64.0607V64.0026C78.1694 62.8972 77.8204 62.0827 77.1222 61.53C76.4241 60.9774 75.4351 60.7156 74.2134 60.7156H69.1811V67.2896H74.3007Z"
            stroke="#63CDF6"
          />
          <path
            {...props}
            d="M84.598 56.0905H89.6594V65.2243H98.9677V56.0905H104.029V79.1868H98.9677V69.9076H89.6594V79.1868H84.598V56.0905Z"
            stroke="#63CDF6"
          />
          <path
            {...props}
            d="M66.243 83.5792H67.9011C68.3083 83.5792 68.6574 83.6374 68.9774 83.7828C69.2973 83.9282 69.5882 84.1028 69.8209 84.3355C70.0536 84.5682 70.2573 84.83 70.3736 85.15C70.49 85.4699 70.5772 85.7899 70.5772 86.139V86.1681C70.5772 86.5171 70.5191 86.8662 70.3736 87.1571C70.2573 87.477 70.0536 87.7388 69.8209 87.9716C69.5882 88.2043 69.2973 88.3788 68.9774 88.5242C68.6574 88.6697 68.2792 88.7279 67.9011 88.7279H66.243V83.5792ZM66.5048 83.8119V88.4661H67.9302C68.2792 88.4661 68.6283 88.4079 68.9192 88.2915C69.2101 88.1752 69.4719 88.0006 69.7046 87.797C69.9082 87.5934 70.0827 87.3316 70.1991 87.0698C70.3154 86.7789 70.3736 86.488 70.3736 86.1681V86.139C70.3736 85.819 70.3154 85.5281 70.1991 85.2372C70.0827 84.9463 69.9082 84.7136 69.7046 84.51C69.501 84.3064 69.2392 84.1319 68.9483 84.0155C68.6574 83.8992 68.3083 83.841 67.9593 83.841H66.5048V83.8119Z"
            stroke="#0166B3"
          />
          <path
            {...props}
            d="M73.1661 83.5792H73.3988V88.6988H73.1661V83.5792Z"
            stroke="#0166B3"
          />
          <path
            {...props}
            d="M78.4893 88.786C78.0821 88.786 77.733 88.7279 77.413 88.5824C77.0931 88.437 76.8313 88.2624 76.6277 88.0006C76.424 87.7679 76.2495 87.477 76.1331 87.1571C76.0168 86.8371 75.9586 86.488 75.9586 86.139V86.1099C75.9586 85.7608 76.0168 85.4409 76.1331 85.1209C76.2495 84.8009 76.424 84.51 76.6277 84.2773C76.8313 84.0446 77.1222 83.841 77.413 83.6955C77.733 83.5501 78.0821 83.4628 78.4602 83.4628C78.6639 83.4628 78.8384 83.4919 79.0129 83.521C79.1874 83.5501 79.3329 83.5792 79.4783 83.6374C79.6238 83.6955 79.7692 83.7537 79.8856 83.841C80.0019 83.9282 80.1474 84.0155 80.2637 84.1319L80.1183 84.3355C80.0019 84.2482 79.8856 84.161 79.7692 84.0737C79.6529 83.9864 79.5365 83.9282 79.3911 83.8701C79.2456 83.8119 79.1293 83.7828 78.9547 83.7537C78.8093 83.7246 78.6348 83.6955 78.4311 83.6955C78.0821 83.6955 77.7912 83.7537 77.5003 83.8992C77.2385 84.0446 76.9767 84.2191 76.8022 84.4228C76.5986 84.6555 76.4531 84.8882 76.3368 85.1791C76.2204 85.4699 76.1913 85.7608 76.1913 86.0808V86.1099C76.1913 86.4299 76.2495 86.7498 76.3368 87.0407C76.4531 87.3316 76.5986 87.5934 76.7731 87.797C76.9767 88.0297 77.2094 88.1752 77.5003 88.3206C77.7912 88.437 78.1112 88.5242 78.4602 88.5242C78.6348 88.5242 78.8093 88.4951 78.9838 88.4661C79.1584 88.437 79.3038 88.3788 79.4492 88.3206C79.5947 88.2624 79.7401 88.2043 79.8565 88.117C79.9728 88.0297 80.0892 87.9425 80.2055 87.8843V86.3135H78.4021V86.0808H80.4673V87.9716C80.2346 88.2043 79.9437 88.3788 79.5947 88.5242C79.2747 88.6988 78.8966 88.786 78.4893 88.786Z"
            stroke="#0166B3"
          />
          <path
            {...props}
            d="M83.2598 83.5792H83.4925V88.6988H83.2598V83.5792Z"
            stroke="#0166B3"
          />
          <path
            {...props}
            d="M87.914 83.8119H86.1105V83.5792H89.9793V83.8119H88.1758V88.6988H87.9431V83.8119H87.914Z"
            stroke="#0166B3"
          />
          <path
            {...props}
            d="M93.5863 83.5501H93.819L96.2334 88.6987H95.9425L95.2444 87.2152H92.1028L91.4047 88.6987H91.1429L93.5863 83.5501ZM95.1571 86.9825L93.7027 83.841L92.2482 86.9825H95.1571Z"
            stroke="#0166B3"
          />
          <path
            {...props}
            d="M98.6186 83.5792H98.8513V88.4661H101.906V88.6988H98.5895V83.5792H98.6186Z"
            stroke="#0166B3"
          />
          <path
            {...props}
            d="M65.4868 51H62.2288H62.1416H59V57.4577H62.2288V54.2288H65.4868V51Z"
            stroke="white"
          />
        </>
      );
    case 'otorrino':
      return (
        <>
          <path
            {...props}
            d="M76.7449 73.5942C76.2655 73.2746 66.677 66.4028 62.8416 74.8726C62.8416 74.8726 58.8464 84.7808 47.6598 84.9406H47.0206C35.834 84.7808 31.8388 74.8726 31.8388 74.8726C27.8436 66.5626 17.9354 73.5942 17.9354 73.5942"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.657 45.7875C16.657 45.7875 -8.11332 62.2478 6.74886 81.4248C6.74886 81.4248 12.502 89.7348 22.2503 82.8631"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M78.343 45.7875C78.343 45.7875 103.113 62.2478 88.2511 81.4248C88.2511 81.4248 82.498 89.7348 72.7497 82.8631"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63.321 73.754C63.321 73.754 67.476 66.5626 63.9603 47.3856C63.9603 47.3856 60.4445 32.3636 58.367 2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'raioX':
      return (
        <>
          <path
            {...props}
            d="M91 2H6C3.79086 2 2 3.79086 2 6V92C2 94.2091 3.79086 96 6 96H91C93.2091 96 95 94.2091 95 92V6C95 3.79086 93.2091 2 91 2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 88H24.7006"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32 88H34.7006"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.1701 33C20.1701 33 17.3538 45.6605 34.6375 42.4906C35.737 42.2818 37.7431 41.7124 40 41.1429"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.5394 17C26.5394 17 22.0328 28.1558 39.071 26.9017C39.3873 26.883 39.7035 26.8455 40 26.8081"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.1711 50C20.1711 50 17.3384 62.6605 34.7227 59.4906C35.8286 59.3008 37.7882 58.7314 40 58.1619"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.454 67C29.454 67 22.8653 76 37.7388 76H40"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M76.833 33C76.833 33 79.5974 45.6605 62.6325 42.4906C60.1521 42.0351 53.0897 39.6434 49 39.6434"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70.4776 17C70.4776 17 74.842 28.1558 58.3414 26.9017C55.2212 26.6583 53.1539 25.4978 49 25.4978"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M76.833 50C76.833 50 79.5974 62.6605 62.6325 59.4906C60.1521 59.0351 53.0897 56.6434 49 56.6434"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67.596 67C67.596 67 73.9579 76 59.5967 76H49"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49 21V81"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'ressonancia':
      return (
        <>
          <path
            {...props}
            d="M77.5544 53.909H77.5559V35.7578C77.5559 26.4354 73.7447 17.9955 67.5819 11.8867C61.4191 5.77786 52.9047 2 43.5 2C24.6905 2 9.44403 17.113 9.44403 35.7578V53.909H9.44558"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.7733 83.5553C70.177 77.9354 77.2953 67.0954 77.5482 54.5856C77.5528 54.3611 77.5559 54.1351 77.5559 53.909C77.5559 53.9044 77.5559 53.8983 77.5559 53.8937C77.5559 35.2488 62.3095 20.1343 43.5 20.1343C24.6905 20.1343 9.44403 35.2488 9.44403 53.8937C9.44403 53.8983 9.44403 53.9044 9.44403 53.909C9.44403 54.1351 9.44713 54.3611 9.45179 54.5856C9.70463 67.0954 16.8229 77.9354 27.2266 83.5553"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.2267 68.8037C23.7489 65.0381 21.5835 60.0609 21.4517 54.5856C21.4455 54.4072 21.4439 54.2273 21.4439 54.0474C21.4439 48.3599 23.6357 43.1797 27.2267 39.2912C31.0208 35.1812 36.377 32.5135 42.3645 32.2121C42.7415 32.1937 43.12 32.1844 43.5 32.1844C43.88 32.1844 44.2585 32.1937 44.6354 32.2121C50.623 32.5135 55.9792 35.1812 59.7733 39.2912C63.3643 43.1797 65.5561 48.3599 65.5561 54.0474C65.5561 54.2273 65.5545 54.4072 65.5483 54.5856C65.4165 60.0609 63.251 65.0381 59.7733 68.8037"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.4908 70.9342L29.4883 70.9317"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 96.7694V61.1419C2 57.5347 4.9767 54.5856 8.61419 54.5856H9.45182"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.5482 54.5856H78.3858C82.0233 54.5856 85 57.5347 85 61.1419V96.7694"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.6355 32.2121H42.3646"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.2266 96.7694V87.4177V74.7726V66.6157V63.4452V57.5101V48.732V39.2912"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.7733 96.7694V78.4182V68.8037V54.5856V39.2912"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.5001 63.6481C40.2147 63.6481 37.5513 61.0081 37.5513 57.7515V51.5996C37.5513 48.343 40.2147 45.7029 43.5001 45.7029C46.7854 45.7029 49.4488 47.5234 49.4488 51.5996V57.7515C49.4488 61.0081 46.7854 63.6481 43.5001 63.6481Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.1401 97V80.9205C27.1401 74.3365 33.2147 69 40.7094 69H45.7503C53.245 69 59.3195 74.3365 59.3195 80.9205V97"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.5511 81.4919V96.7694"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.4474 96.7694V81.4919"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.5 32.2121V20.1343"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'tomografia':
      return (
        <>
          <path
            {...props}
            d="M15.0692 65.8271C8.54179 59.0836 4.52161 49.8905 4.52161 39.7753C4.52161 19.0692 21.3084 2.29689 42 2.29689C62.6916 2.29689 79.4784 19.0692 79.4784 39.7753C79.4784 49.9482 75.4294 59.1701 68.8588 65.9136"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.1038 50.4093C22.245 47.2969 21.1787 43.6514 21.1787 39.7753C21.1787 28.2767 30.5014 18.9539 42 18.9539C53.4986 18.9539 62.8213 28.2767 62.8213 39.7753C62.8213 43.709 61.7262 47.3833 59.8386 50.5246"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.4323 87.5274V96.5476"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.5821 87.5274V96.5476"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.2882 48.781L16.121 77.5274"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.7118 48.781L67.879 77.5274"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37.4467 10.8848H46.5677"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71 35L71 36"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71 42L71 43"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68.5418 86.879H15.4583V79.7753C15.4583 77.4842 17.3314 75.611 19.6225 75.611H64.3776C66.6686 75.611 68.5418 77.4842 68.5418 79.7753V86.879Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.93948 79.9194H2L6.2219 50.5101"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M74.0605 79.9194H82L77.7925 50.5101"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'ultrasonografia':
      return (
        <>
          <path
            {...props}
            d="M3.54348 41C2.69457 41 2 40.325 2 39.5V3.5C2 2.675 2.69457 2 3.54348 2H71.4565C72.3054 2 73 2.675 73 3.5V39.5C73 40.325 72.3054 41 71.4565 41H10.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 39V51.25C2 52.2125 2.69457 53 3.54348 53H71.4565C72.3054 53 73 52.2125 73 51.25V39"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M88.2314 14.4297C84.0364 14.4297 81.2397 15.7615 81.2397 15.7615V19.7568L84.0364 22.4203V29.0791C84.0364 31.2898 85.9102 33.0744 88.2314 33.0744C90.5527 33.0744 92.4265 31.2898 92.4265 29.0791V22.4203L95.2232 19.7568V15.7615C95.2232 15.7615 92.4265 14.4297 88.2314 14.4297Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M84.3471 8.99174C86.4883 6.92011 89.9608 6.92011 92.1157 8.99174"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M80.4628 5.10744C84.749 0.964187 91.7139 0.964187 96 5.10744"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M88.2314 33.5V58.0893C88.2314 61.0079 85.8211 63.3719 82.8452 63.3719H43.4193C40.4434 63.3719 38.0331 61.0079 38.0331 58.0893V54.1273"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47.4341 10C44.6141 11.6277 41.1745 12.5831 37.5 12.5831C33.8255 12.5831 30.3859 11.6277 27.5659 10L14 26.9138C20.7082 30.7531 28.7836 33 37.5 33C46.2164 33 54.2918 30.7531 61 26.9138L47.4341 10Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'urodinamica':
      return (
        <>
          <path
            {...props}
            d="M62 12V8C62 4.68629 59.3137 2 56 2H41C37.6863 2 35 4.68629 35 8V12"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49.8766 12H38.6197C34.0039 12 29.9878 15.1592 28.9009 19.6452L23 44H75L69.0991 19.6452C68.0122 15.1592 63.9961 12 59.3803 12H59.1234"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.5 52H15C13.8954 52 13 51.1046 13 50V46C13 44.8954 13.8954 44 15 44H83C84.1046 44 85 44.8954 85 46V50C85 51.1046 84.1046 52 83 52H62"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63 52V44H34V52"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34 91H63"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M35 52L45.5 62.5M62 52L51.5 62.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 32C2 29.7909 3.79086 28 6 28H30L27.76 36H6C3.79086 36 2 34.2091 2 32V32Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68 28H92C94.2091 28 96 29.7909 96 32V32C96 34.2091 94.2091 36 92 36H70.24L68 28Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18 87C18 84.7909 19.7909 83 22 83H41V91H22C19.7909 91 18 89.2091 18 87V87Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56 83H75C77.2091 83 79 84.7909 79 87V87C79 89.2091 77.2091 91 75 91H56V83Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46 63V70H51V63"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27 52V83M70 52V83"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 36H25L23.5 42H17V36Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81 36H73L74.5 42H81V36Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'vascular':
      return (
        <>
          <path
            {...props}
            d="M66.7937 19.9126C54.6747 20.2135 42.6146 25.0205 33.495 34.3815C15.0024 53.3635 15.3994 83.7653 34.3815 102.258C53.3924 120.779 83.7942 120.382 102.287 101.4C120.779 82.4176 120.382 52.0158 101.371 33.495C96.7648 29.0071 91.486 25.6222 85.8707 23.3555"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.8708 20.8905V37.521L95.8708 71.8905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M85.8708 58.8905L101.871 56.8905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M78.8708 51.8905L76.8708 67.8905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.8708 37.8905L66.8708 80.0215L86.8708 99.8905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M80.6266 91.7448L88.0051 91.3891"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M74.8708 88.8905L70.8708 101.891"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67.0615 80.5528L52.3641 95.2502"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.8708 42.8905L56.8708 47.8905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.8708 58.8905L50.8708 73.8905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.8707 37.8905L33.8708 74.8905"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cases':
      return (
        <>
          <path
            {...props}
            d="M90.125 82.0001H7.875C4.64375 82.0001 2 79.3334 2 76.0741V25.7038C2 22.4445 4.64375 19.7778 7.875 19.7778H90.125C93.3563 19.7778 96 22.4445 96 25.7038V76.0741C96 79.3334 93.3563 82.0001 90.125 82.0001Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.3125 13.8519V4.96296C34.3125 3.33333 35.6344 2 37.25 2H60.75C62.3656 2 63.6875 3.33333 63.6875 4.96296V13.8519"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.5 25.7037V82"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M72.5 25.7037V82"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'centerSearch':
      return (
        <>
          <path
            {...props}
            d="M73.2104 33.6315H55.4177"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.2104 25.7236H55.4177"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.2104 17.8158H55.4177"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.2104 9.90784H55.4177"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.8092 33.6315H39.6019"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.8092 25.7236H39.6019"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.8092 17.8158H39.6019"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.8092 9.90784H39.6019"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.5164 2.05931H13.7037V41.5987H39.6218C43.9909 41.5987 47.3913 45.1375 47.3913 49.5066L47.3122 9.90788C47.3122 5.53878 51.0289 2 55.398 2H81.1184V41.3812L55.2201 41.6382C50.851 41.6382 47.3913 45.177 47.3913 49.5461V53.5001"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.4012 51.4837H81.0788L81.1184 41.3616"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.7037 41.5988V51.4836H47.4704"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.7236 69.2764L12.2605 65.0457C11.9441 64.9073 11.6476 64.7096 11.3906 64.512C9.94741 63.3455 9.4334 61.2697 10.4021 59.53C11.4104 57.6914 13.763 57.0785 15.6806 57.9286L29.6776 61.3686H30.6858C37.7634 61.3686 43.5163 67.1018 43.5163 74.1991V85.0922"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5.12361 43.6154L2 48.024V62.4756C2 64.6701 2.90941 66.7657 4.53052 68.2682L16.7284 77.7576L25.7236 82.0674V87.0691"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.90784 60.4195V50.9894H13.7036"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19.7927 93V87.0691H43.5164V93"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69.2169 69.2764L82.6801 65.0457C82.9964 64.9073 83.2929 64.7096 83.5499 64.512C84.9931 63.3455 85.5071 61.2697 84.5384 59.53C83.5302 57.6914 81.1776 57.0785 79.2599 57.9286L65.263 61.3686H64.2547C57.1772 61.3686 51.4242 67.1018 51.4242 74.1991V87.0692"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M89.8169 43.6154L92.9406 48.024V62.4756C92.9406 64.6701 92.0311 66.7657 90.41 68.2682L78.2121 77.7576L69.2169 82.0674V87.0691"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M85.0327 60.4195V50.9894H81.0787"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M75.1478 93V87.0691H51.4242V93"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'graduation':
      return (
        <>
          <path
            {...props}
            d="M100 46.8788V15.9208L51.0114 2L2 16.0118L51.0114 31.9799L98.2855 16.6487"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24.494 34.2089V46.4693C30.6433 52.2696 40.3359 56.0001 50.9886 56.0001C61.6412 56.0001 71.3567 52.2696 77.4831 46.4693V24.0413"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'dorNumber':
      return (
        <>
          <path
            {...props}
            d="M95.7391 88.24H2V2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 75.6195H10.3324"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 62.9991H10.3324"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 50.3784H10.3324"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 37.7581H10.3324"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 25.1375H10.3324"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 12.5172H10.3324"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23 76V31H38V76"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46 76V12H60V76"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69 76V50H84V76"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'infra':
      return (
        <>
          <path
            {...props}
            d="M45 93.9565V70.9565H15V93.9565H45Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.4605 92.9116V54.248H15.3024V70.9674"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M78 93.9565L2 93.9565"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.3024 57.3829V2H78V85.6868"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37 93.9565V80.9565H21V93.9565"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 93.9565V60.9565H2V93.9565"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29 80.9565V93.9565"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.8419 41.7086V45.8885"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.3814 41.7086V45.8885"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.921 41.7086V45.8885"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.4605 41.7086V45.8885"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.8419 31.2589V35.4388"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.3814 31.2589V35.4388"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.921 31.2589V35.4388"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.4605 31.2589V35.4388"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.8419 20.8093V24.9892"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.3814 20.8093V24.9892"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.921 20.8093V24.9892"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.4605 20.8093V24.9892"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.8419 10.3596V14.5395"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.3814 10.3596V14.5395"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.921 10.3596V14.5395"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.4605 10.3596V14.5395"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.8419 60.5177V64.6975"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M40.3814 60.5177V64.6975"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.921 60.5177V64.6975"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.921 70.9674V75.1473"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M52.921 81.417V85.5968"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'inovation':
      return (
        <>
          <path
            {...props}
            d="M47 2V18.3556"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.1727 15.1661L26.75 26.7377"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 46.9778H18.3636"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.1727 78.7895L26.75 67.2179"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M78.8273 78.7895L67.2501 67.2179"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M92 46.9778H75.6364"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M78.8273 15.1661L67.2501 26.7377"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M55.1818 91.9556H53.1364L51.0909 94H47H42.9091L40.8636 91.9556H38.8182"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.7274 79.689H59.2728"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.7727 85.8221H57.2273"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.2273 75.6V71.5111C57.2273 67.8107 58.5159 64.4169 61.0728 61.8C64.9387 57.8542 67.4546 52.9884 67.4546 46.9778C67.4546 35.6924 58.2909 26.5333 47 26.5333C35.7091 26.5333 26.5455 35.6924 26.5455 46.9778C26.5455 52.9884 29.0614 57.8542 32.9273 61.8C35.4841 64.4169 36.7727 67.8107 36.7727 71.5111V75.6"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M47 75.5999V59.2444"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.9091 55.1556L47 59.2445L51.0909 55.1556"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.9069 12.9786L36.0364 20.5431"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.9841 32.8916L20.5523 36.0196"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.9841 61.064L20.5523 57.936"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.0159 61.064L73.4478 57.936"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.0159 32.8916L73.4478 36.0196"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61.0932 12.9786L57.9637 20.5431"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'openTalks':
      return (
        <>
          <path
            {...props}
            d="M53.9348 30.8143C53.9348 35.6743 49.9904 39.6187 45.1304 39.6187"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.8913 78.9565H31.0435C27.152 78.9565 24 75.8045 24 71.913V54.5861C24 50.8882 26.3243 47.5778 29.7933 46.31L39.8478 43.2989V37.8226C37.7172 36.2202 36.3261 33.6845 36.3261 30.8143V25.9191C36.3261 21.3232 39.6893 17.2204 44.2676 16.7802C49.515 16.2695 53.9348 20.3724 53.9348 25.5317V30.8143C53.9348 33.6845 52.5437 36.2026 50.413 37.8226V43.2989L60.5028 46.3804C63.9541 47.6482 66.2609 50.9587 66.2609 54.6389"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.8043 58.9883V70.1522H53.9348"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.0435 78.9565V86"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.1538 34.5455H69.7908V40L75.3846 34.5455H90.6154C91.3769 34.5455 92 33.9318 92 33.1818V11.3636C92 10.6136 91.3769 10 90.6154 10H57.3846C56.6231 10 56 10.6136 56 11.3636V15.4545"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70.8215 79.5728L76.1922 61.8584L75.8752 61.4006L56.5761 61.3478L49.2509 85.7182L49.5326 86H65.0283"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M72.2478 86H65.2043V80.8407L66.613 78.9565H75.0652V81.7739L72.2478 86Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23 56H8C4.68629 56 2 53.3137 2 50V8C2 4.68629 4.68629 2 8 2H80C83.3137 2 86 4.68629 86 8V9.5M67 56H80C83.3137 56 86 53.3137 86 50V44.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'papers':
      return (
        <>
          <path
            {...props}
            d="M4 66.7887C2.9 66.7887 2 65.802 2 64.5959V11.9675C2 10.7614 2.9 9.77466 4 9.77466H13.0141M13.0141 66.7887H92C93.1 66.7887 94 65.802 94 64.5959V11.9675C94 10.7614 93.1 9.77466 92 9.77466H82.9859"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.3161 11.3877C51.6023 5.1439 58.4158 3.43506 65.5031 3.43506H75.8985V47.0762H65.5031C58.4158 47.0762 51.6023 48.796 48.3161 55.0398"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.0213 3.42395H20.7337V47.0651H31.1291C38.2164 47.0651 45.0408 48.7849 48.3161 55.0287"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.3161 11.3877C45.8733 6.73224 41.4479 4.59619 36.4309 3.8075"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.3161 11.8915V53.3528"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M35.9818 15.4407L31.7316 12.2092L27.4923 15.4407V2H35.9818V15.4407Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82.6462 9.75549V53.6267H57.4627C57.4627 53.6267 56.0606 56.902 54.3299 56.902C53.8917 56.902 42.7404 56.902 42.3023 56.902C40.5715 56.902 39.1694 53.6267 39.1694 53.6267H13.9859V9.75549"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.493 90.1128H30.507"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="39.5775"
            y="75.8591"
            width="16.8451"
            height="14.2535"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 62.9015V74.2395C2 75.1304 2.9 75.8592 4 75.8592H92C93.1 75.8592 94 75.1304 94 74.2395V62.9015"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'posGraduation':
      return (
        <>
          <path
            {...props}
            d="M90.5652 67.5227H99V2H2V67.5227H48.3913"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33.6304 18.9091H67.3696"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M39.9565 27.3636H61.0435"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.4348 18.9091V10.4546H18.8696"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M90.5652 18.9091V10.4546H82.1304"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.4348 50.6136V59.0682H18.8696"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69.4783 73.8637C79.9597 73.8637 88.4565 65.3469 88.4565 54.841C88.4565 44.335 79.9597 35.8182 69.4783 35.8182C58.9969 35.8182 50.5 44.335 50.5 54.841C50.5 65.3469 58.9969 73.8637 69.4783 73.8637Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.6957 50.6137V44.2728H65.2609V50.6137H58.9348V59.0683H65.2609V65.4092H73.6957V59.0683H80.0217V50.6137H73.6957Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.9131 73.8636V95L69.4783 88.6591L61.0435 95V73.8636"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'research':
      return (
        <>
          <path
            {...props}
            d="M38.9821 23.7536C42.9385 23.267 47.0642 22.9919 51.338 22.9919C78.2079 22.9919 100 33.4014 100 46.2651C100 55.0666 89.8021 62.7255 74.7381 66.682"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63.5035 68.7976C59.6105 69.2843 55.5272 69.5381 51.338 69.5381C24.4681 69.5381 2.67599 59.1287 2.67599 46.265C2.67599 37.6539 12.4296 30.1431 26.9435 26.1232"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.4619 86.6967C37.8608 90.2723 31.6616 91.0975 27.007 88.4105C15.8782 81.9786 17.7401 57.9015 31.175 34.6284C36.951 24.6421 43.9118 16.4119 50.8514 10.8052"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.2453 4.81767C66.0847 2.13068 71.501 1.70753 75.669 4.11947C86.7978 10.5513 84.9359 34.6284 71.501 57.9016C65.7039 67.9513 58.6796 76.2239 51.6765 81.8517"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.2932 45.9475C17.4862 26.8847 17.7824 9.45102 27.007 4.11935C38.1358 -2.31249 58.0449 11.3552 71.501 34.6283"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77.404 46.6458C85.1899 65.6874 84.8725 83.0999 75.669 88.4104C64.5403 94.8423 44.61 81.1746 31.175 57.9015C30.6038 56.9282 30.0537 55.9338 29.5459 54.9606"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.338 56.8438C57.1804 56.8438 61.9167 52.1076 61.9167 46.2651C61.9167 40.4226 57.1804 35.6864 51.338 35.6864C45.4955 35.6864 40.7593 40.4226 40.7593 46.2651C40.7593 52.1076 45.4955 56.8438 51.338 56.8438Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'specialization':
      return (
        <>
          <path
            {...props}
            d="M2 30.6086C2 46.4047 14.9319 59.2173 30.875 59.2173C46.8181 59.2173 59.75 46.4047 59.75 30.6086H2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.75 24.4783C59.75 12.2174 49.4375 8.13043 45.3125 8.13043C41.1875 8.13043 41.1875 10.1739 37.0625 16.3043C32.9375 22.4348 18.5 22.4348 21.5937 16.3043C23.9037 11.727 26.75 2 42.2187 2C58.7187 2 68 12.8509 68 28.5652C68 53.087 51.5 67.3913 30.875 67.3913H21.5937"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.875 67.3914V85.7827"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.875 85.7826C22.625 85.7826 16.4375 89.8695 16.4375 96H45.3125C45.3125 89.8695 39.125 85.7826 30.875 85.7826Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37.0625 75.5652C46.0962 75.5652 55.625 83.8617 55.625 95.9796C62.5962 85.3535 57.2544 74.5435 49.8706 70.1091"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.3881 58.2366C15.6744 58.2366 12.3125 62.8753 12.3125 67.3914C12.3125 71.9074 16.0044 75.5653 20.5625 75.5653H24.6875"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'studentPortal':
      return (
        <>
          <path
            {...props}
            d="M14.2857 95.963L12.2381 73.556H73.6667L71.6191 95.963"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 79H68"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.6667 57.2397V63.3711H35.7857L42.9524 56.2416L50.1191 63.3711H55.2381V57.2601"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.1429 45.038V54.2045L74.6905 63.9413C80.2395 66.0598 83.9048 71.356 83.9048 77.2633V95.9629"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.9524 47.2991C52.0029 47.2991 59.3333 40.0066 59.3333 31.0031V18.333C59.3333 9.32944 52.0029 2.03699 42.9524 2.03699C33.9019 2.03699 26.5714 9.32944 26.5714 18.333V31.0031C26.5714 36.666 29.4586 41.6566 33.8814 44.5899L34.7619 45.201V54.3471L11.2757 63.9617C5.68571 66.0599 2 71.3764 2 77.3041V95.963"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48 96C48 93.2386 45.7614 91 43 91C40.2386 91 38 93.2386 38 96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'teacher':
      return (
        <>
          <path
            {...props}
            d="M88.4734 33.3876V65.0484"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.3915 65.0483V23.4943C11.3915 20.3924 13.9195 17.8645 17.0213 17.8645H33.9108"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.41388 71.2522C2.41388 71.2522 4.05363 79 9.49213 79H90.3591C95.8113 79 97.4511 71.2522 97.4511 71.2522H2.41388Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67 14.5C67 15.325 66.325 16 65.5 16C64.675 16 64 15.325 64 14.5C64 13.675 64.675 13 65.5 13C66.325 13.025 67 13.675 67 14.5Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M77 14.5C77 15.325 76.325 16 75.5 16C74.675 16 74 15.325 74 14.5C74 13.675 74.675 13 75.5 13C76.325 13.025 77 13.675 77 14.5Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M87 14.5C87 15.325 86.325 16 85.5 16C84.675 16 84 15.325 84 14.5C84 13.675 84.675 13 85.5 13C86.325 13.025 87 13.675 87 14.5Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.6834 8.92794V2H93.9939V27.5664H66.1318"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M75.1915 27.6211L68.8101 35.2596"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56 43.15L65.15 46.44C68.04 47.37 70 50.06 70 53.1V63"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44 43.21L34.87 46.44C31.97 47.37 30 50.07 30 53.11V63"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46 41.57V38.08L45.57 37.78C43.41 36.34 42 33.89 42 31.11V25C42 20.58 45.58 17 50 17C54.42 17 58 20.58 58 25V31.11C58 34.469 55.9325 37.3428 53 38.529"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37 54V63"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63 54V63"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54 38.04V42H56V45L50 60L44 45V42.04H46"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M50 44.5V59"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'themes':
      return (
        <>
          <path
            {...props}
            d="M16.0057 97C4 90.5 2 77.7728 2 69.5946C2 57.5337 8.90919 44.812 17.8578 40.7022C14.8819 45.8859 16.0057 53 20 55.5C26.2332 59.4013 38.7876 55.5163 37 46C35.4179 37.5775 29.6069 38 27.847 28.9098C25.3081 15.7957 38.1276 6.275 50.0105 2C40.5624 9.47609 43.6424 19.7815 60.3327 34.9815C71.5705 45.2043 79 55.8196 79 68.087C79 77.0707 74 92 60.2703 97"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.2072 97.1087C65.0486 82.487 52.4789 75.0109 55.4756 62C48.4208 66.0065 46.2981 71.087 44.8205 76.4359C43.3429 81.7848 40.2 86.5757 33.2289 86.6587C28.0262 86.7206 25.4664 82.6728 23.7599 77.3652C19.3689 87.7946 24.0721 93.1641 28.2967 97.1087"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'units':
      return (
        <>
          <path
            {...props}
            d="M16.8831 75.4075C8.03077 77.2437 2 80.8726 2 85.0698C2 91.1033 14.5354 96 30 96C45.4646 96 58 91.1033 58 85.0698C58 80.8726 51.9692 77.2437 43.1169 75.4075"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="30"
            cy="30"
            r="28"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30 58.5V84.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'voluntary':
      return (
        <>
          <path
            {...props}
            d="M11.9443 39.4285V14.4762C11.9443 11.719 14.3713 9.48572 17.1184 9.48572H21.8885"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.8327 36.9333V6.99047C31.8327 4.23323 29.7072 2 26.9632 2H26.9134C24.1663 2 21.8885 4.23323 21.8885 6.99047V36.9333"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41.777 86.8378V69.3712C44.7883 67.5466 50.0338 63.6571 51.9668 56.8982C53.8966 50.1361 57.6132 45.5823 61.2771 36.3811C62.2218 34.0137 58.4212 32.6039 55.8854 32.7599C48.9244 33.1903 43.7192 45.3078 41.777 46.9141"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.97213 85.5904V75.6094C6.97213 71.2147 2 68.7818 2 63.1333V24.4571C2 21.6999 4.42702 19.4667 7.17412 19.4667H11.9443"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.8328 9.48572H37.0069C39.754 9.48572 41.777 11.719 41.777 14.4762V46.9142C41.777 46.9142 29.3467 46.9142 26.8606 56.8952"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.3188 71.8664C34.3188 71.8664 38.6632 71.146 41.777 69.3712"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63.5045 24.4229H59.5838C58.0987 24.4229 56.7274 25.217 55.9627 26.4054"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.6778 46.9825V22.372C71.6778 20.1058 69.9308 18.2703 67.6755 18.2703H67.6346C65.3767 18.2703 63.5045 20.1058 63.5045 22.372V46.9825"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M79.8512 88.0001V73.644C82.3262 72.1443 86.6376 68.9475 88.2263 63.3921C89.8125 57.8343 92.8673 54.0914 95.8786 46.5288C96.6551 44.583 93.5314 43.4243 91.4471 43.5525C85.7258 43.9063 81.4476 53.8658 79.8512 55.1861"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.2445 86.9746V78.7711C51.2445 76.5293 49.6704 74.9087 48.4761 72.8918"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.6779 24.4229H75.9306C78.1885 24.4229 79.8512 26.2584 79.8512 28.5246V55.186C79.8512 55.186 69.6345 55.186 67.5912 63.3895"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M73.7212 75.6949C73.7212 75.6949 77.292 75.1027 79.8512 73.644"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'benefits':
      return (
        <>
          <path
            {...props}
            d="M28.5 24.0001C28.5 24.0001 32 22 33 21.5C34 21 36.1537 20.231 37 21.5002C37.8463 22.7694 37.5 24.5002 35.9676 25.6373C34.4352 26.7745 22.3855 32.9738 22.3855 32.9738L21.6666 33.1555L9 33.5001C9 33.5001 6.95876 33.7631 5 36.0001"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 30L6.70906 24.2378C9.49939 22.1743 12.8074 23.3139 12.8074 23.3139C14.4099 23.7758 17.3848 23.88 17.3848 23.88H22.3247C23.7961 23.88 25 25.0327 25 26.4406C25 27.85 23.7961 29.0013 22.3247 29.0013H15.4907"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.79829 19C8.66489 17.2392 8 15.0896 8 12.7704C8 9.72169 9.15048 6.96688 11 5"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 2.0672C16.5183 1.38224 18.2081 1 19.9864 1C26.621 1 32 6.30778 32 12.8533C32 15.1045 31.3644 17.2081 30.2607 19"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20 8L20 18"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25 13L15 13"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'paycheck':
      return (
        <>
          <path
            {...props}
            d="M9 5V9H5"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 4.5V1L7.71791 1.00002L1 7.98452V37H12"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.0133 26.0743C21.0133 27.6917 22.3536 29 24.0047 29C25.6597 29 27 27.6917 27 26.0743C27 24.4569 25.4019 23.7489 23.9991 23.001C22.5981 22.2511 21 21.5451 21 19.9277C21 18.3103 22.3403 17 23.9934 17C25.6464 17 26.9867 18.3083 26.9867 19.9257"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 17V15"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 31V29"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 36C31.1797 36 37 30.1797 37 23C37 15.8203 31.1797 10 24 10C16.8203 10 11 15.8203 11 23C11 30.1797 16.8203 36 24 36Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'timeSheet':
      return (
        <>
          <path
            {...props}
            d="M9 5V9H5"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 4.5V1L7.71791 1.00002L1 7.98452V37H12"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 36C31.1797 36 37 30.1797 37 23C37 15.8203 31.1797 10 24 10C16.8203 10 11 15.8203 11 23C11 30.1797 16.8203 36 24 36Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 10V13"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M24 33V36"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37 23H34"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 23H11"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20 20.518L23.9798 25L30 18"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'vacation':
      return (
        <>
          <path
            {...props}
            d="M1.00004 19C0.983474 12.5951 6.24013 6.68519 13.5895 5.29833C20.9389 3.90572 27.8521 7.51385 30 13.5101"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 17.7647C9 17.7647 5.52791 15.3944 1 19"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 15C21 15 23.8839 11.9462 30 13.3856"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 14.8378C21 14.8378 13.9805 11.5503 9 18"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 6C13 6 8.07606 8.49883 9.15438 18"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 6C13 6 18.7167 6.38586 21 15"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20 34L20.5 36"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16 18L18.5 27.5"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 1L11.5 2.5"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37 20L31.505 31H1"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M22 27H33"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4 36L6 31"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23 31L27 27"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M33 36L31 31"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'request':
      return (
        <>
          <path
            {...props}
            d="M6.96851 19.9341H19.6165"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M6.96802 24.592H19.616"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M6.96802 29.2495H19.616"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M23.0243 4.25684H7.53993L1.40149 9.58111V33.7941C1.40149 35.0021 2.38985 35.9904 3.59785 35.9904H23.0243C24.2323 35.9904 25.2206 35.0021 25.2206 33.7941V6.4532C25.2206 5.2452 24.2323 4.25684 23.0243 4.25684Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M9.50514 4.67334V11.4518H5.3775"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M9.69464 1H25.107C26.9209 1 28.4016 2.48444 28.4016 4.29454V28.1137"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'apresentation':
      return (
        <>
          <path
            {...props}
            d="M48.2779 80.6793L28.3181 95.9492"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.5422 80.6793L68.502 95.9492"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.18823 2.61035V55.6024C7.18823 60.0786 10.8506 63.7511 15.3369 63.7511H81.5541C86.0303 63.7511 89.7028 60.0888 89.7028 55.6024V2.61035"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 2H94.7793"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.8113 51.2483L34.9509 32.8552L43.3234 44.8595L53.4254 34.3303L62.6728 42.2654L73.6802 14.1772"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.3896 96.0001V76.7728"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.3896 90.5066V71.2793"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'assembly':
      return (
        <>
          <path
            {...props}
            d="M13.2543 57.0432H2V2H75.7103V10.0229"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M44.2692 53.4988C42.2312 55.9159 42.5354 59.5312 44.9383 61.5624C47.3514 63.6036 50.9507 63.299 52.9887 60.8921C55.0266 58.4751 54.7224 54.8698 52.3195 52.8286C49.9166 50.7873 46.3071 51.0818 44.2692 53.4988Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.3956 53.4988C19.3577 55.9159 19.6619 59.5312 22.0648 61.5624C24.4779 63.6036 28.0772 63.299 30.1151 60.8921C32.1531 58.4751 31.8489 54.8698 29.446 52.8286C27.043 50.7873 23.4336 51.0818 21.3956 53.4988Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.7657 95.9898L25.1269 90.7394C24.8836 87.8349 22.6733 86.2913 20.2197 86.2913H8.46862C6.01499 86.2913 3.8047 87.8349 3.56136 90.7394L2.92261 95.9797"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.97936 69.3213C7.94143 71.7384 8.2456 75.3537 10.6485 77.3849C13.0616 79.4261 16.6609 79.1215 18.6989 76.7146C20.7368 74.2976 20.4326 70.6923 18.0297 68.6511C15.6268 66.6098 12.0173 66.9043 9.97936 69.3213Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.619 95.99L47.9701 90.7395C47.7268 87.835 45.5165 86.2914 43.0628 86.2914H31.3219C28.8683 86.2914 26.658 87.835 26.4146 90.7395L25.7759 95.99"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.8326 69.3213C30.7947 71.7384 31.0989 75.3537 33.5018 77.3849C35.9149 79.4261 39.5142 79.1215 41.5521 76.7146C43.5901 74.2976 43.2859 70.6923 40.883 68.6511C38.48 66.6098 34.8706 66.9043 32.8326 69.3213Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M71.4723 96L70.8335 90.7394C70.5902 87.8349 68.3799 86.2913 65.9262 86.2913H54.1752C51.7215 86.2913 49.5112 87.8349 49.2679 90.7394L48.6292 95.9898"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M55.6859 69.3213C53.648 71.7384 53.9521 75.3537 56.3551 77.3849C58.7682 79.4261 62.3675 79.1215 64.4054 76.7146C66.4434 74.2976 66.1392 70.6923 63.7362 68.6511C61.3333 66.6098 57.7238 66.9043 55.6859 69.3213Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.9255 84.9203L82.473 62.375C84.5819 61.6133 86.8835 59.8462 86.6604 57.6222L85.1598 40.4694C84.9368 38.2453 82.9293 36.4275 80.6987 36.4275H70.5597C68.3292 36.4275 66.3217 38.2453 66.0986 40.4694L64.5879 57.6222"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.6618 22.6158C81.6618 25.957 78.9648 28.6584 75.6291 28.6584C72.2934 28.6584 69.5964 25.957 69.5964 22.6158C69.5964 19.2746 72.2934 16.5732 75.6291 16.5732C78.9547 16.5732 81.6618 19.2848 81.6618 22.6158Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'dfs':
      return (
        <>
          <path
            {...props}
            d="M18.4805 67.627C18.4805 71.4521 21.8173 74.5448 25.9171 74.5448C30.027 74.5448 33.3638 71.4521 33.3638 67.627C33.3638 63.8019 29.3963 62.1335 25.9069 60.3634C22.4175 58.5933 18.45 56.9249 18.45 53.0998C18.45 49.2746 21.7766 46.182 25.8865 46.182C29.9965 46.182 33.3333 49.2848 33.3333 53.0998"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M25.9065 46.1516V41.4719"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M25.9065 79.2143V74.5347"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M53.5678 95.8982C51.6655 95.8982 50.1191 94.301 50.1191 92.4088V38.0028C50.1191 36.1106 51.6655 34.5541 53.5678 34.5541H90.822C92.7243 34.5541 94.2707 36.1106 94.2707 38.0028V92.4088C94.2707 94.301 92.7243 95.8982 90.822 95.8982H53.5678V95.8982Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.4438 54.7987H94.1689"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M64.8701 55.0021V95.6947"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M79.6213 55.0021V95.593"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M57.4438 68.4307H94.1689"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M57.4438 82.1644H79.3161"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M23.4654 11.0542V23.4655H10.9524"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M40.8615 96H2V20.2405L20.2405 2H72.6017V26.0087"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'financial':
      return (
        <>
          <path
            {...props}
            d="M87.3333 2.00007L10.3334 2.00006C5.66672 2.00006 2.00006 5.7001 2.00006 10.4093L2.00006 96L16.3612 96M96 47.0882L96 10.4093C96 5.70011 92.5 2.00007 88.1667 2.00007C83.8333 2.00007 80.3333 5.70011 80.3333 10.4093L80.3333 49.5961L80.3333 55.8189L80.3333 96L32.0278 96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.7645 59.6999C30.7645 65.3275 35.4323 69.8888 41.1843 69.8888C46.9504 69.8888 51.6112 65.3275 51.6112 59.6999C51.6112 54.0722 46.0492 51.6064 41.1562 49C36.2772 46.3935 30.7223 43.9351 30.7223 38.3001C30.7223 32.6724 35.383 28.1111 41.1421 28.1111C46.9011 28.1111 51.5619 32.6724 51.5619 38.3001"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M41.1666 28.1112L41.1666 20.2778"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M41.1666 77.7222V69.8889"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'solicitacoes':
      return (
        <>
          <path
            {...props}
            d="M17.448 53.1764H51.6339"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M17.4475 65.7659H51.6334"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M17.4475 78.3553H51.6334"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M60.8451 10.8024H18.993L2.40161 25.1932V90.6377C2.40161 93.9027 5.07302 96.5741 8.33808 96.5741H60.8451C64.1102 96.5741 66.7816 93.9027 66.7816 90.6377V16.7388C66.7816 13.4738 64.1102 10.8024 60.8451 10.8024Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M24.3049 11.9282V30.2494H13.1484"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M24.8169 2H66.4746C71.3773 2 75.3793 6.01224 75.3793 10.9047V75.2847"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'result':
      return (
        <>
          <path
            {...props}
            d="M23.5522 59.6984L37.4968 37.57L48.1587 52.8496L62.0575 39.4536L72.7651 49.5486L88.8402 11.4365"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M96 73.6887H11.5098V2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M2 20.8367H11.4183"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 42.2335H11.4183"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 63.7218H11.4183"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.4768 83.0156V73.5973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41.959 83.0156V73.5973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62.3501 83.0156V73.5973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82.7412 83.0156V73.5973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'ri':
      return (
        <>
          <path
            {...props}
            d="M37.7225 60.8592C37.7225 66.8364 42.9368 71.6811 49.3623 71.6811C55.8035 71.6811 61.01 66.8364 61.01 60.8592C61.01 54.882 54.7968 52.2631 49.3308 49.4947C43.8806 46.7263 37.6753 44.1152 37.6753 38.1301C37.6753 32.1529 42.8818 27.3082 49.3151 27.3082C55.7485 27.3082 60.9549 32.1529 60.9549 38.1301"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M49.3151 27.2533V19.3177"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M49.3151 79.6874V71.744"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M20.0897 13.0652C24.8164 9.25871 30.3532 6.3173 36.5585 4.54773C61.3167 -2.53054 87.1288 11.8069 94.1992 36.5572C101.262 61.3233 86.9243 87.1197 62.1661 94.1901C37.4157 101.268 11.6115 86.9231 4.5411 62.1727C1.09635 50.0925 2.74008 37.7841 8.19821 27.5049"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'riXls':
      return (
        <>
          <path
            {...props}
            d="M2 41.4164V6.58359C2 4.05471 4.00772 2 6.47877 2H56.0541C57.8301 2 59.6062 2.71125 60.9189 4.05471L79.9923 23.5745C81.305 24.9179 82 26.6565 82 28.5532V41.4164"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54 2V27.4209C54 31.0347 56.471 34 59.4826 34H70"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 58L18 82"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 82L18 58"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34 58V82H50"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M82 58H72C68.6863 58 66 60.6863 66 64V64C66 67.3137 68.6863 70 72 70H76C79.3137 70 82 72.6863 82 76V76C82 79.3137 79.3137 82 76 82H66"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'sustainability':
      return (
        <>
          <path
            {...props}
            d="M59.0139 9.68825C77.4897 1.46456 95.7298 2.00066 95.9977 2.01138C95.9977 2.01138 96.4263 24.5488 85.5916 44.3414"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
          />
          <path
            {...props}
            d="M43.8184 54.7848L71.2749 61.0464"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M59.8287 38.5948L85.592 44.3418"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M51.6083 46.8071L79.1612 53.0902"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M62.3791 24.924L59.014 9.68823"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M19.8229 78.1697C27.6783 86.0289 45.3182 81.7079 62.8616 68.8202L35.8338 62.5908"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.9345 33.3732L49.4763 14.8351C46.2077 16.958 43.0677 19.4348 40.1956 22.3082C23.1879 39.3346 14.0143 58.9878 16.2756 71.05"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M94.3156 3.65149L2.00085 95.9991"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'talkWith':
      return (
        <>
          <path
            {...props}
            d="M20.0777 42.3051C20.0777 42.8409 19.6759 43.3766 19.0062 43.3766C18.4704 43.3766 17.9347 42.9748 17.9347 42.3051C17.9347 41.7694 18.3365 41.2336 19.0062 41.2336C19.6759 41.2336 20.0777 41.7694 20.0777 42.3051Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
          />
          <path
            {...props}
            d="M29.5843 43.3766C30.1761 43.3766 30.6558 42.8969 30.6558 42.3051C30.6558 41.7134 30.1761 41.2336 29.5843 41.2336C28.9925 41.2336 28.5128 41.7134 28.5128 42.3051C28.5128 42.8969 28.9925 43.3766 29.5843 43.3766Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
          />
          <path
            {...props}
            d="M40.1624 43.3766C40.7542 43.3766 41.2339 42.8969 41.2339 42.3051C41.2339 41.7134 40.7542 41.2336 40.1624 41.2336C39.5707 41.2336 39.0909 41.7134 39.0909 42.3051C39.0909 42.8969 39.5707 43.3766 40.1624 43.3766Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
          />
          <path
            {...props}
            d="M63.1938 43.9117H70.9602L84.6183 59.8461V43.9117H88.3676C92.5186 43.9117 96.0001 40.4302 96.0001 36.2792V9.63248C96.0001 5.48148 92.5186 2 88.3676 2H48.4645C44.3135 2 40.832 5.48148 40.832 9.63248V15.5242"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.3818 79.1284V63.1939H9.63247C5.48148 63.1939 2 59.7124 2 55.5614V29.0486C2 24.8976 5.48148 21.4161 9.63247 21.4161H49.5356C53.6866 21.4161 57.1681 24.8976 57.1681 29.0486V55.6953C57.1681 59.8463 53.6866 63.3278 49.5356 63.3278H27.0399L13.3818 79.1284Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67.7469 23.9606C68.3387 23.9606 68.8184 23.4809 68.8184 22.8891C68.8184 22.2973 68.3387 21.8176 67.7469 21.8176C67.1551 21.8176 66.6754 22.2973 66.6754 22.8891C66.6754 23.4809 67.1551 23.9606 67.7469 23.9606Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
          />
          <path
            {...props}
            d="M78.3248 23.9606C78.9165 23.9606 79.3963 23.4809 79.3963 22.8891C79.3963 22.2973 78.9165 21.8176 78.3248 21.8176C77.733 21.8176 77.2533 22.2973 77.2533 22.8891C77.2533 23.4809 77.733 23.9606 78.3248 23.9606Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
          />
        </>
      );
    case 'facebook':
      return (
        <>
          <path
            {...props}
            d="M3.26757 21H7.62887V10.9128H10.675L11 7.53645H7.63643C7.63643 7.53645 7.63643 6.27381 7.63643 5.61109C7.63643 4.81584 7.81028 4.50192 8.64172 4.50192C9.31444 4.50192 11 4.50192 11 4.50192V1C11 1 8.51323 1 7.97657 1C4.73394 1 3.26757 2.31845 3.26757 4.84374C3.26757 7.04116 3.26757 7.53645 3.26757 7.53645H1V10.9547H3.26757V21Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'facebookOutline':
      return (
        <>
          <path
            {...props}
            d="M2.26757 20H6.62887V9.9128H9.67498L10 6.53645H6.63643C6.63643 6.53645 6.63643 5.27381 6.63643 4.61109C6.63643 3.81584 6.81028 3.50192 7.64172 3.50192C8.31444 3.50192 10 3.50192 10 3.50192V0C10 0 7.51323 0 6.97657 0C3.73394 0 2.26757 1.31845 2.26757 3.84374C2.26757 6.04116 2.26757 6.53645 2.26757 6.53645H0V9.95466H2.26757V20Z"
            fill={color}
          />
        </>
      );
    case 'google':
      return (
        <>
          <path
            {...props}
            d="M15.1048 6.47273L14.4211 7.20244C14.812 7.56874 15.4221 7.56191 15.8048 7.18694L15.1048 6.47273ZM5.49443 9.1L4.54751 8.77854C4.5097 8.88992 4.49183 9.0071 4.49474 9.12468L5.49443 9.1ZM5.49443 9.10008L6.44117 9.4221C6.47911 9.31055 6.49704 9.19318 6.49413 9.07539L5.49443 9.10008ZM5.49439 12.9L4.54765 13.222C4.68553 13.6273 5.0662 13.9 5.49439 13.9V12.9ZM5.49443 12.9L6.44135 12.5785C6.30364 12.1728 5.92283 11.9 5.49443 11.9V12.9ZM14.6595 16.0682L15.2084 16.904C15.49 16.7192 15.6595 16.405 15.6595 16.0682H14.6595ZM14.6595 16.0681L14.1109 15.232C13.8292 15.4168 13.6595 15.7311 13.6595 16.0681H14.6595ZM16.6957 13.0499L17.6783 13.2358C17.7336 12.9432 17.6557 12.6412 17.4658 12.4119C17.2758 12.1826 16.9935 12.0499 16.6957 12.0499V13.0499ZM11.2041 13.0499H10.2041C10.2041 13.6022 10.6518 14.0499 11.2041 14.0499V13.0499ZM11.2041 9.18169V8.18169C10.6518 8.18169 10.2041 8.62941 10.2041 9.18169H11.2041ZM20.8144 9.18169L21.7979 9.0005C21.7105 8.52609 21.2969 8.18169 20.8144 8.18169V9.18169ZM17.9573 18.5772L17.2874 17.8347C17.0207 18.0754 16.9035 18.4406 16.9806 18.7916L17.9573 18.5772ZM17.9573 18.5772L18.6282 19.3188C18.8943 19.0781 19.011 18.7133 18.9341 18.3628L17.9573 18.5772ZM2.08539 15.491L2.97486 15.034C2.84005 14.7716 2.59627 14.5821 2.30873 14.5162C2.02118 14.4503 1.71922 14.5148 1.48362 14.6923L2.08539 15.491ZM2.08534 15.491L1.1952 15.9467C1.32974 16.2095 1.57355 16.3994 1.86129 16.4656C2.14903 16.5317 2.4513 16.4673 2.68711 16.2897L2.08534 15.491ZM2.08534 6.50917V5.50917C1.70999 5.50917 1.36624 5.71937 1.1952 6.05349L2.08534 6.50917ZM2.08544 6.50917V7.50917C2.51474 7.50917 2.89614 7.23516 3.03315 6.82832C3.17016 6.42147 3.0322 5.97257 2.69036 5.71288L2.08544 6.50917ZM2.08534 6.50909L1.19586 6.05212C0.974187 6.4836 1.09415 7.01194 1.48042 7.30538L2.08534 6.50909ZM18.0315 3.60455L18.7315 4.31876C18.9278 4.12639 19.0362 3.86171 19.0314 3.58691C19.0265 3.31211 18.9088 3.05142 18.7058 2.86609L18.0315 3.60455ZM11.2041 5.97727C12.466 5.97727 13.5615 6.39696 14.4211 7.20244L15.7886 5.74301C14.5332 4.56667 12.9384 3.97727 11.2041 3.97727V5.97727ZM6.44135 9.42146C7.11386 7.44048 8.99858 5.97727 11.2041 5.97727V3.97727C8.09418 3.97727 5.47983 6.03225 4.54751 8.77854L6.44135 9.42146ZM6.49413 9.07539L6.49413 9.07532L4.49474 9.12468L4.49474 9.12476L6.49413 9.07539ZM6.1744 11.0001C6.1744 10.4585 6.2697 9.92622 6.44117 9.4221L4.5477 8.77806C4.31101 9.47394 4.1744 10.2235 4.1744 11.0001H6.1744ZM6.44113 12.578C6.26968 12.0739 6.1744 11.5416 6.1744 11.0001H4.1744C4.1744 11.7766 4.31099 12.5261 4.54765 13.222L6.44113 12.578ZM5.49443 11.9H5.49439V13.9H5.49443V11.9ZM11.2041 16.0227C8.99858 16.0227 7.11386 14.5595 6.44135 12.5785L4.54751 13.2214C5.47983 15.9677 8.09418 18.0227 11.2041 18.0227V16.0227ZM14.1106 15.2323C13.3766 15.7143 12.4028 16.0227 11.2041 16.0227V18.0227C12.7512 18.0227 14.115 17.622 15.2084 16.904L14.1106 15.2323ZM13.6595 16.0681V16.0682H15.6595V16.0681H13.6595ZM15.7132 12.8639C15.5286 13.8393 14.9717 14.6672 14.1109 15.232L15.2081 16.9042C16.5088 16.0507 17.3898 14.7605 17.6783 13.2358L15.7132 12.8639ZM11.2041 14.0499H16.6957V12.0499H11.2041V14.0499ZM10.2041 9.18169V13.0499H12.2041V9.18169H10.2041ZM20.8144 8.18169H11.2041V10.1817H20.8144V8.18169ZM22 11.2271C22 10.4566 21.9294 9.71418 21.7979 9.0005L19.831 9.36289C19.9407 9.9583 20 10.5795 20 11.2271H22ZM18.6272 19.3196C20.7895 17.3687 22 14.5237 22 11.2271H20C20 14.0216 18.9841 16.3038 17.2874 17.8347L18.6272 19.3196ZM18.9341 18.3628L18.9341 18.3627L16.9806 18.7916L16.9806 18.7916L18.9341 18.3628ZM11.2041 22C14.1827 22 16.7387 21.0281 18.6282 19.3188L17.2865 17.8356C15.7993 19.1809 13.7357 20 11.2041 20V22ZM1.19591 15.9479C3.04309 19.5433 6.83355 22 11.2041 22V20C7.59694 20 4.48578 17.9749 2.97486 15.034L1.19591 15.9479ZM2.68711 16.2897L2.68715 16.2896L1.48362 14.6923L1.48357 14.6923L2.68711 16.2897ZM0 11.0001C0 12.7783 0.434743 14.4612 1.1952 15.9467L2.97549 15.0353C2.35375 13.8208 2 12.4491 2 11.0001H0ZM1.1952 6.05349C0.434743 7.53898 0 9.22187 0 11.0001H2C2 9.55101 2.35375 8.17935 2.97549 6.96485L1.1952 6.05349ZM2.08544 5.50917H2.08534V7.50917H2.08544V5.50917ZM1.48042 7.30538L1.48052 7.30546L2.69036 5.71288L2.69026 5.7128L1.48042 7.30538ZM11.2041 0C6.83351 0 3.04303 2.45668 1.19586 6.05212L2.97482 6.96606C4.48573 4.02514 7.59691 2 11.2041 2V0ZM18.7058 2.86609C16.7596 1.08893 14.211 0 11.2041 0V2C13.6981 2 15.7692 2.89289 17.3572 4.343L18.7058 2.86609ZM15.8048 7.18694L18.7315 4.31876L17.3316 2.89033L14.4049 5.75851L15.8048 7.18694Z"
            fill={color}
          />
        </>
      );
    case 'googleOutline':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1048 5.47273C13.0473 4.48182 11.7022 3.97727 10.2041 3.97727C7.54638 3.97727 5.29684 5.73636 4.49443 8.1L4.49443 8.10008C4.29035 8.70008 4.1744 9.34099 4.1744 10.0001C4.1744 10.6591 4.29034 11.3 4.49439 11.9H4.49443C5.29684 14.2636 7.54638 16.0227 10.2041 16.0227C11.577 16.0227 12.7458 15.6681 13.6595 15.0682V15.0681C14.7402 14.359 15.4592 13.2999 15.6957 12.0499H10.2041V8.18169H19.8144C19.935 8.83624 20 9.51806 20 10.2271C20 13.2726 18.8868 15.8362 16.9573 17.5772L16.9573 17.5772C15.269 19.1045 12.9592 20 10.2041 20C6.21525 20 2.76444 17.7591 1.08539 14.491L1.08534 14.491C0.394249 13.141 0 11.6137 0 10.0001C0 8.38644 0.394249 6.85917 1.08534 5.50917H1.08544L1.08534 5.50909C2.76438 2.24091 6.21521 0 10.2041 0C12.9545 0 15.2644 0.990909 17.0315 2.60455L14.1048 5.47273Z"
            fill={color}
          />
        </>
      );
    case 'instagram':
      return (
        <>
          <path
            {...props}
            d="M11.0047 1C14.2614 1 14.6462 1.00939 15.932 1.07508C17.1239 1.13139 17.7715 1.32848 18.1938 1.49742C18.7663 1.72267 19.1699 1.98545 19.5922 2.40779C20.0239 2.83951 20.2867 3.24308 20.5026 3.80619C20.6715 4.23792 20.8686 4.8855 20.9249 6.06804C20.9812 7.35382 21 7.73862 21 10.9953C21 14.252 20.9906 14.6368 20.9249 15.9226C20.8686 17.1145 20.6715 17.7621 20.5026 18.1844C20.2773 18.7569 20.0145 19.1605 19.5922 19.5922C19.1699 20.0145 18.7569 20.2867 18.1938 20.5026C17.7621 20.6715 17.1145 20.8686 15.932 20.9249C14.6462 20.9812 14.2614 21 11.0047 21C7.74801 21 7.36321 20.9906 6.07743 20.9249C4.8855 20.8686 4.23792 20.6715 3.81558 20.5026C3.24308 20.2773 2.83951 20.0145 2.40779 19.5922C1.98545 19.1605 1.71328 18.7569 1.49742 18.1844C1.32848 17.7527 1.13139 17.1051 1.07508 15.9226C1.01877 14.6368 1 14.252 1 10.9953C1 7.73862 1.00938 7.35382 1.07508 6.06804C1.13139 4.87611 1.32848 4.22853 1.49742 3.80619C1.72266 3.23369 1.98545 2.83013 2.40779 2.40779C2.83951 1.97607 3.24308 1.71328 3.81558 1.49742C4.2473 1.32848 4.89489 1.13139 6.07743 1.07508C7.35383 1.01877 7.73862 1 11.0047 1Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 15C8.79215 15 7 13.2079 7 11C7 8.79215 8.79215 7 11 7C13.2079 7 15 8.79215 15 11C15 13.2079 13.2079 15 11 15Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.71 5.5C17.71 6.05128 17.2613 6.5 16.71 6.5C16.1587 6.5 15.71 6.05128 15.71 5.5C15.71 4.94872 16.1587 4.5 16.71 4.5C17.2613 4.5 17.71 4.94872 17.71 5.5Z"
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'instagramOutline':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.932 0.0750821C13.6462 0.00938519 13.2614 0 10.0047 0C6.77863 0 6.36368 0.0183135 5.12394 0.0730297L5.07743 0.0750821C3.89489 0.131394 3.2473 0.328484 2.81558 0.497419C2.24308 0.71328 1.83951 0.976068 1.40779 1.40779C0.985453 1.83013 0.722664 2.23369 0.497418 2.80619C0.328483 3.22853 0.131392 3.87611 0.0750803 5.06804C0.0093834 6.35383 0 6.73862 0 9.99531C0 13.209 0.0182765 13.6261 0.07287 14.8721L0.0750803 14.9226C0.131392 16.1051 0.328483 16.7527 0.497418 17.1844C0.713279 17.7569 0.985453 18.1605 1.40779 18.5922C1.83951 19.0145 2.24308 19.2773 2.81558 19.5026C3.23792 19.6715 3.8855 19.8686 5.07743 19.9249C6.36321 19.9906 6.74801 20 10.0047 20C13.2184 20 13.6355 19.9817 14.8815 19.9271L14.932 19.9249C16.1145 19.8686 16.7621 19.6715 17.1938 19.5026C17.7569 19.2867 18.1699 19.0145 18.5922 18.5922C19.0145 18.1605 19.2773 17.7569 19.5026 17.1844C19.6715 16.7621 19.8686 16.1145 19.9249 14.9226C19.9906 13.6368 20 13.252 20 9.99531C20 6.78169 19.9817 6.36451 19.9271 5.11859L19.9249 5.06804C19.8686 3.8855 19.6715 3.23792 19.5026 2.80619C19.2867 2.24308 19.0239 1.83951 18.5922 1.40779C18.1699 0.985453 17.7663 0.722665 17.1938 0.497419C16.7715 0.328484 16.1239 0.131394 14.932 0.0750821ZM16.71 4.5C16.71 5.05128 16.2613 5.5 15.71 5.5C15.1587 5.5 14.71 5.05128 14.71 4.5C14.71 3.94872 15.1587 3.5 15.71 3.5C16.2613 3.5 16.71 3.94872 16.71 4.5ZM10 7C8.34443 7 7 8.34443 7 10C7 11.6556 8.34443 13 10 13C11.6556 13 13 11.6556 13 10C13 8.34443 11.6556 7 10 7ZM5 10C5 7.23986 7.23987 5 10 5C12.7601 5 15 7.23986 15 10C15 12.7601 12.7601 15 10 15C7.23987 15 5 12.7601 5 10Z"
            fill={color}
          />
        </>
      );
    case 'linkedin':
      return (
        <>
          <path
            {...props}
            d="M5.52026 7.6665H1.38727V20.9915H5.52026V7.6665Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.44113 5.92645C4.78792 5.92645 5.88219 4.82515 5.88219 3.46323C5.88219 2.10131 4.78792 1 3.44113 1C2.09433 1 1.00005 2.10131 1.00005 3.46323C0.991631 4.82515 2.08591 5.92645 3.44113 5.92645Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.128 14.0055C12.128 12.1308 12.995 11.0127 14.6448 11.0127C16.1599 11.0127 16.8923 12.0803 16.8923 14.0055C16.8923 15.9223 16.8923 21.0001 16.8923 21.0001H21C21 21.0001 21 16.1325 21 12.5595C21 8.9866 18.9714 7.26318 16.1431 7.26318C13.3148 7.26318 12.1195 9.46579 12.1195 9.46579V7.66671H8.15491V20.9917H12.1195C12.128 21.0001 12.128 16.0568 12.128 14.0055Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'linkedinOutline':
      return (
        <>
          <path
            {...props}
            d="M4.52026 6.6665H0.387268V19.9915H4.52026V6.6665Z"
            fill={color}
          />
          <path
            {...props}
            d="M2.44113 4.92645C3.78792 4.92645 4.88219 3.82515 4.88219 2.46323C4.88219 1.10131 3.78792 0 2.44113 0C1.09433 0 4.82383e-05 1.10131 4.82383e-05 2.46323C-0.00836925 3.82515 1.08591 4.92645 2.44113 4.92645Z"
            fill={color}
          />
          <path
            {...props}
            d="M11.128 13.0055C11.128 11.1308 11.995 10.0127 13.6448 10.0127C15.1599 10.0127 15.8923 11.0803 15.8923 13.0055C15.8923 14.9223 15.8923 20.0001 15.8923 20.0001H20C20 20.0001 20 15.1325 20 11.5595C20 7.9866 17.9714 6.26318 15.1431 6.26318C12.3148 6.26318 11.1195 8.46579 11.1195 8.46579V6.66671H7.15491V19.9917H11.1195C11.128 20.0001 11.128 15.0568 11.128 13.0055Z"
            fill={color}
          />
        </>
      );
    case 'share':
      return (
        <>
          <path
            {...props}
            d="M4.33532 13.2214C6.17737 13.2214 7.67064 11.7281 7.67064 9.8861C7.67064 8.04406 6.17737 6.55078 4.33532 6.55078C2.49327 6.55078 1 8.04406 1 9.8861C1 11.7281 2.49327 13.2214 4.33532 13.2214Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.6647 18.7847C19.5067 18.7847 21 17.2914 21 15.4493C21 13.6073 19.5067 12.114 17.6647 12.114C15.8226 12.114 14.3293 13.6073 14.3293 15.4493C14.3293 17.2914 15.8226 18.7847 17.6647 18.7847Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.6647 7.67064C19.5067 7.67064 21 6.17737 21 4.33532C21 2.49327 19.5067 1 17.6647 1C15.8226 1 14.3293 2.49327 14.3293 4.33532C14.3293 6.17737 15.8226 7.67064 17.6647 7.67064Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.44434 8.58769L14.5557 5.63354"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.44434 11.1848L14.5557 14.1509"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'twitter':
      return (
        <>
          <path
            {...props}
            d="M1 15.1841C2.81171 16.3298 4.97152 17 7.28956 17C14.9082 17 19.2041 10.6639 18.951 4.98246C19.75 4.41354 20.4462 3.70434 21 2.89381C20.2642 3.21335 19.4731 3.43156 18.6424 3.53288C19.4889 3.0341 20.1377 2.23916 20.4462 1.29615C19.6551 1.75597 18.7769 2.09888 17.8434 2.27813C17.0918 1.49099 16.0316 1 14.8529 1C12.2025 1 10.2563 3.43156 10.8576 5.96444C7.44779 5.79299 4.42564 4.18753 2.40032 1.74038C1.32437 3.55626 1.84652 5.93327 3.66614 7.13346C2.99367 7.11008 2.36076 6.93083 1.80697 6.62689C1.7595 8.49732 3.12816 10.2509 5.0981 10.6405C4.52057 10.7964 3.88766 10.8276 3.24684 10.7107C3.76899 12.3161 5.28006 13.4851 7.07595 13.5163C5.35127 14.8412 3.17563 15.4413 1 15.1841Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'twitterOutline':
      return (
        <>
          <path
            {...props}
            d="M0 14.1841C1.81171 15.3298 3.97152 16 6.28956 16C13.9082 16 18.2041 9.66391 17.951 3.98246C18.75 3.41354 19.4462 2.70433 20 1.89381C19.2642 2.21335 18.4731 2.43156 17.6424 2.53288C18.4889 2.0341 19.1377 1.23916 19.4462 0.296152C18.6551 0.755967 17.7769 1.09888 16.8434 1.27813C16.0918 0.490989 15.0316 0 13.8529 0C11.2025 0 9.25634 2.43156 9.8576 4.96444C6.44779 4.79299 3.42564 3.18753 1.40032 0.74038C0.324371 2.55626 0.846521 4.93327 2.66614 6.13346C1.99367 6.11008 1.36076 5.93083 0.806965 5.62689C0.759497 7.49732 2.12816 9.25085 4.0981 9.64053C3.52057 9.7964 2.88766 9.82757 2.24684 9.71067C2.76899 11.3161 4.28006 12.4851 6.07595 12.5163C4.35127 13.8412 2.17563 14.4413 0 14.1841Z"
            fill={color}
          />
        </>
      );
    case 'whatsapp':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 20L4.90435 18.6C6.3913 19.487 8.13913 20 10 20C15.5217 20 20 15.5217 20 10C20 4.47826 15.5217 0 10 0C4.47826 0 0 4.47826 0 10C0 11.8609 0.513043 13.6087 1.4 15.0957L0 20ZM8.35215 6.8565C8.3652 6.84128 8.37824 6.82606 8.39128 6.80867C8.64346 6.51302 8.78259 6.02606 8.59998 5.63476C8.55015 5.52744 8.50708 5.41504 8.46406 5.30279C8.40949 5.16039 8.35501 5.01823 8.28693 4.88693C7.98259 4.31302 7.52172 4.09563 7.00867 4.11302C6.48324 4.13404 6.05376 4.42598 5.74752 4.63415C5.67365 4.68437 5.60695 4.72971 5.5478 4.76519C5 5.09387 4.8087 5.9 5.00001 6.5C6.34784 10.7 8.59131 13.6826 13.4783 15.1522C14.087 15.3348 14.9652 14.8869 15.1652 14.5217L15.1781 14.4985C15.3554 14.1797 15.6806 13.5948 15.7739 13.0348C15.8522 12.5391 15.4869 12.0087 14.9739 11.8C14.7247 11.7027 14.5434 11.6225 14.3737 11.5473C14.3007 11.515 14.2298 11.4836 14.1565 11.4522C13.7565 11.2869 13.3217 11.4869 13.0348 11.7478C13 11.7826 12.9739 11.8087 12.9391 11.8348C12.6522 12.0956 12.1739 12.0608 11.7304 11.8261C10.3913 11.113 8.89563 9.61737 8.3565 8.11302C8.18259 7.63476 8.06085 7.19998 8.31302 6.90432C8.32607 6.88693 8.33911 6.87171 8.35215 6.8565Z"
            fill={color}
          />
        </>
      );
    case 'whatsappOutline':
      return (
        <>
          <path
            {...props}
            d="M9.39128 7.80867C9.3652 7.84346 9.33911 7.86954 9.31302 7.90432C9.06085 8.19998 9.18259 8.63476 9.3565 9.11302C9.89563 10.6174 11.3913 12.113 12.7304 12.8261C13.1739 13.0608 13.6522 13.0956 13.9391 12.8348C13.9739 12.8087 14 12.7826 14.0348 12.7478C14.3217 12.4869 14.7565 12.2869 15.1565 12.4522C15.4 12.5565 15.6174 12.6608 15.9739 12.8C16.4869 13.0087 16.8522 13.5391 16.7739 14.0348C16.6782 14.6087 16.3391 15.2087 16.1652 15.5217C15.9652 15.8869 15.087 16.3348 14.4783 16.1522C9.59131 14.6826 7.34784 11.7 6.00001 7.5C5.8087 6.9 6 6.09387 6.5478 5.76519C6.85215 5.58259 7.3565 5.13911 8.00867 5.11302C8.52172 5.09563 8.98259 5.31302 9.28693 5.88693C9.40867 6.12172 9.48693 6.39128 9.59998 6.63476C9.78259 7.02606 9.64346 7.51302 9.39128 7.80867Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5.90435 19.6L1 21L2.4 16.0957C1.51304 14.6087 1 12.8609 1 11C1 5.47826 5.47826 1 11 1C16.5217 1 21 5.47826 21 11C21 16.5217 16.5217 21 11 21C9.13913 21 7.3913 20.487 5.90435 19.6Z"
            stroke={color}
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'youtube':
      return (
        <>
          <path
            {...props}
            d="M102.335 44.6931C101.408 41.2824 98.7102 38.5788 95.2539 37.6637C89.0158 36 64 36 64 36C64 36 38.9842 36 32.7461 37.6637C29.3109 38.5788 26.5922 41.2616 25.6649 44.6931C24 50.8905 24 60 24 63.8261C24 67.6522 24 76.7617 25.6649 82.9591C26.5922 86.3698 29.2898 89.0734 32.7461 89.9884C38.9842 91.6522 64 91.6522 64 91.6522C64 91.6522 89.0158 91.6522 95.2539 89.9884C98.6891 89.0734 101.408 86.3906 102.335 82.9591C104 76.7617 104 67.6522 104 63.8261C104 60 104 50.8697 102.335 44.6931Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path {...props} d="M56 76V52L76 64L56 76Z" fill={color} />
        </>
      );
    case 'youtubeOutline':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8135 0.415936C18.6776 0.6447 19.3519 1.3206 19.5838 2.17326C20 3.71742 20 6 20 6.95652C20 7.91305 20 10.1904 19.5838 11.7398C19.3519 12.5976 18.6723 13.2683 17.8135 13.4971C16.2539 13.913 10 13.913 10 13.913C10 13.913 3.74605 13.913 2.18652 13.4971C1.32245 13.2683 0.648055 12.5924 0.416232 11.7398C4.29153e-06 10.1904 0 7.91305 0 6.95652C0 6 4.29153e-06 3.72262 0.416232 2.17326C0.648055 1.3154 1.32772 0.6447 2.18652 0.415936C3.74605 0 10 0 10 0C10 0 16.2539 0 17.8135 0.415936ZM13 7L8 4V10L13 7Z"
            fill={color}
          />
        </>
      );
    case 'acharMedico':
      return (
        <>
          <path
            {...props}
            d="M72.5 65L97.6468 88.4407C99.4511 90.2875 99.4511 93.3257 97.6468 95.1724L95.2604 97.6149C93.4561 99.4617 90.4877 99.4617 88.6834 97.6149L63.5 73.5M93.5 84.5753C91.9379 86.1374 89.5 88.5753 89.5 88.5753"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41 80C62.5391 80 80 62.5391 80 41C80 19.4609 62.5391 2 41 2C19.4609 2 2 19.4609 2 41C2 62.5391 19.4609 80 41 80Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.6 33.4V22H33.4V33.4H22V48.6H33.4V60H48.6V48.6H60V33.4H48.6Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'agendamento':
      return (
        <>
          <path
            {...props}
            d="M2 30L82 30"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M79.7409 10.3364H89.6306C92.5855 10.3364 95 12.7562 95 15.7081V89.6027C95 92.5545 92.5855 95.0001 89.6306 95.0001H7.36943C4.41881 95.0001 2 92.5545 2 89.6027V15.7081C2 12.7562 4.41881 10.3364 7.36943 10.3364H22.1396"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M56.2475 10.3364H69.1135"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.7627 10.3364H45.6244"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M22.5085 2V20.2645"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69.4824 2V20.2645"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.9976 2V20.2645"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M55.9 54.1V43H41.1V54.1H30V68.9H41.1V80H55.9V68.9H67V54.1H55.9Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'bemEstar':
      return (
        <>
          <rect
            x="36"
            y="2"
            width="18"
            height="22"
            rx="9"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54 82H39.3469C39.3469 82 27.2796 82 32.164 95"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M89 77L68.12 64.2328V41.6448C68.12 30 56.955 30 56.955 30H34.19C34.19 30 23.025 30 23.75 41.9254V64.2328L2 77"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M58.2427 42V69.8795L76.8835 80.4795C81.2524 83.0931 83 84.8356 83 88.4658C83 92.0959 80.0874 95 76.4466 95H14.5534C10.9126 95 8 92.0959 8 88.4658C8 84.8356 9.74757 83.0931 14.1165 80.4795L32.7573 69.8795V42"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'cobertura':
      return (
        <>
          <path
            {...props}
            d="M60.0634 87.2509L5.74568 32.9217C0.751439 27.9264 0.751439 19.8144 5.74568 14.7978L14.7951 5.74647C19.7893 0.751177 27.8996 0.751177 32.9152 5.74647L87.2543 60.097C92.2486 65.0923 92.2486 73.2043 87.2543 78.2209L78.2049 87.2722C73.1893 92.2462 65.079 92.2462 60.0634 87.2509Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41.9646 78.1996L32.9152 87.2509C27.921 92.2462 19.8107 92.2462 14.7951 87.2509L5.74568 78.1996C0.751439 73.2043 0.751439 65.0923 5.74568 60.0757L14.7951 51.0244"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M51.0139 14.7978L60.0633 5.74647C65.0576 0.751177 73.1679 0.751177 78.1835 5.74647L87.2329 14.7978C92.2271 19.7931 92.2271 27.9051 87.2329 32.9217L78.1835 41.973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41.9646 23.8491L23.8445 41.973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M69.134 51.0244L51.0139 69.1483"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.9338 38.9417L37.4398 40.4574"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M46.4894 46.4987L44.974 48.0143"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M48.0046 35.9317L46.4893 37.4474"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M57.0542 44.983L55.5388 46.4986"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M35.9246 48.0143L34.4093 49.5086"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M44.974 57.0656L43.48 58.5813"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54.0234 54.0343L52.5294 55.55"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'comunicacaoInterna':
      return (
        <>
          <path
            {...props}
            d="M54.9724 56.6477V61.9591C54.9724 63.854 53.4144 65.3756 51.539 65.3756H25.399L13.4831 77.1468V65.3756H5.43339C3.55801 65.3756 2 63.854 2 61.9591V31.7846C2 29.9185 3.52916 28.3681 5.43339 28.3681H11.4635"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.4604 28.3681H51.5101C53.3855 28.3681 54.9724 29.8897 54.9724 31.7846V50.5898"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.3204 28.3681H37.1707"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M64.4359 19.4106V36.2061C64.4359 36.2061 62.9644 39.6226 61.0602 39.5939H34.8336L22.9466 51.3938V39.7949H15.0988C13.2235 39.7949 11.6654 38.2445 11.6654 36.3783V6.00289C11.6654 4.13672 13.1946 2.58636 15.0988 2.58636H60.9736C62.849 2.58636 64.4359 4.13672 64.4359 6.00289V13.5824"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M72.7452 50.8197L84.7188 62.5622V50.8197H92.5666C94.442 50.8197 96 49.298 96 47.4032V17.2C96 15.3338 94.442 13.7834 92.5666 13.7834H46.4899C44.6145 13.7834 43.0276 15.3051 43.0276 17.2V47.3745C43.0276 49.2693 44.5856 50.8197 46.4899 50.8197H72.7452Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'emergencia':
      return (
        <>
          <path
            {...props}
            d="M39.9935 10.9877V2"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M58.3925 12.8243L61.7839 4.40973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.6074 12.8243L18.2161 4.40973"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M70.9184 24.3129L78 18.6598"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.08155 24.3129L2 18.6598"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.9547 69.4467L18.0212 35.7364C18.6709 28.6635 24.9988 22.8671 32.0804 22.8671H47.8937C54.9882 22.8671 61.3161 28.6635 61.9528 35.7364L65.5261 75.2041"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.1033 36.5049C26.649 33.4438 29.1048 30.7606 32.2623 30.7606H37.5897"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.10753 94L10.5758 82.85H69.4112L70.8924 94H9.10753Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M41.1369 54.5584C41.1369 60.5372 45.9706 65.3827 51.9347 65.3827V43.7341C45.9706 43.7341 41.1369 48.5797 41.1369 54.5584Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M38.863 54.5584C38.863 60.5372 34.0294 65.3827 28.0653 65.3827V43.7341C34.0294 43.7341 38.863 48.5797 38.863 54.5584Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M39.9935 67.6882V75.2431"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.8102 75.4646H68.1898"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M68.4756 75.5817L70.6715 92.1894"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'especialidades':
      return (
        <>
          <path
            {...props}
            d="M2 30.6087C2 46.4048 14.9319 59.2174 30.875 59.2174C46.8181 59.2174 59.75 46.4048 59.75 30.6087H2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M59.75 24.4783C59.75 12.2174 49.4375 8.13043 45.3125 8.13043C41.1875 8.13043 41.1875 10.1739 37.0625 16.3043C32.9375 22.4348 18.5 22.4348 21.5937 16.3043C23.9037 11.727 26.75 2 42.2187 2C58.7187 2 68 12.8509 68 28.5652C68 53.087 51.5 67.3913 30.875 67.3913H21.5937"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.875 67.3914V85.7827"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.875 85.7826C22.625 85.7826 16.4375 89.8695 16.4375 96H45.3125C45.3125 89.8695 39.125 85.7826 30.875 85.7826Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M37.0625 75.5652C46.0962 75.5652 55.625 83.8617 55.625 95.9796C62.5962 85.3535 57.2544 74.5435 49.8706 70.1091"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.3881 58.2366C15.6744 58.2366 12.3125 62.8753 12.3125 67.3914C12.3125 71.9074 16.0044 75.5653 20.5625 75.5653H24.6875"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'exame':
      return (
        <>
          <path
            {...props}
            d="M78.4528 40.0403L29.6823 88.7958C23.0909 95.3872 12.8675 95.9551 6.9487 90.0363C1.04483 84.1325 1.59785 73.8941 8.18926 67.3027L56.9597 18.5322"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M60.0536 20.834L56.6608 17.4411C55.0166 15.797 55.0166 13.0917 56.6608 11.4476L57.2287 10.8796C58.8728 9.23552 61.5782 9.23552 63.2223 10.8796L86.1203 33.7777C87.7644 35.4218 87.7644 38.1271 86.1203 39.7712L85.5524 40.3392C83.9082 41.9833 81.2029 41.9833 79.5588 40.3392L66.6899 27.4703"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M65.2102 52.8494H38.7926"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M66.7198 13.9138L77.7503 2.86829L94.1317 19.2497L82.9367 30.4446"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M36.2536 70.2656C35.2905 71.2287 33.6854 71.2608 32.7223 70.2656C31.7592 69.3026 31.7592 67.6974 32.7223 66.7344C33.7175 65.7392 35.2905 65.7713 36.2536 66.7344C37.2488 67.6974 37.2488 69.3026 36.2536 70.2656Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.2554 81.276C17.2626 82.2413 15.6934 82.2413 14.7326 81.276C13.7719 80.3106 13.7398 78.7016 14.7326 77.7362C15.7254 76.7386 17.2947 76.7708 18.2554 77.7362C19.2482 78.7016 19.2482 80.2784 18.2554 81.276Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'exameDownload':
      return (
        <>
          <path
            {...props}
            d="M66.4456 2H20.2866L2 17.9347V90.4222C2 94.04 4.94946 97 8.55435 97H66.4456C70.0505 97 73 94.04 73 90.4222V8.57781C73 4.96001 70.0505 2 66.4456 2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.5003 2.78528V23.8672H11.1945"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.4691 45.271V56.9606H52.2191L38.7191 77L25.2191 56.9606H31.9691V40"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'exameImagem':
      return (
        <>
          <path
            {...props}
            d="M66.4456 2H20.2866L2 17.9347V90.4222C2 94.04 4.94946 97 8.55435 97H66.4456C70.0505 97 73 94.04 73 90.4222V8.57781C73 4.96001 70.0505 2 66.4456 2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.5003 2.78528V23.8672H11.1945"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23 35L14.5 35L14.5 43.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61 43.5L61 35L52.5 35"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23 82L14.5 82L14.5 73.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M61 73L61 81.5L52.5 81.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.4747 82.5253V59.8203C42.4747 58.5696 43.9632 56.9578 44.8968 56.1122C47.3894 53.8486 47.0812 51.1446 46.905 50.0876C46.5791 48.1058 44.6238 46.1153 42.2809 46.1153C39.4095 46.1153 38.4318 47.3572 37.4982 47.3572C36.5646 47.3572 35.5957 46.1065 32.7155 46.1153C30.3727 46.1153 28.4173 48.1058 28.0914 50.0876C27.9153 51.1446 27.5894 53.8486 30.0996 56.1122C31.0332 56.9578 32.5218 58.552 32.5218 59.8203L32.5218 82.5253"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'exameResultado':
      return (
        <>
          <path
            {...props}
            d="M66.4456 2H20.2866L2 17.9347V90.4222C2 94.04 4.94946 97 8.55435 97H66.4456C70.0505 97 73 94.04 73 90.4222V8.57781C73 4.96001 70.0505 2 66.4456 2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.9 44.1657V36.0657H33.1V44.1657H25V54.9657H33.1V63.0657H43.9V54.9657H52V44.1657H43.9Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.5003 2.78528V23.8672H11.1945"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'financeiro':
      return (
        <>
          <path
            {...props}
            d="M87.3333 2.00007L10.3334 2.00006C5.66669 2.00006 2.00003 5.7001 2.00003 10.4093L2.00003 96L16.3611 96M96 47.0882L96 10.4093C96 5.70011 92.5 2.00007 88.1666 2.00007C83.8333 2.00007 80.3333 5.70011 80.3333 10.4093L80.3333 49.5961L80.3333 55.8189L80.3333 96L32.0278 96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.7645 59.6999C30.7645 65.3276 35.4323 69.8889 41.1843 69.8889C46.9504 69.8889 51.6111 65.3276 51.6111 59.6999C51.6111 54.0723 46.0492 51.6065 41.1561 49C36.2771 46.3935 30.7222 43.9352 30.7222 38.3001C30.7222 32.6725 35.383 28.1111 41.142 28.1111C46.9011 28.1111 51.5618 32.6725 51.5618 38.3001"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M41.1667 28.1112L41.1667 20.2778"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M41.1667 77.7222V69.8889"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      );
    case 'historico':
      return (
        <>
          <path
            {...props}
            d="M50.4263 2H6.27273C3.92273 2 2 3.9125 2 6.25V65.75C2 68.0875 3.92273 70 6.27273 70H91.7273C94.0773 70 96 68.0875 96 65.75V6.25C96 3.9125 94.0773 2 91.7273 2H67.8641C66.7318 2 65.6423 2.44625 64.8518 3.25375L58.8059 11.2675C57.9941 12.0537 56.9045 12.5 55.7723 12.5H16.8113C14.4613 12.5 12.5386 14.4125 12.5386 16.75V57.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M54.9 35.1V27H44.1V35.1H36V45.9H44.1V54H54.9V45.9H63V35.1H54.9Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'internacao':
      return (
        <>
          <path
            {...props}
            d="M55.1304 10.2222V2H44.913V10.2222H36.7391V20.5H44.913V28.7222H55.1304V20.5H63.3043V10.2222H55.1304Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.8696 41.0555V65.7222"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17.3261 18.4444C13.0348 18.4444 10.1739 15.2789 10.1739 11.3939V9.05056C10.1739 5.145 13.0348 2 17.3261 2C21.6174 2 24.4783 5.145 24.4783 9.05056V11.3939C24.4783 15.2789 21.6174 18.4444 17.3261 18.4444Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 24.6111V76"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 65.7222H96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 53.3889H42.8696"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.1739 36.9444V32.8333C10.1739 26.6667 18.3478 24.6111 22.4348 28.7222L32.6522 41.0556H87.8261C92.3422 41.0556 96 44.735 96 49.2778V76"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'laudo':
      return (
        <>
          <path
            {...props}
            d="M62.8175 15H68.9779C71.7401 15 74 17.5064 74 20.5697V104.43C74 107.494 71.7401 110 68.9779 110H7.02209C4.25994 110 2 107.494 2 104.43V20.5697C2 17.5064 4.25994 15 7.02209 15H13.1825"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.4509 9.58221H45.7449C45.668 5.38878 42.2687 2 38.0696 2C33.8706 2 30.4713 5.38878 30.3944 9.58221H22.6884V21.3888H53.4509V9.58221Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M43.9773 59.1657V51.0657H33.1773V59.1657H25.0773V69.9657H33.1773V78.0657H43.9773V69.9657H52.0773V59.1657H43.9773Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'maternidade':
      return (
        <>
          <path
            {...props}
            d="M61.1441 88.3237C55.8211 93.039 48.8054 95.8967 41.1371 95.8967"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.4734 24.4536V55.0721"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.1775 63.9106C18.6011 70.4834 27.1056 75.7089 36.3036 79.3627L63.469 87.7318H71.3413L73.3808 80.8324L69.8525 75.0761C70.8111 72.1163 71.3413 68.9524 71.3413 65.666C71.3413 51.2141 61.1237 38.783 46.9495 36.0069L40.0765 34.6597H41.9324C46.5416 34.6597 50.2738 30.9243 50.2738 26.3111C50.2738 22.7593 48.0304 19.5954 44.6653 18.4319L40.7904 17.0847C35.4674 15.2272 31.0826 11.4713 28.3905 6.6336C26.7997 3.73505 23.6998 2 20.4162 2C15.3176 2 11.1775 6.1437 11.1775 11.2468V63.9106ZM11.1775 63.9106C4.9776 70.1159 2 76.9132 2 85.6905C2.04079 89.4668 3.36643 93.039 5.60983 95.9171"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.4189 34.4171H33.4189"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M26.4734 61.1958C31.0622 61.1958 35.4266 63.4207 44.8284 69.5649L62.1026 79.5669H65.6104"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'medico':
      return (
        <>
          <path
            {...props}
            d="M2 96V86.2117C2 77.9765 7.14956 70.62 14.8943 67.8L38.7826 61.0974V48.8978C34.0622 45.3217 30.6087 39.7022 30.6087 33.3265V20.473C30.6087 10.2761 38.8848 2 49.0817 2C59.2787 2 67.5548 10.2761 67.5548 20.473V33.3265C67.5548 43.8096 59.34 52.3513 49 52.8826"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.3043 89.8695V95.9999"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M96 96V86.2118C96 77.9766 90.8504 70.62 83.1057 67.8L59.2174 61.0974V50.9413"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67 65L49 87L31 65"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49 87V96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.6087 96C33.9945 96 36.7391 93.2553 36.7391 89.8696C36.7391 86.4838 33.9945 83.7391 30.6087 83.7391C27.223 83.7391 24.4783 86.4838 24.4783 89.8696C24.4783 93.2553 27.223 96 30.6087 96Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.6086 83.7391V65.0004"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M81.0214 96H83.7392V84.1887C83.7392 79.0391 80.4492 74.4821 75.5653 72.8474C70.6814 74.4821 67.3914 79.0391 67.3914 84.1887V96H70.1092"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M75.5652 72.8473V66.5"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'paciente':
      return (
        <>
          <path
            {...props}
            d="M58.4 49.6131V59.7627L85.4249 70.5439C91.7934 72.8896 95.9999 78.7538 95.9999 85.2947V96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M29.5 64C29.5 76.5 68.4588 76 68.4588 64"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M49 52.1167C59.387 52.1167 67.8 44.0421 67.8 34.0729V20.0438C67.8 10.0746 59.387 2 49 2C38.613 2 30.2 10.0746 30.2 20.0438V34.0729C30.2 40.3431 33.5135 45.869 38.5895 49.1169L39.6 49.7935V59.9206L12.6455 70.5665C6.23 72.8896 2 78.7764 2 85.3398V96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18 92V96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M80 92V96"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'plano':
      return (
        <>
          <path
            {...props}
            d="M91.9091 33.3636V8.25182C91.9091 4.78091 89.2536 2 85.7827 2H8.41909C4.96909 2 2 4.78091 2 8.25182V58.4127C2 61.8627 4.96909 64.7273 8.41909 64.7273H61"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 14.5454H91.9091"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2 27.0909H91.9091"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 38.3357H45"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.2727 48.4546H26.9091"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M83.9 45.4357V37.3357H73.1V45.4357H65V56.2357H73.1V64.3357H83.9V56.2357H92V45.4357H83.9Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'redeDor':
      return (
        <>
          <path
            {...props}
            d="M27 27V2H42V42H2V27H27Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27 67L2 67L2 52L42 52L42 92L27 92L27 67Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67 67L67 92L52 92L52 52L92 52L92 67L67 67Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M67 27L92 27L92 42L52 42L52 2L67 2L67 27Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'riProduto':
      return (
        <>
          <path
            {...props}
            d="M37.7224 60.8592C37.7224 66.8364 42.9367 71.6811 49.3622 71.6811C55.8035 71.6811 61.0099 66.8364 61.0099 60.8592C61.0099 54.882 54.7968 52.263 49.3308 49.4946C43.8805 46.7262 37.6752 44.1151 37.6752 38.1301C37.6752 32.1529 42.8817 27.3082 49.315 27.3082C55.7484 27.3082 60.9549 32.1529 60.9549 38.1301"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M49.315 27.2532V19.3177"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M49.315 79.6873V71.7439"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M20.0896 13.0652C24.8164 9.25871 30.3531 6.3173 36.5584 4.54773C61.3166 -2.53054 87.1287 11.8069 94.1991 36.5572C101.262 61.3233 86.9242 87.1197 62.166 94.1901C37.4157 101.268 11.6114 86.9231 4.54104 62.1727C1.09629 50.0925 2.74002 37.7841 8.19815 27.5049"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'unidade':
      return (
        <>
          <path
            {...props}
            d="M58 30.3749C58 30.3967 58 30.3967 58 30.4186V30.3312C58 30.353 58 30.3749 58 30.3749ZM30 2C14.5354 2 2 14.6791 2 30.3749C2 52.126 22.9569 57.0009 30 80.6976C37.0215 57.0228 57.9569 52.0823 58 30.3749C57.9785 14.7009 45.4431 2 30 2Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.8831 75.4075C8.03077 77.2437 2 80.8726 2 85.0698C2 91.1033 14.5354 96 30 96C45.4646 96 58 91.1033 58 85.0698C58 80.8726 51.9692 77.2437 43.1169 75.4075"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M34.3077 26.0465V17.3023H25.6923V26.0465H17.0769V34.7907H25.6923V43.5349H34.3077V34.7907H42.9231V26.0465H34.3077Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'wallet':
      return (
        <>
          <path
            {...props}
            d="M88.7255 61.7327V73.0253C88.7255 77.7743 84.8387 81.6611 80.0853 81.6611H10.6402C5.88676 81.6611 2 77.7743 2 73.0253V7.51068"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M63.4703 47.2493C63.4703 47.9934 62.8707 48.5974 62.1266 48.5974C61.3869 48.5974 60.7828 47.9934 60.7828 47.2493C60.7828 46.5052 61.3869 45.9055 62.1266 45.9055C62.8707 45.9012 63.4703 46.5008 63.4703 47.2493Z"
            fill={color}
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M57.8765 61.3605C53.1231 61.3605 49.2363 57.4738 49.2363 52.7204V41.7779C49.2363 37.0245 53.1231 33.1422 57.8765 33.1422H96V61.3649H57.8765V61.3605Z"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M62 2H7.08167C4.22788 2 2 4.5474 2 7.51062C2 10.4826 4.22788 12.798 7.08167 12.798H80.0853C84.8387 12.798 88.7255 16.7198 88.7255 21.4688V26.3579"
            stroke={color}
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case '360':
      return (
        <>
          <path
            {...props}
            d="M11.6597 12.9665C14.9533 12.6023 17.328 9.63696 16.9638 6.34334C16.5995 3.04971 13.6343 0.67497 10.3406 1.03921C7.047 1.40345 4.67226 4.36874 5.0365 7.66237C5.40074 10.956 8.36604 13.3307 11.6597 12.9665Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 5V9"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 7H11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 18.0001C5.47692 18.0001 1 16.8112 1 15.3462C1 14.6019 2.14883 13.9312 4 13.45M16.1032 17.6289C19.0353 17.166 21 16.3167 21 15.3462C21 14.6019 19.8512 13.9312 18 13.45"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 18L10 20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 18L10 16"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'alert':
      return (
        <>
          <path
            {...props}
            d="M3 11C3 7.13401 6.13401 4 10 4V4C13.866 4 17 7.13401 17 11V18H3V11Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 18L19 18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="10"
            cy="2"
            r="1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 19C12 20.1046 11.1046 21 10 21C8.89543 21 8 20.1046 8 19"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'alertCircle':
      return (
        <>
          <path
            {...props}
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.9761 17.137V16.3623"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.9762 12.5374V5.85083"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );

    case 'cancelCircle':
      return (
        <>
          <path
            {...props}
            d="M7.92893 22.0711C11.8342 25.9764 18.1658 25.9764 22.0711 22.0711C25.9763 18.1659 25.9763 11.8342 22.0711 7.92898C18.1658 4.02373 11.8342 4.02373 7.92893 7.92898C4.02369 11.8342 4.02369 18.1659 7.92893 22.0711Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.4645 11.4646L18.5355 18.5357"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.4645 18.5357L18.5355 11.4646"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'card':
      return (
        <path
          {...props}
          d="M28 18H36M28 24H36M28 30H30M18 19C18 20.6569 16.6569 22 15 22C13.3431 22 12 20.6569 12 19C12 17.3431 13.3431 16 15 16C16.6569 16 18 17.3431 18 19ZM20 32V30C20 27.7909 18.2091 26 16 26H14C11.7909 26 10 27.7909 10 30V32H20ZM8 40H40C42.2091 40 44 38.2091 44 36V12C44 9.79086 42.2091 8 40 8H8C5.79086 8 4 9.79086 4 12V36C4 38.2091 5.79086 40 8 40Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      );
    case 'alertTri':
      return (
        <>
          <path
            {...props}
            d="M32 42.2602V40.9602"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32 34.22V25"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.1467 13.3963C31.5366 12.7582 32.4634 12.7582 32.8533 13.3963L53.0702 46.4785C53.4774 47.1449 52.9979 48 52.2169 48H11.7831C11.0021 48 10.5226 47.1449 10.9298 46.4785L31.1467 13.3963Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'alertTriBlockedAccess':
      return (
        <>
          <path
            {...props}
            d="M22.5 30.26V28.96"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M22.5 22.22V13"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21.6503 1.36895C22.0415 0.738738 22.9585 0.738742 23.3496 1.36895L43.8958 34.4727C44.3092 35.1388 43.8302 36 43.0461 36H1.95386C1.16983 36 0.690756 35.1388 1.10421 34.4727L21.6503 1.36895Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'alertTriInfo':
      return (
        <>
          <path
            {...props}
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 6L11 7"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 11L11 17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'appointment':
      return (
        <>
          <path
            {...props}
            d="M1 7H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 1V3"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 11L11 17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 14L8 14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 1V3"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.66191 2.03387H1.89127C1.40404 2.03387 1 2.42648 1 2.91427V20.1297C1 20.6175 1.39216 21.022 1.89127 21.022H20.1087C20.596 21.022 21 20.6294 21 20.1297V2.91427C21 2.42648 20.6078 2.02197 20.1087 2.02197H18.3381"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 2H12"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'arrowDown':
      return (
        <>
          <path
            {...props}
            d="M21 11.0565L11.0164 21M10.8852 20.8547L10.8852 0.999999L10.8852 20.8547ZM1 11.0565L11.0164 21L1 11.0565Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'arrowLeft':
      return (
        <>
          <path
            {...props}
            d="M10.9435 1L1 10.9836M1.14528 11.1148H21H1.14528ZM10.9435 21L1 10.9836L10.9435 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'arrowRight':
      return (
        <>
          <path
            {...props}
            d="M11.0565 1L21 10.9836M20.8547 11.1148H0.999999H20.8547ZM11.0565 21L21 10.9836L11.0565 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'arrowUp':
      return (
        <>
          <path
            {...props}
            d="M1 10.9435L10.9836 1M11.1148 1.14528L11.1148 21L11.1148 1.14528ZM21 10.9435L10.9836 1L21 10.9435Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'attachment':
      return (
        <>
          <path
            {...props}
            d="M2.23864 11.0553C2.23864 11.0553 8.67879 4.50719 10.7364 2.4542C11.6183 1.5686 12.607 1.11238 13.7294 1.01845C14.2104 0.991617 14.6379 0.951363 15.6267 1.24656C17.1365 1.70278 18.4994 3.29955 18.8735 4.92315C19.2476 6.53334 18.7799 8.17036 17.6309 9.33774C16.749 10.2233 7.70342 19.3209 6.84829 20.1528C5.81947 21.186 4.09586 21.0653 3.37435 20.864C2.43906 20.609 1.46368 19.8442 1.12965 18.6634C0.795618 17.4558 1.11629 16.181 1.98478 15.2686C2.05158 15.2015 10.9502 6.2113 10.9502 6.2113C11.5248 5.64774 12.1795 5.41963 12.9678 5.48672C13.5156 5.54039 13.8229 5.74166 14.1436 6.15763C14.4642 6.56017 14.6513 6.92246 14.5711 7.52628C14.4776 8.15694 14.2237 8.65341 13.7561 9.10963C11.6584 11.1358 9.45375 13.4571 6.78149 16.0468"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'avatarMan':
      return (
        <>
          <path
            {...props}
            d="M13 11.5557V13.3426L18.75 15.6462C20.105 16.1475 21 17.4005 21 18.7981V21.0001"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 21V18.8076C1 17.4052 1.9 16.1473 3.265 15.6509L9 13.3762V11.2123L8.785 11.0677C7.705 10.3737 7 9.19296 7 7.85317V4.85551C7 2.72534 8.79 1 11 1C13.21 1 15 2.72534 15 4.85551V7.85317C15 9.55075 13.8632 10.9912 12.2829 11.5063"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 3L12.5 5.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'avatarWomen':
      return (
        <>
          <path
            {...props}
            d="M13 11.5557V13.3426L18.75 15.6462C20.105 16.1475 21 17.4005 21 18.7981V21.0001"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 6V7.85313C15 9.55071 13.8632 10.9912 12.2829 11.5062M7 5V7.85313C7 9.19292 7.705 10.3737 8.785 11.0677L9 11.2122V13.3761L3.265 15.6509C1.9 16.1473 1 17.4052 1 18.8076V20.9999"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 15V7C17 3.68629 14.3137 1 11 1V1C7.68629 1 5 3.68629 5 7V15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6 5L11 5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'biometry':
      return (
        <>
          <path
            {...props}
            d="M12.4968 1.73193C13.0069 1.75319 13.5169 1.80631 14.0269 1.90195C14.3032 1.95508 14.452 1.98695 14.6114 2.01883C19.5311 3.18767 22.942 7.46988 23.1758 12.3259"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.76361 6.75787C4.45312 4.18642 7.17333 2.40128 10.2229 1.88062"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19.68 8.24561C19.7437 8.35186 19.8075 8.45812 19.8712 8.57501C20.8063 10.2858 21.1888 12.3047 20.8382 14.3661C20.8063 14.5467 20.4663 16.4169 19.4143 18.8502"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.56055 10.2644C4.84627 6.01411 9.17099 3.28327 13.6445 4.08021C13.857 4.12271 13.9845 4.14396 14.112 4.17584C15.7803 4.56899 17.236 5.41906 18.373 6.55602"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.6386 13.9836C18.5961 14.1962 18.0648 17.1183 16.2053 20.3379"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.0364 6.86426C16.9597 7.82058 18.2986 9.65885 18.6492 11.7415"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.91119 14.6955C4.86752 13.7285 5.37756 12.2197 5.51569 11.5821C6.1745 8.10748 9.4685 5.75917 12.9538 6.22671"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.164 17.5327C14.4945 19.0203 13.5063 20.7098 12.0718 22.2506"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.903 8.55368C11.5193 8.38366 12.1887 8.34116 12.8581 8.46867C12.9431 8.48992 13.0175 8.50055 13.0812 8.51117C15.3764 9.05309 16.8534 11.2845 16.4496 13.6009C16.4284 13.6966 16.3009 14.4085 15.9608 15.4498"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.99622 17.3521C6.88644 15.9707 7.69401 12.071 7.70463 12.0285C7.88527 11.051 8.38468 10.2009 9.07536 9.57397"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.88286 12.4428C10.106 11.242 11.2536 10.4345 12.4649 10.647C13.6763 10.8701 14.4732 12.0071 14.2607 13.2184C14.2182 13.4841 13.1875 19.052 8.66089 22.3035"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4.95251 19.3496C7.30082 18.2339 8.59717 16.0343 9.25598 14.4192"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.0718 12.8359C12.0718 12.8359 11.0092 18.9245 5.90881 21.3579"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'blood':
      return (
        <>
          <path
            {...props}
            d="M8.49531 1L13.8016 6.12715C14.8509 7.14046 15.5657 8.43171 15.8555 9.8376C16.1453 11.2435 15.9971 12.7008 15.4296 14.0253C14.8621 15.3498 13.9008 16.4818 12.6673 17.2784C11.4338 18.0749 9.98357 18.5 8.5 18.5C7.01643 18.5 5.56619 18.0749 4.33271 17.2784C3.09924 16.4818 2.13795 15.3498 1.57044 14.0253C1.00292 12.7008 0.854686 11.2435 1.14447 9.8376C1.43426 8.43171 2.14905 7.14046 3.19844 6.12715L8.49531 1Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'calendar':
      return (
        <>
          <path
            {...props}
            d="M1 7H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 1V3"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 1V3"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.66191 2.03387H1.89127C1.40404 2.03387 1 2.42648 1 2.91427V20.1297C1 20.6175 1.39216 21.022 1.89127 21.022H20.1087C20.596 21.022 21 20.6294 21 20.1297V2.91427C21 2.42648 20.6078 2.02197 20.1087 2.02197H18.3381"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 2H12"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18 10H15V13H18V10Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'camera':
      return (
        <>
          <path
            {...props}
            d="M10.5 5H7.72608C7.38146 5 7.06061 5.19126 6.90612 5.48379L6.25253 6.69888C6.09804 6.9914 5.77718 7.18266 5.43256 7.18266H1.89127C1.40404 7.18266 1 7.55394 1 8.02647V21.1562C1 21.6175 1.39216 22 1.89127 22H20.1087C20.596 22 21 21.6287 21 21.1562V8.01522C21 7.55394 20.6078 7.17141 20.1087 7.17141H19.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.327 3.01623L15.1716 1.1716L16.0917 2.09168L17.0118 3.01176M15.1716 6.82843L15.1773 1.17734"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 18C13.2091 18 15 16.2091 15 14C15 11.7909 13.2091 10 11 10C8.79086 10 7 11.7909 7 14C7 16.2091 8.79086 18 11 18Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'chatCircle':
      return (
        <>
          <path
            {...props}
            d="M5.90435 19.6L1 21L2.55652 16.3391C1.56522 14.8 1 12.9652 1 11C1 5.47826 5.47826 1 11 1C16.5217 1 21 5.47826 21 11C21 16.5217 16.5217 21 11 21C9.13913 21 7.3913 20.487 5.90435 19.6Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 11L11 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 11L6 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 11L16 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'check':
      return (
        <>
          <path
            {...props}
            d="M21 1L7.78718 15L1 7.94878"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'checkBadge':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.30911 15.5115C3.02092 17.3508 3.28456 18.7525 4.20352 19.6715C5.12248 20.5904 6.52425 20.8541 8.36351 20.5659C9.46027 22.0702 10.6379 22.875 11.9375 22.875C13.2371 22.875 14.4147 22.0702 15.5115 20.5659C17.3508 20.8541 18.7525 20.5904 19.6715 19.6715C20.5904 18.7525 20.8541 17.3508 20.5659 15.5115C22.0702 14.4147 22.875 13.2371 22.875 11.9375C22.875 10.6379 22.0702 9.46027 20.5659 8.36351C20.8541 6.52425 20.5904 5.12248 19.6715 4.20352C18.7525 3.28456 17.3508 3.02092 15.5115 3.30911C14.4147 1.80478 13.2371 1 11.9375 1C10.6379 1 9.46027 1.80478 8.36351 3.30911C6.52425 3.02092 5.12248 3.28456 4.20352 4.20352C3.28456 5.12248 3.02092 6.52425 3.30911 8.36351C1.80478 9.46027 1 10.6379 1 11.9375C1 13.2371 1.80478 14.4147 3.30911 15.5115Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.3125 8.65625L10.5319 15.2187L7.5625 11.9135"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'checkCircle':
      return (
        <>
          <path
            {...props}
            d="M22 6L12.751 16L8 10.9634"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18 3.28047C17.0391 2.69212 15.9616 2.25741 14.7944 2.01704C9.38507 0.903059 4.09688 4.38513 2.9829 9.79447C1.86892 15.2038 5.35099 20.492 10.7603 21.606C16.1697 22.7199 21.4579 19.2379 22.5718 13.8285C22.7683 12.8745 22.8218 11.9243 22.747 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'checkHard':
      return (
        <>
          <path
            {...props}
            d="M17 1L6.42975 12L1 6.45976"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 2L10.9765 12.5L10 11.5235"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'circleChevronDown':
      return (
        <>
          <path
            {...props}
            d="M1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 10L11.0032 13L8 10"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'circleChevronLeft':
      return (
        <>
          <path
            {...props}
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 8L9 10.9968L12 14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'circleChevronRight':
      return (
        <>
          <path
            {...props}
            d="M11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 8L13 10.9968L10 14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'circleChevronUp':
      return (
        <>
          <path
            {...props}
            d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 0.999999 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 12L10.9968 9L14 12"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'close':
      return (
        <>
          <path
            {...props}
            d="M1 19.0601L19.0601 1M1 1L19.0601 19.0601L1 1Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'closeStrong':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3749 8.70825C17.6741 8.4091 17.6741 7.92407 17.3749 7.62492C17.0758 7.32576 16.5907 7.32576 16.2916 7.62492L12.4999 11.4166L8.70825 7.62492C8.4091 7.32576 7.92407 7.32576 7.62492 7.62492C7.32576 7.92407 7.32576 8.4091 7.62492 8.70825L11.4166 12.4999L7.62492 16.2916C7.32576 16.5907 7.32576 17.0758 7.62492 17.3749C7.92407 17.6741 8.4091 17.6741 8.70825 17.3749L12.4999 13.5833L16.2916 17.3749C16.5907 17.6741 17.0758 17.6741 17.3749 17.3749C17.6741 17.0758 17.6741 16.5907 17.3749 16.2916L13.5833 12.4999L17.3749 8.70825Z"
            fill={color}
          />
        </>
      );
    case 'clockDisabled':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5327 7.74199H9.25768V5.46699C9.25768 5.04763 8.91795 4.70866 8.49935 4.70866C8.08075 4.70866 7.74101 5.04763 7.74101 5.46699V8.50032C7.74101 8.91968 8.08075 9.25866 8.49935 9.25866H11.5327C11.952 9.25866 12.291 8.91968 12.291 8.50032C12.291 8.08097 11.952 7.74199 11.5327 7.74199ZM8.49935 14.567C5.15434 14.567 2.43268 11.8453 2.43268 8.50032C2.43268 5.15532 5.15434 2.43366 8.49935 2.43366C11.8444 2.43366 14.566 5.15532 14.566 8.50032C14.566 11.8453 11.8444 14.567 8.49935 14.567ZM8.49935 0.916992C4.3179 0.916992 0.916016 4.31888 0.916016 8.50032C0.916016 12.6818 4.3179 16.0837 8.49935 16.0837C12.6808 16.0837 16.0827 12.6818 16.0827 8.50032C16.0827 4.31888 12.6808 0.916992 8.49935 0.916992Z"
            fill="#BDBDBD"
          />
        </>
      );
    case 'collapse':
      return (
        <>
          <path
            {...props}
            d="M1 1L7 7L13 1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 21L7 15L1 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'dateRange':
      return (
        <>
          <path
            {...props}
            d="M1.01843 7H21.0184"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.5 1H21.0184M1 1H2.01843"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.5 13H1M21.0184 13H20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'delete':
      return (
        <>
          <path
            {...props}
            d="M1.68382 5.62671H3.77424H20.4975"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.90985 5.62687V3.53646C6.90985 2.98205 7.13009 2.45034 7.52212 2.05831C7.91415 1.66628 8.44585 1.44604 9.00026 1.44604H13.1811C13.7355 1.44604 14.2672 1.66628 14.6592 2.05831C15.0513 2.45034 15.2715 2.98205 15.2715 3.53646V5.62687M18.4071 5.62687V20.2598C18.4071 20.8142 18.1869 21.3459 17.7949 21.7379C17.4028 22.1299 16.8711 22.3502 16.3167 22.3502H5.86464C5.31023 22.3502 4.77853 22.1299 4.3865 21.7379C3.99447 21.3459 3.77423 20.8142 3.77423 20.2598V5.62687H18.4071Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.00029 10.853V17.1243"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.1811 10.853V17.1243"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'download':
      return (
        <>
          <path
            {...props}
            d="M1 21H17M9.00773 18.9576V1V18.9576ZM8.99227 18.9733L16.8609 11.055L8.99227 18.9733ZM8.99227 18.9733L1.2628 11.055L8.99227 18.9733Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'duplicate':
      return (
        <>
          <path
            {...props}
            d="M13.8816 21H2.1184C1.49929 21 1 20.5007 1 19.8816V8.1184C1 7.49929 1.49929 7 2.1184 7H13.8816C14.5007 7 15 7.49929 15 8.1184V19.8816C15 20.5007 14.5007 21 13.8816 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 3.50785V2.1184C7 1.49929 7.49929 1 8.1184 1H19.8816C20.5007 1 21 1.49929 21 2.1184V13.8816C21 14.5007 20.5007 15 19.8816 15H18.4922"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'edit':
      return (
        <>
          <path
            {...props}
            d="M2.7969 16.274L17.6023 1.47513C18.2351 0.841622 19.2727 0.841622 19.9181 1.47513L20.5255 2.08331C21.1582 2.71682 21.1582 3.75578 20.5255 4.40196L5.70737 19.1882L1 21L2.7969 16.274Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 5L17 7"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4 16L6 18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'en':
      return (
        <>
          <path
            {...props}
            d="M9 8L6 8L6 11M9 11L6 11M6 11L6 14L9 14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 14V8L16 14V8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="1"
            y="1"
            width="20"
            height="20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'exit':
      return (
        <>
          <path
            {...props}
            d="M12 3H15V6M12 19H15V16M20.5 10.7383H12M21 10.7588L18.19 13.5687M21 10.8099L18.19 7.99998M8.5297 20.9884L1.3091 18.8852C1.136 18.8493 1 18.7059 1 18.5386V3.54156C1 3.37427 1.12364 3.23087 1.29674 3.19502L8.51734 1.00819C8.76462 0.960394 8.99953 1.12769 8.99953 1.35474V20.6538C9.0119 20.8689 8.77698 21.0481 8.5297 20.9884Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'expand':
      return (
        <>
          <path
            {...props}
            d="M1 7L7 1L13 7"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 15L7 21L1 15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'externalLink':
      return (
        <>
          <path
            {...props}
            d="M8 1H1V21H21V14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.4122 1H21V8.60563M20.8361 1.14085L11 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'iconFerias':
      return (
        <>
          <path
            {...props}
            d="M3.00002 13C2.99174 9.79757 5.62007 6.84259 9.29476 6.14916C12.9694 5.45286 16.426 7.25692 17.5 10.2551"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 12.3823C7 12.3823 5.26395 11.1972 3 13"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 11C13 11 14.4419 9.47312 17.5 10.1928"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 10.9189C13 10.9189 9.49025 9.27513 7 12.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 6.5C9 6.5 6.53803 7.74941 7.07719 12.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 6.5C9 6.5 11.8583 6.69293 13 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.5 20.5L12.75 21.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.5 12.5L11.75 17.25"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 4L8.25 4.75"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 13.5L18.2525 19H3"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.5 17H19"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4.5 21.5L5.5 19"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 19L16 17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 21.5L18 19"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'iconPng':
      return (
        <>
          <path
            {...props}
            d="M4.5 11.8906V5.35942C4.5 4.88526 4.87645 4.5 5.33977 4.5H14.6351C14.9681 4.5 15.3012 4.63336 15.5473 4.88526L19.1236 8.54521C19.3697 8.79711 19.5 9.1231 19.5 9.47872V11.8906"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.25 4.5V9.26641C14.25 9.94402 14.7133 10.5 15.278 10.5H17.25"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip0)">
            <path
              {...props}
              d="M18.9697 15.9053C19.2626 16.1982 19.7374 16.1982 20.0303 15.9053C20.3232 15.6124 20.3232 15.1376 20.0303 14.8447L18.9697 15.9053ZM19.5 17.25H20.25C20.25 16.8358 19.9142 16.5 19.5 16.5V17.25ZM18.375 16.5C17.9608 16.5 17.625 16.8358 17.625 17.25C17.625 17.6642 17.9608 18 18.375 18V16.5ZM20.0303 14.8447C19.5914 14.4057 19.073 14.2337 18.5791 14.1789L18.4135 15.6697C18.6704 15.6982 18.8351 15.7708 18.9697 15.9053L20.0303 14.8447ZM15.75 17V17.9384H17.25V17H15.75ZM18.0001 20.4857C18.3925 20.5074 18.8709 20.4997 19.2796 20.3662C19.4898 20.2975 19.7329 20.1793 19.9284 19.9661C20.139 19.7364 20.25 19.4439 20.25 19.125H18.75C18.75 19.0822 18.7707 19.0092 18.8228 18.9524C18.8598 18.912 18.8764 18.9199 18.8139 18.9403C18.6774 18.9849 18.4267 19.007 18.0831 18.988L18.0001 20.4857ZM20.25 19.125C20.25 19.1228 20.25 19.1206 20.25 19.1184C20.25 19.1162 20.25 19.114 20.25 19.1118C20.25 19.1096 20.25 19.1075 20.25 19.1053C20.25 19.1031 20.25 19.1009 20.25 19.0987C20.25 19.0965 20.25 19.0943 20.25 19.0922C20.25 19.09 20.25 19.0878 20.25 19.0856C20.25 19.0834 20.25 19.0813 20.25 19.0791C20.25 19.0769 20.25 19.0747 20.25 19.0725C20.25 19.0704 20.25 19.0682 20.25 19.066C20.25 19.0639 20.25 19.0617 20.25 19.0595C20.25 19.0574 20.25 19.0552 20.25 19.053C20.25 19.0509 20.25 19.0487 20.25 19.0465C20.25 19.0444 20.25 19.0422 20.25 19.04C20.25 19.0379 20.25 19.0357 20.25 19.0336C20.25 19.0314 20.25 19.0293 20.25 19.0271C20.25 19.025 20.25 19.0228 20.25 19.0206C20.25 19.0185 20.25 19.0163 20.25 19.0142C20.25 19.0121 20.25 19.0099 20.25 19.0078C20.25 19.0056 20.25 19.0035 20.25 19.0013C20.25 18.9992 20.25 18.997 20.25 18.9949C20.25 18.9928 20.25 18.9906 20.25 18.9885C20.25 18.9864 20.25 18.9842 20.25 18.9821C20.25 18.98 20.25 18.9778 20.25 18.9757C20.25 18.9736 20.25 18.9714 20.25 18.9693C20.25 18.9672 20.25 18.9651 20.25 18.9629C20.25 18.9608 20.25 18.9587 20.25 18.9566C20.25 18.9544 20.25 18.9523 20.25 18.9502C20.25 18.9481 20.25 18.946 20.25 18.9439C20.25 18.9417 20.25 18.9396 20.25 18.9375C20.25 18.9354 20.25 18.9333 20.25 18.9312C20.25 18.9291 20.25 18.927 20.25 18.9249C20.25 18.9228 20.25 18.9207 20.25 18.9186C20.25 18.9165 20.25 18.9144 20.25 18.9123C20.25 18.9102 20.25 18.9081 20.25 18.906C20.25 18.9039 20.25 18.9018 20.25 18.8997C20.25 18.8976 20.25 18.8955 20.25 18.8934C20.25 18.8913 20.25 18.8892 20.25 18.8871C20.25 18.885 20.25 18.883 20.25 18.8809C20.25 18.8788 20.25 18.8767 20.25 18.8746C20.25 18.8725 20.25 18.8705 20.25 18.8684C20.25 18.8663 20.25 18.8642 20.25 18.8621C20.25 18.8601 20.25 18.858 20.25 18.8559C20.25 18.8539 20.25 18.8518 20.25 18.8497C20.25 18.8476 20.25 18.8456 20.25 18.8435C20.25 18.8414 20.25 18.8394 20.25 18.8373C20.25 18.8353 20.25 18.8332 20.25 18.8311C20.25 18.8291 20.25 18.827 20.25 18.825C20.25 18.8229 20.25 18.8208 20.25 18.8188C20.25 18.8167 20.25 18.8147 20.25 18.8126C20.25 18.8106 20.25 18.8085 20.25 18.8065C20.25 18.8044 20.25 18.8024 20.25 18.8004C20.25 18.7983 20.25 18.7963 20.25 18.7942C20.25 18.7922 20.25 18.7901 20.25 18.7881C20.25 18.7861 20.25 18.784 20.25 18.782C20.25 18.78 20.25 18.7779 20.25 18.7759C20.25 18.7739 20.25 18.7718 20.25 18.7698C20.25 18.7678 20.25 18.7658 20.25 18.7637C20.25 18.7617 20.25 18.7597 20.25 18.7577C20.25 18.7556 20.25 18.7536 20.25 18.7516C20.25 18.7496 20.25 18.7476 20.25 18.7456C20.25 18.7435 20.25 18.7415 20.25 18.7395C20.25 18.7375 20.25 18.7355 20.25 18.7335C20.25 18.7315 20.25 18.7295 20.25 18.7275C20.25 18.7254 20.25 18.7234 20.25 18.7214C20.25 18.7194 20.25 18.7174 20.25 18.7154C20.25 18.7134 20.25 18.7114 20.25 18.7094C20.25 18.7074 20.25 18.7055 20.25 18.7035C20.25 18.7015 20.25 18.6995 20.25 18.6975C20.25 18.6955 20.25 18.6935 20.25 18.6915C20.25 18.6895 20.25 18.6875 20.25 18.6856C20.25 18.6836 20.25 18.6816 20.25 18.6796C20.25 18.6776 20.25 18.6757 20.25 18.6737C20.25 18.6717 20.25 18.6697 20.25 18.6678C20.25 18.6658 20.25 18.6638 20.25 18.6618C20.25 18.6599 20.25 18.6579 20.25 18.6559C20.25 18.654 20.25 18.652 20.25 18.65C20.25 18.6481 20.25 18.6461 20.25 18.6442C20.25 18.6422 20.25 18.6402 20.25 18.6383C20.25 18.6363 20.25 18.6344 20.25 18.6324C20.25 18.6305 20.25 18.6285 20.25 18.6266C20.25 18.6246 20.25 18.6227 20.25 18.6207C20.25 18.6188 20.25 18.6168 20.25 18.6149C20.25 18.6129 20.25 18.611 20.25 18.609C20.25 18.6071 20.25 18.6052 20.25 18.6032C20.25 18.6013 20.25 18.5994 20.25 18.5974C20.25 18.5955 20.25 18.5936 20.25 18.5916C20.25 18.5897 20.25 18.5878 20.25 18.5858C20.25 18.5839 20.25 18.582 20.25 18.5801C20.25 18.5781 20.25 18.5762 20.25 18.5743C20.25 18.5724 20.25 18.5705 20.25 18.5685C20.25 18.5666 20.25 18.5647 20.25 18.5628C20.25 18.5609 20.25 18.559 20.25 18.5571C20.25 18.5551 20.25 18.5532 20.25 18.5513C20.25 18.5494 20.25 18.5475 20.25 18.5456C20.25 18.5437 20.25 18.5418 20.25 18.5399C20.25 18.538 20.25 18.5361 20.25 18.5342C20.25 18.5323 20.25 18.5304 20.25 18.5285C20.25 18.5266 20.25 18.5247 20.25 18.5229C20.25 18.521 20.25 18.5191 20.25 18.5172C20.25 18.5153 20.25 18.5134 20.25 18.5115C20.25 18.5097 20.25 18.5078 20.25 18.5059C20.25 18.504 20.25 18.5021 20.25 18.5003C20.25 18.4984 20.25 18.4965 20.25 18.4946C20.25 18.4928 20.25 18.4909 20.25 18.489C20.25 18.4871 20.25 18.4853 20.25 18.4834C20.25 18.4815 20.25 18.4797 20.25 18.4778C20.25 18.476 20.25 18.4741 20.25 18.4722C20.25 18.4704 20.25 18.4685 20.25 18.4667C20.25 18.4648 20.25 18.463 20.25 18.4611C20.25 18.4593 20.25 18.4574 20.25 18.4556C20.25 18.4537 20.25 18.4519 20.25 18.45C20.25 18.4482 20.25 18.4463 20.25 18.4445C20.25 18.4426 20.25 18.4408 20.25 18.439C20.25 18.4371 20.25 18.4353 20.25 18.4335C20.25 18.4316 20.25 18.4298 20.25 18.428C20.25 18.4261 20.25 18.4243 20.25 18.4225C20.25 18.4206 20.25 18.4188 20.25 18.417C20.25 18.4152 20.25 18.4133 20.25 18.4115C20.25 18.4097 20.25 18.4079 20.25 18.4061C20.25 18.4042 20.25 18.4024 20.25 18.4006C20.25 18.3988 20.25 18.397 20.25 18.3952C20.25 18.3934 20.25 18.3916 20.25 18.3898C20.25 18.3879 20.25 18.3861 20.25 18.3843C20.25 18.3825 20.25 18.3807 20.25 18.3789C20.25 18.3771 20.25 18.3753 20.25 18.3735C20.25 18.3717 20.25 18.37 20.25 18.3682C20.25 18.3664 20.25 18.3646 20.25 18.3628C20.25 18.361 20.25 18.3592 20.25 18.3574C20.25 18.3556 20.25 18.3539 20.25 18.3521C20.25 18.3503 20.25 18.3485 20.25 18.3467C20.25 18.345 20.25 18.3432 20.25 18.3414C20.25 18.3396 20.25 18.3379 20.25 18.3361C20.25 18.3343 20.25 18.3325 20.25 18.3308C20.25 18.329 20.25 18.3272 20.25 18.3255C20.25 18.3237 20.25 18.322 20.25 18.3202C20.25 18.3184 20.25 18.3167 20.25 18.3149C20.25 18.3132 20.25 18.3114 20.25 18.3097C20.25 18.3079 20.25 18.3062 20.25 18.3044C20.25 18.3027 20.25 18.3009 20.25 18.2992C20.25 18.2974 20.25 18.2957 20.25 18.2939C20.25 18.2922 20.25 18.2905 20.25 18.2887C20.25 18.287 20.25 18.2852 20.25 18.2835C20.25 18.2818 20.25 18.28 20.25 18.2783C20.25 18.2766 20.25 18.2748 20.25 18.2731C20.25 18.2714 20.25 18.2697 20.25 18.2679C20.25 18.2662 20.25 18.2645 20.25 18.2628C20.25 18.2611 20.25 18.2593 20.25 18.2576C20.25 18.2559 20.25 18.2542 20.25 18.2525C20.25 18.2508 20.25 18.2491 20.25 18.2473C20.25 18.2456 20.25 18.2439 20.25 18.2422C20.25 18.2405 20.25 18.2388 20.25 18.2371C20.25 18.2354 20.25 18.2337 20.25 18.232C20.25 18.2303 20.25 18.2286 20.25 18.2269C20.25 18.2252 20.25 18.2235 20.25 18.2218C20.25 18.2202 20.25 18.2185 20.25 18.2168C20.25 18.2151 20.25 18.2134 20.25 18.2117C20.25 18.21 20.25 18.2084 20.25 18.2067C20.25 18.205 20.25 18.2033 20.25 18.2017C20.25 18.2 20.25 18.1983 20.25 18.1966C20.25 18.195 20.25 18.1933 20.25 18.1916C20.25 18.19 20.25 18.1883 20.25 18.1866C20.25 18.185 20.25 18.1833 20.25 18.1816C20.25 18.18 20.25 18.1783 20.25 18.1767C20.25 18.175 20.25 18.1734 20.25 18.1717C20.25 18.17 20.25 18.1684 20.25 18.1667C20.25 18.1651 20.25 18.1634 20.25 18.1618C20.25 18.1602 20.25 18.1585 20.25 18.1569C20.25 18.1552 20.25 18.1536 20.25 18.152C20.25 18.1503 20.25 18.1487 20.25 18.147C20.25 18.1454 20.25 18.1438 20.25 18.1421C20.25 18.1405 20.25 18.1389 20.25 18.1373C20.25 18.1356 20.25 18.134 20.25 18.1324C20.25 18.1308 20.25 18.1291 20.25 18.1275C20.25 18.1259 20.25 18.1243 20.25 18.1227C20.25 18.1211 20.25 18.1195 20.25 18.1178C20.25 18.1162 20.25 18.1146 20.25 18.113C20.25 18.1114 20.25 18.1098 20.25 18.1082C20.25 18.1066 20.25 18.105 20.25 18.1034C20.25 18.1018 20.25 18.1002 20.25 18.0986C20.25 18.097 20.25 18.0954 20.25 18.0938C20.25 18.0922 20.25 18.0906 20.25 18.089C20.25 18.0875 20.25 18.0859 20.25 18.0843C20.25 18.0827 20.25 18.0811 20.25 18.0795C20.25 18.078 20.25 18.0764 20.25 18.0748C20.25 18.0732 20.25 18.0717 20.25 18.0701C20.25 18.0685 20.25 18.0669 20.25 18.0654C20.25 18.0638 20.25 18.0622 20.25 18.0607C20.25 18.0591 20.25 18.0576 20.25 18.056C20.25 18.0544 20.25 18.0529 20.25 18.0513C20.25 18.0498 20.25 18.0482 20.25 18.0466C20.25 18.0451 20.25 18.0435 20.25 18.042C20.25 18.0404 20.25 18.0389 20.25 18.0374C20.25 18.0358 20.25 18.0343 20.25 18.0327C20.25 18.0312 20.25 18.0296 20.25 18.0281C20.25 18.0266 20.25 18.025 20.25 18.0235C20.25 18.022 20.25 18.0204 20.25 18.0189C20.25 18.0174 20.25 18.0159 20.25 18.0143C20.25 18.0128 20.25 18.0113 20.25 18.0098C20.25 18.0082 20.25 18.0067 20.25 18.0052C20.25 18.0037 20.25 18.0022 20.25 18.0007C20.25 17.9991 20.25 17.9976 20.25 17.9961C20.25 17.9946 20.25 17.9931 20.25 17.9916C20.25 17.9901 20.25 17.9886 20.25 17.9871C20.25 17.9856 20.25 17.9841 20.25 17.9826C20.25 17.9811 20.25 17.9796 20.25 17.9781C20.25 17.9766 20.25 17.9751 20.25 17.9736C20.25 17.9721 20.25 17.9707 20.25 17.9692C20.25 17.9677 20.25 17.9662 20.25 17.9647C20.25 17.9632 20.25 17.9618 20.25 17.9603C20.25 17.9588 20.25 17.9573 20.25 17.9559C20.25 17.9544 20.25 17.9529 20.25 17.9514C20.25 17.95 20.25 17.9485 20.25 17.947C20.25 17.9456 20.25 17.9441 20.25 17.9427C20.25 17.9412 20.25 17.9397 20.25 17.9383C20.25 17.9368 20.25 17.9354 20.25 17.9339C20.25 17.9325 20.25 17.931 20.25 17.9296C20.25 17.9281 20.25 17.9267 20.25 17.9252C20.25 17.9238 20.25 17.9223 20.25 17.9209C20.25 17.9194 20.25 17.918 20.25 17.9166C20.25 17.9151 20.25 17.9137 20.25 17.9123C20.25 17.9108 20.25 17.9094 20.25 17.908C20.25 17.9065 20.25 17.9051 20.25 17.9037C20.25 17.9023 20.25 17.9008 20.25 17.8994C20.25 17.898 20.25 17.8966 20.25 17.8952C20.25 17.8938 20.25 17.8923 20.25 17.8909C20.25 17.8895 20.25 17.8881 20.25 17.8867C20.25 17.8853 20.25 17.8839 20.25 17.8825C20.25 17.8811 20.25 17.8797 20.25 17.8783C20.25 17.8769 20.25 17.8755 20.25 17.8741C20.25 17.8727 20.25 17.8713 20.25 17.8699C20.25 17.8685 20.25 17.8671 20.25 17.8657C20.25 17.8643 20.25 17.863 20.25 17.8616C20.25 17.8602 20.25 17.8588 20.25 17.8574C20.25 17.8561 20.25 17.8547 20.25 17.8533C20.25 17.8519 20.25 17.8506 20.25 17.8492C20.25 17.8478 20.25 17.8464 20.25 17.8451C20.25 17.8437 20.25 17.8424 20.25 17.841C20.25 17.8396 20.25 17.8383 20.25 17.8369C20.25 17.8356 20.25 17.8342 20.25 17.8328C20.25 17.8315 20.25 17.8301 20.25 17.8288C20.25 17.8274 20.25 17.8261 20.25 17.8247C20.25 17.8234 20.25 17.8221 20.25 17.8207C20.25 17.8194 20.25 17.818 20.25 17.8167C20.25 17.8154 20.25 17.814 20.25 17.8127C20.25 17.8114 20.25 17.81 20.25 17.8087C20.25 17.8074 20.25 17.806 20.25 17.8047C20.25 17.8034 20.25 17.8021 20.25 17.8008C20.25 17.7994 20.25 17.7981 20.25 17.7968C20.25 17.7955 20.25 17.7942 20.25 17.7929C20.25 17.7915 20.25 17.7902 20.25 17.7889C20.25 17.7876 20.25 17.7863 20.25 17.785C20.25 17.7837 20.25 17.7824 20.25 17.7811C20.25 17.7798 20.25 17.7785 20.25 17.7772C20.25 17.7759 20.25 17.7746 20.25 17.7733C20.25 17.7721 20.25 17.7708 20.25 17.7695C20.25 17.7682 20.25 17.7669 20.25 17.7656C20.25 17.7643 20.25 17.7631 20.25 17.7618C20.25 17.7605 20.25 17.7592 20.25 17.758C20.25 17.7567 20.25 17.7554 20.25 17.7541C20.25 17.7529 20.25 17.7516 20.25 17.7503C20.25 17.7491 20.25 17.7478 20.25 17.7466C20.25 17.7453 20.25 17.744 20.25 17.7428C20.25 17.7415 20.25 17.7403 20.25 17.739C20.25 17.7378 20.25 17.7365 20.25 17.7353C20.25 17.734 20.25 17.7328 20.25 17.7315C20.25 17.7303 20.25 17.7291 20.25 17.7278C20.25 17.7266 20.25 17.7253 20.25 17.7241C20.25 17.7229 20.25 17.7216 20.25 17.7204C20.25 17.7192 20.25 17.718 20.25 17.7167C20.25 17.7155 20.25 17.7143 20.25 17.7131C20.25 17.7118 20.25 17.7106 20.25 17.7094C20.25 17.7082 20.25 17.707 20.25 17.7058C20.25 17.7045 20.25 17.7033 20.25 17.7021C20.25 17.7009 20.25 17.6997 20.25 17.6985C20.25 17.6973 20.25 17.6961 20.25 17.6949C20.25 17.6937 20.25 17.6925 20.25 17.6913C20.25 17.6901 20.25 17.6889 20.25 17.6877C20.25 17.6865 20.25 17.6854 20.25 17.6842C20.25 17.683 20.25 17.6818 20.25 17.6806C20.25 17.6794 20.25 17.6783 20.25 17.6771C20.25 17.6759 20.25 17.6747 20.25 17.6736C20.25 17.6724 20.25 17.6712 20.25 17.67C20.25 17.6689 20.25 17.6677 20.25 17.6666C20.25 17.6654 20.25 17.6642 20.25 17.6631C20.25 17.6619 20.25 17.6607 20.25 17.6596C20.25 17.6584 20.25 17.6573 20.25 17.6561C20.25 17.655 20.25 17.6538 20.25 17.6527C20.25 17.6515 20.25 17.6504 20.25 17.6493C20.25 17.6481 20.25 17.647 20.25 17.6458C20.25 17.6447 20.25 17.6436 20.25 17.6424C20.25 17.6413 20.25 17.6402 20.25 17.639C20.25 17.6379 20.25 17.6368 20.25 17.6357C20.25 17.6345 20.25 17.6334 20.25 17.6323C20.25 17.6312 20.25 17.6301 20.25 17.629C20.25 17.6278 20.25 17.6267 20.25 17.6256C20.25 17.6245 20.25 17.6234 20.25 17.6223C20.25 17.6212 20.25 17.6201 20.25 17.619C20.25 17.6179 20.25 17.6168 20.25 17.6157C20.25 17.6146 20.25 17.6135 20.25 17.6124C20.25 17.6113 20.25 17.6102 20.25 17.6091C20.25 17.608 20.25 17.607 20.25 17.6059C20.25 17.6048 20.25 17.6037 20.25 17.6026C20.25 17.6016 20.25 17.6005 20.25 17.5994C20.25 17.5983 20.25 17.5973 20.25 17.5962C20.25 17.5951 20.25 17.5941 20.25 17.593C20.25 17.5919 20.25 17.5909 20.25 17.5898C20.25 17.5887 20.25 17.5877 20.25 17.5866C20.25 17.5856 20.25 17.5845 20.25 17.5835C20.25 17.5824 20.25 17.5814 20.25 17.5803C20.25 17.5793 20.25 17.5782 20.25 17.5772C20.25 17.5762 20.25 17.5751 20.25 17.5741C20.25 17.573 20.25 17.572 20.25 17.571C20.25 17.5699 20.25 17.5689 20.25 17.5679C20.25 17.5669 20.25 17.5658 20.25 17.5648C20.25 17.5638 20.25 17.5628 20.25 17.5617C20.25 17.5607 20.25 17.5597 20.25 17.5587C20.25 17.5577 20.25 17.5567 20.25 17.5557C20.25 17.5546 20.25 17.5536 20.25 17.5526C20.25 17.5516 20.25 17.5506 20.25 17.5496C20.25 17.5486 20.25 17.5476 20.25 17.5466C20.25 17.5456 20.25 17.5446 20.25 17.5436C20.25 17.5427 20.25 17.5417 20.25 17.5407C20.25 17.5397 20.25 17.5387 20.25 17.5377C20.25 17.5367 20.25 17.5358 20.25 17.5348C20.25 17.5338 20.25 17.5328 20.25 17.5319C20.25 17.5309 20.25 17.5299 20.25 17.529C20.25 17.528 20.25 17.527 20.25 17.5261C20.25 17.5251 20.25 17.5241 20.25 17.5232C20.25 17.5222 20.25 17.5213 20.25 17.5203C20.25 17.5194 20.25 17.5184 20.25 17.5175C20.25 17.5165 20.25 17.5156 20.25 17.5146C20.25 17.5137 20.25 17.5127 20.25 17.5118C20.25 17.5109 20.25 17.5099 20.25 17.509C20.25 17.508 20.25 17.5071 20.25 17.5062C20.25 17.5053 20.25 17.5043 20.25 17.5034C20.25 17.5025 20.25 17.5016 20.25 17.5006C20.25 17.4997 20.25 17.4988 20.25 17.4979C20.25 17.497 20.25 17.4961 20.25 17.4951C20.25 17.4942 20.25 17.4933 20.25 17.4924C20.25 17.4915 20.25 17.4906 20.25 17.4897C20.25 17.4888 20.25 17.4879 20.25 17.487C20.25 17.4861 20.25 17.4852 20.25 17.4843C20.25 17.4834 20.25 17.4825 20.25 17.4817C20.25 17.4808 20.25 17.4799 20.25 17.479C20.25 17.4781 20.25 17.4772 20.25 17.4764C20.25 17.4755 20.25 17.4746 20.25 17.4737C20.25 17.4729 20.25 17.472 20.25 17.4711C20.25 17.4703 20.25 17.4694 20.25 17.4685C20.25 17.4677 20.25 17.4668 20.25 17.4659C20.25 17.4651 20.25 17.4642 20.25 17.4634C20.25 17.4625 20.25 17.4617 20.25 17.4608C20.25 17.46 20.25 17.4591 20.25 17.4583C20.25 17.4574 20.25 17.4566 20.25 17.4558C20.25 17.4549 20.25 17.4541 20.25 17.4532C20.25 17.4524 20.25 17.4516 20.25 17.4507C20.25 17.4499 20.25 17.4491 20.25 17.4483C20.25 17.4474 20.25 17.4466 20.25 17.4458C20.25 17.445 20.25 17.4442 20.25 17.4433C20.25 17.4425 20.25 17.4417 20.25 17.4409C20.25 17.4401 20.25 17.4393 20.25 17.4385C20.25 17.4377 20.25 17.4369 20.25 17.4361C20.25 17.4353 20.25 17.4345 20.25 17.4337C20.25 17.4329 20.25 17.4321 20.25 17.4313C20.25 17.4305 20.25 17.4297 20.25 17.4289C20.25 17.4282 20.25 17.4274 20.25 17.4266C20.25 17.4258 20.25 17.425 20.25 17.4243C20.25 17.4235 20.25 17.4227 20.25 17.4219C20.25 17.4212 20.25 17.4204 20.25 17.4196C20.25 17.4189 20.25 17.4181 20.25 17.4173C20.25 17.4166 20.25 17.4158 20.25 17.4151C20.25 17.4143 20.25 17.4136 20.25 17.4128C20.25 17.4121 20.25 17.4113 20.25 17.4106C20.25 17.4098 20.25 17.4091 20.25 17.4083C20.25 17.4076 20.25 17.4068 20.25 17.4061C20.25 17.4054 20.25 17.4046 20.25 17.4039C20.25 17.4032 20.25 17.4024 20.25 17.4017C20.25 17.401 20.25 17.4003 20.25 17.3995C20.25 17.3988 20.25 17.3981 20.25 17.3974C20.25 17.3967 20.25 17.396 20.25 17.3952C20.25 17.3945 20.25 17.3938 20.25 17.3931C20.25 17.3924 20.25 17.3917 20.25 17.391C20.25 17.3903 20.25 17.3896 20.25 17.3889C20.25 17.3882 20.25 17.3875 20.25 17.3868C20.25 17.3861 20.25 17.3854 20.25 17.3848C20.25 17.3841 20.25 17.3834 20.25 17.3827C20.25 17.382 20.25 17.3813 20.25 17.3807C20.25 17.38 20.25 17.3793 20.25 17.3786C20.25 17.378 20.25 17.3773 20.25 17.3766C20.25 17.376 20.25 17.3753 20.25 17.3747C20.25 17.374 20.25 17.3733 20.25 17.3727C20.25 17.372 20.25 17.3714 20.25 17.3707C20.25 17.3701 20.25 17.3694 20.25 17.3688C20.25 17.3681 20.25 17.3675 20.25 17.3668C20.25 17.3662 20.25 17.3656 20.25 17.3649C20.25 17.3643 20.25 17.3636 20.25 17.363C20.25 17.3624 20.25 17.3618 20.25 17.3611C20.25 17.3605 20.25 17.3599 20.25 17.3593C20.25 17.3586 20.25 17.358 20.25 17.3574C20.25 17.3568 20.25 17.3562 20.25 17.3556C20.25 17.355 20.25 17.3543 20.25 17.3537C20.25 17.3531 20.25 17.3525 20.25 17.3519C20.25 17.3513 20.25 17.3507 20.25 17.3501C20.25 17.3495 20.25 17.3489 20.25 17.3484C20.25 17.3478 20.25 17.3472 20.25 17.3466C20.25 17.346 20.25 17.3454 20.25 17.3448C20.25 17.3443 20.25 17.3437 20.25 17.3431C20.25 17.3425 20.25 17.342 20.25 17.3414C20.25 17.3408 20.25 17.3403 20.25 17.3397C20.25 17.3391 20.25 17.3386 20.25 17.338C20.25 17.3374 20.25 17.3369 20.25 17.3363C20.25 17.3358 20.25 17.3352 20.25 17.3347C20.25 17.3341 20.25 17.3336 20.25 17.333C20.25 17.3325 20.25 17.3319 20.25 17.3314C20.25 17.3309 20.25 17.3303 20.25 17.3298C20.25 17.3293 20.25 17.3287 20.25 17.3282C20.25 17.3277 20.25 17.3271 20.25 17.3266C20.25 17.3261 20.25 17.3256 20.25 17.3251C20.25 17.3245 20.25 17.324 20.25 17.3235C20.25 17.323 20.25 17.3225 20.25 17.322C20.25 17.3215 20.25 17.321 20.25 17.3205C20.25 17.32 20.25 17.3195 20.25 17.319C20.25 17.3185 20.25 17.318 20.25 17.3175C20.25 17.317 20.25 17.3165 20.25 17.316C20.25 17.3155 20.25 17.315 20.25 17.3146C20.25 17.3141 20.25 17.3136 20.25 17.3131C20.25 17.3126 20.25 17.3122 20.25 17.3117C20.25 17.3112 20.25 17.3108 20.25 17.3103C20.25 17.3098 20.25 17.3094 20.25 17.3089C20.25 17.3084 20.25 17.308 20.25 17.3075C20.25 17.3071 20.25 17.3066 20.25 17.3062C20.25 17.3057 20.25 17.3053 20.25 17.3048C20.25 17.3044 20.25 17.3039 20.25 17.3035C20.25 17.3031 20.25 17.3026 20.25 17.3022C20.25 17.3017 20.25 17.3013 20.25 17.3009C20.25 17.3005 20.25 17.3 20.25 17.2996C20.25 17.2992 20.25 17.2988 20.25 17.2983C20.25 17.2979 20.25 17.2975 20.25 17.2971C20.25 17.2967 20.25 17.2963 20.25 17.2959C20.25 17.2955 20.25 17.2951 20.25 17.2946C20.25 17.2942 20.25 17.2938 20.25 17.2934C20.25 17.293 20.25 17.2927 20.25 17.2923C20.25 17.2919 20.25 17.2915 20.25 17.2911C20.25 17.2907 20.25 17.2903 20.25 17.2899C20.25 17.2896 20.25 17.2892 20.25 17.2888C20.25 17.2884 20.25 17.2881 20.25 17.2877C20.25 17.2873 20.25 17.2869 20.25 17.2866C20.25 17.2862 20.25 17.2859 20.25 17.2855C20.25 17.2851 20.25 17.2848 20.25 17.2844C20.25 17.2841 20.25 17.2837 20.25 17.2834C20.25 17.283 20.25 17.2827 20.25 17.2823C20.25 17.282 20.25 17.2816 20.25 17.2813C20.25 17.281 20.25 17.2806 20.25 17.2803C20.25 17.28 20.25 17.2796 20.25 17.2793C20.25 17.279 20.25 17.2786 20.25 17.2783C20.25 17.278 20.25 17.2777 20.25 17.2774C20.25 17.277 20.25 17.2767 20.25 17.2764C20.25 17.2761 20.25 17.2758 20.25 17.2755C20.25 17.2752 20.25 17.2749 20.25 17.2746C20.25 17.2743 20.25 17.274 20.25 17.2737C20.25 17.2734 20.25 17.2731 20.25 17.2728C20.25 17.2725 20.25 17.2722 20.25 17.2719C20.25 17.2717 20.25 17.2714 20.25 17.2711C20.25 17.2708 20.25 17.2705 20.25 17.2703C20.25 17.27 20.25 17.2697 20.25 17.2695C20.25 17.2692 20.25 17.2689 20.25 17.2687C20.25 17.2684 20.25 17.2681 20.25 17.2679C20.25 17.2676 20.25 17.2674 20.25 17.2671C20.25 17.2669 20.25 17.2666 20.25 17.2664C20.25 17.2661 20.25 17.2659 20.25 17.2656C20.25 17.2654 20.25 17.2652 20.25 17.2649C20.25 17.2647 20.25 17.2645 20.25 17.2642C20.25 17.264 20.25 17.2638 20.25 17.2635C20.25 17.2633 20.25 17.2631 20.25 17.2629C20.25 17.2627 20.25 17.2624 20.25 17.2622C20.25 17.262 20.25 17.2618 20.25 17.2616C20.25 17.2614 20.25 17.2612 20.25 17.261C20.25 17.2608 20.25 17.2606 20.25 17.2604C20.25 17.2602 20.25 17.26 20.25 17.2598C20.25 17.2596 20.25 17.2594 20.25 17.2592C20.25 17.2591 20.25 17.2589 20.25 17.2587C20.25 17.2585 20.25 17.2583 20.25 17.2582C20.25 17.258 20.25 17.2578 20.25 17.2576C20.25 17.2575 20.25 17.2573 20.25 17.2571C20.25 17.257 20.25 17.2568 20.25 17.2567C20.25 17.2565 20.25 17.2563 20.25 17.2562C20.25 17.256 20.25 17.2559 20.25 17.2557C20.25 17.2556 20.25 17.2555 20.25 17.2553C20.25 17.2552 20.25 17.255 20.25 17.2549C20.25 17.2548 20.25 17.2546 20.25 17.2545C20.25 17.2544 20.25 17.2542 20.25 17.2541C20.25 17.254 20.25 17.2539 20.25 17.2538C20.25 17.2536 20.25 17.2535 20.25 17.2534C20.25 17.2533 20.25 17.2532 20.25 17.2531C20.25 17.253 20.25 17.2529 20.25 17.2528C20.25 17.2527 20.25 17.2526 20.25 17.2525C20.25 17.2524 20.25 17.2523 20.25 17.2522C20.25 17.2521 20.25 17.252 20.25 17.2519C20.25 17.2518 20.25 17.2517 20.25 17.2517C20.25 17.2516 20.25 17.2515 20.25 17.2514C20.25 17.2514 20.25 17.2513 20.25 17.2512C20.25 17.2512 20.25 17.2511 20.25 17.251C20.25 17.251 20.25 17.2509 20.25 17.2508C20.25 17.2508 20.25 17.2507 20.25 17.2507C20.25 17.2506 20.25 17.2506 20.25 17.2505C20.25 17.2505 20.25 17.2505 20.25 17.2504C20.25 17.2504 20.25 17.2503 20.25 17.2503C20.25 17.2503 20.25 17.2502 20.25 17.2502C20.25 17.2502 20.25 17.2502 20.25 17.2501C20.25 17.2501 20.25 17.2501 20.25 17.2501C20.25 17.2501 20.25 17.25 20.25 17.25C20.25 17.25 20.25 17.25 20.25 17.25C20.25 17.25 20.25 17.25 19.5 17.25C18.75 17.25 18.75 17.25 18.75 17.25C18.75 17.25 18.75 17.25 18.75 17.25C18.75 17.25 18.75 17.2501 18.75 17.2501C18.75 17.2501 18.75 17.2501 18.75 17.2501C18.75 17.2502 18.75 17.2502 18.75 17.2502C18.75 17.2502 18.75 17.2503 18.75 17.2503C18.75 17.2503 18.75 17.2504 18.75 17.2504C18.75 17.2505 18.75 17.2505 18.75 17.2505C18.75 17.2506 18.75 17.2506 18.75 17.2507C18.75 17.2507 18.75 17.2508 18.75 17.2508C18.75 17.2509 18.75 17.251 18.75 17.251C18.75 17.2511 18.75 17.2512 18.75 17.2512C18.75 17.2513 18.75 17.2514 18.75 17.2514C18.75 17.2515 18.75 17.2516 18.75 17.2517C18.75 17.2517 18.75 17.2518 18.75 17.2519C18.75 17.252 18.75 17.2521 18.75 17.2522C18.75 17.2523 18.75 17.2524 18.75 17.2525C18.75 17.2526 18.75 17.2527 18.75 17.2528C18.75 17.2529 18.75 17.253 18.75 17.2531C18.75 17.2532 18.75 17.2533 18.75 17.2534C18.75 17.2535 18.75 17.2536 18.75 17.2538C18.75 17.2539 18.75 17.254 18.75 17.2541C18.75 17.2542 18.75 17.2544 18.75 17.2545C18.75 17.2546 18.75 17.2548 18.75 17.2549C18.75 17.255 18.75 17.2552 18.75 17.2553C18.75 17.2555 18.75 17.2556 18.75 17.2557C18.75 17.2559 18.75 17.256 18.75 17.2562C18.75 17.2563 18.75 17.2565 18.75 17.2567C18.75 17.2568 18.75 17.257 18.75 17.2571C18.75 17.2573 18.75 17.2575 18.75 17.2576C18.75 17.2578 18.75 17.258 18.75 17.2582C18.75 17.2583 18.75 17.2585 18.75 17.2587C18.75 17.2589 18.75 17.2591 18.75 17.2592C18.75 17.2594 18.75 17.2596 18.75 17.2598C18.75 17.26 18.75 17.2602 18.75 17.2604C18.75 17.2606 18.75 17.2608 18.75 17.261C18.75 17.2612 18.75 17.2614 18.75 17.2616C18.75 17.2618 18.75 17.262 18.75 17.2622C18.75 17.2624 18.75 17.2627 18.75 17.2629C18.75 17.2631 18.75 17.2633 18.75 17.2635C18.75 17.2638 18.75 17.264 18.75 17.2642C18.75 17.2645 18.75 17.2647 18.75 17.2649C18.75 17.2652 18.75 17.2654 18.75 17.2656C18.75 17.2659 18.75 17.2661 18.75 17.2664C18.75 17.2666 18.75 17.2669 18.75 17.2671C18.75 17.2674 18.75 17.2676 18.75 17.2679C18.75 17.2681 18.75 17.2684 18.75 17.2687C18.75 17.2689 18.75 17.2692 18.75 17.2695C18.75 17.2697 18.75 17.27 18.75 17.2703C18.75 17.2705 18.75 17.2708 18.75 17.2711C18.75 17.2714 18.75 17.2717 18.75 17.2719C18.75 17.2722 18.75 17.2725 18.75 17.2728C18.75 17.2731 18.75 17.2734 18.75 17.2737C18.75 17.274 18.75 17.2743 18.75 17.2746C18.75 17.2749 18.75 17.2752 18.75 17.2755C18.75 17.2758 18.75 17.2761 18.75 17.2764C18.75 17.2767 18.75 17.277 18.75 17.2774C18.75 17.2777 18.75 17.278 18.75 17.2783C18.75 17.2786 18.75 17.279 18.75 17.2793C18.75 17.2796 18.75 17.28 18.75 17.2803C18.75 17.2806 18.75 17.281 18.75 17.2813C18.75 17.2816 18.75 17.282 18.75 17.2823C18.75 17.2827 18.75 17.283 18.75 17.2834C18.75 17.2837 18.75 17.2841 18.75 17.2844C18.75 17.2848 18.75 17.2851 18.75 17.2855C18.75 17.2859 18.75 17.2862 18.75 17.2866C18.75 17.2869 18.75 17.2873 18.75 17.2877C18.75 17.2881 18.75 17.2884 18.75 17.2888C18.75 17.2892 18.75 17.2896 18.75 17.2899C18.75 17.2903 18.75 17.2907 18.75 17.2911C18.75 17.2915 18.75 17.2919 18.75 17.2923C18.75 17.2927 18.75 17.293 18.75 17.2934C18.75 17.2938 18.75 17.2942 18.75 17.2946C18.75 17.2951 18.75 17.2955 18.75 17.2959C18.75 17.2963 18.75 17.2967 18.75 17.2971C18.75 17.2975 18.75 17.2979 18.75 17.2983C18.75 17.2988 18.75 17.2992 18.75 17.2996C18.75 17.3 18.75 17.3005 18.75 17.3009C18.75 17.3013 18.75 17.3017 18.75 17.3022C18.75 17.3026 18.75 17.3031 18.75 17.3035C18.75 17.3039 18.75 17.3044 18.75 17.3048C18.75 17.3053 18.75 17.3057 18.75 17.3062C18.75 17.3066 18.75 17.3071 18.75 17.3075C18.75 17.308 18.75 17.3084 18.75 17.3089C18.75 17.3094 18.75 17.3098 18.75 17.3103C18.75 17.3108 18.75 17.3112 18.75 17.3117C18.75 17.3122 18.75 17.3126 18.75 17.3131C18.75 17.3136 18.75 17.3141 18.75 17.3146C18.75 17.315 18.75 17.3155 18.75 17.316C18.75 17.3165 18.75 17.317 18.75 17.3175C18.75 17.318 18.75 17.3185 18.75 17.319C18.75 17.3195 18.75 17.32 18.75 17.3205C18.75 17.321 18.75 17.3215 18.75 17.322C18.75 17.3225 18.75 17.323 18.75 17.3235C18.75 17.324 18.75 17.3245 18.75 17.3251C18.75 17.3256 18.75 17.3261 18.75 17.3266C18.75 17.3271 18.75 17.3277 18.75 17.3282C18.75 17.3287 18.75 17.3293 18.75 17.3298C18.75 17.3303 18.75 17.3309 18.75 17.3314C18.75 17.3319 18.75 17.3325 18.75 17.333C18.75 17.3336 18.75 17.3341 18.75 17.3347C18.75 17.3352 18.75 17.3358 18.75 17.3363C18.75 17.3369 18.75 17.3374 18.75 17.338C18.75 17.3386 18.75 17.3391 18.75 17.3397C18.75 17.3403 18.75 17.3408 18.75 17.3414C18.75 17.342 18.75 17.3425 18.75 17.3431C18.75 17.3437 18.75 17.3443 18.75 17.3448C18.75 17.3454 18.75 17.346 18.75 17.3466C18.75 17.3472 18.75 17.3478 18.75 17.3484C18.75 17.3489 18.75 17.3495 18.75 17.3501C18.75 17.3507 18.75 17.3513 18.75 17.3519C18.75 17.3525 18.75 17.3531 18.75 17.3537C18.75 17.3543 18.75 17.355 18.75 17.3556C18.75 17.3562 18.75 17.3568 18.75 17.3574C18.75 17.358 18.75 17.3586 18.75 17.3593C18.75 17.3599 18.75 17.3605 18.75 17.3611C18.75 17.3618 18.75 17.3624 18.75 17.363C18.75 17.3636 18.75 17.3643 18.75 17.3649C18.75 17.3656 18.75 17.3662 18.75 17.3668C18.75 17.3675 18.75 17.3681 18.75 17.3688C18.75 17.3694 18.75 17.3701 18.75 17.3707C18.75 17.3714 18.75 17.372 18.75 17.3727C18.75 17.3733 18.75 17.374 18.75 17.3747C18.75 17.3753 18.75 17.376 18.75 17.3766C18.75 17.3773 18.75 17.378 18.75 17.3786C18.75 17.3793 18.75 17.38 18.75 17.3807C18.75 17.3813 18.75 17.382 18.75 17.3827C18.75 17.3834 18.75 17.3841 18.75 17.3848C18.75 17.3854 18.75 17.3861 18.75 17.3868C18.75 17.3875 18.75 17.3882 18.75 17.3889C18.75 17.3896 18.75 17.3903 18.75 17.391C18.75 17.3917 18.75 17.3924 18.75 17.3931C18.75 17.3938 18.75 17.3945 18.75 17.3952C18.75 17.396 18.75 17.3967 18.75 17.3974C18.75 17.3981 18.75 17.3988 18.75 17.3995C18.75 17.4003 18.75 17.401 18.75 17.4017C18.75 17.4024 18.75 17.4032 18.75 17.4039C18.75 17.4046 18.75 17.4054 18.75 17.4061C18.75 17.4068 18.75 17.4076 18.75 17.4083C18.75 17.4091 18.75 17.4098 18.75 17.4106C18.75 17.4113 18.75 17.4121 18.75 17.4128C18.75 17.4136 18.75 17.4143 18.75 17.4151C18.75 17.4158 18.75 17.4166 18.75 17.4173C18.75 17.4181 18.75 17.4189 18.75 17.4196C18.75 17.4204 18.75 17.4212 18.75 17.4219C18.75 17.4227 18.75 17.4235 18.75 17.4243C18.75 17.425 18.75 17.4258 18.75 17.4266C18.75 17.4274 18.75 17.4282 18.75 17.4289C18.75 17.4297 18.75 17.4305 18.75 17.4313C18.75 17.4321 18.75 17.4329 18.75 17.4337C18.75 17.4345 18.75 17.4353 18.75 17.4361C18.75 17.4369 18.75 17.4377 18.75 17.4385C18.75 17.4393 18.75 17.4401 18.75 17.4409C18.75 17.4417 18.75 17.4425 18.75 17.4433C18.75 17.4442 18.75 17.445 18.75 17.4458C18.75 17.4466 18.75 17.4474 18.75 17.4483C18.75 17.4491 18.75 17.4499 18.75 17.4507C18.75 17.4516 18.75 17.4524 18.75 17.4532C18.75 17.4541 18.75 17.4549 18.75 17.4558C18.75 17.4566 18.75 17.4574 18.75 17.4583C18.75 17.4591 18.75 17.46 18.75 17.4608C18.75 17.4617 18.75 17.4625 18.75 17.4634C18.75 17.4642 18.75 17.4651 18.75 17.4659C18.75 17.4668 18.75 17.4677 18.75 17.4685C18.75 17.4694 18.75 17.4703 18.75 17.4711C18.75 17.472 18.75 17.4729 18.75 17.4737C18.75 17.4746 18.75 17.4755 18.75 17.4764C18.75 17.4772 18.75 17.4781 18.75 17.479C18.75 17.4799 18.75 17.4808 18.75 17.4817C18.75 17.4825 18.75 17.4834 18.75 17.4843C18.75 17.4852 18.75 17.4861 18.75 17.487C18.75 17.4879 18.75 17.4888 18.75 17.4897C18.75 17.4906 18.75 17.4915 18.75 17.4924C18.75 17.4933 18.75 17.4942 18.75 17.4951C18.75 17.4961 18.75 17.497 18.75 17.4979C18.75 17.4988 18.75 17.4997 18.75 17.5006C18.75 17.5016 18.75 17.5025 18.75 17.5034C18.75 17.5043 18.75 17.5053 18.75 17.5062C18.75 17.5071 18.75 17.508 18.75 17.509C18.75 17.5099 18.75 17.5109 18.75 17.5118C18.75 17.5127 18.75 17.5137 18.75 17.5146C18.75 17.5156 18.75 17.5165 18.75 17.5175C18.75 17.5184 18.75 17.5194 18.75 17.5203C18.75 17.5213 18.75 17.5222 18.75 17.5232C18.75 17.5241 18.75 17.5251 18.75 17.5261C18.75 17.527 18.75 17.528 18.75 17.529C18.75 17.5299 18.75 17.5309 18.75 17.5319C18.75 17.5328 18.75 17.5338 18.75 17.5348C18.75 17.5358 18.75 17.5367 18.75 17.5377C18.75 17.5387 18.75 17.5397 18.75 17.5407C18.75 17.5417 18.75 17.5427 18.75 17.5436C18.75 17.5446 18.75 17.5456 18.75 17.5466C18.75 17.5476 18.75 17.5486 18.75 17.5496C18.75 17.5506 18.75 17.5516 18.75 17.5526C18.75 17.5536 18.75 17.5546 18.75 17.5557C18.75 17.5567 18.75 17.5577 18.75 17.5587C18.75 17.5597 18.75 17.5607 18.75 17.5617C18.75 17.5628 18.75 17.5638 18.75 17.5648C18.75 17.5658 18.75 17.5669 18.75 17.5679C18.75 17.5689 18.75 17.5699 18.75 17.571C18.75 17.572 18.75 17.573 18.75 17.5741C18.75 17.5751 18.75 17.5762 18.75 17.5772C18.75 17.5782 18.75 17.5793 18.75 17.5803C18.75 17.5814 18.75 17.5824 18.75 17.5835C18.75 17.5845 18.75 17.5856 18.75 17.5866C18.75 17.5877 18.75 17.5887 18.75 17.5898C18.75 17.5909 18.75 17.5919 18.75 17.593C18.75 17.5941 18.75 17.5951 18.75 17.5962C18.75 17.5973 18.75 17.5983 18.75 17.5994C18.75 17.6005 18.75 17.6016 18.75 17.6026C18.75 17.6037 18.75 17.6048 18.75 17.6059C18.75 17.607 18.75 17.608 18.75 17.6091C18.75 17.6102 18.75 17.6113 18.75 17.6124C18.75 17.6135 18.75 17.6146 18.75 17.6157C18.75 17.6168 18.75 17.6179 18.75 17.619C18.75 17.6201 18.75 17.6212 18.75 17.6223C18.75 17.6234 18.75 17.6245 18.75 17.6256C18.75 17.6267 18.75 17.6278 18.75 17.629C18.75 17.6301 18.75 17.6312 18.75 17.6323C18.75 17.6334 18.75 17.6345 18.75 17.6357C18.75 17.6368 18.75 17.6379 18.75 17.639C18.75 17.6402 18.75 17.6413 18.75 17.6424C18.75 17.6436 18.75 17.6447 18.75 17.6458C18.75 17.647 18.75 17.6481 18.75 17.6493C18.75 17.6504 18.75 17.6515 18.75 17.6527C18.75 17.6538 18.75 17.655 18.75 17.6561C18.75 17.6573 18.75 17.6584 18.75 17.6596C18.75 17.6607 18.75 17.6619 18.75 17.6631C18.75 17.6642 18.75 17.6654 18.75 17.6666C18.75 17.6677 18.75 17.6689 18.75 17.67C18.75 17.6712 18.75 17.6724 18.75 17.6736C18.75 17.6747 18.75 17.6759 18.75 17.6771C18.75 17.6783 18.75 17.6794 18.75 17.6806C18.75 17.6818 18.75 17.683 18.75 17.6842C18.75 17.6854 18.75 17.6865 18.75 17.6877C18.75 17.6889 18.75 17.6901 18.75 17.6913C18.75 17.6925 18.75 17.6937 18.75 17.6949C18.75 17.6961 18.75 17.6973 18.75 17.6985C18.75 17.6997 18.75 17.7009 18.75 17.7021C18.75 17.7033 18.75 17.7045 18.75 17.7058C18.75 17.707 18.75 17.7082 18.75 17.7094C18.75 17.7106 18.75 17.7118 18.75 17.7131C18.75 17.7143 18.75 17.7155 18.75 17.7167C18.75 17.718 18.75 17.7192 18.75 17.7204C18.75 17.7216 18.75 17.7229 18.75 17.7241C18.75 17.7253 18.75 17.7266 18.75 17.7278C18.75 17.7291 18.75 17.7303 18.75 17.7315C18.75 17.7328 18.75 17.734 18.75 17.7353C18.75 17.7365 18.75 17.7378 18.75 17.739C18.75 17.7403 18.75 17.7415 18.75 17.7428C18.75 17.744 18.75 17.7453 18.75 17.7466C18.75 17.7478 18.75 17.7491 18.75 17.7503C18.75 17.7516 18.75 17.7529 18.75 17.7541C18.75 17.7554 18.75 17.7567 18.75 17.758C18.75 17.7592 18.75 17.7605 18.75 17.7618C18.75 17.7631 18.75 17.7643 18.75 17.7656C18.75 17.7669 18.75 17.7682 18.75 17.7695C18.75 17.7708 18.75 17.7721 18.75 17.7733C18.75 17.7746 18.75 17.7759 18.75 17.7772C18.75 17.7785 18.75 17.7798 18.75 17.7811C18.75 17.7824 18.75 17.7837 18.75 17.785C18.75 17.7863 18.75 17.7876 18.75 17.7889C18.75 17.7902 18.75 17.7915 18.75 17.7929C18.75 17.7942 18.75 17.7955 18.75 17.7968C18.75 17.7981 18.75 17.7994 18.75 17.8008C18.75 17.8021 18.75 17.8034 18.75 17.8047C18.75 17.806 18.75 17.8074 18.75 17.8087C18.75 17.81 18.75 17.8114 18.75 17.8127C18.75 17.814 18.75 17.8154 18.75 17.8167C18.75 17.818 18.75 17.8194 18.75 17.8207C18.75 17.8221 18.75 17.8234 18.75 17.8247C18.75 17.8261 18.75 17.8274 18.75 17.8288C18.75 17.8301 18.75 17.8315 18.75 17.8328C18.75 17.8342 18.75 17.8356 18.75 17.8369C18.75 17.8383 18.75 17.8396 18.75 17.841C18.75 17.8424 18.75 17.8437 18.75 17.8451C18.75 17.8464 18.75 17.8478 18.75 17.8492C18.75 17.8506 18.75 17.8519 18.75 17.8533C18.75 17.8547 18.75 17.8561 18.75 17.8574C18.75 17.8588 18.75 17.8602 18.75 17.8616C18.75 17.863 18.75 17.8643 18.75 17.8657C18.75 17.8671 18.75 17.8685 18.75 17.8699C18.75 17.8713 18.75 17.8727 18.75 17.8741C18.75 17.8755 18.75 17.8769 18.75 17.8783C18.75 17.8797 18.75 17.8811 18.75 17.8825C18.75 17.8839 18.75 17.8853 18.75 17.8867C18.75 17.8881 18.75 17.8895 18.75 17.8909C18.75 17.8923 18.75 17.8938 18.75 17.8952C18.75 17.8966 18.75 17.898 18.75 17.8994C18.75 17.9008 18.75 17.9023 18.75 17.9037C18.75 17.9051 18.75 17.9065 18.75 17.908C18.75 17.9094 18.75 17.9108 18.75 17.9123C18.75 17.9137 18.75 17.9151 18.75 17.9166C18.75 17.918 18.75 17.9194 18.75 17.9209C18.75 17.9223 18.75 17.9238 18.75 17.9252C18.75 17.9267 18.75 17.9281 18.75 17.9296C18.75 17.931 18.75 17.9325 18.75 17.9339C18.75 17.9354 18.75 17.9368 18.75 17.9383C18.75 17.9397 18.75 17.9412 18.75 17.9427C18.75 17.9441 18.75 17.9456 18.75 17.947C18.75 17.9485 18.75 17.95 18.75 17.9514C18.75 17.9529 18.75 17.9544 18.75 17.9559C18.75 17.9573 18.75 17.9588 18.75 17.9603C18.75 17.9618 18.75 17.9632 18.75 17.9647C18.75 17.9662 18.75 17.9677 18.75 17.9692C18.75 17.9707 18.75 17.9721 18.75 17.9736C18.75 17.9751 18.75 17.9766 18.75 17.9781C18.75 17.9796 18.75 17.9811 18.75 17.9826C18.75 17.9841 18.75 17.9856 18.75 17.9871C18.75 17.9886 18.75 17.9901 18.75 17.9916C18.75 17.9931 18.75 17.9946 18.75 17.9961C18.75 17.9976 18.75 17.9991 18.75 18.0007C18.75 18.0022 18.75 18.0037 18.75 18.0052C18.75 18.0067 18.75 18.0082 18.75 18.0098C18.75 18.0113 18.75 18.0128 18.75 18.0143C18.75 18.0159 18.75 18.0174 18.75 18.0189C18.75 18.0204 18.75 18.022 18.75 18.0235C18.75 18.025 18.75 18.0266 18.75 18.0281C18.75 18.0296 18.75 18.0312 18.75 18.0327C18.75 18.0343 18.75 18.0358 18.75 18.0374C18.75 18.0389 18.75 18.0404 18.75 18.042C18.75 18.0435 18.75 18.0451 18.75 18.0466C18.75 18.0482 18.75 18.0498 18.75 18.0513C18.75 18.0529 18.75 18.0544 18.75 18.056C18.75 18.0576 18.75 18.0591 18.75 18.0607C18.75 18.0622 18.75 18.0638 18.75 18.0654C18.75 18.0669 18.75 18.0685 18.75 18.0701C18.75 18.0717 18.75 18.0732 18.75 18.0748C18.75 18.0764 18.75 18.078 18.75 18.0795C18.75 18.0811 18.75 18.0827 18.75 18.0843C18.75 18.0859 18.75 18.0875 18.75 18.089C18.75 18.0906 18.75 18.0922 18.75 18.0938C18.75 18.0954 18.75 18.097 18.75 18.0986C18.75 18.1002 18.75 18.1018 18.75 18.1034C18.75 18.105 18.75 18.1066 18.75 18.1082C18.75 18.1098 18.75 18.1114 18.75 18.113C18.75 18.1146 18.75 18.1162 18.75 18.1178C18.75 18.1195 18.75 18.1211 18.75 18.1227C18.75 18.1243 18.75 18.1259 18.75 18.1275C18.75 18.1291 18.75 18.1308 18.75 18.1324C18.75 18.134 18.75 18.1356 18.75 18.1373C18.75 18.1389 18.75 18.1405 18.75 18.1421C18.75 18.1438 18.75 18.1454 18.75 18.147C18.75 18.1487 18.75 18.1503 18.75 18.152C18.75 18.1536 18.75 18.1552 18.75 18.1569C18.75 18.1585 18.75 18.1602 18.75 18.1618C18.75 18.1634 18.75 18.1651 18.75 18.1667C18.75 18.1684 18.75 18.17 18.75 18.1717C18.75 18.1734 18.75 18.175 18.75 18.1767C18.75 18.1783 18.75 18.18 18.75 18.1816C18.75 18.1833 18.75 18.185 18.75 18.1866C18.75 18.1883 18.75 18.19 18.75 18.1916C18.75 18.1933 18.75 18.195 18.75 18.1966C18.75 18.1983 18.75 18.2 18.75 18.2017C18.75 18.2033 18.75 18.205 18.75 18.2067C18.75 18.2084 18.75 18.21 18.75 18.2117C18.75 18.2134 18.75 18.2151 18.75 18.2168C18.75 18.2185 18.75 18.2202 18.75 18.2218C18.75 18.2235 18.75 18.2252 18.75 18.2269C18.75 18.2286 18.75 18.2303 18.75 18.232C18.75 18.2337 18.75 18.2354 18.75 18.2371C18.75 18.2388 18.75 18.2405 18.75 18.2422C18.75 18.2439 18.75 18.2456 18.75 18.2473C18.75 18.2491 18.75 18.2508 18.75 18.2525C18.75 18.2542 18.75 18.2559 18.75 18.2576C18.75 18.2593 18.75 18.2611 18.75 18.2628C18.75 18.2645 18.75 18.2662 18.75 18.2679C18.75 18.2697 18.75 18.2714 18.75 18.2731C18.75 18.2748 18.75 18.2766 18.75 18.2783C18.75 18.28 18.75 18.2818 18.75 18.2835C18.75 18.2852 18.75 18.287 18.75 18.2887C18.75 18.2905 18.75 18.2922 18.75 18.2939C18.75 18.2957 18.75 18.2974 18.75 18.2992C18.75 18.3009 18.75 18.3027 18.75 18.3044C18.75 18.3062 18.75 18.3079 18.75 18.3097C18.75 18.3114 18.75 18.3132 18.75 18.3149C18.75 18.3167 18.75 18.3184 18.75 18.3202C18.75 18.322 18.75 18.3237 18.75 18.3255C18.75 18.3272 18.75 18.329 18.75 18.3308C18.75 18.3325 18.75 18.3343 18.75 18.3361C18.75 18.3379 18.75 18.3396 18.75 18.3414C18.75 18.3432 18.75 18.345 18.75 18.3467C18.75 18.3485 18.75 18.3503 18.75 18.3521C18.75 18.3539 18.75 18.3556 18.75 18.3574C18.75 18.3592 18.75 18.361 18.75 18.3628C18.75 18.3646 18.75 18.3664 18.75 18.3682C18.75 18.37 18.75 18.3717 18.75 18.3735C18.75 18.3753 18.75 18.3771 18.75 18.3789C18.75 18.3807 18.75 18.3825 18.75 18.3843C18.75 18.3861 18.75 18.3879 18.75 18.3898C18.75 18.3916 18.75 18.3934 18.75 18.3952C18.75 18.397 18.75 18.3988 18.75 18.4006C18.75 18.4024 18.75 18.4042 18.75 18.4061C18.75 18.4079 18.75 18.4097 18.75 18.4115C18.75 18.4133 18.75 18.4152 18.75 18.417C18.75 18.4188 18.75 18.4206 18.75 18.4225C18.75 18.4243 18.75 18.4261 18.75 18.428C18.75 18.4298 18.75 18.4316 18.75 18.4335C18.75 18.4353 18.75 18.4371 18.75 18.439C18.75 18.4408 18.75 18.4426 18.75 18.4445C18.75 18.4463 18.75 18.4482 18.75 18.45C18.75 18.4519 18.75 18.4537 18.75 18.4556C18.75 18.4574 18.75 18.4593 18.75 18.4611C18.75 18.463 18.75 18.4648 18.75 18.4667C18.75 18.4685 18.75 18.4704 18.75 18.4722C18.75 18.4741 18.75 18.476 18.75 18.4778C18.75 18.4797 18.75 18.4815 18.75 18.4834C18.75 18.4853 18.75 18.4871 18.75 18.489C18.75 18.4909 18.75 18.4928 18.75 18.4946C18.75 18.4965 18.75 18.4984 18.75 18.5003C18.75 18.5021 18.75 18.504 18.75 18.5059C18.75 18.5078 18.75 18.5097 18.75 18.5115C18.75 18.5134 18.75 18.5153 18.75 18.5172C18.75 18.5191 18.75 18.521 18.75 18.5229C18.75 18.5247 18.75 18.5266 18.75 18.5285C18.75 18.5304 18.75 18.5323 18.75 18.5342C18.75 18.5361 18.75 18.538 18.75 18.5399C18.75 18.5418 18.75 18.5437 18.75 18.5456C18.75 18.5475 18.75 18.5494 18.75 18.5513C18.75 18.5532 18.75 18.5551 18.75 18.5571C18.75 18.559 18.75 18.5609 18.75 18.5628C18.75 18.5647 18.75 18.5666 18.75 18.5685C18.75 18.5705 18.75 18.5724 18.75 18.5743C18.75 18.5762 18.75 18.5781 18.75 18.5801C18.75 18.582 18.75 18.5839 18.75 18.5858C18.75 18.5878 18.75 18.5897 18.75 18.5916C18.75 18.5936 18.75 18.5955 18.75 18.5974C18.75 18.5994 18.75 18.6013 18.75 18.6032C18.75 18.6052 18.75 18.6071 18.75 18.609C18.75 18.611 18.75 18.6129 18.75 18.6149C18.75 18.6168 18.75 18.6188 18.75 18.6207C18.75 18.6227 18.75 18.6246 18.75 18.6266C18.75 18.6285 18.75 18.6305 18.75 18.6324C18.75 18.6344 18.75 18.6363 18.75 18.6383C18.75 18.6402 18.75 18.6422 18.75 18.6442C18.75 18.6461 18.75 18.6481 18.75 18.65C18.75 18.652 18.75 18.654 18.75 18.6559C18.75 18.6579 18.75 18.6599 18.75 18.6618C18.75 18.6638 18.75 18.6658 18.75 18.6678C18.75 18.6697 18.75 18.6717 18.75 18.6737C18.75 18.6757 18.75 18.6776 18.75 18.6796C18.75 18.6816 18.75 18.6836 18.75 18.6856C18.75 18.6875 18.75 18.6895 18.75 18.6915C18.75 18.6935 18.75 18.6955 18.75 18.6975C18.75 18.6995 18.75 18.7015 18.75 18.7035C18.75 18.7055 18.75 18.7074 18.75 18.7094C18.75 18.7114 18.75 18.7134 18.75 18.7154C18.75 18.7174 18.75 18.7194 18.75 18.7214C18.75 18.7234 18.75 18.7254 18.75 18.7275C18.75 18.7295 18.75 18.7315 18.75 18.7335C18.75 18.7355 18.75 18.7375 18.75 18.7395C18.75 18.7415 18.75 18.7435 18.75 18.7456C18.75 18.7476 18.75 18.7496 18.75 18.7516C18.75 18.7536 18.75 18.7556 18.75 18.7577C18.75 18.7597 18.75 18.7617 18.75 18.7637C18.75 18.7658 18.75 18.7678 18.75 18.7698C18.75 18.7718 18.75 18.7739 18.75 18.7759C18.75 18.7779 18.75 18.78 18.75 18.782C18.75 18.784 18.75 18.7861 18.75 18.7881C18.75 18.7901 18.75 18.7922 18.75 18.7942C18.75 18.7963 18.75 18.7983 18.75 18.8004C18.75 18.8024 18.75 18.8044 18.75 18.8065C18.75 18.8085 18.75 18.8106 18.75 18.8126C18.75 18.8147 18.75 18.8167 18.75 18.8188C18.75 18.8208 18.75 18.8229 18.75 18.825C18.75 18.827 18.75 18.8291 18.75 18.8311C18.75 18.8332 18.75 18.8353 18.75 18.8373C18.75 18.8394 18.75 18.8414 18.75 18.8435C18.75 18.8456 18.75 18.8476 18.75 18.8497C18.75 18.8518 18.75 18.8539 18.75 18.8559C18.75 18.858 18.75 18.8601 18.75 18.8621C18.75 18.8642 18.75 18.8663 18.75 18.8684C18.75 18.8705 18.75 18.8725 18.75 18.8746C18.75 18.8767 18.75 18.8788 18.75 18.8809C18.75 18.883 18.75 18.885 18.75 18.8871C18.75 18.8892 18.75 18.8913 18.75 18.8934C18.75 18.8955 18.75 18.8976 18.75 18.8997C18.75 18.9018 18.75 18.9039 18.75 18.906C18.75 18.9081 18.75 18.9102 18.75 18.9123C18.75 18.9144 18.75 18.9165 18.75 18.9186C18.75 18.9207 18.75 18.9228 18.75 18.9249C18.75 18.927 18.75 18.9291 18.75 18.9312C18.75 18.9333 18.75 18.9354 18.75 18.9375C18.75 18.9396 18.75 18.9417 18.75 18.9439C18.75 18.946 18.75 18.9481 18.75 18.9502C18.75 18.9523 18.75 18.9544 18.75 18.9566C18.75 18.9587 18.75 18.9608 18.75 18.9629C18.75 18.9651 18.75 18.9672 18.75 18.9693C18.75 18.9714 18.75 18.9736 18.75 18.9757C18.75 18.9778 18.75 18.98 18.75 18.9821C18.75 18.9842 18.75 18.9864 18.75 18.9885C18.75 18.9906 18.75 18.9928 18.75 18.9949C18.75 18.997 18.75 18.9992 18.75 19.0013C18.75 19.0035 18.75 19.0056 18.75 19.0078C18.75 19.0099 18.75 19.0121 18.75 19.0142C18.75 19.0163 18.75 19.0185 18.75 19.0206C18.75 19.0228 18.75 19.025 18.75 19.0271C18.75 19.0293 18.75 19.0314 18.75 19.0336C18.75 19.0357 18.75 19.0379 18.75 19.04C18.75 19.0422 18.75 19.0444 18.75 19.0465C18.75 19.0487 18.75 19.0509 18.75 19.053C18.75 19.0552 18.75 19.0574 18.75 19.0595C18.75 19.0617 18.75 19.0639 18.75 19.066C18.75 19.0682 18.75 19.0704 18.75 19.0725C18.75 19.0747 18.75 19.0769 18.75 19.0791C18.75 19.0813 18.75 19.0834 18.75 19.0856C18.75 19.0878 18.75 19.09 18.75 19.0922C18.75 19.0943 18.75 19.0965 18.75 19.0987C18.75 19.1009 18.75 19.1031 18.75 19.1053C18.75 19.1075 18.75 19.1096 18.75 19.1118C18.75 19.114 18.75 19.1162 18.75 19.1184C18.75 19.1206 18.75 19.1228 18.75 19.125H20.25ZM19.5 16.5H18.375V18H19.5V16.5ZM15.75 17.9384C15.75 19.157 16.596 20.4079 18.0001 20.4857L18.0831 18.988C17.6546 18.9642 17.25 18.5553 17.25 17.9384H15.75ZM18.5791 14.1789C17.7429 14.086 17.0198 14.4631 16.5327 14.9964C16.0498 15.525 15.75 16.253 15.75 17H17.25C17.25 16.6425 17.3994 16.2716 17.6402 16.0081C17.8768 15.7491 18.1519 15.6406 18.4135 15.6697L18.5791 14.1789Z"
              fill="#004186"
            />
            <path
              {...props}
              d="M4.5 19.5938L4.5 18.0938M4.5 18.0938L4.5 15.0938L6 15.0938C6.82843 15.0938 7.5 15.7653 7.5 16.5938V16.5938C7.5 17.4222 6.82843 18.0938 6 18.0938L4.5 18.0938Z"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              {...props}
              d="M10.5 15V19.5"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
            />
            <path
              {...props}
              d="M13.5 15V19.5"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
            />
            <path
              {...props}
              d="M10.5 15L13.5 19.5"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="16.5"
                height="6.75"
                fill="white"
                transform="translate(3.75 14.25)"
              />
            </clipPath>
          </defs>
        </>
      );
    case 'iconJpg':
      return (
        <>
          <path
            {...props}
            d="M4.5 11.8906V5.35942C4.5 4.88526 4.87645 4.5 5.33977 4.5H14.6351C14.9681 4.5 15.3012 4.63336 15.5473 4.88526L19.1236 8.54521C19.3697 8.79711 19.5 9.1231 19.5 9.47872V11.8906"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.25 4.5V9.26641C14.25 9.94402 14.7133 10.5 15.278 10.5H17.25"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.75 15.0938V17.5938C6.75 18.6983 5.85457 19.5938 4.75 19.5938H4.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip0)">
            <path
              {...props}
              d="M10.5 19.5938L10.5 18.0938M10.5 18.0938L10.5 15.0938L12 15.0938C12.8284 15.0938 13.5 15.7653 13.5 16.5938V16.5938C13.5 17.4222 12.8284 18.0938 12 18.0938L10.5 18.0938Z"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              {...props}
              d="M18.9697 15.9991C19.2626 16.292 19.7374 16.292 20.0303 15.9991C20.3232 15.7062 20.3232 15.2313 20.0303 14.9384L18.9697 15.9991ZM19.5 17.3437H20.25C20.25 16.9295 19.9142 16.5937 19.5 16.5937V17.3437ZM18.375 16.5937C17.9608 16.5937 17.625 16.9295 17.625 17.3437C17.625 17.758 17.9608 18.0937 18.375 18.0937V16.5937ZM18.0416 19.8306L18.0001 20.5794L18.0416 19.8306ZM20.0303 14.9384C19.5914 14.4995 19.073 14.3274 18.5791 14.2726L18.4135 15.7634C18.6704 15.792 18.8351 15.8645 18.9697 15.9991L20.0303 14.9384ZM15.75 17.0938V18.0322H17.25V17.0938H15.75ZM18.0001 20.5794C18.3925 20.6012 18.8709 20.5934 19.2796 20.4599C19.4898 20.3913 19.7329 20.2731 19.9284 20.0598C20.139 19.8302 20.25 19.5377 20.25 19.2188H18.75C18.75 19.1759 18.7707 19.103 18.8228 19.0462C18.8598 19.0058 18.8764 19.0137 18.8139 19.0341C18.6774 19.0787 18.4267 19.1008 18.0831 19.0817L18.0001 20.5794ZM20.25 19.2188C20.25 19.2166 20.25 19.2144 20.25 19.2122C20.25 19.21 20.25 19.2078 20.25 19.2056C20.25 19.2034 20.25 19.2012 20.25 19.199C20.25 19.1968 20.25 19.1946 20.25 19.1925C20.25 19.1903 20.25 19.1881 20.25 19.1859C20.25 19.1837 20.25 19.1815 20.25 19.1794C20.25 19.1772 20.25 19.175 20.25 19.1728C20.25 19.1706 20.25 19.1685 20.25 19.1663C20.25 19.1641 20.25 19.162 20.25 19.1598C20.25 19.1576 20.25 19.1554 20.25 19.1533C20.25 19.1511 20.25 19.1489 20.25 19.1468C20.25 19.1446 20.25 19.1424 20.25 19.1403C20.25 19.1381 20.25 19.136 20.25 19.1338C20.25 19.1316 20.25 19.1295 20.25 19.1273C20.25 19.1252 20.25 19.123 20.25 19.1209C20.25 19.1187 20.25 19.1165 20.25 19.1144C20.25 19.1122 20.25 19.1101 20.25 19.1079C20.25 19.1058 20.25 19.1037 20.25 19.1015C20.25 19.0994 20.25 19.0972 20.25 19.0951C20.25 19.0929 20.25 19.0908 20.25 19.0887C20.25 19.0865 20.25 19.0844 20.25 19.0822C20.25 19.0801 20.25 19.078 20.25 19.0758C20.25 19.0737 20.25 19.0716 20.25 19.0694C20.25 19.0673 20.25 19.0652 20.25 19.0631C20.25 19.0609 20.25 19.0588 20.25 19.0567C20.25 19.0546 20.25 19.0524 20.25 19.0503C20.25 19.0482 20.25 19.0461 20.25 19.044C20.25 19.0418 20.25 19.0397 20.25 19.0376C20.25 19.0355 20.25 19.0334 20.25 19.0313C20.25 19.0292 20.25 19.027 20.25 19.0249C20.25 19.0228 20.25 19.0207 20.25 19.0186C20.25 19.0165 20.25 19.0144 20.25 19.0123C20.25 19.0102 20.25 19.0081 20.25 19.006C20.25 19.0039 20.25 19.0018 20.25 18.9997C20.25 18.9976 20.25 18.9955 20.25 18.9934C20.25 18.9913 20.25 18.9892 20.25 18.9871C20.25 18.9851 20.25 18.983 20.25 18.9809C20.25 18.9788 20.25 18.9767 20.25 18.9746C20.25 18.9725 20.25 18.9704 20.25 18.9684C20.25 18.9663 20.25 18.9642 20.25 18.9621C20.25 18.9601 20.25 18.958 20.25 18.9559C20.25 18.9538 20.25 18.9517 20.25 18.9497C20.25 18.9476 20.25 18.9455 20.25 18.9435C20.25 18.9414 20.25 18.9393 20.25 18.9373C20.25 18.9352 20.25 18.9331 20.25 18.9311C20.25 18.929 20.25 18.9269 20.25 18.9249C20.25 18.9228 20.25 18.9208 20.25 18.9187C20.25 18.9167 20.25 18.9146 20.25 18.9125C20.25 18.9105 20.25 18.9084 20.25 18.9064C20.25 18.9043 20.25 18.9023 20.25 18.9002C20.25 18.8982 20.25 18.8962 20.25 18.8941C20.25 18.8921 20.25 18.89 20.25 18.888C20.25 18.8859 20.25 18.8839 20.25 18.8819C20.25 18.8798 20.25 18.8778 20.25 18.8758C20.25 18.8737 20.25 18.8717 20.25 18.8697C20.25 18.8676 20.25 18.8656 20.25 18.8636C20.25 18.8615 20.25 18.8595 20.25 18.8575C20.25 18.8555 20.25 18.8534 20.25 18.8514C20.25 18.8494 20.25 18.8474 20.25 18.8454C20.25 18.8433 20.25 18.8413 20.25 18.8393C20.25 18.8373 20.25 18.8353 20.25 18.8333C20.25 18.8312 20.25 18.8292 20.25 18.8272C20.25 18.8252 20.25 18.8232 20.25 18.8212C20.25 18.8192 20.25 18.8172 20.25 18.8152C20.25 18.8132 20.25 18.8112 20.25 18.8092C20.25 18.8072 20.25 18.8052 20.25 18.8032C20.25 18.8012 20.25 18.7992 20.25 18.7972C20.25 18.7952 20.25 18.7932 20.25 18.7912C20.25 18.7892 20.25 18.7873 20.25 18.7853C20.25 18.7833 20.25 18.7813 20.25 18.7793C20.25 18.7773 20.25 18.7754 20.25 18.7734C20.25 18.7714 20.25 18.7694 20.25 18.7674C20.25 18.7655 20.25 18.7635 20.25 18.7615C20.25 18.7595 20.25 18.7576 20.25 18.7556C20.25 18.7536 20.25 18.7517 20.25 18.7497C20.25 18.7477 20.25 18.7458 20.25 18.7438C20.25 18.7418 20.25 18.7399 20.25 18.7379C20.25 18.7359 20.25 18.734 20.25 18.732C20.25 18.7301 20.25 18.7281 20.25 18.7262C20.25 18.7242 20.25 18.7223 20.25 18.7203C20.25 18.7184 20.25 18.7164 20.25 18.7145C20.25 18.7125 20.25 18.7106 20.25 18.7086C20.25 18.7067 20.25 18.7047 20.25 18.7028C20.25 18.7009 20.25 18.6989 20.25 18.697C20.25 18.695 20.25 18.6931 20.25 18.6912C20.25 18.6892 20.25 18.6873 20.25 18.6854C20.25 18.6834 20.25 18.6815 20.25 18.6796C20.25 18.6777 20.25 18.6757 20.25 18.6738C20.25 18.6719 20.25 18.67 20.25 18.668C20.25 18.6661 20.25 18.6642 20.25 18.6623C20.25 18.6604 20.25 18.6585 20.25 18.6565C20.25 18.6546 20.25 18.6527 20.25 18.6508C20.25 18.6489 20.25 18.647 20.25 18.6451C20.25 18.6432 20.25 18.6413 20.25 18.6394C20.25 18.6375 20.25 18.6356 20.25 18.6337C20.25 18.6318 20.25 18.6299 20.25 18.628C20.25 18.6261 20.25 18.6242 20.25 18.6223C20.25 18.6204 20.25 18.6185 20.25 18.6166C20.25 18.6147 20.25 18.6128 20.25 18.6109C20.25 18.6091 20.25 18.6072 20.25 18.6053C20.25 18.6034 20.25 18.6015 20.25 18.5996C20.25 18.5978 20.25 18.5959 20.25 18.594C20.25 18.5921 20.25 18.5903 20.25 18.5884C20.25 18.5865 20.25 18.5846 20.25 18.5828C20.25 18.5809 20.25 18.579 20.25 18.5772C20.25 18.5753 20.25 18.5734 20.25 18.5716C20.25 18.5697 20.25 18.5678 20.25 18.566C20.25 18.5641 20.25 18.5623 20.25 18.5604C20.25 18.5586 20.25 18.5567 20.25 18.5549C20.25 18.553 20.25 18.5512 20.25 18.5493C20.25 18.5475 20.25 18.5456 20.25 18.5438C20.25 18.5419 20.25 18.5401 20.25 18.5382C20.25 18.5364 20.25 18.5345 20.25 18.5327C20.25 18.5309 20.25 18.529 20.25 18.5272C20.25 18.5254 20.25 18.5235 20.25 18.5217C20.25 18.5199 20.25 18.518 20.25 18.5162C20.25 18.5144 20.25 18.5126 20.25 18.5107C20.25 18.5089 20.25 18.5071 20.25 18.5053C20.25 18.5034 20.25 18.5016 20.25 18.4998C20.25 18.498 20.25 18.4962 20.25 18.4944C20.25 18.4926 20.25 18.4907 20.25 18.4889C20.25 18.4871 20.25 18.4853 20.25 18.4835C20.25 18.4817 20.25 18.4799 20.25 18.4781C20.25 18.4763 20.25 18.4745 20.25 18.4727C20.25 18.4709 20.25 18.4691 20.25 18.4673C20.25 18.4655 20.25 18.4637 20.25 18.4619C20.25 18.4601 20.25 18.4583 20.25 18.4565C20.25 18.4547 20.25 18.453 20.25 18.4512C20.25 18.4494 20.25 18.4476 20.25 18.4458C20.25 18.444 20.25 18.4423 20.25 18.4405C20.25 18.4387 20.25 18.4369 20.25 18.4352C20.25 18.4334 20.25 18.4316 20.25 18.4298C20.25 18.4281 20.25 18.4263 20.25 18.4245C20.25 18.4228 20.25 18.421 20.25 18.4192C20.25 18.4175 20.25 18.4157 20.25 18.4139C20.25 18.4122 20.25 18.4104 20.25 18.4087C20.25 18.4069 20.25 18.4052 20.25 18.4034C20.25 18.4017 20.25 18.3999 20.25 18.3982C20.25 18.3964 20.25 18.3947 20.25 18.3929C20.25 18.3912 20.25 18.3894 20.25 18.3877C20.25 18.3859 20.25 18.3842 20.25 18.3825C20.25 18.3807 20.25 18.379 20.25 18.3773C20.25 18.3755 20.25 18.3738 20.25 18.3721C20.25 18.3703 20.25 18.3686 20.25 18.3669C20.25 18.3651 20.25 18.3634 20.25 18.3617C20.25 18.36 20.25 18.3582 20.25 18.3565C20.25 18.3548 20.25 18.3531 20.25 18.3514C20.25 18.3497 20.25 18.3479 20.25 18.3462C20.25 18.3445 20.25 18.3428 20.25 18.3411C20.25 18.3394 20.25 18.3377 20.25 18.336C20.25 18.3343 20.25 18.3326 20.25 18.3309C20.25 18.3292 20.25 18.3275 20.25 18.3258C20.25 18.3241 20.25 18.3224 20.25 18.3207C20.25 18.319 20.25 18.3173 20.25 18.3156C20.25 18.3139 20.25 18.3122 20.25 18.3105C20.25 18.3088 20.25 18.3072 20.25 18.3055C20.25 18.3038 20.25 18.3021 20.25 18.3004C20.25 18.2988 20.25 18.2971 20.25 18.2954C20.25 18.2937 20.25 18.2921 20.25 18.2904C20.25 18.2887 20.25 18.287 20.25 18.2854C20.25 18.2837 20.25 18.282 20.25 18.2804C20.25 18.2787 20.25 18.277 20.25 18.2754C20.25 18.2737 20.25 18.2721 20.25 18.2704C20.25 18.2688 20.25 18.2671 20.25 18.2654C20.25 18.2638 20.25 18.2621 20.25 18.2605C20.25 18.2588 20.25 18.2572 20.25 18.2556C20.25 18.2539 20.25 18.2523 20.25 18.2506C20.25 18.249 20.25 18.2473 20.25 18.2457C20.25 18.2441 20.25 18.2424 20.25 18.2408C20.25 18.2392 20.25 18.2375 20.25 18.2359C20.25 18.2343 20.25 18.2326 20.25 18.231C20.25 18.2294 20.25 18.2278 20.25 18.2261C20.25 18.2245 20.25 18.2229 20.25 18.2213C20.25 18.2197 20.25 18.218 20.25 18.2164C20.25 18.2148 20.25 18.2132 20.25 18.2116C20.25 18.21 20.25 18.2084 20.25 18.2068C20.25 18.2052 20.25 18.2036 20.25 18.2019C20.25 18.2003 20.25 18.1987 20.25 18.1971C20.25 18.1955 20.25 18.1939 20.25 18.1923C20.25 18.1908 20.25 18.1892 20.25 18.1876C20.25 18.186 20.25 18.1844 20.25 18.1828C20.25 18.1812 20.25 18.1796 20.25 18.178C20.25 18.1765 20.25 18.1749 20.25 18.1733C20.25 18.1717 20.25 18.1701 20.25 18.1686C20.25 18.167 20.25 18.1654 20.25 18.1638C20.25 18.1623 20.25 18.1607 20.25 18.1591C20.25 18.1576 20.25 18.156 20.25 18.1544C20.25 18.1529 20.25 18.1513 20.25 18.1497C20.25 18.1482 20.25 18.1466 20.25 18.1451C20.25 18.1435 20.25 18.142 20.25 18.1404C20.25 18.1388 20.25 18.1373 20.25 18.1357C20.25 18.1342 20.25 18.1327 20.25 18.1311C20.25 18.1296 20.25 18.128 20.25 18.1265C20.25 18.1249 20.25 18.1234 20.25 18.1219C20.25 18.1203 20.25 18.1188 20.25 18.1173C20.25 18.1157 20.25 18.1142 20.25 18.1127C20.25 18.1111 20.25 18.1096 20.25 18.1081C20.25 18.1066 20.25 18.105 20.25 18.1035C20.25 18.102 20.25 18.1005 20.25 18.099C20.25 18.0974 20.25 18.0959 20.25 18.0944C20.25 18.0929 20.25 18.0914 20.25 18.0899C20.25 18.0884 20.25 18.0869 20.25 18.0853C20.25 18.0838 20.25 18.0823 20.25 18.0808C20.25 18.0793 20.25 18.0778 20.25 18.0763C20.25 18.0748 20.25 18.0733 20.25 18.0719C20.25 18.0704 20.25 18.0689 20.25 18.0674C20.25 18.0659 20.25 18.0644 20.25 18.0629C20.25 18.0614 20.25 18.06 20.25 18.0585C20.25 18.057 20.25 18.0555 20.25 18.054C20.25 18.0526 20.25 18.0511 20.25 18.0496C20.25 18.0481 20.25 18.0467 20.25 18.0452C20.25 18.0437 20.25 18.0423 20.25 18.0408C20.25 18.0393 20.25 18.0379 20.25 18.0364C20.25 18.0349 20.25 18.0335 20.25 18.032C20.25 18.0306 20.25 18.0291 20.25 18.0277C20.25 18.0262 20.25 18.0248 20.25 18.0233C20.25 18.0219 20.25 18.0204 20.25 18.019C20.25 18.0175 20.25 18.0161 20.25 18.0146C20.25 18.0132 20.25 18.0118 20.25 18.0103C20.25 18.0089 20.25 18.0074 20.25 18.006C20.25 18.0046 20.25 18.0032 20.25 18.0017C20.25 18.0003 20.25 17.9989 20.25 17.9974C20.25 17.996 20.25 17.9946 20.25 17.9932C20.25 17.9918 20.25 17.9903 20.25 17.9889C20.25 17.9875 20.25 17.9861 20.25 17.9847C20.25 17.9833 20.25 17.9819 20.25 17.9805C20.25 17.979 20.25 17.9776 20.25 17.9762C20.25 17.9748 20.25 17.9734 20.25 17.972C20.25 17.9706 20.25 17.9692 20.25 17.9678C20.25 17.9664 20.25 17.965 20.25 17.9637C20.25 17.9623 20.25 17.9609 20.25 17.9595C20.25 17.9581 20.25 17.9567 20.25 17.9553C20.25 17.9539 20.25 17.9526 20.25 17.9512C20.25 17.9498 20.25 17.9484 20.25 17.9471C20.25 17.9457 20.25 17.9443 20.25 17.9429C20.25 17.9416 20.25 17.9402 20.25 17.9388C20.25 17.9375 20.25 17.9361 20.25 17.9347C20.25 17.9334 20.25 17.932 20.25 17.9307C20.25 17.9293 20.25 17.9279 20.25 17.9266C20.25 17.9252 20.25 17.9239 20.25 17.9225C20.25 17.9212 20.25 17.9198 20.25 17.9185C20.25 17.9171 20.25 17.9158 20.25 17.9145C20.25 17.9131 20.25 17.9118 20.25 17.9104C20.25 17.9091 20.25 17.9078 20.25 17.9064C20.25 17.9051 20.25 17.9038 20.25 17.9024C20.25 17.9011 20.25 17.8998 20.25 17.8985C20.25 17.8971 20.25 17.8958 20.25 17.8945C20.25 17.8932 20.25 17.8919 20.25 17.8905C20.25 17.8892 20.25 17.8879 20.25 17.8866C20.25 17.8853 20.25 17.884 20.25 17.8827C20.25 17.8814 20.25 17.8801 20.25 17.8788C20.25 17.8775 20.25 17.8762 20.25 17.8749C20.25 17.8736 20.25 17.8723 20.25 17.871C20.25 17.8697 20.25 17.8684 20.25 17.8671C20.25 17.8658 20.25 17.8645 20.25 17.8632C20.25 17.8619 20.25 17.8607 20.25 17.8594C20.25 17.8581 20.25 17.8568 20.25 17.8555C20.25 17.8543 20.25 17.853 20.25 17.8517C20.25 17.8504 20.25 17.8492 20.25 17.8479C20.25 17.8466 20.25 17.8454 20.25 17.8441C20.25 17.8428 20.25 17.8416 20.25 17.8403C20.25 17.839 20.25 17.8378 20.25 17.8365C20.25 17.8353 20.25 17.834 20.25 17.8328C20.25 17.8315 20.25 17.8303 20.25 17.829C20.25 17.8278 20.25 17.8265 20.25 17.8253C20.25 17.824 20.25 17.8228 20.25 17.8216C20.25 17.8203 20.25 17.8191 20.25 17.8179C20.25 17.8166 20.25 17.8154 20.25 17.8142C20.25 17.8129 20.25 17.8117 20.25 17.8105C20.25 17.8093 20.25 17.808 20.25 17.8068C20.25 17.8056 20.25 17.8044 20.25 17.8032C20.25 17.8019 20.25 17.8007 20.25 17.7995C20.25 17.7983 20.25 17.7971 20.25 17.7959C20.25 17.7947 20.25 17.7935 20.25 17.7923C20.25 17.7911 20.25 17.7899 20.25 17.7887C20.25 17.7875 20.25 17.7863 20.25 17.7851C20.25 17.7839 20.25 17.7827 20.25 17.7815C20.25 17.7803 20.25 17.7791 20.25 17.7779C20.25 17.7767 20.25 17.7756 20.25 17.7744C20.25 17.7732 20.25 17.772 20.25 17.7708C20.25 17.7697 20.25 17.7685 20.25 17.7673C20.25 17.7661 20.25 17.765 20.25 17.7638C20.25 17.7626 20.25 17.7615 20.25 17.7603C20.25 17.7591 20.25 17.758 20.25 17.7568C20.25 17.7557 20.25 17.7545 20.25 17.7533C20.25 17.7522 20.25 17.751 20.25 17.7499C20.25 17.7487 20.25 17.7476 20.25 17.7464C20.25 17.7453 20.25 17.7442 20.25 17.743C20.25 17.7419 20.25 17.7407 20.25 17.7396C20.25 17.7385 20.25 17.7373 20.25 17.7362C20.25 17.7351 20.25 17.7339 20.25 17.7328C20.25 17.7317 20.25 17.7305 20.25 17.7294C20.25 17.7283 20.25 17.7272 20.25 17.7261C20.25 17.7249 20.25 17.7238 20.25 17.7227C20.25 17.7216 20.25 17.7205 20.25 17.7194C20.25 17.7183 20.25 17.7171 20.25 17.716C20.25 17.7149 20.25 17.7138 20.25 17.7127C20.25 17.7116 20.25 17.7105 20.25 17.7094C20.25 17.7083 20.25 17.7072 20.25 17.7062C20.25 17.7051 20.25 17.704 20.25 17.7029C20.25 17.7018 20.25 17.7007 20.25 17.6996C20.25 17.6985 20.25 17.6975 20.25 17.6964C20.25 17.6953 20.25 17.6942 20.25 17.6932C20.25 17.6921 20.25 17.691 20.25 17.6899C20.25 17.6889 20.25 17.6878 20.25 17.6867C20.25 17.6857 20.25 17.6846 20.25 17.6836C20.25 17.6825 20.25 17.6814 20.25 17.6804C20.25 17.6793 20.25 17.6783 20.25 17.6772C20.25 17.6762 20.25 17.6751 20.25 17.6741C20.25 17.673 20.25 17.672 20.25 17.6709C20.25 17.6699 20.25 17.6689 20.25 17.6678C20.25 17.6668 20.25 17.6658 20.25 17.6647C20.25 17.6637 20.25 17.6627 20.25 17.6616C20.25 17.6606 20.25 17.6596 20.25 17.6586C20.25 17.6575 20.25 17.6565 20.25 17.6555C20.25 17.6545 20.25 17.6535 20.25 17.6524C20.25 17.6514 20.25 17.6504 20.25 17.6494C20.25 17.6484 20.25 17.6474 20.25 17.6464C20.25 17.6454 20.25 17.6444 20.25 17.6434C20.25 17.6424 20.25 17.6414 20.25 17.6404C20.25 17.6394 20.25 17.6384 20.25 17.6374C20.25 17.6364 20.25 17.6354 20.25 17.6344C20.25 17.6334 20.25 17.6325 20.25 17.6315C20.25 17.6305 20.25 17.6295 20.25 17.6285C20.25 17.6276 20.25 17.6266 20.25 17.6256C20.25 17.6246 20.25 17.6237 20.25 17.6227C20.25 17.6217 20.25 17.6208 20.25 17.6198C20.25 17.6188 20.25 17.6179 20.25 17.6169C20.25 17.616 20.25 17.615 20.25 17.6141C20.25 17.6131 20.25 17.6122 20.25 17.6112C20.25 17.6103 20.25 17.6093 20.25 17.6084C20.25 17.6074 20.25 17.6065 20.25 17.6055C20.25 17.6046 20.25 17.6037 20.25 17.6027C20.25 17.6018 20.25 17.6009 20.25 17.5999C20.25 17.599 20.25 17.5981 20.25 17.5972C20.25 17.5962 20.25 17.5953 20.25 17.5944C20.25 17.5935 20.25 17.5925 20.25 17.5916C20.25 17.5907 20.25 17.5898 20.25 17.5889C20.25 17.588 20.25 17.5871 20.25 17.5862C20.25 17.5853 20.25 17.5844 20.25 17.5835C20.25 17.5826 20.25 17.5817 20.25 17.5808C20.25 17.5799 20.25 17.579 20.25 17.5781C20.25 17.5772 20.25 17.5763 20.25 17.5754C20.25 17.5745 20.25 17.5736 20.25 17.5727C20.25 17.5719 20.25 17.571 20.25 17.5701C20.25 17.5692 20.25 17.5684 20.25 17.5675C20.25 17.5666 20.25 17.5657 20.25 17.5649C20.25 17.564 20.25 17.5631 20.25 17.5623C20.25 17.5614 20.25 17.5605 20.25 17.5597C20.25 17.5588 20.25 17.558 20.25 17.5571C20.25 17.5563 20.25 17.5554 20.25 17.5546C20.25 17.5537 20.25 17.5529 20.25 17.552C20.25 17.5512 20.25 17.5503 20.25 17.5495C20.25 17.5487 20.25 17.5478 20.25 17.547C20.25 17.5462 20.25 17.5453 20.25 17.5445C20.25 17.5437 20.25 17.5428 20.25 17.542C20.25 17.5412 20.25 17.5404 20.25 17.5396C20.25 17.5387 20.25 17.5379 20.25 17.5371C20.25 17.5363 20.25 17.5355 20.25 17.5347C20.25 17.5339 20.25 17.533 20.25 17.5322C20.25 17.5314 20.25 17.5306 20.25 17.5298C20.25 17.529 20.25 17.5282 20.25 17.5274C20.25 17.5266 20.25 17.5258 20.25 17.5251C20.25 17.5243 20.25 17.5235 20.25 17.5227C20.25 17.5219 20.25 17.5211 20.25 17.5203C20.25 17.5196 20.25 17.5188 20.25 17.518C20.25 17.5172 20.25 17.5165 20.25 17.5157C20.25 17.5149 20.25 17.5141 20.25 17.5134C20.25 17.5126 20.25 17.5119 20.25 17.5111C20.25 17.5103 20.25 17.5096 20.25 17.5088C20.25 17.5081 20.25 17.5073 20.25 17.5066C20.25 17.5058 20.25 17.5051 20.25 17.5043C20.25 17.5036 20.25 17.5028 20.25 17.5021C20.25 17.5013 20.25 17.5006 20.25 17.4999C20.25 17.4991 20.25 17.4984 20.25 17.4977C20.25 17.4969 20.25 17.4962 20.25 17.4955C20.25 17.4947 20.25 17.494 20.25 17.4933C20.25 17.4926 20.25 17.4919 20.25 17.4911C20.25 17.4904 20.25 17.4897 20.25 17.489C20.25 17.4883 20.25 17.4876 20.25 17.4869C20.25 17.4862 20.25 17.4855 20.25 17.4848C20.25 17.4841 20.25 17.4834 20.25 17.4827C20.25 17.482 20.25 17.4813 20.25 17.4806C20.25 17.4799 20.25 17.4792 20.25 17.4785C20.25 17.4778 20.25 17.4771 20.25 17.4765C20.25 17.4758 20.25 17.4751 20.25 17.4744C20.25 17.4737 20.25 17.4731 20.25 17.4724C20.25 17.4717 20.25 17.4711 20.25 17.4704C20.25 17.4697 20.25 17.4691 20.25 17.4684C20.25 17.4677 20.25 17.4671 20.25 17.4664C20.25 17.4658 20.25 17.4651 20.25 17.4645C20.25 17.4638 20.25 17.4632 20.25 17.4625C20.25 17.4619 20.25 17.4612 20.25 17.4606C20.25 17.4599 20.25 17.4593 20.25 17.4587C20.25 17.458 20.25 17.4574 20.25 17.4568C20.25 17.4561 20.25 17.4555 20.25 17.4549C20.25 17.4543 20.25 17.4536 20.25 17.453C20.25 17.4524 20.25 17.4518 20.25 17.4512C20.25 17.4505 20.25 17.4499 20.25 17.4493C20.25 17.4487 20.25 17.4481 20.25 17.4475C20.25 17.4469 20.25 17.4463 20.25 17.4457C20.25 17.4451 20.25 17.4445 20.25 17.4439C20.25 17.4433 20.25 17.4427 20.25 17.4421C20.25 17.4415 20.25 17.4409 20.25 17.4403C20.25 17.4398 20.25 17.4392 20.25 17.4386C20.25 17.438 20.25 17.4374 20.25 17.4369C20.25 17.4363 20.25 17.4357 20.25 17.4351C20.25 17.4346 20.25 17.434 20.25 17.4334C20.25 17.4329 20.25 17.4323 20.25 17.4317C20.25 17.4312 20.25 17.4306 20.25 17.4301C20.25 17.4295 20.25 17.429 20.25 17.4284C20.25 17.4279 20.25 17.4273 20.25 17.4268C20.25 17.4262 20.25 17.4257 20.25 17.4252C20.25 17.4246 20.25 17.4241 20.25 17.4235C20.25 17.423 20.25 17.4225 20.25 17.422C20.25 17.4214 20.25 17.4209 20.25 17.4204C20.25 17.4199 20.25 17.4193 20.25 17.4188C20.25 17.4183 20.25 17.4178 20.25 17.4173C20.25 17.4168 20.25 17.4162 20.25 17.4157C20.25 17.4152 20.25 17.4147 20.25 17.4142C20.25 17.4137 20.25 17.4132 20.25 17.4127C20.25 17.4122 20.25 17.4117 20.25 17.4112C20.25 17.4107 20.25 17.4102 20.25 17.4098C20.25 17.4093 20.25 17.4088 20.25 17.4083C20.25 17.4078 20.25 17.4073 20.25 17.4069C20.25 17.4064 20.25 17.4059 20.25 17.4054C20.25 17.405 20.25 17.4045 20.25 17.404C20.25 17.4036 20.25 17.4031 20.25 17.4027C20.25 17.4022 20.25 17.4017 20.25 17.4013C20.25 17.4008 20.25 17.4004 20.25 17.3999C20.25 17.3995 20.25 17.399 20.25 17.3986C20.25 17.3981 20.25 17.3977 20.25 17.3972C20.25 17.3968 20.25 17.3964 20.25 17.3959C20.25 17.3955 20.25 17.3951 20.25 17.3946C20.25 17.3942 20.25 17.3938 20.25 17.3934C20.25 17.3929 20.25 17.3925 20.25 17.3921C20.25 17.3917 20.25 17.3913 20.25 17.3908C20.25 17.3904 20.25 17.39 20.25 17.3896C20.25 17.3892 20.25 17.3888 20.25 17.3884C20.25 17.388 20.25 17.3876 20.25 17.3872C20.25 17.3868 20.25 17.3864 20.25 17.386C20.25 17.3856 20.25 17.3852 20.25 17.3848C20.25 17.3845 20.25 17.3841 20.25 17.3837C20.25 17.3833 20.25 17.3829 20.25 17.3826C20.25 17.3822 20.25 17.3818 20.25 17.3814C20.25 17.3811 20.25 17.3807 20.25 17.3803C20.25 17.38 20.25 17.3796 20.25 17.3792C20.25 17.3789 20.25 17.3785 20.25 17.3782C20.25 17.3778 20.25 17.3775 20.25 17.3771C20.25 17.3768 20.25 17.3764 20.25 17.3761C20.25 17.3757 20.25 17.3754 20.25 17.375C20.25 17.3747 20.25 17.3744 20.25 17.374C20.25 17.3737 20.25 17.3734 20.25 17.373C20.25 17.3727 20.25 17.3724 20.25 17.3721C20.25 17.3718 20.25 17.3714 20.25 17.3711C20.25 17.3708 20.25 17.3705 20.25 17.3702C20.25 17.3699 20.25 17.3695 20.25 17.3692C20.25 17.3689 20.25 17.3686 20.25 17.3683C20.25 17.368 20.25 17.3677 20.25 17.3674C20.25 17.3671 20.25 17.3668 20.25 17.3666C20.25 17.3663 20.25 17.366 20.25 17.3657C20.25 17.3654 20.25 17.3651 20.25 17.3649C20.25 17.3646 20.25 17.3643 20.25 17.364C20.25 17.3637 20.25 17.3635 20.25 17.3632C20.25 17.3629 20.25 17.3627 20.25 17.3624C20.25 17.3622 20.25 17.3619 20.25 17.3616C20.25 17.3614 20.25 17.3611 20.25 17.3609C20.25 17.3606 20.25 17.3604 20.25 17.3601C20.25 17.3599 20.25 17.3596 20.25 17.3594C20.25 17.3592 20.25 17.3589 20.25 17.3587C20.25 17.3584 20.25 17.3582 20.25 17.358C20.25 17.3577 20.25 17.3575 20.25 17.3573C20.25 17.3571 20.25 17.3569 20.25 17.3566C20.25 17.3564 20.25 17.3562 20.25 17.356C20.25 17.3558 20.25 17.3556 20.25 17.3554C20.25 17.3551 20.25 17.3549 20.25 17.3547C20.25 17.3545 20.25 17.3543 20.25 17.3541C20.25 17.3539 20.25 17.3537 20.25 17.3536C20.25 17.3534 20.25 17.3532 20.25 17.353C20.25 17.3528 20.25 17.3526 20.25 17.3524C20.25 17.3523 20.25 17.3521 20.25 17.3519C20.25 17.3517 20.25 17.3516 20.25 17.3514C20.25 17.3512 20.25 17.3511 20.25 17.3509C20.25 17.3507 20.25 17.3506 20.25 17.3504C20.25 17.3503 20.25 17.3501 20.25 17.3499C20.25 17.3498 20.25 17.3496 20.25 17.3495C20.25 17.3494 20.25 17.3492 20.25 17.3491C20.25 17.3489 20.25 17.3488 20.25 17.3486C20.25 17.3485 20.25 17.3484 20.25 17.3483C20.25 17.3481 20.25 17.348 20.25 17.3479C20.25 17.3477 20.25 17.3476 20.25 17.3475C20.25 17.3474 20.25 17.3473 20.25 17.3472C20.25 17.347 20.25 17.3469 20.25 17.3468C20.25 17.3467 20.25 17.3466 20.25 17.3465C20.25 17.3464 20.25 17.3463 20.25 17.3462C20.25 17.3461 20.25 17.346 20.25 17.3459C20.25 17.3458 20.25 17.3458 20.25 17.3457C20.25 17.3456 20.25 17.3455 20.25 17.3454C20.25 17.3453 20.25 17.3453 20.25 17.3452C20.25 17.3451 20.25 17.345 20.25 17.345C20.25 17.3449 20.25 17.3448 20.25 17.3448C20.25 17.3447 20.25 17.3447 20.25 17.3446C20.25 17.3445 20.25 17.3445 20.25 17.3444C20.25 17.3444 20.25 17.3443 20.25 17.3443C20.25 17.3442 20.25 17.3442 20.25 17.3442C20.25 17.3441 20.25 17.3441 20.25 17.3441C20.25 17.344 20.25 17.344 20.25 17.344C20.25 17.3439 20.25 17.3439 20.25 17.3439C20.25 17.3439 20.25 17.3438 20.25 17.3438C20.25 17.3438 20.25 17.3438 20.25 17.3438C20.25 17.3438 20.25 17.3438 20.25 17.3438C20.25 17.3437 20.25 17.3437 19.5 17.3437C18.75 17.3437 18.75 17.3437 18.75 17.3438C18.75 17.3438 18.75 17.3438 18.75 17.3438C18.75 17.3438 18.75 17.3438 18.75 17.3438C18.75 17.3438 18.75 17.3439 18.75 17.3439C18.75 17.3439 18.75 17.3439 18.75 17.344C18.75 17.344 18.75 17.344 18.75 17.3441C18.75 17.3441 18.75 17.3441 18.75 17.3442C18.75 17.3442 18.75 17.3442 18.75 17.3443C18.75 17.3443 18.75 17.3444 18.75 17.3444C18.75 17.3445 18.75 17.3445 18.75 17.3446C18.75 17.3447 18.75 17.3447 18.75 17.3448C18.75 17.3448 18.75 17.3449 18.75 17.345C18.75 17.345 18.75 17.3451 18.75 17.3452C18.75 17.3453 18.75 17.3453 18.75 17.3454C18.75 17.3455 18.75 17.3456 18.75 17.3457C18.75 17.3458 18.75 17.3458 18.75 17.3459C18.75 17.346 18.75 17.3461 18.75 17.3462C18.75 17.3463 18.75 17.3464 18.75 17.3465C18.75 17.3466 18.75 17.3467 18.75 17.3468C18.75 17.3469 18.75 17.347 18.75 17.3472C18.75 17.3473 18.75 17.3474 18.75 17.3475C18.75 17.3476 18.75 17.3477 18.75 17.3479C18.75 17.348 18.75 17.3481 18.75 17.3483C18.75 17.3484 18.75 17.3485 18.75 17.3486C18.75 17.3488 18.75 17.3489 18.75 17.3491C18.75 17.3492 18.75 17.3494 18.75 17.3495C18.75 17.3496 18.75 17.3498 18.75 17.3499C18.75 17.3501 18.75 17.3503 18.75 17.3504C18.75 17.3506 18.75 17.3507 18.75 17.3509C18.75 17.3511 18.75 17.3512 18.75 17.3514C18.75 17.3516 18.75 17.3517 18.75 17.3519C18.75 17.3521 18.75 17.3523 18.75 17.3524C18.75 17.3526 18.75 17.3528 18.75 17.353C18.75 17.3532 18.75 17.3534 18.75 17.3536C18.75 17.3537 18.75 17.3539 18.75 17.3541C18.75 17.3543 18.75 17.3545 18.75 17.3547C18.75 17.3549 18.75 17.3551 18.75 17.3554C18.75 17.3556 18.75 17.3558 18.75 17.356C18.75 17.3562 18.75 17.3564 18.75 17.3566C18.75 17.3569 18.75 17.3571 18.75 17.3573C18.75 17.3575 18.75 17.3577 18.75 17.358C18.75 17.3582 18.75 17.3584 18.75 17.3587C18.75 17.3589 18.75 17.3592 18.75 17.3594C18.75 17.3596 18.75 17.3599 18.75 17.3601C18.75 17.3604 18.75 17.3606 18.75 17.3609C18.75 17.3611 18.75 17.3614 18.75 17.3616C18.75 17.3619 18.75 17.3622 18.75 17.3624C18.75 17.3627 18.75 17.3629 18.75 17.3632C18.75 17.3635 18.75 17.3637 18.75 17.364C18.75 17.3643 18.75 17.3646 18.75 17.3649C18.75 17.3651 18.75 17.3654 18.75 17.3657C18.75 17.366 18.75 17.3663 18.75 17.3666C18.75 17.3668 18.75 17.3671 18.75 17.3674C18.75 17.3677 18.75 17.368 18.75 17.3683C18.75 17.3686 18.75 17.3689 18.75 17.3692C18.75 17.3695 18.75 17.3699 18.75 17.3702C18.75 17.3705 18.75 17.3708 18.75 17.3711C18.75 17.3714 18.75 17.3718 18.75 17.3721C18.75 17.3724 18.75 17.3727 18.75 17.373C18.75 17.3734 18.75 17.3737 18.75 17.374C18.75 17.3744 18.75 17.3747 18.75 17.375C18.75 17.3754 18.75 17.3757 18.75 17.3761C18.75 17.3764 18.75 17.3768 18.75 17.3771C18.75 17.3775 18.75 17.3778 18.75 17.3782C18.75 17.3785 18.75 17.3789 18.75 17.3792C18.75 17.3796 18.75 17.38 18.75 17.3803C18.75 17.3807 18.75 17.3811 18.75 17.3814C18.75 17.3818 18.75 17.3822 18.75 17.3826C18.75 17.3829 18.75 17.3833 18.75 17.3837C18.75 17.3841 18.75 17.3845 18.75 17.3848C18.75 17.3852 18.75 17.3856 18.75 17.386C18.75 17.3864 18.75 17.3868 18.75 17.3872C18.75 17.3876 18.75 17.388 18.75 17.3884C18.75 17.3888 18.75 17.3892 18.75 17.3896C18.75 17.39 18.75 17.3904 18.75 17.3908C18.75 17.3913 18.75 17.3917 18.75 17.3921C18.75 17.3925 18.75 17.3929 18.75 17.3934C18.75 17.3938 18.75 17.3942 18.75 17.3946C18.75 17.3951 18.75 17.3955 18.75 17.3959C18.75 17.3964 18.75 17.3968 18.75 17.3972C18.75 17.3977 18.75 17.3981 18.75 17.3986C18.75 17.399 18.75 17.3995 18.75 17.3999C18.75 17.4004 18.75 17.4008 18.75 17.4013C18.75 17.4017 18.75 17.4022 18.75 17.4027C18.75 17.4031 18.75 17.4036 18.75 17.404C18.75 17.4045 18.75 17.405 18.75 17.4054C18.75 17.4059 18.75 17.4064 18.75 17.4069C18.75 17.4073 18.75 17.4078 18.75 17.4083C18.75 17.4088 18.75 17.4093 18.75 17.4098C18.75 17.4102 18.75 17.4107 18.75 17.4112C18.75 17.4117 18.75 17.4122 18.75 17.4127C18.75 17.4132 18.75 17.4137 18.75 17.4142C18.75 17.4147 18.75 17.4152 18.75 17.4157C18.75 17.4162 18.75 17.4168 18.75 17.4173C18.75 17.4178 18.75 17.4183 18.75 17.4188C18.75 17.4193 18.75 17.4199 18.75 17.4204C18.75 17.4209 18.75 17.4214 18.75 17.422C18.75 17.4225 18.75 17.423 18.75 17.4235C18.75 17.4241 18.75 17.4246 18.75 17.4252C18.75 17.4257 18.75 17.4262 18.75 17.4268C18.75 17.4273 18.75 17.4279 18.75 17.4284C18.75 17.429 18.75 17.4295 18.75 17.4301C18.75 17.4306 18.75 17.4312 18.75 17.4317C18.75 17.4323 18.75 17.4329 18.75 17.4334C18.75 17.434 18.75 17.4346 18.75 17.4351C18.75 17.4357 18.75 17.4363 18.75 17.4369C18.75 17.4374 18.75 17.438 18.75 17.4386C18.75 17.4392 18.75 17.4398 18.75 17.4403C18.75 17.4409 18.75 17.4415 18.75 17.4421C18.75 17.4427 18.75 17.4433 18.75 17.4439C18.75 17.4445 18.75 17.4451 18.75 17.4457C18.75 17.4463 18.75 17.4469 18.75 17.4475C18.75 17.4481 18.75 17.4487 18.75 17.4493C18.75 17.4499 18.75 17.4505 18.75 17.4512C18.75 17.4518 18.75 17.4524 18.75 17.453C18.75 17.4536 18.75 17.4543 18.75 17.4549C18.75 17.4555 18.75 17.4561 18.75 17.4568C18.75 17.4574 18.75 17.458 18.75 17.4587C18.75 17.4593 18.75 17.4599 18.75 17.4606C18.75 17.4612 18.75 17.4619 18.75 17.4625C18.75 17.4632 18.75 17.4638 18.75 17.4645C18.75 17.4651 18.75 17.4658 18.75 17.4664C18.75 17.4671 18.75 17.4677 18.75 17.4684C18.75 17.4691 18.75 17.4697 18.75 17.4704C18.75 17.4711 18.75 17.4717 18.75 17.4724C18.75 17.4731 18.75 17.4737 18.75 17.4744C18.75 17.4751 18.75 17.4758 18.75 17.4765C18.75 17.4771 18.75 17.4778 18.75 17.4785C18.75 17.4792 18.75 17.4799 18.75 17.4806C18.75 17.4813 18.75 17.482 18.75 17.4827C18.75 17.4834 18.75 17.4841 18.75 17.4848C18.75 17.4855 18.75 17.4862 18.75 17.4869C18.75 17.4876 18.75 17.4883 18.75 17.489C18.75 17.4897 18.75 17.4904 18.75 17.4911C18.75 17.4919 18.75 17.4926 18.75 17.4933C18.75 17.494 18.75 17.4947 18.75 17.4955C18.75 17.4962 18.75 17.4969 18.75 17.4977C18.75 17.4984 18.75 17.4991 18.75 17.4999C18.75 17.5006 18.75 17.5013 18.75 17.5021C18.75 17.5028 18.75 17.5036 18.75 17.5043C18.75 17.5051 18.75 17.5058 18.75 17.5066C18.75 17.5073 18.75 17.5081 18.75 17.5088C18.75 17.5096 18.75 17.5103 18.75 17.5111C18.75 17.5119 18.75 17.5126 18.75 17.5134C18.75 17.5141 18.75 17.5149 18.75 17.5157C18.75 17.5165 18.75 17.5172 18.75 17.518C18.75 17.5188 18.75 17.5196 18.75 17.5203C18.75 17.5211 18.75 17.5219 18.75 17.5227C18.75 17.5235 18.75 17.5243 18.75 17.5251C18.75 17.5258 18.75 17.5266 18.75 17.5274C18.75 17.5282 18.75 17.529 18.75 17.5298C18.75 17.5306 18.75 17.5314 18.75 17.5322C18.75 17.533 18.75 17.5339 18.75 17.5347C18.75 17.5355 18.75 17.5363 18.75 17.5371C18.75 17.5379 18.75 17.5387 18.75 17.5396C18.75 17.5404 18.75 17.5412 18.75 17.542C18.75 17.5428 18.75 17.5437 18.75 17.5445C18.75 17.5453 18.75 17.5462 18.75 17.547C18.75 17.5478 18.75 17.5487 18.75 17.5495C18.75 17.5503 18.75 17.5512 18.75 17.552C18.75 17.5529 18.75 17.5537 18.75 17.5546C18.75 17.5554 18.75 17.5563 18.75 17.5571C18.75 17.558 18.75 17.5588 18.75 17.5597C18.75 17.5605 18.75 17.5614 18.75 17.5623C18.75 17.5631 18.75 17.564 18.75 17.5649C18.75 17.5657 18.75 17.5666 18.75 17.5675C18.75 17.5684 18.75 17.5692 18.75 17.5701C18.75 17.571 18.75 17.5719 18.75 17.5727C18.75 17.5736 18.75 17.5745 18.75 17.5754C18.75 17.5763 18.75 17.5772 18.75 17.5781C18.75 17.579 18.75 17.5799 18.75 17.5808C18.75 17.5817 18.75 17.5826 18.75 17.5835C18.75 17.5844 18.75 17.5853 18.75 17.5862C18.75 17.5871 18.75 17.588 18.75 17.5889C18.75 17.5898 18.75 17.5907 18.75 17.5916C18.75 17.5925 18.75 17.5935 18.75 17.5944C18.75 17.5953 18.75 17.5962 18.75 17.5972C18.75 17.5981 18.75 17.599 18.75 17.5999C18.75 17.6009 18.75 17.6018 18.75 17.6027C18.75 17.6037 18.75 17.6046 18.75 17.6055C18.75 17.6065 18.75 17.6074 18.75 17.6084C18.75 17.6093 18.75 17.6103 18.75 17.6112C18.75 17.6122 18.75 17.6131 18.75 17.6141C18.75 17.615 18.75 17.616 18.75 17.6169C18.75 17.6179 18.75 17.6188 18.75 17.6198C18.75 17.6208 18.75 17.6217 18.75 17.6227C18.75 17.6237 18.75 17.6246 18.75 17.6256C18.75 17.6266 18.75 17.6276 18.75 17.6285C18.75 17.6295 18.75 17.6305 18.75 17.6315C18.75 17.6325 18.75 17.6334 18.75 17.6344C18.75 17.6354 18.75 17.6364 18.75 17.6374C18.75 17.6384 18.75 17.6394 18.75 17.6404C18.75 17.6414 18.75 17.6424 18.75 17.6434C18.75 17.6444 18.75 17.6454 18.75 17.6464C18.75 17.6474 18.75 17.6484 18.75 17.6494C18.75 17.6504 18.75 17.6514 18.75 17.6524C18.75 17.6535 18.75 17.6545 18.75 17.6555C18.75 17.6565 18.75 17.6575 18.75 17.6586C18.75 17.6596 18.75 17.6606 18.75 17.6616C18.75 17.6627 18.75 17.6637 18.75 17.6647C18.75 17.6658 18.75 17.6668 18.75 17.6678C18.75 17.6689 18.75 17.6699 18.75 17.6709C18.75 17.672 18.75 17.673 18.75 17.6741C18.75 17.6751 18.75 17.6762 18.75 17.6772C18.75 17.6783 18.75 17.6793 18.75 17.6804C18.75 17.6814 18.75 17.6825 18.75 17.6836C18.75 17.6846 18.75 17.6857 18.75 17.6867C18.75 17.6878 18.75 17.6889 18.75 17.6899C18.75 17.691 18.75 17.6921 18.75 17.6932C18.75 17.6942 18.75 17.6953 18.75 17.6964C18.75 17.6975 18.75 17.6985 18.75 17.6996C18.75 17.7007 18.75 17.7018 18.75 17.7029C18.75 17.704 18.75 17.7051 18.75 17.7062C18.75 17.7072 18.75 17.7083 18.75 17.7094C18.75 17.7105 18.75 17.7116 18.75 17.7127C18.75 17.7138 18.75 17.7149 18.75 17.716C18.75 17.7171 18.75 17.7183 18.75 17.7194C18.75 17.7205 18.75 17.7216 18.75 17.7227C18.75 17.7238 18.75 17.7249 18.75 17.7261C18.75 17.7272 18.75 17.7283 18.75 17.7294C18.75 17.7305 18.75 17.7317 18.75 17.7328C18.75 17.7339 18.75 17.7351 18.75 17.7362C18.75 17.7373 18.75 17.7385 18.75 17.7396C18.75 17.7407 18.75 17.7419 18.75 17.743C18.75 17.7442 18.75 17.7453 18.75 17.7464C18.75 17.7476 18.75 17.7487 18.75 17.7499C18.75 17.751 18.75 17.7522 18.75 17.7533C18.75 17.7545 18.75 17.7557 18.75 17.7568C18.75 17.758 18.75 17.7591 18.75 17.7603C18.75 17.7615 18.75 17.7626 18.75 17.7638C18.75 17.765 18.75 17.7661 18.75 17.7673C18.75 17.7685 18.75 17.7697 18.75 17.7708C18.75 17.772 18.75 17.7732 18.75 17.7744C18.75 17.7756 18.75 17.7767 18.75 17.7779C18.75 17.7791 18.75 17.7803 18.75 17.7815C18.75 17.7827 18.75 17.7839 18.75 17.7851C18.75 17.7863 18.75 17.7875 18.75 17.7887C18.75 17.7899 18.75 17.7911 18.75 17.7923C18.75 17.7935 18.75 17.7947 18.75 17.7959C18.75 17.7971 18.75 17.7983 18.75 17.7995C18.75 17.8007 18.75 17.8019 18.75 17.8032C18.75 17.8044 18.75 17.8056 18.75 17.8068C18.75 17.808 18.75 17.8093 18.75 17.8105C18.75 17.8117 18.75 17.8129 18.75 17.8142C18.75 17.8154 18.75 17.8166 18.75 17.8179C18.75 17.8191 18.75 17.8203 18.75 17.8216C18.75 17.8228 18.75 17.824 18.75 17.8253C18.75 17.8265 18.75 17.8278 18.75 17.829C18.75 17.8303 18.75 17.8315 18.75 17.8328C18.75 17.834 18.75 17.8353 18.75 17.8365C18.75 17.8378 18.75 17.839 18.75 17.8403C18.75 17.8416 18.75 17.8428 18.75 17.8441C18.75 17.8454 18.75 17.8466 18.75 17.8479C18.75 17.8492 18.75 17.8504 18.75 17.8517C18.75 17.853 18.75 17.8543 18.75 17.8555C18.75 17.8568 18.75 17.8581 18.75 17.8594C18.75 17.8607 18.75 17.8619 18.75 17.8632C18.75 17.8645 18.75 17.8658 18.75 17.8671C18.75 17.8684 18.75 17.8697 18.75 17.871C18.75 17.8723 18.75 17.8736 18.75 17.8749C18.75 17.8762 18.75 17.8775 18.75 17.8788C18.75 17.8801 18.75 17.8814 18.75 17.8827C18.75 17.884 18.75 17.8853 18.75 17.8866C18.75 17.8879 18.75 17.8892 18.75 17.8905C18.75 17.8919 18.75 17.8932 18.75 17.8945C18.75 17.8958 18.75 17.8971 18.75 17.8985C18.75 17.8998 18.75 17.9011 18.75 17.9024C18.75 17.9038 18.75 17.9051 18.75 17.9064C18.75 17.9078 18.75 17.9091 18.75 17.9104C18.75 17.9118 18.75 17.9131 18.75 17.9145C18.75 17.9158 18.75 17.9171 18.75 17.9185C18.75 17.9198 18.75 17.9212 18.75 17.9225C18.75 17.9239 18.75 17.9252 18.75 17.9266C18.75 17.9279 18.75 17.9293 18.75 17.9307C18.75 17.932 18.75 17.9334 18.75 17.9347C18.75 17.9361 18.75 17.9375 18.75 17.9388C18.75 17.9402 18.75 17.9416 18.75 17.9429C18.75 17.9443 18.75 17.9457 18.75 17.9471C18.75 17.9484 18.75 17.9498 18.75 17.9512C18.75 17.9526 18.75 17.9539 18.75 17.9553C18.75 17.9567 18.75 17.9581 18.75 17.9595C18.75 17.9609 18.75 17.9623 18.75 17.9637C18.75 17.965 18.75 17.9664 18.75 17.9678C18.75 17.9692 18.75 17.9706 18.75 17.972C18.75 17.9734 18.75 17.9748 18.75 17.9762C18.75 17.9776 18.75 17.979 18.75 17.9805C18.75 17.9819 18.75 17.9833 18.75 17.9847C18.75 17.9861 18.75 17.9875 18.75 17.9889C18.75 17.9903 18.75 17.9918 18.75 17.9932C18.75 17.9946 18.75 17.996 18.75 17.9974C18.75 17.9989 18.75 18.0003 18.75 18.0017C18.75 18.0032 18.75 18.0046 18.75 18.006C18.75 18.0074 18.75 18.0089 18.75 18.0103C18.75 18.0118 18.75 18.0132 18.75 18.0146C18.75 18.0161 18.75 18.0175 18.75 18.019C18.75 18.0204 18.75 18.0219 18.75 18.0233C18.75 18.0248 18.75 18.0262 18.75 18.0277C18.75 18.0291 18.75 18.0306 18.75 18.032C18.75 18.0335 18.75 18.0349 18.75 18.0364C18.75 18.0379 18.75 18.0393 18.75 18.0408C18.75 18.0423 18.75 18.0437 18.75 18.0452C18.75 18.0467 18.75 18.0481 18.75 18.0496C18.75 18.0511 18.75 18.0526 18.75 18.054C18.75 18.0555 18.75 18.057 18.75 18.0585C18.75 18.06 18.75 18.0614 18.75 18.0629C18.75 18.0644 18.75 18.0659 18.75 18.0674C18.75 18.0689 18.75 18.0704 18.75 18.0719C18.75 18.0733 18.75 18.0748 18.75 18.0763C18.75 18.0778 18.75 18.0793 18.75 18.0808C18.75 18.0823 18.75 18.0838 18.75 18.0853C18.75 18.0869 18.75 18.0884 18.75 18.0899C18.75 18.0914 18.75 18.0929 18.75 18.0944C18.75 18.0959 18.75 18.0974 18.75 18.099C18.75 18.1005 18.75 18.102 18.75 18.1035C18.75 18.105 18.75 18.1066 18.75 18.1081C18.75 18.1096 18.75 18.1111 18.75 18.1127C18.75 18.1142 18.75 18.1157 18.75 18.1173C18.75 18.1188 18.75 18.1203 18.75 18.1219C18.75 18.1234 18.75 18.1249 18.75 18.1265C18.75 18.128 18.75 18.1296 18.75 18.1311C18.75 18.1327 18.75 18.1342 18.75 18.1357C18.75 18.1373 18.75 18.1388 18.75 18.1404C18.75 18.142 18.75 18.1435 18.75 18.1451C18.75 18.1466 18.75 18.1482 18.75 18.1497C18.75 18.1513 18.75 18.1529 18.75 18.1544C18.75 18.156 18.75 18.1576 18.75 18.1591C18.75 18.1607 18.75 18.1623 18.75 18.1638C18.75 18.1654 18.75 18.167 18.75 18.1686C18.75 18.1701 18.75 18.1717 18.75 18.1733C18.75 18.1749 18.75 18.1765 18.75 18.178C18.75 18.1796 18.75 18.1812 18.75 18.1828C18.75 18.1844 18.75 18.186 18.75 18.1876C18.75 18.1892 18.75 18.1908 18.75 18.1923C18.75 18.1939 18.75 18.1955 18.75 18.1971C18.75 18.1987 18.75 18.2003 18.75 18.2019C18.75 18.2036 18.75 18.2052 18.75 18.2068C18.75 18.2084 18.75 18.21 18.75 18.2116C18.75 18.2132 18.75 18.2148 18.75 18.2164C18.75 18.218 18.75 18.2197 18.75 18.2213C18.75 18.2229 18.75 18.2245 18.75 18.2261C18.75 18.2278 18.75 18.2294 18.75 18.231C18.75 18.2326 18.75 18.2343 18.75 18.2359C18.75 18.2375 18.75 18.2392 18.75 18.2408C18.75 18.2424 18.75 18.2441 18.75 18.2457C18.75 18.2473 18.75 18.249 18.75 18.2506C18.75 18.2523 18.75 18.2539 18.75 18.2556C18.75 18.2572 18.75 18.2588 18.75 18.2605C18.75 18.2621 18.75 18.2638 18.75 18.2654C18.75 18.2671 18.75 18.2688 18.75 18.2704C18.75 18.2721 18.75 18.2737 18.75 18.2754C18.75 18.277 18.75 18.2787 18.75 18.2804C18.75 18.282 18.75 18.2837 18.75 18.2854C18.75 18.287 18.75 18.2887 18.75 18.2904C18.75 18.2921 18.75 18.2937 18.75 18.2954C18.75 18.2971 18.75 18.2988 18.75 18.3004C18.75 18.3021 18.75 18.3038 18.75 18.3055C18.75 18.3072 18.75 18.3088 18.75 18.3105C18.75 18.3122 18.75 18.3139 18.75 18.3156C18.75 18.3173 18.75 18.319 18.75 18.3207C18.75 18.3224 18.75 18.3241 18.75 18.3258C18.75 18.3275 18.75 18.3292 18.75 18.3309C18.75 18.3326 18.75 18.3343 18.75 18.336C18.75 18.3377 18.75 18.3394 18.75 18.3411C18.75 18.3428 18.75 18.3445 18.75 18.3462C18.75 18.3479 18.75 18.3497 18.75 18.3514C18.75 18.3531 18.75 18.3548 18.75 18.3565C18.75 18.3582 18.75 18.36 18.75 18.3617C18.75 18.3634 18.75 18.3651 18.75 18.3669C18.75 18.3686 18.75 18.3703 18.75 18.3721C18.75 18.3738 18.75 18.3755 18.75 18.3773C18.75 18.379 18.75 18.3807 18.75 18.3825C18.75 18.3842 18.75 18.3859 18.75 18.3877C18.75 18.3894 18.75 18.3912 18.75 18.3929C18.75 18.3947 18.75 18.3964 18.75 18.3982C18.75 18.3999 18.75 18.4017 18.75 18.4034C18.75 18.4052 18.75 18.4069 18.75 18.4087C18.75 18.4104 18.75 18.4122 18.75 18.4139C18.75 18.4157 18.75 18.4175 18.75 18.4192C18.75 18.421 18.75 18.4228 18.75 18.4245C18.75 18.4263 18.75 18.4281 18.75 18.4298C18.75 18.4316 18.75 18.4334 18.75 18.4352C18.75 18.4369 18.75 18.4387 18.75 18.4405C18.75 18.4423 18.75 18.444 18.75 18.4458C18.75 18.4476 18.75 18.4494 18.75 18.4512C18.75 18.453 18.75 18.4547 18.75 18.4565C18.75 18.4583 18.75 18.4601 18.75 18.4619C18.75 18.4637 18.75 18.4655 18.75 18.4673C18.75 18.4691 18.75 18.4709 18.75 18.4727C18.75 18.4745 18.75 18.4763 18.75 18.4781C18.75 18.4799 18.75 18.4817 18.75 18.4835C18.75 18.4853 18.75 18.4871 18.75 18.4889C18.75 18.4907 18.75 18.4926 18.75 18.4944C18.75 18.4962 18.75 18.498 18.75 18.4998C18.75 18.5016 18.75 18.5034 18.75 18.5053C18.75 18.5071 18.75 18.5089 18.75 18.5107C18.75 18.5126 18.75 18.5144 18.75 18.5162C18.75 18.518 18.75 18.5199 18.75 18.5217C18.75 18.5235 18.75 18.5254 18.75 18.5272C18.75 18.529 18.75 18.5309 18.75 18.5327C18.75 18.5345 18.75 18.5364 18.75 18.5382C18.75 18.5401 18.75 18.5419 18.75 18.5438C18.75 18.5456 18.75 18.5475 18.75 18.5493C18.75 18.5512 18.75 18.553 18.75 18.5549C18.75 18.5567 18.75 18.5586 18.75 18.5604C18.75 18.5623 18.75 18.5641 18.75 18.566C18.75 18.5678 18.75 18.5697 18.75 18.5716C18.75 18.5734 18.75 18.5753 18.75 18.5772C18.75 18.579 18.75 18.5809 18.75 18.5828C18.75 18.5846 18.75 18.5865 18.75 18.5884C18.75 18.5903 18.75 18.5921 18.75 18.594C18.75 18.5959 18.75 18.5978 18.75 18.5996C18.75 18.6015 18.75 18.6034 18.75 18.6053C18.75 18.6072 18.75 18.6091 18.75 18.6109C18.75 18.6128 18.75 18.6147 18.75 18.6166C18.75 18.6185 18.75 18.6204 18.75 18.6223C18.75 18.6242 18.75 18.6261 18.75 18.628C18.75 18.6299 18.75 18.6318 18.75 18.6337C18.75 18.6356 18.75 18.6375 18.75 18.6394C18.75 18.6413 18.75 18.6432 18.75 18.6451C18.75 18.647 18.75 18.6489 18.75 18.6508C18.75 18.6527 18.75 18.6546 18.75 18.6565C18.75 18.6585 18.75 18.6604 18.75 18.6623C18.75 18.6642 18.75 18.6661 18.75 18.668C18.75 18.67 18.75 18.6719 18.75 18.6738C18.75 18.6757 18.75 18.6777 18.75 18.6796C18.75 18.6815 18.75 18.6834 18.75 18.6854C18.75 18.6873 18.75 18.6892 18.75 18.6912C18.75 18.6931 18.75 18.695 18.75 18.697C18.75 18.6989 18.75 18.7009 18.75 18.7028C18.75 18.7047 18.75 18.7067 18.75 18.7086C18.75 18.7106 18.75 18.7125 18.75 18.7145C18.75 18.7164 18.75 18.7184 18.75 18.7203C18.75 18.7223 18.75 18.7242 18.75 18.7262C18.75 18.7281 18.75 18.7301 18.75 18.732C18.75 18.734 18.75 18.7359 18.75 18.7379C18.75 18.7399 18.75 18.7418 18.75 18.7438C18.75 18.7458 18.75 18.7477 18.75 18.7497C18.75 18.7517 18.75 18.7536 18.75 18.7556C18.75 18.7576 18.75 18.7595 18.75 18.7615C18.75 18.7635 18.75 18.7655 18.75 18.7674C18.75 18.7694 18.75 18.7714 18.75 18.7734C18.75 18.7754 18.75 18.7773 18.75 18.7793C18.75 18.7813 18.75 18.7833 18.75 18.7853C18.75 18.7873 18.75 18.7892 18.75 18.7912C18.75 18.7932 18.75 18.7952 18.75 18.7972C18.75 18.7992 18.75 18.8012 18.75 18.8032C18.75 18.8052 18.75 18.8072 18.75 18.8092C18.75 18.8112 18.75 18.8132 18.75 18.8152C18.75 18.8172 18.75 18.8192 18.75 18.8212C18.75 18.8232 18.75 18.8252 18.75 18.8272C18.75 18.8292 18.75 18.8312 18.75 18.8333C18.75 18.8353 18.75 18.8373 18.75 18.8393C18.75 18.8413 18.75 18.8433 18.75 18.8454C18.75 18.8474 18.75 18.8494 18.75 18.8514C18.75 18.8534 18.75 18.8555 18.75 18.8575C18.75 18.8595 18.75 18.8615 18.75 18.8636C18.75 18.8656 18.75 18.8676 18.75 18.8697C18.75 18.8717 18.75 18.8737 18.75 18.8758C18.75 18.8778 18.75 18.8798 18.75 18.8819C18.75 18.8839 18.75 18.8859 18.75 18.888C18.75 18.89 18.75 18.8921 18.75 18.8941C18.75 18.8962 18.75 18.8982 18.75 18.9002C18.75 18.9023 18.75 18.9043 18.75 18.9064C18.75 18.9084 18.75 18.9105 18.75 18.9125C18.75 18.9146 18.75 18.9167 18.75 18.9187C18.75 18.9208 18.75 18.9228 18.75 18.9249C18.75 18.9269 18.75 18.929 18.75 18.9311C18.75 18.9331 18.75 18.9352 18.75 18.9373C18.75 18.9393 18.75 18.9414 18.75 18.9435C18.75 18.9455 18.75 18.9476 18.75 18.9497C18.75 18.9517 18.75 18.9538 18.75 18.9559C18.75 18.958 18.75 18.9601 18.75 18.9621C18.75 18.9642 18.75 18.9663 18.75 18.9684C18.75 18.9704 18.75 18.9725 18.75 18.9746C18.75 18.9767 18.75 18.9788 18.75 18.9809C18.75 18.983 18.75 18.9851 18.75 18.9871C18.75 18.9892 18.75 18.9913 18.75 18.9934C18.75 18.9955 18.75 18.9976 18.75 18.9997C18.75 19.0018 18.75 19.0039 18.75 19.006C18.75 19.0081 18.75 19.0102 18.75 19.0123C18.75 19.0144 18.75 19.0165 18.75 19.0186C18.75 19.0207 18.75 19.0228 18.75 19.0249C18.75 19.027 18.75 19.0292 18.75 19.0313C18.75 19.0334 18.75 19.0355 18.75 19.0376C18.75 19.0397 18.75 19.0418 18.75 19.044C18.75 19.0461 18.75 19.0482 18.75 19.0503C18.75 19.0524 18.75 19.0546 18.75 19.0567C18.75 19.0588 18.75 19.0609 18.75 19.0631C18.75 19.0652 18.75 19.0673 18.75 19.0694C18.75 19.0716 18.75 19.0737 18.75 19.0758C18.75 19.078 18.75 19.0801 18.75 19.0822C18.75 19.0844 18.75 19.0865 18.75 19.0887C18.75 19.0908 18.75 19.0929 18.75 19.0951C18.75 19.0972 18.75 19.0994 18.75 19.1015C18.75 19.1037 18.75 19.1058 18.75 19.1079C18.75 19.1101 18.75 19.1122 18.75 19.1144C18.75 19.1165 18.75 19.1187 18.75 19.1209C18.75 19.123 18.75 19.1252 18.75 19.1273C18.75 19.1295 18.75 19.1316 18.75 19.1338C18.75 19.136 18.75 19.1381 18.75 19.1403C18.75 19.1424 18.75 19.1446 18.75 19.1468C18.75 19.1489 18.75 19.1511 18.75 19.1533C18.75 19.1554 18.75 19.1576 18.75 19.1598C18.75 19.162 18.75 19.1641 18.75 19.1663C18.75 19.1685 18.75 19.1706 18.75 19.1728C18.75 19.175 18.75 19.1772 18.75 19.1794C18.75 19.1815 18.75 19.1837 18.75 19.1859C18.75 19.1881 18.75 19.1903 18.75 19.1925C18.75 19.1946 18.75 19.1968 18.75 19.199C18.75 19.2012 18.75 19.2034 18.75 19.2056C18.75 19.2078 18.75 19.21 18.75 19.2122C18.75 19.2144 18.75 19.2166 18.75 19.2188H20.25ZM19.5 16.5937H18.375V18.0937H19.5V16.5937ZM15.75 18.0322C15.75 19.2508 16.596 20.5016 18.0001 20.5794L18.0831 19.0817C17.6546 19.058 17.25 18.6491 17.25 18.0322H15.75ZM18.5791 14.2726C17.7429 14.1798 17.0198 14.5569 16.5327 15.0901C16.0498 15.6188 15.75 16.3467 15.75 17.0938H17.25C17.25 16.7362 17.3994 16.3654 17.6402 16.1018C17.8768 15.8428 18.1519 15.7344 18.4135 15.7634L18.5791 14.2726Z"
              fill="#004186"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="16.5"
                height="6.75"
                fill="white"
                transform="translate(3.75 14.25)"
              />
            </clipPath>
          </defs>
        </>
      );
    case 'iconBmp':
      return (
        <>
          <path
            {...props}
            d="M4.5 11.8906V5.35942C4.5 4.88526 4.87645 4.5 5.33977 4.5H14.6351C14.9681 4.5 15.3012 4.63336 15.5473 4.88526L19.1236 8.54521C19.3697 8.79711 19.5 9.1231 19.5 9.47872V11.8906"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.25 4.5V9.26641C14.25 9.94402 14.7133 10.5 15.278 10.5H17.25"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.375 15L4.5 15L4.5 17.25L6.375 17.25C6.99632 17.25 7.5 16.7463 7.5 16.125C7.5 15.5037 6.99632 15 6.375 15Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.375 17.25L4.5 17.25L4.5 19.5L6.375 19.5C6.99632 19.5 7.5 18.9963 7.5 18.375C7.5 17.7537 6.99632 17.25 6.375 17.25Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.7612 15V19.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M10.7611 14.9996L12.2611 18.2007"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M14.0222 15V19.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M14.0221 14.9996L12.5221 18.2007"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M17.25 19.5L17.25 18M17.25 18L17.25 15L18.75 15C19.5784 15 20.25 15.6716 20.25 16.5V16.5C20.25 17.3284 19.5784 18 18.75 18L17.25 18Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'iconPdf':
      return (
        <>
          <path
            {...props}
            d="M4.5 11.8906V5.35942C4.5 4.88526 4.87645 4.5 5.33977 4.5H14.6351C14.9681 4.5 15.3012 4.63336 15.5473 4.88526L19.1236 8.54521C19.3697 8.79711 19.5 9.1231 19.5 9.47872V11.8906"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.25 4.5V9.26641C14.25 9.94402 14.7133 10.5 15.278 10.5H17.25"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4.5 19.5L4.5 18M4.5 18L4.5 15L6 15C6.82843 15 7.5 15.6716 7.5 16.5V16.5C7.5 17.3284 6.82843 18 6 18L4.5 18Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.5 19.5L16.5 18M19.5 15L16.5 15L16.5 18M19.5 18L16.5 18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.25 15L10.5 15L10.5 19.5L11.25 19.5C12.4926 19.5 13.5 18.4926 13.5 17.25C13.5 16.0074 12.4926 15 11.25 15Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'filter':
      return (
        <>
          <path
            {...props}
            d="M11 12L11 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.9498 1.15967V3.93704"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.9785 7.97416C12.0854 7.97416 12.9828 7.07681 12.9828 5.96987C12.9828 4.86293 12.0854 3.96558 10.9785 3.96558C9.87153 3.96558 8.97418 4.86293 8.97418 5.96987C8.97418 7.07681 9.87153 7.97416 10.9785 7.97416Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3 12V21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3 1L3 4"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.96138 11.9827C4.06832 11.9827 4.96567 11.0854 4.96567 9.97841C4.96567 8.87147 4.06832 7.97412 2.96138 7.97412C1.85444 7.97412 0.957092 8.87147 0.957092 9.97841C0.957092 11.0854 1.85444 11.9827 2.96138 11.9827Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 18V21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 1V9"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19.0043 17.3228C20.1112 17.3228 21.0086 16.4254 21.0086 15.3185C21.0086 14.2116 20.1112 13.3142 19.0043 13.3142C17.8974 13.3142 17 14.2116 17 15.3185C17 16.4254 17.8974 17.3228 19.0043 17.3228Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'fullscreen':
      return (
        <>
          <path
            {...props}
            d="M7 1H1V7"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 21L21 21L21 15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 7L21 1L15 1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 15L1 21L7 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'galery':
      return (
        <>
          <rect
            x="1"
            y="1"
            width="8"
            height="8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="1"
            y="13"
            width="8"
            height="8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="13"
            y="1"
            width="8"
            height="8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="13"
            y="13"
            width="8"
            height="8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'geoTag':
      return (
        <>
          <path
            {...props}
            d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 11L21 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 11L3 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 3L11 1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 21L11 19"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'headset':
      return (
        <>
          <path
            {...props}
            d="M3 13C3 13 1 12.2286 1 11.2857V8.71429C1 7 3 7 3 7V13Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 13C19 13 21 12.2286 21 11.2857V8.71429C21 7 19 7 19 7V13Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 14C19 18 16.0171 19.96 13 20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.2 21H9.8C9.36 21 9 20.55 9 20C9 19.45 9.36 19 9.8 19H12.2C12.64 19 13 19.45 13 20C13 20.55 12.64 21 12.2 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 9V8.55556C19 4.38667 15.4141 1 11 1C6.58588 1 3 4.38667 3 8.55556V9"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'height':
      return (
        <>
          <path
            {...props}
            d="M4 19.4999V1.12671"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 4L3.99471 1L1 4"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 18L3.99471 21L1 18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 1L21 1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 6L21 6"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 11L21 11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 16L21 16"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 21L21 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'heightPerson':
      return (
        <>
          <path
            {...props}
            d="M11.1698 10.5V12.1082L15 13.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 21V17.0269C1 15.7647 1.76274 14.6326 2.91956 14.1859L7.7799 12.1386V10.1911L7.59769 10.0609C6.6824 9.43634 6.08492 8.37367 6.08492 7.16786V4.46996C6.08492 2.55281 7.60193 1 9.47487 1C11.3478 1 12.8648 2.55281 12.8648 4.46996V7.16786C12.8648 8.69568 11.9014 9.99212 10.5622 10.4557"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19 1H22V21H19"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.5 6H21.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.5 11H21.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.5 16H21.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'helpCircle':
      return (
        <>
          <path
            {...props}
            d="M1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 8.94314C8 7.31769 9.34315 6 11 6C12.6569 6 14 7.31769 14 8.94314C14 10.5686 12.6569 11.8863 11 11.8863V13.6522M11 17V16.5217"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'helpSquare':
      return (
        <>
          <path
            {...props}
            d="M8 8.94314C8 7.31769 9.34315 6 11 6C12.6569 6 14 7.31769 14 8.94314C14 10.5686 12.6569 11.8863 11 11.8863V13.6522M11 17V16.5217"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="1"
            y="1"
            width="20"
            height="20"
            rx="2"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'home':
      return (
        <>
          <path
            {...props}
            d="M1 10L11.1852 1L15.2593 5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 10.4781L18.3148 7.84178"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3.03705 8.5V21H8.12964C8.12964 21 8.12964 16.6257 8.12964 15.5629C8.12964 14.5 9.14816 13 11.1852 13C13.2222 13 14.2408 14.5 14.2408 15.5629C14.2408 16.6257 14.2408 21 14.2408 21H19.3333V9"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.2593 5V2H18.3148V7.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'menuCard':
      return (
        <>
          <rect
            x="26"
            y="14"
            width="4"
            height="4"
            rx="2"
            transform="rotate(90 26 14)"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="18"
            y="14"
            width="4"
            height="4"
            rx="2"
            transform="rotate(90 18 14)"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="10"
            y="14"
            width="4"
            height="4"
            rx="2"
            transform="rotate(90 10 14)"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'info':
      return (
        <>
          <path
            {...props}
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 6L11 7"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 11L11 17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'infoOutline':
      return (
        <>
          <path
            {...props}
            d="M12.1573 21.7173H11.619L11.0807 22.2553H10.0042H8.92763L8.38935 21.7173H7.85107"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.77454 18.4893H13.2339"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.31281 20.1033H12.6956"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.6956 17.4133V16.3372C12.6956 15.3634 13.0347 14.4703 13.7076 13.7817C14.7249 12.7433 15.387 11.4628 15.387 9.88109C15.387 6.91127 12.9755 4.50098 10.0042 4.50098C7.03291 4.50098 4.62143 6.91127 4.62143 9.88109C4.62143 11.4628 5.28351 12.7433 6.30086 13.7817C6.9737 14.4703 7.31282 15.3634 7.31282 16.3372V17.4133"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.0042 17.4132V13.1091"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8.92764 12.0332L10.0042 13.1092L11.0808 12.0332"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6 1.5L6.31578 1.98661"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1.5 6L2.10526 6.19716"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.5 6L17.8947 6.19716"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 1.5L13.6842 1.98661"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'key':
      return (
        <>
          <path
            {...props}
            d="M14.8291 1.00291C14.3428 1.01471 13.8802 1.08554 13.4296 1.21539C10.5475 1.78201 8.38894 4.2846 8.38894 7.30659C8.38894 8.06209 8.5194 8.78218 8.76847 9.44324C6.90641 11.2848 1.13046 16.9392 1.13046 16.9392C1.04744 17.0218 1 17.1281 1 17.2461V20.5632C1 20.7993 1.20162 21 1.43883 21H4.91388C5.16295 21 5.35271 20.7993 5.35271 20.5632V18.7099H7.16733C7.44012 18.7099 7.6536 18.4856 7.6536 18.2259V16.4198H8.93451C9.21916 16.4198 9.4445 16.1955 9.4445 15.9122V14.6019L10.3696 13.6575L10.6898 13.9998C10.8559 14.1651 11.1287 14.1769 11.2947 14.0116C11.2947 14.0116 11.8166 13.4804 12.2791 13.0437C13.0026 13.3388 13.8091 13.504 14.6393 13.504C17.6874 13.504 20.2136 11.3556 20.7829 8.49886C20.9015 8.06209 20.9727 7.61352 20.9964 7.15313C21.115 3.71798 18.2923 0.896664 14.8291 1.00291Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16 4C17.1096 4 18 4.89041 18 6C18 7.10959 17.0959 8 16 8C14.8904 8 14 7.10959 14 6C14 4.89041 14.8904 4 16 4Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'language':
      return (
        <>
          <path
            {...props}
            d="M11.0054 21.072V1.09717"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 11.0486H1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 1C10 1 1 9.63498 10 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 1C12 1 21 9.63498 12 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.5184 17.3858C15.5693 15.6127 10.1099 13.6455 3.48158 17.393"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M18.6011 4.67574C15.652 6.47038 10.1063 8.52397 3.36287 4.64697"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.0018 1.04297C9.95592 1.04297 8.94756 1.20347 8 1.50118C6.47752 1.97952 5.11199 2.8121 4 3.90232C2.14859 5.7175 1 8.2469 1 11.0448C1 16.569 5.47761 21.043 11.0018 21.043C16.526 21.043 21 16.5654 21 11.0448C21 5.52058 16.5224 1.04297 11.0018 1.04297Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'languageOutline':
      return (
        <>
          <path
            {...props}
            d="M7.27839 1.78L7.39539 5.8112L4.56965 7.73285L4.79656 9.54104L8 9L11 11.5L7.73817 17.4564L6 13.5L4 12.5L4.79656 9.71122L1.92473 6.81457C3.50601 3.37901 6.97702 1 11.0047 1C11.4216 1 11.833 1.02509 12.2366 1.07466"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.6661 8.54841L17.9325 13.5617L16.8512 15.0544L16.0144 10.9097L14.9756 10.853C14.9756 10.853 12.2066 9.83542 14.5785 7.85705L17.461 7.51668L18.592 5.2724L14.5714 5.47449L13.9084 4.82567L15.1423 1.88647C18.6026 3.46066 21.01 6.94586 21.01 10.9983C21.01 16.5222 16.5321 21.0001 11.0011 21.0001C5.4773 21.0001 0.999374 16.5222 0.999374 10.9983C0.999374 10.6197 1.02034 10.2457 1.06129 9.87758"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'link':
      return (
        <>
          <path
            {...props}
            d="M10 12.8829L9.08302 11.9659C7.77354 10.6555 7.77354 8.49409 9.08302 7.18372L14.2805 1.98278C15.5899 0.672408 17.7499 0.672408 19.0594 1.98278L20.0179 2.94191C21.3274 4.25228 21.3274 6.41371 20.0179 7.72408L16.2379 11.5066"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 9.14403L12.9035 10.0475C14.213 11.3579 14.213 13.5193 12.9035 14.8297L7.71954 20.0171C6.41006 21.3275 4.25008 21.3275 2.9406 20.0171L1.98211 19.058C0.672629 17.7476 0.672629 15.5862 1.98211 14.2758L5.73507 10.5203"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'list':
      return (
        <>
          <path
            {...props}
            d="M3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3C1 4.10457 1.89543 5 3 5Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3 13C4.10457 13 5 12.1046 5 11C5 9.89543 4.10457 9 3 9C1.89543 9 1 9.89543 1 11C1 12.1046 1.89543 13 3 13Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M3 21C4.10457 21 5 20.1046 5 19C5 17.8954 4.10457 17 3 17C1.89543 17 1 17.8954 1 19C1 20.1046 1.89543 21 3 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.01843 3H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.01843 11H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.01843 19H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'listHorizontal':
      return (
        <>
          <rect
            x="21"
            y="1"
            width="20"
            height="8"
            transform="rotate(90 21 1)"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="9"
            y="1"
            width="20"
            height="8"
            transform="rotate(90 9 1)"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'listOutline':
      return (
        <>
          <rect
            x="1"
            y="1"
            width="20"
            height="8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="1"
            y="13"
            width="20"
            height="8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'location':
      return (
        <>
          <path
            {...props}
            d="M8 1C4.1362 1 1 3.95935 1 7.60163C1 13.5745 5.5 16 8 21C11 16 15 13.5745 15 7.60163C15 3.95935 11.8638 1 8 1Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5 8C5 9.65385 6.34483 11 8 11C9.65517 11 10.9871 9.65385 11 8C11 6.34615 9.65517 5 8 5C6.34483 5 5 6.34615 5 8Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'lock':
      return (
        <>
          <path
            {...props}
            d="M7 21.0001C10.3137 21.0001 13 18.2749 13 14.9131C13 11.5514 10.3137 8.82617 7 8.82617C3.68629 8.82617 1 11.5514 1 14.9131C1 18.2749 3.68629 21.0001 7 21.0001Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.71429 10.6609V5.34783C2.71429 2.94783 4.63429 1 7.00001 1C8.18287 1 9.25429 1.48696 10.0343 2.26957C10.8057 3.06087 11.2857 4.14783 11.2857 5.34783V10.6609"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 15.7827V17.5218"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.99999 15.348C7.71007 15.348 8.28571 14.764 8.28571 14.0436C8.28571 13.3232 7.71007 12.7393 6.99999 12.7393C6.28991 12.7393 5.71428 13.3232 5.71428 14.0436C5.71428 14.764 6.28991 15.348 6.99999 15.348Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'login':
      return (
        <>
          <path
            {...props}
            d="M8.5297 20.9884L1.3091 18.8852C1.136 18.8493 1 18.7059 1 18.5386V3.54156C1 3.37427 1.12364 3.23087 1.29674 3.19502L8.51734 1.00819C8.76462 0.960394 8.99953 1.12769 8.99953 1.35474V20.6538C9.0119 20.8689 8.77698 21.0481 8.5297 20.9884Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 3H15V5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 19H15V17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12.5 10.8306L21 10.8306"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 10.81L14.81 8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 10.7588L14.81 13.5687"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'mail':
      return (
        <>
          <path
            {...props}
            d="M19.2294 17H2.77065C1.7962 17 1 16.1854 1 15.1884V2.81155C1 1.81459 1.7962 1 2.77065 1H19.2175C20.1919 1 20.9881 1.81459 20.9881 2.81155V15.1763C21 16.1854 20.2038 17 19.2294 17Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1.5 2.17944L9.35412 10.0336C9.87699 10.4713 10.388 10.7023 11.0059 10.7023H11.0178C11.6239 10.7023 12.123 10.4713 12.634 10.0457L20.5003 2.17944"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1.67653 16.3486L8.5 9.52515"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.4986 16.3489L13.4658 9.31616"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'mailInput':
      return (
        <>
          <path
            {...props}
            d="M1 17V1H20.9999V16.9843L1 17Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="13"
            y="4"
            width="5"
            height="5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4 11H10"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4 14H10"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'menu':
      return (
        <>
          <path
            {...props}
            d="M1 10H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 19H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 1H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'menuOutline':
      return (
        <>
          <rect
            x="1"
            y="1"
            width="4"
            height="4"
            rx="2"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="1"
            y="9"
            width="4"
            height="4"
            rx="2"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="1"
            y="17"
            width="4"
            height="4"
            rx="2"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'minus':
      return (
        <>
          <path
            {...props}
            d="M1 10H21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'minusCircle':
      return (
        <>
          <path
            {...props}
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6 10.988H16"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'minusSquare':
      return (
        <>
          <rect
            x="1"
            y="1"
            width="20"
            height="20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 11H15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'news':
      return (
        <>
          <path
            {...props}
            d="M17 13H15V17H17V13Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 13H11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 17H11"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 9H17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 5H17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.84215 20.7999H19.2089C20.2008 20.7999 20.9802 20.0206 20.9802 19.0287V1H4.33003V9.46366V10.7744V19.0287C4.33003 20.0206 3.58609 20.7999 2.66502 20.7999C1.74394 20.7999 1 20.0206 1 19.0287V11.3027"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'npsDeslike':
      return (
        <>
          <path
            {...props}
            d="M4.5 20.4403L4.12375 20.1651C2.23375 18.844 1 16.5963 1 14.0459V8.33944C1 4.2844 4.1325 1 8 1C11.8675 1 15 4.2844 15 8.33944V14.0459C15 17.2774 13.0106 20.0196 10.2452 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5.5 16.9966C6.76273 15.671 9.23727 15.6644 10.5 16.9966"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'npsHate':
      return (
        <>
          <path
            {...props}
            d="M4.5 20.4403L4.12375 20.1651C2.23375 18.844 1 16.5963 1 14.0459V8.33944C1 4.2844 4.1325 1 8 1C11.8675 1 15 4.2844 15 8.33944V14.0459C15 17.2774 13.0106 20.0196 10.2452 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5 17C5 13 11 12.995 11 17Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'npsLike':
      return (
        <>
          <path
            {...props}
            d="M4.5 20.4403L4.12375 20.1651C2.23375 18.844 1 16.5963 1 14.0459V8.33944C1 4.2844 4.1325 1 8 1C11.8675 1 15 4.2844 15 8.33944V14.0459C15 17.2774 13.0106 20.0196 10.2452 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.5 16C9.23727 17.3256 6.76273 17.3322 5.5 16"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'npsLove':
      return (
        <>
          <path
            {...props}
            d="M4.5 20.4403L4.12375 20.1651C2.23375 18.844 1 16.5963 1 14.0459V8.33944C1 4.2844 4.1325 1 8 1C11.8675 1 15 4.2844 15 8.33944V14.0459C15 17.2774 13.0106 20.0196 10.2452 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M12 14C12 18.5 4 18.5 4 14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'npsNeutral':
      return (
        <>
          <path
            {...props}
            d="M4.5 20.4403L4.12375 20.1651C2.23375 18.844 1 16.5963 1 14.0459V8.33944C1 4.2844 4.1325 1 8 1C11.8675 1 15 4.2844 15 8.33944V14.0459C15 17.2774 13.0106 20.0196 10.2452 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.5 16H5.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'order':
      return (
        <>
          <path
            {...props}
            d="M3.99998 18L3.99998 1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 4L14 20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 4L3.99471 1L1 4"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 18L14.0053 21L17 18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'pcd':
      return (
        <>
          <path
            {...props}
            d="M2.87587 13.7751C1.80517 14.8994 1.18839 16.4082 1.18839 17.9813C1.18839 21.3391 3.92005 24.071 7.27801 24.071C8.88664 24.071 10.3984 23.4398 11.518 22.3539"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.85436 0.805908C6.61618 0.805908 5.6123 1.80978 5.6123 3.04796C5.6123 3.33315 5.66559 4.62292 5.7627 4.87384C6.0872 5.71235 6.90139 6.30704 7.85439 6.30704C8.80739 6.30704 9.62158 5.71235 9.94608 4.87384C10.0432 4.62292 10.0964 3.33315 10.0964 3.04796C10.0964 1.80978 9.09254 0.805908 7.85436 0.805908Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8.37074 9.13079C8.37074 9.13079 9.83264 9.13096 9.93946 10.7379V13.9959V14.4352H10.3788H14.409C14.7927 14.4352 15.1322 14.6798 15.2537 15.0437L16.9514 20.4625C17.1159 20.955 16.8489 21.4898 16.3564 21.654C16.2592 21.6865 14.8593 21.8977 14.7583 21.8977C14.3526 21.8977 13.9936 21.639 13.8652 21.2538L12.6825 17.7116L12.5821 17.4114H12.2656H5.93066C5.43641 17.4114 5.03442 17.0094 5.03442 16.5151V15.0793V10.9949C5.03442 10.0116 5.80374 9.17538 6.74953 9.13096C6.77906 9.12974 8.37074 9.13079 8.37074 9.13079Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'pdf':
      return (
        <>
          <path
            {...props}
            d="M1 10.8541V2.1459C1 1.51368 1.50193 1 2.11969 1H14.5135C14.9575 1 15.4015 1.17781 15.7297 1.51368L20.4981 6.39362C20.8263 6.72948 21 7.16413 21 7.6383V10.8541"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 1V7.35521C14 8.25869 14.6178 9 15.3707 9H18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 21L1 19M1 19L0.999999 15L3 15C4.10457 15 5 15.8954 5 17V17C5 18.1046 4.10457 19 3 19L1 19Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 21L17 19M21 15L17 15L17 19M21 19L17 19"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10 15L9 15L9 21L10 21C11.6569 21 13 19.6569 13 18C13 16.3431 11.6569 15 10 15Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'plus':
      return (
        <>
          <path
            {...props}
            d="M1 11H21M11 1V21V1Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'plusCircle':
      return (
        <>
          <path
            {...props}
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6 11H16"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 16V6"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'plusSquare':
      return (
        <>
          <rect
            x="1"
            y="1"
            width="20"
            height="20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 11H15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 7L11 15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'print':
      return (
        <>
          <path
            {...props}
            d="M4.82828 16H2.33096C1.59418 16 1 15.4073 1 14.6724V6.32759C1 5.59267 1.59418 5 2.33096 5H19.669C20.4058 5 21 5.59267 21 6.32759V14.6724C21 15.4073 20.4058 16 19.669 16H17.1836"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M5 4V1H17V4"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 14H5V21H17V14Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 18H14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M17 8H18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'profile':
      return (
        <>
          <path
            {...props}
            d="M12 12V13.2253L16.3125 14.805C17.3288 15.1487 18 16.0079 18 16.9663V18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4 18V17.0202C4 16.0735 4.64286 15.2245 5.61786 14.8894L9.71429 13.3539V11.8933L9.56071 11.7957C8.78929 11.3273 8.28571 10.5303 8.28571 9.62589V7.60247C8.28571 6.16461 9.56429 5 11.1429 5C12.7214 5 14 6.16461 14 7.60247V9.62589C14 10.7718 13.188 11.7441 12.0592 12.0917"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'profileOutline':
      return (
        <>
          <path
            {...props}
            d="M11.4355 10.5V12.1082L16.8725 14.1815C18.1537 14.6326 19 15.7604 19 17.0182V21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 21V17.0269C1 15.7647 1.81049 14.6326 3.03973 14.1859L8.20434 12.1386V10.1911L8.01073 10.0609C7.03814 9.43634 6.40326 8.37367 6.40326 7.16786V4.46996C6.40326 2.55281 8.01523 1 10.0054 1C11.9956 1 13.6076 2.55281 13.6076 4.46996V7.16786C13.6076 8.69568 12.5839 9.99212 11.1608 10.4557"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'pt':
      return (
        <>
          <rect
            x="1"
            y="1"
            width="20"
            height="20"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6 14L6 12M6 12L6 8L8 8C9.10457 8 10 8.89543 10 10V10C10 11.1046 9.10457 12 8 12L6 12Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 14L14 8L12 8L16 8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'pullDownG':
      return (
        <>
          <path
            {...props}
            d="M21 1L11 11L1 1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'pullDownP':
      return (
        <>
          <path
            {...props}
            d="M11 1L6 6L1 1"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'reload':
      return (
        <>
          <path
            {...props}
            d="M19 13.8421C18.0113 17.9624 14.42 21 10.1309 21C5.08562 21 1 16.7744 1 11.5564C1 6.33835 5.08562 2.11278 10.1309 2.11278C13.1987 2.11278 15.9176 3.67669 17.5751 6.08271C17.7641 6.35338 18.4475 7.16541 18.4475 7.16541M18.4475 7.16541V1M18.4475 7.16541H12.4863"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'search':
      return (
        <>
          <path
            {...props}
            d="M15.5 13.9985L20.7229 18.8878C21.0924 19.2572 21.0924 19.865 20.7229 20.2344L20.2343 20.723C19.8649 21.0924 19.2571 21.0924 18.8877 20.723L13.629 15.798"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'setting':
      return (
        <>
          <path
            {...props}
            d="M14.5354 4.25609L17.1022 2.96078L19.0392 4.8978L17.7439 7.46465L18.2668 8.7243L21 9.63933V12.3607L18.2668 13.2757L17.7439 14.5354L19.0392 17.1022L17.1022 19.0392L14.5354 17.7439L13.2757 18.2668L12.3607 21H9.63933L8.7243 18.2668L7.46465 17.7439L4.8978 19.0392L2.96078 17.1022L4.25609 14.5354L3.73321 13.2757L1 12.3607V9.63933L3.73321 8.7243L4.25609 7.46465L2.96078 4.8978L4.8978 2.96078L7.46465 4.25609L8.7243 3.73321L9.63933 1H12.3607L13.2757 3.73321L14.5354 4.25609Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'sharing':
      return (
        <>
          <path
            {...props}
            d="M20.0343 6.11652C16.9623 6.04633 12.5 6.189 10 6.189C3 6.18908 3.37273 15.2419 10.5408 15.4045"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9.5 2.1001H1V19.1001H18V13.1001"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15 1.1001L20 6.1001L15 10.1001"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'stakeholder':
      return (
        <>
          <path
            {...props}
            d="M12.7265 5.72159V1H8.00492V5.72159H3.28333V10.4432H8.00492V15.1648H12.7265V10.4432H17.4481V5.72159H12.7265Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.8373 18.7453L17.2986 16.3451C17.9753 15.9595 18.841 16.1877 19.2266 16.8645C19.6122 17.5412 19.384 18.4069 18.7072 18.8003L16.8028 19.6974L11.3258 22.2786C11.0425 22.4438 10.7198 22.5225 10.3893 22.5225H5.76216C5.42378 22.5225 5.0854 22.617 4.79424 22.7901L4.31421 23.1599"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.20229 19.3121H10.5625C11.3573 19.3121 12.0026 18.6668 12.0026 17.872C12.0026 17.0772 11.3573 16.4319 10.5625 16.4319H6.06124C5.56548 16.4319 5.08545 16.5421 4.6369 16.7624L1.43408 18.352"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'subItem':
      return (
        <>
          <path
            {...props}
            d="M15 20L21 13.9902L15 8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.4118 14.053H3C1.89543 14.053 1 13.1575 1 12.053V1.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'team':
      return (
        <>
          <path
            {...props}
            d="M16.2917 18.125V16.2083C16.2917 15.1917 15.8878 14.2166 15.1689 13.4978C14.45 12.7789 13.475 12.375 12.4583 12.375H4.79166C3.775 12.375 2.79997 12.7789 2.08109 13.4978C1.3622 14.2166 0.958328 15.1917 0.958328 16.2083V18.125"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8.62501 8.54167C10.7421 8.54167 12.4583 6.82543 12.4583 4.70833C12.4583 2.59124 10.7421 0.875 8.62501 0.875C6.50791 0.875 4.79167 2.59124 4.79167 4.70833C4.79167 6.82543 6.50791 8.54167 8.62501 8.54167Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M22.0417 18.1249V16.2083C22.041 15.3589 21.7583 14.5338 21.238 13.8626C20.7176 13.1913 19.989 12.7118 19.1667 12.4995"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M15.3333 0.999512C16.1579 1.21063 16.8887 1.69018 17.4106 2.36256C17.9326 3.03493 18.2158 3.86189 18.2158 4.71305C18.2158 5.56422 17.9326 6.39117 17.4106 7.06355C16.8887 7.73592 16.1579 8.21547 15.3333 8.4266"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'teamRemove':
      return (
        <>
          <path
            {...props}
            d="M31.9375 37.6875V34.8125C31.9375 33.2875 31.3317 31.825 30.2534 30.7466C29.175 29.6683 27.7125 29.0625 26.1875 29.0625H14.6875C13.1625 29.0625 11.7 29.6683 10.6216 30.7466C9.5433 31.825 8.9375 33.2875 8.9375 34.8125V37.6875"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.4375 23.3125C23.6131 23.3125 26.1875 20.7381 26.1875 17.5625C26.1875 14.3869 23.6131 11.8125 20.4375 11.8125C17.2619 11.8125 14.6875 14.3869 14.6875 17.5625C14.6875 20.7381 17.2619 23.3125 20.4375 23.3125Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M30.5 11.9993C31.7368 12.316 32.8331 13.0353 33.616 14.0438C34.3988 15.0524 34.8238 16.2928 34.8238 17.5696C34.8238 18.8463 34.3988 20.0868 33.616 21.0953C32.8331 22.1039 31.7368 22.8232 30.5 23.1399"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.2202 31.7399L36.7401 37.2199"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M42.2202 37.2203L36.7401 31.7403"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'telephone':
      return (
        <>
          <path
            {...props}
            d="M1.12888 3.83704C0.958284 4.12118 0.982655 4.51085 1.05577 4.91676C1.7869 9.01647 3.76907 12.6859 6.55549 15.4786C9.34191 18.2632 13.1194 20.3495 17.0919 20.9503C17.4981 21.0152 17.888 21.0396 18.1723 20.8772C18.2698 20.8204 18.3998 20.7149 18.4323 20.5525L19.987 16.7243C20.0357 16.4726 19.9463 16.2128 19.7432 16.0018C19.6458 15.9043 17.428 15.1006 16.38 14.5973C15.9495 14.3862 15.4458 14.508 15.2346 14.8571L14.8284 15.5553C14.6903 15.7907 14.4547 15.9693 14.1948 16.0342C13.1712 16.294 10.003 13.3796 9.31245 12.6895C8.59757 11.9751 5.58369 8.72782 5.84365 7.70492C5.90863 7.43702 6.08736 7.20971 6.32294 7.0717C6.94034 6.7145 6.76974 6.81192 7.02158 6.66579C7.37902 6.45471 7.50087 5.95138 7.28966 5.52112C6.83473 4.58752 6.56665 3.71075 6.26608 2.71221C6.1361 2.27382 5.71367 1.92474 5.29124 2.01404C5.29124 2.01404 4.16667 2.43436 1.4457 3.57725C1.29135 3.60973 1.18575 3.73962 1.12888 3.83704Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13 4C15.7637 4 18 6.23629 18 9"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 1C17.8666 1 21 4.1334 21 8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'telephoneAlert':
      return (
        <>
          <path
            {...props}
            d="M1.44929 6.67407C1.10276 7.24235 1.15227 8.0217 1.30078 8.83353C2.78589 17.0329 6.81218 24.3718 12.4721 29.9572C18.132 35.5263 25.8051 39.6991 33.8742 40.9006C34.6992 41.0305 35.4913 41.0792 36.0688 40.7544C36.2668 40.6408 36.5309 40.4297 36.5969 40.105L39.7548 32.4486C39.8538 31.9452 39.6723 31.4257 39.2597 31.0035C39.0617 30.8087 34.5569 29.2013 32.4282 28.1946C31.5537 27.7725 30.5306 28.016 30.1016 28.7142L29.2765 30.1105C28.996 30.5814 28.5174 30.9386 27.9894 31.0685C25.9102 31.588 19.4748 25.7591 18.0722 24.379C16.6201 22.9502 10.4981 16.4556 11.0262 14.4098C11.1582 13.874 11.5212 13.4194 11.9997 13.1434C13.2538 12.429 12.9073 12.6238 13.4188 12.3316C14.1449 11.9094 14.3924 10.9028 13.9634 10.0422C13.0393 8.17504 12.4948 6.4215 11.8842 4.42441C11.6202 3.54764 10.7621 2.84947 9.90407 3.02807C9.90407 3.02807 7.61979 3.86872 2.09284 6.15451C1.77931 6.21945 1.5648 6.47924 1.44929 6.67407Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M25.5625 7C31.1763 7 35.7188 11.4726 35.7188 17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M27.5938 1C35.4478 1 41.8125 7.2668 41.8125 15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'time':
      return (
        <>
          <path
            {...props}
            d="M1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 11L10.9972 5.99719"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 11.1235L15.2449 11.1213"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'unlink':
      return (
        <>
          <path
            {...props}
            d="M10.5182 5.74707L14.2653 1.99497C15.5902 0.668342 17.7447 0.668342 19.0696 1.99497L20.0064 2.933C21.3312 4.25963 21.3312 6.41709 20.0064 7.74372L16.2191 11.536"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11.4282 16.3332L7.7347 20.0049C6.40984 21.3315 4.25527 21.3315 2.93041 20.0049L1.99364 19.0669C0.668786 17.7402 0.668786 15.5828 1.99364 14.2561L5.70057 10.571"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1.44497 7.28809H4.6166"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.21278 1.51245V4.68833"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.2479 2.30322L5.03144 5.09049"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M20.5015 14.8057H17.3165"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.7203 20.5813V17.124"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M19.6183 19.6969L16.821316.9097"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'unlock':
      return (
        <>
          <path
            {...props}
            d="M7 21.0001C10.3137 21.0001 13 18.2749 13 14.9131C13 11.5514 10.3137 8.82617 7 8.82617C3.68629 8.82617 1 11.5514 1 14.9131C1 18.2749 3.68629 21.0001 7 21.0001Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.71429 10.6609V5.34783C2.71429 2.94783 4.63429 1 7.00001 1C8.18287 1 9.25429 1.48696 10.0343 2.26956C10.8057 3.06087 11.2857 4.14783 11.2857 5.34783V6.21739"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7 15.7827V17.5218"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6.99999 15.348C7.71007 15.348 8.28571 14.764 8.28571 14.0436C8.28571 13.3232 7.71007 12.7393 6.99999 12.7393C6.28991 12.7393 5.71428 13.3232 5.71428 14.0436C5.71428 14.764 6.28991 15.348 6.99999 15.348Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'upload':
      return (
        <>
          <path
            {...props}
            d="M8.99227 3.04242L8.99227 21M1.13913 10.945L9.00773 3.02671L16.7372 10.945M17 1L1 0.999999"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'uploadArchive':
      return (
        <>
          <path
            {...props}
            d="M1.00001 14.8541V8.6383C1.00001 8.16413 1.17376 7.72948 1.50194 7.39362L6.27028 2.51368C6.59847 2.17781 7.04248 2 7.4865 2H13.6834"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M0.999999 11.9999L1 20.7081C1 21.3403 1.50193 21.854 2.11969 21.854L14.5135 21.854"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 9.99966L21 20.7079C21 21.3401 20.4981 21.8538 19.8803 21.8538L7.48649 21.8538"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M16.9838 3.01598L18.8284 1.17136L19.7485 2.09144L20.6686 3.01152M18.8284 6.82818L18.8341 1.17709"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M8 2V7.35521C8 8.25869 7.38224 9 6.62934 9H4"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'vacancies':
      return (
        <>
          <g clipPath="url(#clip0)">
            <path
              {...props}
              d="M10 19.9957V16.958C10 15.2838 11.1203 14.6666 12.5629 14.6666L14.3358 16.7763L15.9804 14.6666C17.422 14.6666 18.6667 15.2838 18.6667 16.958V20"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinejoin="round"
            />
            <path
              {...props}
              d="M16.6667 11.0891C16.6667 11.6843 16.4208 12.2551 15.9832 12.676C15.5457 13.0969 14.9522 13.3333 14.3333 13.3333C13.7145 13.3333 13.121 13.0969 12.6834 12.676C12.2458 12.2551 12 11.6843 12 11.0891V10.2442C12 9.64902 12.2458 9.07819 12.6834 8.65732C13.121 8.23645 13.7145 8 14.3333 8C14.9522 8 15.5457 8.23645 15.9832 8.65732C16.4208 9.07819 16.6667 9.64902 16.6667 10.2442V11.0891Z"
              stroke={color}
              strokeWidth="1.2"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <path
              {...props}
              d="M21.1693 7.49854C22.5211 8.85045 23.4417 10.5728 23.8146 12.4479C24.1876 14.323 23.9961 16.2666 23.2644 18.0329C22.5328 19.7991 21.2938 21.3088 19.7041 22.3709C18.1144 23.4331 16.2455 24 14.3337 24C12.4218 24 10.5529 23.4331 8.96322 22.3709C7.37356 21.3088 6.13456 19.7991 5.40289 18.0329C4.67123 16.2666 4.47975 14.323 4.85269 12.4479C5.22562 10.5728 6.14621 8.85045 7.49804 7.49854C8.39562 6.60073 9.46127 5.88853 10.6341 5.40262C11.807 4.91671 13.0641 4.66663 14.3337 4.66663C15.6032 4.66663 16.8603 4.91671 18.0332 5.40262C19.206 5.88853 20.2717 6.60073 21.1693 7.49854V7.49854Z"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeMiterlimit="10"
            />
            <path
              {...props}
              d="M21.8597 20L26.9779 25.0319C27.4799 25.5267 27.4469 26.3711 26.9009 26.9081C26.3548 27.445 25.4972 27.4775 24.9941 26.9827L21.3335 23.3831"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeMiterlimit="10"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="25.3333"
                height="25.3333"
                fill="white"
                transform="translate(3.3335 3.33331)"
              />
            </clipPath>
          </defs>
        </>
      );
    case 'viewFalse':
      return (
        <>
          <path
            {...props}
            d="M17.6975 5.82764C19.2072 6.99367 20.3346 8.20392 20.8297 8.74905C19.7226 9.97347 15.5083 13.7622 10.9488 13.7622C10.2581 13.7622 9.58338 13.6928 8.93103 13.5666"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M4.82977 11.9948C4.71073 11.9255 4.60358 11.8562 4.48454 11.7869C2.93692 10.8281 1.68692 9.68456 0.829773 8.74892C2.68692 6.72747 6.37739 3.0542 10.9369 3.0542C11.6869 3.0542 12.4369 3.18126 13.1512 3.38918C13.306 3.43539 13.4488 3.48159 13.5917 3.5278"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M7.3773 9.419C7.34158 9.31504 7.31777 9.21108 7.29396 9.09557C7.24634 8.87609 7.22253 8.64507 7.22253 8.41405C7.22253 6.4619 8.82968 4.87939 10.8297 4.87939C11.1392 4.87939 11.4368 4.91405 11.7225 4.98336C11.8416 5.00646 11.9487 5.04111 12.0559 5.08732"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.3535 7.698C14.4011 7.92902 14.425 8.1716 14.425 8.41417C14.425 10.3663 12.8178 11.9488 10.8178 11.9488C10.5559 11.9488 10.294 11.9257 10.044 11.868"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M2.62396 15.4487L17.0644 1.44873"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'viewTrue':
      return (
        <>
          <path
            {...props}
            d="M21 7.38188C19.8922 8.75405 15.6754 13 11.1132 13C6.55092 13 2.85825 9.64725 1 7.38188C2.85825 5.11651 6.55092 1 11.1132 1C15.6873 1 19.9041 6.00971 21 7.38188Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M11 11C13.2091 11 15 9.20914 15 7C15 4.79086 13.2091 3 11 3C8.79086 3 7 4.79086 7 7C7 9.20914 8.79086 11 11 11Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'volume':
      return (
        <>
          <path
            {...props}
            d="M1 6.52946V12.2795H4.83333L9.625 17.0711V1.73779L4.83333 6.52946H1Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.5416 5.54248C14.96 6.25165 15.9375 7.70831 15.9375 9.40456C15.9375 11.1008 14.96 12.5575 13.5416 13.2571"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M13.5416 1C17.3845 1.87208 20.25 5.30292 20.25 9.40458C20.25 13.5062 17.3845 16.9371 13.5416 17.8092"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'weight':
      return (
        <>
          <path
            {...props}
            d="M17.835 6.57887C12.5555 3.93914 6.52185 5.47898 4.16495 6.57887L5.28448 10.35C10.3282 8.0874 14.8103 9.40726 16.4208 10.35L17.835 6.57887Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M10.7643 8.93606L8.40738 7.05054"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 18.5758V3.42424C1 2.08537 2.08537 1 3.42424 1H18.5758C19.9146 1 21 2.08537 21 3.42424V18.5758C21 19.9146 19.9146 21 18.5758 21H3.42424C2.08537 21 1 19.9146 1 18.5758Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
        </>
      );
    case 'xls':
      return (
        <>
          <path
            {...props}
            d="M1 10.8541V2.1459C1 1.51368 1.50193 1 2.11969 1H14.5135C14.9575 1 15.4015 1.17781 15.7297 1.51368L20.4981 6.39362C20.8263 6.72948 21 7.16413 21 7.6383V10.8541"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14 1V7.35521C14 8.25869 14.6178 9 15.3707 9H18"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 15L5 21"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M1 21L5 15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 15V21H13"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M21 15H18.5C17.6716 15 17 15.6716 17 16.5V16.5C17 17.3284 17.6716 18 18.5 18H19.5C20.3284 18 21 18.6716 21 19.5V19.5C21 20.3284 20.3284 21 19.5 21H17"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'zooIn':
      return (
        <>
          <path
            {...props}
            d="M15.371 13.8693L20.7229 18.8876C21.0924 19.2571 21.0924 19.8648 20.7229 20.2343L20.2343 20.7229C19.8649 21.0923 19.2571 21.0923 18.8877 20.7229L13.5 15.6688"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 6V12"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6 9H12"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'zoomOut':
      return (
        <>
          <path
            {...props}
            d="M15.8352 14L20.7229 18.8877C21.0924 19.2572 21.0924 19.8649 20.7229 20.2344L20.2343 20.723C19.8649 21.0924 19.2571 21.0924 18.8877 20.723L13.6647 15.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M6 9H12"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'logoRedeDorSaoLuiz':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.26939 26.853L8.07771 26.8121L7.88604 26.7711L7.68067 26.7438L7.47531 26.7028L7.07827 26.6482L6.66754 26.6073L6.46217 26.58L6.24311 26.5663L6.03775 26.5527L5.83238 26.539L5.64071 26.5254L5.43534 26.5117H5.22998H5.0383H4.81925H4.61388L4.39482 26.5254L4.17577 26.539L3.95671 26.5527L3.73765 26.58L3.5186 26.5936L3.31323 26.6346L3.09417 26.6619L2.87512 26.7028L2.66975 26.7574L2.46439 26.7984L2.25902 26.8667L2.05366 26.9349L1.86198 27.0032L1.684 27.0851L1.49232 27.1806L1.32803 27.2762L1.16374 27.3718L0.999446 27.4946L0.848844 27.6175L0.725625 27.754L0.588715 27.8905L0.465495 28.0543L0.369658 28.2182L0.273821 28.382L0.191675 28.5731L0.123219 28.7642L0.0684552 28.969L0.0273821 29.1874L0.013691 29.4331L0 29.6652L0.013691 30.0201L0.0547642 30.3205L0.123219 30.6208L0.219057 30.8665L0.342276 31.1123L0.479186 31.3307L0.629788 31.5218L0.807771 31.6993L0.999446 31.8494L1.19112 31.986L1.41018 32.1225L1.62923 32.2317L1.86198 32.3272L2.09473 32.4092L2.32748 32.4911L2.57392 32.5593L3.5186 32.7641L4.34006 32.9552L4.51804 33.0098L4.66864 33.0644L4.80555 33.1327L4.92877 33.2009L5.01092 33.2692L5.09307 33.3648L5.13414 33.474L5.14783 33.5832V33.6241L5.13414 33.6787L5.12045 33.7197L5.10676 33.7607L5.09307 33.788L5.06568 33.8289L5.0383 33.8699L5.01092 33.8972L4.96985 33.9245L4.92877 33.9654L4.8877 33.9927L4.84663 34.0064L4.79186 34.0473L4.75079 34.061L4.69603 34.0883L4.62757 34.1019L4.51804 34.1429L4.38113 34.1702L4.24422 34.1975L4.10731 34.2248L3.94302 34.2385L3.79242 34.2521H3.62813H3.46383H3.24478H3.03941L2.82035 34.2385L2.6013 34.2248L2.39593 34.1975L2.17688 34.1702L1.95782 34.1292L1.73876 34.0883L1.51971 34.0473L1.31434 34.0064L1.09528 33.9518L0.889918 33.8972L0.684552 33.8289L0.479186 33.7607L0.287512 33.6924L0.0958373 33.6105V36.136L0.355967 36.2043L0.616097 36.2589L0.862536 36.2998L1.12267 36.3544L1.3691 36.3954L1.61554 36.4363L1.86198 36.4636L2.10842 36.4909L2.34117 36.5182L2.58761 36.5455L2.84774 36.5592L3.09417 36.5729L3.34061 36.5865L3.60074 36.6002H3.87456H4.13469H4.34006H4.54543L4.76448 36.5865L4.96985 36.5729L5.17521 36.5592L5.38058 36.5319L5.58594 36.4909L5.805 36.4636L5.99668 36.4227L6.20204 36.3681L6.40741 36.3135L6.59908 36.2589L6.79076 36.1906L6.98243 36.1224L7.16041 36.0404L7.3384 35.9449L7.50269 35.8493L7.66698 35.7538L7.81758 35.6446L7.96818 35.5217L8.1051 35.3852L8.22831 35.2487L8.35153 35.0985L8.46106 34.9483L8.5569 34.7845L8.65274 34.607L8.72119 34.4296L8.78965 34.2248L8.84441 34.02L8.87179 33.8016L8.89918 33.5695V33.3375L8.88548 32.9962L8.84441 32.6822L8.77596 32.4092L8.68012 32.1361L8.57059 31.904L8.43368 31.6993L8.26939 31.4945L8.1051 31.3307L7.91342 31.1805L7.70806 31.0304L7.489 30.9211L7.26994 30.8119L7.05089 30.7164L6.80445 30.6345L6.5717 30.5526L6.32526 30.4843L5.38058 30.2795L4.55912 30.1157L4.39482 30.0611L4.23053 30.0065L4.09362 29.9519L3.98409 29.8836L3.88826 29.8017L3.8198 29.7198L3.77873 29.6243L3.76504 29.5014V29.4468V29.3922L3.77873 29.3376L3.80611 29.2966L3.83349 29.2557L3.86087 29.2147L3.88826 29.1738L3.92933 29.1328L3.9704 29.1055L4.01147 29.0782L4.06624 29.0509L4.10731 29.0236L4.16208 28.9963L4.23053 28.9826L4.2853 28.9553L4.34006 28.9417L4.46328 28.9144L4.60019 28.9007L4.7371 28.8871L4.87401 28.8734L5.13414 28.8598H5.36689H5.57225L5.76393 28.8734H5.9556L6.14728 28.8871L6.33895 28.9144L6.53063 28.9417L6.7223 28.969L6.90028 28.9963L7.07827 29.0236L7.25625 29.0645L7.43423 29.1055L7.61222 29.1465L7.77651 29.1874L7.9408 29.242L8.1051 29.2966L8.26939 29.3512V26.853Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.81641 36.4366L12.2529 26.6895H17.4144L20.9193 36.4366H16.9763L14.7857 28.7781H14.7583L12.5541 36.4366H8.81641Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.2145 30.9621L31.1871 30.6754L31.146 30.4023L31.0912 30.1293L31.0228 29.8836L30.9406 29.6379L30.8585 29.3921L30.7627 29.1601L30.6531 28.9416L30.5299 28.7232L30.4067 28.5321L30.2561 28.341L30.1192 28.1499L29.9549 27.9724L29.7906 27.8086L29.6126 27.6448L29.4209 27.4946L29.2156 27.3581L29.0102 27.2352L28.7911 27.1123L28.5584 27.0031L28.312 26.9076L28.0655 26.8257L27.8054 26.7438L27.5453 26.6755L27.2714 26.6209L26.9839 26.5799L26.6964 26.539L26.3952 26.5117L26.0803 26.498L25.7654 26.4844L25.4505 26.498L25.1356 26.5117L24.8344 26.539L24.5469 26.5799L24.2594 26.6209L23.9856 26.6755L23.7255 26.7438L23.479 26.8257L23.2326 26.9076L22.9861 27.0031L22.7534 27.1123L22.5343 27.2352L22.329 27.3581L22.1373 27.4946L21.9456 27.6448L21.7676 27.8086L21.6033 27.9724L21.4391 28.1499L21.2885 28.3273L21.1378 28.5184L21.0146 28.7096L20.9051 28.928L20.7956 29.1464L20.6997 29.3785L20.6176 29.6242L20.5354 29.8699L20.4807 30.1157L20.4259 30.3887L20.3848 30.6617L20.3575 30.9484L20.3301 31.2351V31.8494L20.3575 32.1497L20.3848 32.4364L20.4259 32.7094L20.4807 32.9825L20.5354 33.2419L20.6176 33.4876L20.6997 33.7333L20.7956 33.9654L20.9051 34.1838L21.0146 34.4022L21.1378 34.607L21.2885 34.7981L21.4391 34.9756L21.6033 35.1531L21.7676 35.3169L21.9456 35.4807L22.1373 35.6309L22.329 35.7674L22.5343 35.8902L22.7534 35.9995L22.9861 36.1087L23.2326 36.2042L23.479 36.2861L23.7255 36.368L23.9856 36.4226L24.2594 36.4773L24.5469 36.5182L24.8344 36.5455L25.1356 36.5728L25.4505 36.5865H26.0803L26.3952 36.5728L26.6964 36.5455L26.9839 36.5182L27.2714 36.4773L27.5453 36.4226L27.8054 36.368L28.0655 36.2861L28.312 36.2042L28.5584 36.1087L28.7911 35.9995L29.0102 35.8902L29.2156 35.7674L29.4209 35.6309L29.6126 35.4807L29.7906 35.3169L29.9549 35.1531L30.1192 34.9756L30.2698 34.7981L30.4204 34.607L30.5436 34.4022L30.6668 34.1838L30.7763 33.9654L30.8722 33.7333L30.9543 33.4876L31.0365 33.2419L31.1049 32.9825L31.1597 32.7094L31.2008 32.4364L31.2281 32.1497L31.2555 31.8494V31.2351L31.2145 30.9621ZM27.3125 31.7675L27.2988 31.9859L27.2851 32.2043L27.2714 32.4228L27.2577 32.5456L27.2441 32.6548L27.2304 32.7641L27.203 32.8733L27.1756 32.9825L27.1482 33.0917L27.1208 33.2009L27.0798 33.3101L27.0387 33.4057L26.9976 33.5012L26.9565 33.5968L26.9018 33.6924L26.847 33.7743L26.7786 33.8562L26.7101 33.9381L26.628 34.0063L26.5458 34.0609L26.45 34.1155L26.3541 34.1565L26.2583 34.1975L26.1488 34.2384L26.0256 34.2521L25.9023 34.2657L25.7791 34.2794L25.6559 34.2657L25.5327 34.2521L25.4231 34.2384L25.3136 34.1975L25.2178 34.1565L25.1219 34.1155L25.0398 34.0609L24.9577 34.0063L24.807 33.8562L24.7523 33.7743L24.6975 33.6924L24.6428 33.5968L24.6017 33.5012L24.5606 33.4057L24.5195 33.3101L24.4785 33.2009L24.4511 33.0917L24.4237 32.9825L24.3963 32.8733L24.3689 32.7641L24.3416 32.6548L24.3279 32.5456L24.3142 32.4228L24.2868 32.2043L24.2731 31.9859L24.2594 31.7675V31.3853L24.2731 31.1941L24.2868 30.9757L24.3005 30.7573L24.3142 30.6481L24.3279 30.5389L24.3552 30.416L24.3689 30.3068L24.3963 30.1976L24.4237 30.0884L24.5058 29.8699L24.5469 29.7607L24.588 29.6652L24.6428 29.5696L24.7523 29.3921L24.8207 29.3102L24.8892 29.2283L24.9577 29.1464L25.0398 29.0918L25.2178 28.9826L25.3136 28.9416L25.4231 28.9143L25.5327 28.887L25.6559 28.8734H25.916L26.0392 28.887L26.1488 28.9143L26.2583 28.9416L26.3678 28.9826L26.5458 29.0918L26.628 29.1464L26.6964 29.2283L26.7786 29.3102L26.847 29.3921L26.9565 29.5696L27.0113 29.6652L27.0524 29.7607L27.0935 29.8699L27.1756 30.0884L27.203 30.1976L27.2304 30.3068L27.2577 30.416L27.2714 30.5389L27.2851 30.6481L27.2988 30.7573L27.3262 30.9757L27.3399 31.1941L27.3536 31.3853V31.7675H27.3125Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.7715 36.4366H51.5606V33.5561H45.5228V26.6895H41.7715V36.4366Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.3119 26.6758H51.5469V32.6005L51.5606 32.8735L51.5743 33.1193L51.6016 33.365L51.6427 33.5971L51.6975 33.8291L51.7659 34.0476L51.8481 34.2523L51.9302 34.4435L52.0261 34.6346L52.1356 34.812L52.2451 34.9759L52.3683 35.126L52.5053 35.2898L52.6559 35.4264L52.8065 35.5629L52.9571 35.6857L53.135 35.7949L53.313 35.9042L53.491 35.9997L53.6827 36.0953L53.8744 36.1772L54.0797 36.2454L54.2988 36.3137L54.5178 36.382L54.7369 36.4366L54.9696 36.4775L55.1887 36.5185L55.4351 36.5458L55.6816 36.5731L55.928 36.5867L56.1745 36.6004H56.4346H56.7084L56.9685 36.5867L57.2287 36.5731L57.4888 36.5458L57.7352 36.5185L57.9817 36.4912L58.2144 36.4366L58.4472 36.3956L58.6662 36.3274L58.8716 36.2727L59.077 36.1908L59.2823 36.1089L59.474 36.0134L59.652 35.9178L59.83 35.8086L59.9943 35.6857L60.1449 35.5629L60.2955 35.4264L60.4324 35.2762L60.5556 35.126L60.6788 34.9622L60.7884 34.7847L60.8979 34.5936L60.98 34.3888L61.0622 34.1841L61.1306 33.9657L61.1991 33.7336L61.2539 33.5015L61.2812 33.2421L61.3086 32.9691L61.336 32.6961V32.4094V26.6758H57.6531V32.4776V32.6551V32.8189L57.6394 32.9827L57.612 33.1329L57.5983 33.2012L57.5846 33.2694L57.5573 33.3377L57.5436 33.4059L57.5162 33.4742L57.4888 33.5288L57.4614 33.5834L57.434 33.638L57.393 33.6926L57.3656 33.7472L57.3108 33.7882L57.2697 33.8291L57.2287 33.8701L57.1739 33.911L57.1191 33.9384L57.0644 33.9793L57.0096 33.993L56.9412 34.0203L56.8727 34.0339L56.8042 34.0612L56.7221 34.0749L56.64 34.0885H56.5578H56.462H56.3935L56.3114 34.0749H56.2292L56.1608 34.0612L56.0923 34.0339L56.0239 34.0203L55.9691 33.993L55.9006 33.9657L55.8596 33.9384L55.8048 33.8974L55.75 33.8564L55.709 33.8155L55.6679 33.7745L55.6268 33.7336L55.5857 33.679L55.5584 33.6244L55.5173 33.5698L55.4899 33.5152L55.4625 33.4469L55.4351 33.3786L55.4078 33.324L55.3941 33.2558L55.3804 33.1875L55.3667 33.1056L55.3393 32.9554L55.3119 32.8053V32.6415V32.464V26.6758Z"
            fill={color}
          />
          <path
            {...props}
            d="M66.5521 26.6895H62.8008V36.4366H66.5521V26.6895Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.9358 26.6758V29.2013H72.5634L67.7715 33.4742V36.4366H76.8076V33.8428H72.0157L76.657 29.6381V26.6758H67.9358Z"
            fill={color}
          />
          <path
            {...props}
            d="M17.4702 23.5908H12.2812V25.3655H17.4702V23.5908Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.7715 37.3789H51.5606V40.2457H45.5228V47.126H41.7715V37.3789Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.8399 36.4366H31.0508V33.5561H37.0748V26.6895H40.8399V36.4366Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.8399 37.3789H31.0508V40.2457H37.0748V47.126H40.8399V37.3789Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.4278 17.3109C44.1545 16.7103 43.0455 16.4099 42.0735 16.4099C41.5395 16.4099 41.1151 16.4782 40.7865 16.642C40.4579 16.7922 40.2936 16.9833 40.2936 17.229C40.2936 17.4611 40.4716 17.6386 40.8139 17.7887C41.1698 17.9389 41.608 18.0072 42.1419 18.0072C43.1961 18.0072 44.2914 17.7751 45.4278 17.3109ZM46.3588 17.3246C47.2213 17.7614 48.0975 17.9662 48.9737 17.9662C50.3155 17.9662 51.5477 17.4748 52.6703 16.5055C54.2448 15.154 55.3948 13.3111 56.1068 10.963C56.5038 9.65247 56.7092 8.42383 56.7092 7.30441C56.7092 6.59454 56.6133 5.87101 56.408 5.13383C55.8466 5.7891 55.3401 6.45802 54.8883 7.1406C54.4365 7.82317 53.7793 8.88799 52.9305 10.335C52.0679 11.8094 51.356 12.9015 50.781 13.6387C50.2059 14.3622 49.494 15.0858 48.6452 15.7683C48.166 16.1506 47.413 16.6693 46.3588 17.3246ZM56.6681 4.8881C56.9009 5.69354 57.0104 6.48533 57.0104 7.24981C57.0104 8.46479 56.8187 9.73438 56.4217 11.0586C55.6824 13.5704 54.4639 15.5226 52.7799 16.9424C51.6709 17.8843 50.3976 18.3485 48.9737 18.3485C48.4809 18.3485 48.0154 18.2938 47.6183 18.1983C47.2076 18.1027 46.6326 17.8843 45.8796 17.5703C44.5242 18.1164 43.2783 18.3894 42.1145 18.3894C41.5395 18.3894 41.074 18.3211 40.677 18.1846C40.4305 18.1027 40.2389 17.9662 40.0746 17.7751C39.9103 17.584 39.8281 17.3929 39.8281 17.1881C39.8281 16.8195 40.0335 16.5192 40.4442 16.3007C40.855 16.0823 41.4163 15.9731 42.1145 15.9731C43.2098 15.9731 44.4694 16.3417 45.8933 17.0789C46.8243 16.4509 47.6868 15.6591 48.5082 14.7035C49.0148 14.1028 49.4255 13.5841 49.7541 13.1199C50.069 12.6694 50.8905 11.4272 52.2048 9.39309C53.2317 7.83682 54.5734 6.2396 56.2437 4.62873C55.8603 3.75503 55.4359 3.07246 54.943 2.60831C53.9162 1.65271 52.5745 1.16125 50.8768 1.16125C48.6452 1.16125 46.7695 1.91208 45.2224 3.41374C44.4557 4.15092 43.8533 4.98366 43.4289 5.88466C43.0318 6.7174 42.8265 7.53649 42.8265 8.36923C42.8265 9.20197 43.0866 9.87089 43.6069 10.376C44.0997 10.8674 44.7843 11.1132 45.6468 11.1132C46.8379 11.1132 47.988 10.649 49.0833 9.73438C50.5756 8.47844 51.6024 6.70375 52.1774 4.4103L52.4102 4.47856C52.1774 5.95292 51.6983 7.26346 50.9589 8.39653C50.2059 9.54326 49.2749 10.4033 48.166 10.9494C47.3719 11.3453 46.5504 11.55 45.7016 11.55C44.5789 11.55 43.7164 11.1678 43.1277 10.4169C42.5937 9.74803 42.3336 8.92894 42.3336 7.97334C42.3336 6.7447 42.6896 5.52972 43.4152 4.3557C44.1545 3.15437 45.1266 2.21242 46.3451 1.5708C47.5636 0.915526 48.919 0.587891 50.4113 0.587891C52.3965 0.587891 53.971 1.1749 55.121 2.33528C55.6002 2.81308 56.052 3.50931 56.4901 4.39665C57.4485 3.55026 58.3658 2.89499 59.2283 2.40354L59.3105 2.71752C58.5027 3.20897 57.6265 3.94615 56.6681 4.8881ZM60.1456 0.970132H61.9665V2.84038C61.9665 3.59121 61.8433 4.09632 61.6106 4.32839C61.3641 4.57412 60.926 4.72429 60.2962 4.76524C60.2278 4.75159 60.1319 4.73794 59.995 4.73794V3.8779C60.2825 3.8779 60.5016 3.80964 60.6385 3.68677C60.7754 3.55026 60.8439 3.30453 60.8302 2.92229H60.1319V0.970132H60.1456Z"
            fill={color}
          />
          <path
            {...props}
            d="M29.5993 18.0479V7.63184H36.7734V9.33827H31.5982V11.9457H36.4996V13.5702H31.5982V16.3278H36.8008V18.0479H29.5993ZM24.6158 18.0479H19.1805V7.63184H24.2051C26.0534 7.63184 27.2445 8.12329 27.7921 9.11985C28.1207 9.73416 28.285 10.5806 28.285 11.6727V13.8979C28.285 15.7408 27.7647 16.9694 26.7105 17.5838C26.4641 17.7203 26.1492 17.8295 25.7385 17.925C25.3414 18.007 24.9718 18.0479 24.6158 18.0479ZM24.2051 16.3415C24.6021 16.3415 24.9307 16.3005 25.1908 16.205C25.4373 16.1094 25.67 15.9183 25.8754 15.6316C26.1492 15.2494 26.2861 14.5941 26.2861 13.6248V12.915V11.7546C26.2861 11.1403 26.245 10.6761 26.1629 10.3485C26.0807 10.0208 25.8891 9.77512 25.5605 9.59765C25.2456 9.42018 24.7527 9.33827 24.0818 9.33827H21.193V16.3415H24.2051ZM10.4866 18.0479V7.63184H17.6607V9.33827H12.4855V11.9457H17.3869V13.5702H12.4855V16.3278H17.6881V18.0479H10.4866ZM5.62633 7.63184C6.98174 7.63184 7.89904 7.89121 8.36453 8.42362C8.78896 8.88777 8.99432 9.66591 8.99432 10.7307C8.99432 11.8911 8.84372 12.6419 8.52883 13.0105C8.25501 13.3518 7.78951 13.5702 7.14603 13.6931V13.734C7.76213 13.7887 8.22762 13.9934 8.54252 14.362C8.78896 14.7579 8.92587 15.3586 8.92587 16.1367V18.0479H6.89959V16.478C6.89959 16.1231 6.8859 15.8091 6.84483 15.577C6.80376 15.3449 6.72161 15.1401 6.57101 14.9763C6.4341 14.8125 6.25611 14.717 6.06444 14.6623C5.87277 14.6214 5.61264 14.5941 5.28405 14.5941H5.07869H2.50477V18.0479H0.492188V7.63184H5.62633ZM5.32512 9.33827H2.50477V12.8877H5.39358C5.73586 12.8877 6.00968 12.8604 6.20135 12.8057C6.39302 12.7511 6.55732 12.6419 6.70792 12.4918C6.89959 12.246 6.99543 11.7546 6.99543 11.0447C6.99543 10.3894 6.91328 9.93894 6.76268 9.70686C6.62577 9.54304 6.46148 9.44748 6.22873 9.40653C5.99599 9.36557 5.69478 9.33827 5.32512 9.33827Z"
            fill={color}
          />
          <path
            {...props}
            d="M73.0138 7.63169C74.3692 7.63169 75.2728 7.89107 75.752 8.42348C76.1764 8.88763 76.3818 9.66576 76.3818 10.7306C76.3818 11.891 76.2311 12.6418 75.9163 13.0104C75.6424 13.3517 75.1769 13.5701 74.5335 13.6929V13.7339C75.1496 13.7885 75.615 13.9933 75.9299 14.3619C76.1764 14.7578 76.3133 15.3584 76.3133 16.1366V18.0478H74.3007V16.4778C74.3007 16.1229 74.287 15.8089 74.2459 15.5768C74.2049 15.3448 74.1227 15.14 73.9721 14.9762C73.8352 14.8124 73.6572 14.7168 73.4656 14.6622C73.2739 14.6212 73.0138 14.5939 72.6852 14.5939H72.4798H69.8922V18.0478H67.8933V7.63169H73.0138ZM72.7262 9.33813H69.8922V12.8875H72.781C73.1233 12.8875 73.3971 12.8602 73.5888 12.8056C73.7805 12.751 73.9447 12.6418 74.0953 12.4916C74.287 12.2459 74.3829 11.7544 74.3829 11.0446C74.3829 10.3893 74.3007 9.93879 74.1501 9.70672C74.0132 9.5429 73.8489 9.44734 73.6162 9.40638C73.3834 9.36543 73.0959 9.33813 72.7262 9.33813ZM62.0198 7.53613C62.5675 7.53613 63.0741 7.56344 63.5396 7.60439C64.005 7.64534 64.4569 7.75456 64.8813 7.90472C65.3057 8.06854 65.6206 8.30062 65.826 8.6146C65.9355 8.73746 66.0724 8.99684 66.2367 9.40638C66.401 9.81593 66.4831 10.4166 66.4831 11.222V14.5803C66.4831 15.2083 66.4284 15.6997 66.3051 16.041C66.1819 16.3823 66.0176 16.7099 65.7986 17.0239C65.5521 17.3515 65.2099 17.5973 64.7717 17.7611C64.3336 17.9249 63.8818 18.0205 63.4163 18.0614C62.9508 18.1024 62.3895 18.116 61.746 18.116C60.9519 18.116 60.2811 18.0614 59.7334 17.9386C59.1858 17.8293 58.7477 17.5836 58.4054 17.2014C57.8715 16.669 57.6113 15.6997 57.6113 14.2663V11.4405C57.6113 10.8398 57.6524 10.3074 57.7346 9.82958C57.8167 9.36543 57.9673 8.94223 58.2137 8.60095C58.4465 8.28696 58.7614 8.04124 59.1858 7.89107C59.6102 7.7409 60.0346 7.64534 60.4864 7.60439C60.9246 7.56344 61.4448 7.53613 62.0198 7.53613ZM62.0472 9.25622C61.4038 9.25622 60.8972 9.29717 60.5549 9.39273C60.1989 9.48829 59.9662 9.66576 59.8567 9.92514C59.7198 10.2255 59.6376 10.6896 59.5965 11.3176C59.6102 11.3995 59.6239 11.5087 59.6239 11.6316V14.1025C59.6239 14.9625 59.7198 15.5495 59.9114 15.8635C60.0757 16.1093 60.3085 16.2594 60.6097 16.314C60.9109 16.3686 61.3764 16.4096 62.0198 16.4369C62.6359 16.4232 63.0877 16.3823 63.4026 16.3004C63.7175 16.2185 63.964 16.082 64.1283 15.8772C64.2241 15.727 64.3063 15.5086 64.3747 15.2219C64.4432 14.9352 64.4705 14.6212 64.4705 14.2936V11.536V11.1674C64.4705 10.5122 64.361 10.0344 64.1283 9.74767C63.8955 9.50194 63.5396 9.35178 63.033 9.28352C62.7318 9.26987 62.4032 9.25622 62.0472 9.25622Z"
            fill={color}
          />
        </>
      );
    case 'logoRedeDor':
      return (
        <>
          <path
            {...props}
            d="M27.33 10.6192C26.5591 10.2555 25.8775 10.0741 25.2853 10.0752C24.9624 10.0752 24.7047 10.12 24.5045 10.2124C24.3044 10.3048 24.2037 10.4227 24.2037 10.5658C24.2037 10.7089 24.3113 10.8173 24.5223 10.9075C24.7332 10.9977 25.0065 11.041 25.3294 11.041C25.9708 11.041 26.6375 10.9004 27.3294 10.6192H27.33ZM27.8993 10.6267C28.3923 10.8797 28.9386 11.0136 29.4936 11.0175C30.3093 11.0175 31.0592 10.7237 31.7433 10.1361C32.7022 9.31747 33.3979 8.19778 33.8305 6.77699C34.0723 5.98011 34.1934 5.24125 34.1937 4.56039C34.1916 4.11737 34.1308 3.67654 34.0129 3.24922C33.6799 3.63595 33.37 4.04167 33.0848 4.4643C32.8082 4.87608 32.4113 5.52206 31.894 6.40222C31.372 7.29199 30.9351 7.95754 30.5832 8.39887C30.1975 8.875 29.7607 9.30802 29.2805 9.69029C28.9975 9.91629 28.5371 10.2284 27.8993 10.6267V10.6267ZM34.1701 3.096C34.3081 3.56158 34.3793 4.04414 34.3815 4.52943C34.3748 5.31189 34.2546 6.08932 34.0248 6.83786C33.5749 8.35723 32.8354 9.54561 31.8063 10.403C31.1646 10.9593 30.3398 11.2632 29.4877 11.2572C29.2096 11.2598 28.9322 11.2288 28.6617 11.1648C28.4153 11.104 28.0632 10.9764 27.6055 10.782C26.7844 11.1141 26.0215 11.2803 25.317 11.2807C25.0205 11.2875 24.7248 11.2464 24.4416 11.1589C24.298 11.1132 24.1704 11.028 24.0735 10.9134C23.9819 10.8175 23.9284 10.6919 23.9229 10.5599C23.9229 10.3339 24.0484 10.156 24.2995 10.0261C24.5506 9.89618 24.8883 9.82927 25.3127 9.82535C25.9799 9.82535 26.7449 10.048 27.6076 10.4932C28.1995 10.088 28.7334 9.60527 29.195 9.05819C29.5038 8.69463 29.7557 8.37698 29.9483 8.09724C30.1409 7.81749 30.6397 7.06848 31.4398 5.84167C32.064 4.89708 32.883 3.93613 33.8967 2.9588C33.6657 2.42494 33.4026 2.01564 33.1074 1.73092C32.4993 1.13192 31.6805 0.83278 30.651 0.833492C29.2972 0.833492 28.1507 1.28834 27.2116 2.19805C26.7604 2.62767 26.3903 3.13392 26.1188 3.69287C25.8849 4.16001 25.7608 4.67361 25.7556 5.19516C25.7556 5.6977 25.9139 6.10397 26.2307 6.41397C26.5299 6.7108 26.9424 6.85939 27.4683 6.85974C28.1936 6.85974 28.8899 6.58107 29.5571 6.02371C30.4643 5.26171 31.0921 4.1858 31.4404 2.79597L31.583 2.84135C31.4452 3.73646 31.1518 4.52623 30.7027 5.21064C30.2437 5.90466 29.6771 6.42411 29.0013 6.75884C28.5368 6.99522 28.0225 7.1189 27.5006 7.11973C26.819 7.11973 26.2961 6.89213 25.932 6.43692C25.6092 6.03439 25.4505 5.5395 25.4505 4.95652C25.4505 4.20911 25.6691 3.47807 26.1064 2.76341C26.5374 2.05326 27.1529 1.47115 27.8885 1.078C28.6296 0.681874 29.4547 0.483632 30.3637 0.483276C31.5719 0.483276 32.5262 0.835983 33.2268 1.54139C33.5181 1.83395 33.7948 2.25072 34.0571 2.7917C34.6414 2.27991 35.1956 1.8788 35.7197 1.58837L35.7735 1.77896C35.2882 2.08113 34.7546 2.52086 34.1728 3.09814L34.1701 3.096ZM36.2831 0.725651H37.3899V1.85904C37.3899 2.31603 37.3182 2.61855 37.1747 2.76661C37.0276 2.9193 36.762 3.00721 36.3778 3.03034C36.3168 3.01623 36.2542 3.0103 36.1916 3.01272V2.49434C36.3692 2.49434 36.5007 2.45483 36.586 2.37582C36.6711 2.29628 36.7109 2.14306 36.7055 1.91457H36.2804L36.2831 0.725651Z"
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            {...props}
            d="M3.77249 7.69813C3.68917 7.78761 3.58329 7.85341 3.46578 7.88872C3.30575 7.92944 3.14071 7.94741 2.97559 7.94211H1.22037V5.78957H2.94223C3.12247 5.78651 3.3026 5.80009 3.48031 5.83014C3.60646 5.85217 3.72076 5.91757 3.80316 6.01486C3.89947 6.15633 3.94898 6.427 3.94898 6.82366C3.94898 7.25396 3.88961 7.54491 3.77087 7.69653L3.77249 7.69813ZM4.04906 8.44394V8.41831C4.44616 8.34731 4.72704 8.20957 4.89385 8.0067C5.08182 7.78675 5.17544 7.32656 5.17473 6.62614C5.17473 5.98016 5.04702 5.51499 4.79161 5.23062C4.50105 4.91243 3.94503 4.75316 3.12356 4.75281H0V11.0615H1.22037V8.9746H2.92339C3.08233 8.97082 3.24119 8.98497 3.39691 9.01677C3.51616 9.04542 3.62329 9.11061 3.70307 9.20309C3.79247 9.30461 3.84875 9.43062 3.8645 9.56452C3.88802 9.74524 3.89881 9.92738 3.89678 10.1096V11.0615H5.12307V9.89231C5.12307 9.42144 5.04684 9.06464 4.89438 8.82191C4.70337 8.60837 4.42087 8.47971 4.0496 8.44501"
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            {...props}
            d="M6.07422 11.0594V4.75342H10.4386V5.78911H7.29459V7.36828H10.2777V8.35219H7.29459V10.0237H10.4553V11.0594H6.07422Z"
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            {...props}
            d="M15.6834 7.9582V8.38529C15.6834 8.964 15.6014 9.3676 15.4375 9.59609C15.3159 9.77227 15.1792 9.88758 15.0253 9.94204C14.8327 10.003 14.6311 10.0309 14.4291 10.0248H12.5899V5.78911H14.3441C14.7525 5.78911 15.0533 5.8425 15.247 5.94927C15.3364 5.99479 15.415 6.05872 15.4776 6.13679C15.5401 6.21486 15.5851 6.30527 15.6097 6.40199C15.6592 6.59845 15.6834 6.88246 15.6834 7.25617V7.9582ZM16.6137 5.65298C16.2797 5.05363 15.5515 4.75377 14.4291 4.75342H11.3701V11.061H14.6734C14.9056 11.0589 15.137 11.034 15.3643 10.9868C15.5711 10.9502 15.7709 10.8816 15.9562 10.7834C16.5943 10.4108 16.9134 9.66532 16.9134 8.54705V7.20171C16.9134 6.53901 16.8141 6.02294 16.6153 5.65351"
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            {...props}
            d="M17.7065 11.0594V4.75342H22.0709V5.78911H18.9269V7.36828H21.91V8.35219H18.9269V10.0237H22.0876V11.0594H17.7065Z"
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            {...props}
            d="M38.9158 7.1159V8.78903C38.9168 8.978 38.897 9.16651 38.8566 9.35119C38.8304 9.49128 38.7792 9.62561 38.7054 9.74785C38.5889 9.87928 38.4329 9.97006 38.2604 10.0068C38.0699 10.0559 37.7883 10.0844 37.4156 10.0922C37.1296 10.0902 36.8441 10.0665 36.5617 10.0212C36.4755 10.007 36.3932 9.97538 36.3198 9.92837C36.2464 9.88136 36.1835 9.81992 36.135 9.74785C36.0163 9.55316 35.9569 9.19726 35.9569 8.68012V7.1853C35.9583 7.12047 35.9528 7.05568 35.9402 6.99204C35.9655 6.61193 36.0188 6.33219 36.1016 6.15014C36.1734 5.98856 36.3156 5.87965 36.5283 5.82342C36.7436 5.76576 37.0454 5.738 37.4393 5.738C37.6545 5.738 37.8558 5.74334 38.0425 5.75455C38.3449 5.79405 38.565 5.88641 38.7049 6.03376C38.8448 6.20566 38.9153 6.49181 38.9153 6.88794L38.9158 7.1159ZM39.992 5.84103C39.8919 5.59012 39.8085 5.43049 39.7423 5.36056C39.6164 5.16997 39.4243 5.02689 39.1644 4.92919C38.9014 4.83116 38.6263 4.76885 38.3465 4.74394C38.0602 4.71725 37.7519 4.70337 37.4199 4.70337C37.0713 4.70337 36.7606 4.71494 36.488 4.73807C36.2175 4.76154 35.9515 4.82097 35.697 4.91478C35.4604 4.99386 35.2538 5.1429 35.1051 5.34187C34.9527 5.56624 34.8529 5.82162 34.8129 6.08928C34.7639 6.41187 34.7416 6.73791 34.7462 7.06411V8.78903C34.7462 9.65246 34.9076 10.2438 35.2305 10.5631C35.4449 10.7925 35.7278 10.9477 36.0376 11.0062C36.4409 11.0832 36.8511 11.119 37.2617 11.1129C37.6588 11.1129 37.9996 11.1021 38.2841 11.0804C38.5656 11.0579 38.8428 10.9975 39.1079 10.901C39.3557 10.8184 39.5724 10.6632 39.7294 10.4558C39.858 10.2713 39.9612 10.0706 40.0361 9.85889C40.1077 9.65015 40.1437 9.35546 40.1437 8.97588V6.93972C40.1437 6.45604 40.0937 6.08981 39.9936 5.84103"
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            {...props}
            d="M44.7661 7.69813C44.6828 7.78761 44.5769 7.85341 44.4594 7.88872C44.2996 7.92941 44.1347 7.94738 43.9698 7.94211H42.214V5.78957H43.9359C44.1161 5.78651 44.2963 5.80009 44.474 5.83014C44.6001 5.85217 44.7144 5.91757 44.7968 6.01486C44.8931 6.15633 44.9426 6.427 44.9426 6.82366C44.9426 7.25396 44.8833 7.54491 44.7645 7.69653L44.7661 7.69813ZM45.0427 8.44394V8.41831C45.4398 8.34731 45.7207 8.20957 45.8875 8.0067C46.0755 7.78675 46.1691 7.32656 46.1684 6.62614C46.1684 5.98016 46.0408 5.51499 45.7858 5.23062C45.4945 4.91243 44.9385 4.75316 44.1177 4.75281H40.9937V11.0615H42.214V8.9746H43.9176C44.0763 8.97086 44.235 8.98501 44.3906 9.01677C44.5098 9.04542 44.6169 9.11061 44.6967 9.20309C44.7861 9.30461 44.8424 9.43062 44.8581 9.56452C44.8819 9.74522 44.8927 9.92737 44.8904 10.1096V11.0615H46.1167V9.89231C46.1167 9.42144 46.0405 9.06464 45.888 8.82191C45.697 8.60837 45.4145 8.47971 45.0432 8.44501"
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </>
      );
    case 'browser':
      return (
        <>
          <path
            {...props}
            d="M24.296 17.3422C26.6129 17.3422 28.8046 16.4064 30.4326 14.7845C32.0607 13.1626 33 10.9792 33 8.67108C33 6.36295 32.0607 4.17958 30.4326 2.55766C28.8046 0.935728 26.6129 0 24.296 0C21.9791 0 19.7875 0.935728 18.1594 2.55766C16.5313 4.17958 15.592 6.36295 15.592 8.67108C15.592 10.9792 16.5313 13.1626 18.1594 14.7845C19.7875 16.4688 21.9165 17.3422 24.296 17.3422ZM19.7249 9.6068L17.4706 9.91871C17.408 9.48204 17.3454 9.04537 17.3454 8.67108C17.3454 8.29679 17.408 7.86011 17.4706 7.42344L19.7249 7.73535C19.6622 8.04726 19.5996 8.35917 19.5996 8.67108C19.5996 8.98299 19.6622 9.2949 19.7249 9.6068ZM25.1727 4.1172C24.8596 4.05482 24.5465 4.05482 24.2334 4.05482C23.9203 4.05482 23.6072 4.05482 23.2941 4.1172L22.981 1.87146C23.8577 1.68431 24.6091 1.68431 25.4858 1.87146L25.1727 4.1172ZM28.3036 6.42533C28.1157 6.05104 27.8653 5.73913 27.5522 5.42722C27.2391 5.11531 26.926 4.86578 26.5503 4.67864L26.926 2.30813C27.74 2.68242 28.5541 3.18147 29.1803 3.80529C29.8064 4.49149 30.3074 5.24008 30.6831 6.05104L28.3036 6.42533ZM30.6831 11.2911C30.37 12.1021 29.8064 12.8507 29.1803 13.5369C28.5541 14.1607 27.74 14.7221 26.926 15.034L26.5503 12.7259C26.926 12.5388 27.2391 12.2892 27.5522 11.9773C27.8653 11.6654 28.1157 11.3535 28.3036 10.9792L30.6831 11.2911ZM25.5484 15.4707C24.6717 15.6578 23.9203 15.6578 23.0436 15.4707L23.3567 13.225C24.1082 13.3497 24.6717 13.3497 25.1727 13.225L25.5484 15.4707ZM20.2258 10.9792C20.4137 11.3535 20.6641 11.6654 20.9772 11.9773C21.2277 12.2268 21.5408 12.4764 21.9791 12.7259L21.6034 15.034C20.7894 14.6597 19.9753 14.1607 19.3491 13.5369C18.723 12.8507 18.1594 12.1021 17.8463 11.2911L20.2258 10.9792ZM21.6034 2.30813L21.9791 4.61626C21.6034 4.8034 21.2903 5.05293 20.9772 5.36484C20.7268 5.61437 20.4763 5.92628 20.2258 6.36295L17.9089 5.98866C18.2846 5.17769 18.7856 4.42911 19.4118 3.74291C20.038 3.18147 20.7894 2.62004 21.6034 2.30813ZM21.4156 8.67108C21.4156 7.92249 21.7287 7.17391 22.2296 6.67486C22.7932 6.11342 23.482 5.86389 24.2334 5.86389C24.9848 5.86389 25.7362 6.1758 26.2372 6.67486C26.8008 7.23629 27.0512 7.92249 27.0512 8.67108C27.0512 9.41966 26.7381 10.1682 26.2372 10.6673C25.7362 11.1664 24.9848 11.4783 24.2334 11.4783C23.482 11.4783 22.7306 11.1664 22.2296 10.6673C21.7287 10.1682 21.4156 9.48204 21.4156 8.67108ZM28.8046 7.79773L31.0588 7.48582C31.1214 7.9225 31.1841 8.35917 31.1841 8.73346C31.1841 9.10775 31.1214 9.54442 31.0588 9.9811L28.8046 9.6068C28.9298 8.98299 28.9298 8.35917 28.8046 7.79773ZM32.0607 14.7845C31.5598 14.7845 31.1214 15.2212 31.1214 15.7202V25.3894H20.351C19.2865 25.3894 18.222 25.7637 17.408 26.3875V15.7202C17.408 15.2212 16.9696 14.7845 16.4687 14.7845C15.9677 14.7845 15.5294 15.2212 15.5294 15.7202V26.3875C14.7154 25.7637 13.6509 25.3894 12.5863 25.3894H1.87856V6.55009H12.5863C13.0247 6.55009 13.463 6.67486 13.8387 6.862C14.277 7.11153 14.8406 6.92439 15.0911 6.42533C15.2163 6.1758 15.2163 5.92628 15.1537 5.73913C15.0911 5.4896 14.9032 5.30246 14.6528 5.17769C13.9639 4.86578 13.2751 4.67864 12.5237 4.67864H0.939279C0.43833 4.67864 0 5.11531 0 5.61437V32.0643C0 32.5633 0.43833 33 0.939279 33H32.0607C32.5617 33 33 32.5633 33 32.0643V15.7202C33 15.2212 32.5617 14.7845 32.0607 14.7845ZM1.87856 31.1285V27.1985H12.5863C14.2144 27.1985 15.5294 28.5085 15.5294 30.1304C15.5294 30.6295 15.9677 31.0662 16.4687 31.0662C16.9696 31.0662 17.408 30.6295 17.408 30.1304C17.408 28.5085 18.723 27.1985 20.351 27.1985H31.0588V31.1285H1.87856Z"
            fill={color}
          />
        </>
      );
    case 'downloadSquare':
      return (
        <>
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.457 6.29536H22.8305V8.30462C22.8305 8.90739 22.228 9.51017 21.6256 9.51017H10.3743C9.7719 9.51017 9.16949 8.90739 9.16949 8.30462V6.29536H2.54295V26.5889H29.457V6.29536ZM11.5791 7.29998H20.4208V2.47776H11.5791V7.29998ZM31.8666 5.0898V27.7944C31.8666 28.3972 31.2642 29 30.6618 29H1.33813C0.735713 29 0.133301 28.3972 0.133301 27.7944V5.0898C0.133301 4.48702 0.735713 3.88424 1.33813 3.88424H9.16949V1.27221C9.16949 0.669429 9.5711 0.0666504 10.3743 0.0666504H21.6256C22.228 0.0666504 22.8305 0.669429 22.8305 1.27221V4.08517H30.6618C31.2642 3.88424 31.8666 4.48702 31.8666 5.0898Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.342 11.5948C16.9636 11.5948 17.4676 12.1008 17.4676 12.725V21.7667C17.4676 22.3909 16.9636 22.8969 16.342 22.8969C15.7203 22.8969 15.2164 22.3909 15.2164 21.7667V12.725C15.2164 12.1008 15.7203 11.5948 16.342 11.5948Z"
            fill={color}
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1431 15.5425C9.70357 15.9839 9.70361 16.6996 10.1432 17.1409L15.5466 22.5659C15.9862 23.0073 16.6989 23.0072 17.1385 22.5658L22.5408 17.1408C22.9804 16.6994 22.9804 15.9838 22.5408 15.5425C22.1012 15.1011 21.3885 15.1012 20.9489 15.5425L16.3424 20.1683L11.735 15.5425C11.2954 15.1011 10.5827 15.1012 10.1431 15.5425Z"
            fill={color}
          />
        </>
      );
    case 'logoRhDigitalSmall':
      return (
        <>
          <path
            d="M70.0454 47.8281H8.00916V61.5385H70.0454V47.8281Z"
            fill="white"
          />
          <path
            d="M8.00916 7.91855H24.344C28.8689 7.91855 32.3531 9.14027 34.7512 11.5837C36.7874 13.6199 37.8282 16.3801 37.8282 19.819V19.9095C37.8282 22.8054 37.1042 25.2036 35.7015 27.0136C34.2988 28.8235 32.4435 30.181 30.1811 31.0407L38.9141 43.8914H29.6834L22.0363 32.3529H15.8372V43.8461H8.00916V7.91855ZM23.801 25.3394C25.7467 25.3394 27.2399 24.8869 28.2807 23.9819C29.3214 23.0769 29.8191 21.8552 29.8191 20.3167V20.2262C29.8191 18.5068 29.2761 17.2398 28.1902 16.3801C27.1042 15.5204 25.5657 15.1131 23.6653 15.1131H15.8372V25.3394H23.801Z"
            fill="#63CDF6"
          />
          <path
            d="M39.8191 7.91855H47.6924V22.1267H62.172V7.91855H70.0453V43.8462H62.172V29.4118H47.6924V43.8462H39.8191V7.91855Z"
            fill="#63CDF6"
          />
          <path
            d="M11.267 50.6787H13.8462C14.4796 50.6787 15.0226 50.7692 15.5204 50.9955C16.0181 51.2217 16.4706 51.4932 16.8326 51.8552C17.1946 52.2172 17.5113 52.6244 17.6923 53.1222C17.8733 53.6199 18.009 54.1177 18.009 54.6606V54.7059C18.009 55.2489 17.9185 55.7919 17.6923 56.2444C17.5113 56.7421 17.1946 57.1493 16.8326 57.5113C16.4706 57.8733 16.0181 58.1448 15.5204 58.371C15.0226 58.5973 14.4344 58.6878 13.8462 58.6878H11.267V50.6787ZM11.6742 51.0407V58.2806H13.8914C14.4344 58.2806 14.9774 58.1901 15.4299 58.0091C15.8823 57.8281 16.2896 57.5566 16.6516 57.2398C16.9683 56.9231 17.2398 56.5158 17.4208 56.1086C17.6018 55.6561 17.6923 55.2036 17.6923 54.7059V54.6606C17.6923 54.1629 17.6018 53.7104 17.4208 53.2579C17.2398 52.8054 16.9683 52.4434 16.6516 52.1267C16.3348 51.81 15.9276 51.5385 15.4751 51.3575C15.0226 51.1765 14.4796 51.086 13.9366 51.086H11.6742V51.0407Z"
            fill="#0166B3"
          />
          <path
            d="M22.0361 50.6787H22.3981V58.6425H22.0361V50.6787Z"
            fill="#0166B3"
          />
          <path
            d="M30.3167 58.7783C29.6832 58.7783 29.1402 58.6878 28.6424 58.4615C28.1447 58.2353 27.7375 57.9638 27.4207 57.5566C27.104 57.1946 26.8325 56.7421 26.6515 56.2443C26.4705 55.7466 26.38 55.2036 26.38 54.6606V54.6154C26.38 54.0724 26.4705 53.5747 26.6515 53.0769C26.8325 52.5792 27.104 52.1267 27.4207 51.7647C27.7375 51.4027 28.19 51.086 28.6424 50.8597C29.1402 50.6335 29.6832 50.4977 30.2714 50.4977C30.5881 50.4977 30.8596 50.543 31.1311 50.5882C31.4026 50.6335 31.6289 50.6787 31.8551 50.7692C32.0814 50.8597 32.3076 50.9502 32.4886 51.086C32.6696 51.2217 32.8958 51.3575 33.0768 51.5385L32.8506 51.8552C32.6696 51.7195 32.4886 51.5837 32.3076 51.448C32.1266 51.3122 31.9456 51.2217 31.7194 51.1312C31.4931 51.0407 31.3121 50.9955 31.0406 50.9502C30.8144 50.905 30.5429 50.8597 30.2262 50.8597C29.6832 50.8597 29.2307 50.9502 28.7782 51.1765C28.371 51.4027 27.9637 51.6742 27.6922 51.991C27.3755 52.3529 27.1492 52.7149 26.9682 53.1674C26.7872 53.6199 26.742 54.0724 26.742 54.5701V54.6154C26.742 55.1131 26.8325 55.6109 26.9682 56.0633C27.1492 56.5158 27.3755 56.9231 27.647 57.2398C27.9637 57.6018 28.3257 57.8281 28.7782 58.0543C29.2307 58.2353 29.7284 58.371 30.2714 58.371C30.5429 58.371 30.8144 58.3258 31.0859 58.2805C31.3574 58.2353 31.5836 58.1448 31.8099 58.0543C32.0361 57.9638 32.2624 57.8733 32.4433 57.7376C32.6243 57.6018 32.8053 57.4661 32.9863 57.3756V54.9321H30.1809V54.5701H33.3936V57.5113C33.0316 57.8733 32.5791 58.1448 32.0361 58.371C31.5384 58.6425 30.9501 58.7783 30.3167 58.7783Z"
            fill="#0166B3"
          />
          <path
            d="M37.7375 50.6787H38.0995V58.6425H37.7375V50.6787Z"
            fill="#0166B3"
          />
          <path
            d="M44.9773 51.0407H42.1719V50.6787H48.19V51.0407H45.3845V58.6425H45.0226V51.0407H44.9773Z"
            fill="#0166B3"
          />
          <path
            d="M53.8009 50.6335H54.1629L57.9186 58.6425H57.4661L56.3801 56.3348H51.4932L50.4072 58.6425H50L53.8009 50.6335ZM56.2443 55.9728L53.9819 51.086L51.7195 55.9728H56.2443Z"
            fill="#0166B3"
          />
          <path
            d="M61.629 50.6787H61.991V58.2806H66.7421V58.6425H61.5837V50.6787H61.629Z"
            fill="#0166B3"
          />
          <path
            d="M10.0905 0H5.02263H4.88688H0V10.0452H5.02263V5.02262H10.0905V0Z"
            fill="white"
          />
        </>
      );
    case 'logoRhDigitalDefault':
      return (
        <>
          <path d="M207 7.07593H66.0076V38.0001H207V7.07593Z" fill="#0166B3" />
          <path
            d="M6.86475 6.81396H21.1224C25.0829 6.81396 27.9872 7.86224 30.0994 9.95879C31.9477 11.7933 32.7397 14.1519 32.7397 17.0347C32.7397 19.6553 32.2117 21.4898 30.8915 23.0622C29.5714 24.6347 27.9872 25.6829 26.139 26.4691L33.7959 37.476H25.875L19.2742 27.5174H13.9936V37.476H6.86475V6.81396ZM20.5943 21.7519C22.1785 21.7519 23.4987 21.2278 24.5548 20.4416C25.3469 19.6553 25.875 18.6071 25.875 17.2967C25.875 15.7243 25.3469 14.676 24.5548 13.8898C23.4987 13.3657 22.1785 12.8416 20.5943 12.8416H13.7295V21.7519H20.5943Z"
            fill="#63CDF6"
          />
          <path
            d="M34.324 6.81396H41.1888V19.1312H53.8622V6.81396H60.727V37.7381H53.8622V25.1588H41.1888V37.476H34.324V6.81396Z"
            fill="#63CDF6"
          />
          <path
            d="M73.4005 13.3657H79.2092C80.5293 13.3657 81.8495 13.6278 83.1696 14.1519C84.2258 14.6761 85.2819 15.2002 86.074 15.9864C86.8661 16.7726 87.6582 17.8209 87.9222 18.8692C88.4503 19.9174 88.7143 21.2278 88.7143 22.2761C88.7143 23.5864 88.4503 24.6347 87.9222 25.683C87.3941 26.7312 86.8661 27.7795 86.074 28.5657C85.2819 29.3519 84.2258 29.8761 83.1696 30.4002C82.1135 31.1864 80.7934 31.4485 79.2092 31.4485H73.4005V13.3657ZM74.4566 14.1519V30.4002H79.4732C80.7934 30.4002 81.8495 30.1381 82.9056 29.8761C83.9617 29.3519 84.7538 28.8278 85.5459 28.0416C86.338 27.2554 86.8661 26.4692 87.3941 25.4209C87.9222 24.3726 87.9222 23.3243 87.9222 22.2761C87.9222 21.2278 87.6582 20.1795 87.3941 19.1312C86.8661 18.083 86.338 17.2968 85.5459 16.5106C84.7538 15.7243 83.9617 15.2002 82.9056 14.6761C81.8495 14.1519 80.7934 14.1519 79.4732 14.1519H74.4566Z"
            fill="white"
          />
          <path
            d="M97.9554 13.3657H98.7475V31.4485H97.9554V13.3657Z"
            fill="white"
          />
          <path
            d="M116.702 31.7104C115.381 31.7104 114.061 31.4483 113.005 30.9242C111.949 30.4001 110.893 29.8759 110.101 28.8277C109.309 28.0414 108.781 26.9932 108.253 25.9449C107.724 24.8966 107.724 23.5863 107.724 22.2759C107.724 20.9656 107.989 19.9173 108.253 18.869C108.781 17.8208 109.309 16.7725 110.101 15.9863C110.893 15.2001 111.685 14.4139 113.005 13.8897C114.061 13.3656 115.381 13.1035 116.702 13.1035C117.494 13.1035 118.022 13.1035 118.55 13.3656C119.078 13.3656 119.606 13.6277 120.134 13.8897C120.662 14.1518 121.19 14.4139 121.454 14.6759C121.982 14.938 122.246 15.2001 122.774 15.7242L122.246 16.5104C121.982 16.2483 121.454 15.9863 120.926 15.7242C120.398 15.4621 120.134 15.2001 119.606 14.938C119.078 14.6759 118.55 14.6759 118.022 14.4139C117.494 14.4139 116.966 14.1518 116.173 14.1518C114.853 14.1518 113.797 14.4139 113.005 14.938C112.477 15.2001 111.421 15.7242 110.893 16.5104C110.101 17.2966 109.573 18.0828 109.309 19.1311C109.045 20.1794 108.781 21.2277 108.781 22.2759C108.781 23.3242 109.045 24.6346 109.309 25.4208C109.573 26.469 110.101 27.2552 110.893 28.0414C111.685 28.8277 112.477 29.3518 113.533 29.8759C114.589 30.4001 115.645 30.6621 116.966 30.6621C117.494 30.6621 118.286 30.6621 118.814 30.4001C119.342 30.4001 119.87 30.138 120.398 29.8759C120.926 29.6139 121.454 29.3518 121.718 29.0897C121.982 28.8277 122.51 28.5656 123.038 28.3035V23.0621H116.702V22.2759H123.83V28.8277C123.038 29.6139 121.982 30.138 120.662 30.6621C119.606 31.4483 118.286 31.7104 116.702 31.7104Z"
            fill="white"
          />
          <path
            d="M133.6 13.3657H134.392V31.4485H133.6V13.3657Z"
            fill="white"
          />
          <path
            d="M149.969 14.1519H143.633V13.3657H157.362V14.1519H151.025V31.4485H150.233V14.1519H149.969Z"
            fill="white"
          />
          <path
            d="M170.036 13.3657H170.828L179.541 31.4485H178.485L176.108 26.2071H165.019L162.643 31.4485H161.851L170.036 13.3657ZM175.58 25.4209L170.3 14.414L165.019 25.4209H175.58Z"
            fill="white"
          />
          <path
            d="M187.99 13.3657H188.782V30.4002H199.607V31.4485H187.99V13.3657Z"
            fill="white"
          />
          <path
            d="M8.71301 0H4.22449H0V8.64828H4.22449V4.1931H8.71301V0Z"
            fill="#0166B3"
          />
        </>
      );
    case 'shareiOS':
      return (
        <>
          <g clipPath="url(#clip0)">
            <path
              d="M13.5 5H12V6.00001H13V15H3.00001V6.00001H4.00002V5H2.50001C2.22363 5 2 5.22363 2 5.50001V15.5C2 15.7764 2.22363 16 2.50001 16H13.5C13.7764 16 14 15.7764 14 15.5V5.50001C14 5.22363 13.7764 5 13.5 5Z"
              fill="#004186"
            />
            <path
              d="M7.5 1.91406V9.00001H8.50001V1.91406L10.6465 4.06054L11.3535 3.35352L8 0L4.64648 3.35352L5.35351 4.06054L7.5 1.91406Z"
              fill="#004186"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </>
      );
    case 'file':
      return (
        <>
          <path
            {...props}
            d="M14.7675 1H1V14.7346"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <path
            {...props}
            d="M186 14.7346L186 1L172.233 1"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <path
            {...props}
            d="M172.233 98L186 98L186 84.2654"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <path
            {...props}
            d="M1 84.2654L1 98L14.7675 98"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <rect
            x="26.334"
            y="13.1535"
            width="135.04"
            height="71.6219"
            fill="#75BFBA"
          />
          <path
            {...props}
            d="M40.1006 26.888H73.6587"
            stroke="#628D8A"
            strokeWidth="3.14773"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M40.1006 38.0473H67.6355"
            stroke="#628D8A"
            strokeWidth="3.14773"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M40.1006 49.2066H67.6355"
            stroke="#628D8A"
            strokeWidth="3.14773"
            strokeLinecap="round"
          />
          <path
            {...props}
            d="M150.24 26.888L150.24 74.9588"
            stroke="#628D8A"
            strokeWidth="3.14773"
            strokeLinecap="round"
          />
        </>
      );
    case 'doc':
      return (
        <>
          <path
            {...props}
            d="M14.7675 1H1V14.7346"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <path
            {...props}
            d="M186 14.7346L186 1L172.233 0.999999"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <path
            {...props}
            d="M172.233 98L186 98L186 84.2654"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <path
            {...props}
            d="M0.999999 84.2654L1 98L14.7675 98"
            stroke="#BDBDBD"
            strokeWidth="0.627907"
          />
          <rect
            x="26.3359"
            y="13.1523"
            width="135.04"
            height="71.6219"
            fill="#E0E0E0"
          />
          <path
            {...props}
            d="M95.0625 47.2812V49.5931L102.878 52.5734C104.72 53.2219 105.937 54.843 105.937 56.6512V62.375"
            stroke="#4F4F4F"
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M80.0625 62.375V56.6636C80.0625 54.8492 81.2276 53.2219 82.9946 52.5797L90.4187 49.6367V46.8371L90.1404 46.6501C88.7423 45.7522 87.8297 44.2246 87.8297 42.4913V38.6131C87.8297 35.8572 90.1469 33.625 93.0078 33.625C95.8687 33.625 98.1859 35.8572 98.1859 38.6131V42.4913C98.1859 44.6875 96.7143 46.5512 94.6686 47.2175"
            stroke="#4F4F4F"
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'wifiConnection':
      return (
        <>
          <path
            {...props}
            d="M36.0099 45.308C36.0099 47.416 34.2036 49.116 31.9639 49.116C29.7241 49.116 27.9179 47.416 27.9179 45.308C27.9179 43.2 29.7241 41.5 31.9639 41.5C34.2036 41.432 36.0099 43.2 36.0099 45.308Z"
            stroke={color}
            strokeWidth="2.5"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M45.1133 35.584C42.0788 31.912 37.3104 29.532 31.9639 29.532C26.6174 29.532 21.9212 31.844 18.8867 35.516"
            stroke={color}
            strokeWidth="2.5"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M22.7882 40.4799C24.5944 37.4199 27.9902 35.3799 31.9639 35.3799C35.9376 35.3799 39.4056 37.4879 41.2119 40.5479"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M14.8407 30.4158C19.1034 26.0638 25.1724 23.3438 31.9638 23.3438C38.7553 23.3438 44.8965 26.1318 49.1592 30.4838"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M53.3498 25.2479C47.8588 20.0799 40.3448 16.8159 31.9639 16.8159C23.6552 16.8159 16.069 20.0119 10.6503 25.1119"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        </>
      );
    case 'hour':
      return (
        <>
          <path
            {...props}
            d="M12.1875 32C12.1875 20.9543 21.2817 12 32.5 12C43.7183 12 52.8125 20.9543 52.8125 32C52.8125 43.0457 43.7183 52 32.5 52C21.2817 52 12.1875 43.0457 12.1875 32Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.5 32L32.4943 21.9944"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32.5 32.2471L41.1225 32.2425"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'secure':
      return (
        <>
          <path
            {...props}
            d="M32 52.0002C38.6274 52.0002 44 46.5497 44 39.8263C44 33.1028 38.6274 27.6523 32 27.6523C25.3726 27.6523 20 33.1028 20 39.8263C20 46.5497 25.3726 52.0002 32 52.0002Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M23.4277 31.3217V20.6957C23.4277 15.8957 27.2677 12 31.9992 12C34.3649 12 36.5077 12.9739 38.0677 14.5391C39.6106 16.1217 40.5706 18.2957 40.5706 20.6957V31.3217"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M32 41.5654V45.0437"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            {...props}
            d="M31.9992 40.6959C33.4193 40.6959 34.5706 39.528 34.5706 38.0872C34.5706 36.6465 33.4193 35.4785 31.9992 35.4785C30.579 35.4785 29.4277 36.6465 29.4277 38.0872C29.4277 39.528 30.579 40.6959 31.9992 40.6959Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'photoDoc':
      return (
        <>
          <rect
            x="0.662109"
            y="10.5225"
            width="133.076"
            height="71.5823"
            fill="#75BFBA"
          />
          <rect
            x="0.662109"
            y="10.5225"
            width="133.076"
            height="10.226"
            fill="#628D8A"
          />
          <mask
            id="mask0_3826_711"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="92"
            y="27"
            width="36"
            height="52"
          >
            <rect
              x="92.2598"
              y="27.7836"
              width="35.7163"
              height="50.8506"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_3826_711)">
            <rect
              width="36"
              height="51"
              transform="translate(93 27.3367)"
              fill="white"
            />
            <path
              {...props}
              opacity="0.3"
              d="M137.477 111.513C137.477 111.513 135.857 112.391 133.102 112.891C130.362 113.39 128.606 113.269 128.606 113.269L128.107 124.38H88.1601L88.4023 115.646C88.4023 115.646 83.1648 114.526 79.5319 113.027C75.9142 111.529 71.918 108.789 71.918 108.789C71.918 108.789 79.2897 88.3234 84.9056 80.6943C90.2944 73.3831 98.9528 69.2507 102.283 66.9498C106.854 69.1296 110.533 73.0955 111.865 75.1995C113.363 77.5761 115.604 82.4351 115.604 82.4351C115.604 82.4351 118.222 78.6962 119.342 73.8221C119.766 71.9905 120.009 70.5525 120.16 69.4626C122.446 72.2478 128.349 78.4389 130.953 84.5543C134.222 92.1682 137.477 111.513 137.477 111.513Z"
              fill="url(#paint0_angular_3826_711)"
              strokeWidth={strokeWidth}
            />
            <path
              {...props}
              d="M119.257 68.0698C119.287 68.2969 119.62 68.7661 120.195 69.4624C120.059 70.5523 119.802 71.9903 119.378 73.8219C118.258 78.6961 115.639 82.4349 115.639 82.4349C115.639 82.4349 113.399 77.5608 111.9 75.1994C110.568 73.0953 106.89 69.1143 102.318 66.9497C102.455 66.8589 102.591 66.768 102.712 66.6772C105.709 64.4369 105.785 57.4436 105.951 52.9479L120.513 55.7331C120.498 55.7028 119.136 66.9497 119.257 68.0698Z"
              fill="url(#paint1_linear_3826_711)"
              strokeWidth={strokeWidth}
            />
            <path
              {...props}
              d="M121.967 45.2745C121.967 45.2745 124.221 44.7008 124.334 47.6822C124.457 50.6636 121.711 50.264 121.711 50.264L121.967 45.2745Z"
              fill="#78CAEC"
              strokeWidth={strokeWidth}
            />
            <path
              {...props}
              d="M105.15 45.2745C105.15 45.2745 102.896 44.7008 102.783 47.6822C102.66 50.6636 105.406 50.264 105.406 50.264L105.15 45.2745Z"
              fill="#78CAEC"
              strokeWidth={strokeWidth}
            />
            <path
              {...props}
              d="M105.055 46.4692C104.267 43.0633 104.177 39.8542 105.055 37.8107C105.933 35.7672 108.248 33.7389 109.626 32.9063C111.624 31.6953 115.741 31.877 117.073 32.4976C118.617 33.2091 121.569 35.4948 122.069 37.1144C122.568 38.7341 122.78 40.8987 122.689 42.3973C122.614 43.8958 122.311 45.1371 122.311 45.1371L105.055 46.4692Z"
              fill="#004186"
              strokeWidth={strokeWidth}
            />
            <path
              {...props}
              d="M109.758 33.9055C109.758 33.9055 111.877 34.9803 113.633 34.8137C115.374 34.6472 116.797 33.6482 116.797 33.6482C116.797 33.6482 120.081 34.8592 121.08 37.266C122.08 39.6728 122.034 41.0048 121.989 42.2158C121.943 43.4268 122.322 45.1221 122.322 45.1221C122.322 45.1221 122.246 53.1145 121.444 55.0218C120.657 56.929 117.569 59.8959 116.782 60.5165C115.994 61.1372 113.542 61.0615 112.074 60.8041C110.621 60.5619 106.625 57.2621 105.913 54.9764C105.202 52.6907 105.035 46.439 105.035 46.439C105.035 46.439 105.535 45.6065 105.58 43.6084C105.626 41.6103 105.292 40.4902 105.701 38.8705C106.14 37.2811 108.184 34.617 109.758 33.9055Z"
              fill="#91D8F6"
              strokeWidth={strokeWidth}
            />
          </g>
          <path
            d="M14.0176 42.6953H74.991"
            stroke="#628D8A"
            strokeWidth="6.73377"
            strokeLinecap="round"
          />
          <path
            d="M14.0176 54.6008H59.7476"
            stroke="#628D8A"
            strokeWidth="6.73377"
            strokeLinecap="round"
          />
          <defs>
            <radialGradient
              id="paint0_angular_3826_711"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(104.697 95.6649) rotate(90) scale(28.7151 41.3724)"
            >
              <stop offset="0.447917" stopColor="#004186" />
              <stop offset="0.703125" stopColor="#004186" />
            </radialGradient>
            <linearGradient
              id="paint1_linear_3826_711"
              x1="111.416"
              y1="55.4749"
              x2="111.416"
              y2="69.8031"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#49B5E2" />
              <stop offset="1" stopColor="#91D8F6" />
            </linearGradient>
          </defs>
        </>
      );
    case 'photoDocSmall':
      return (
        <>
          <defs>
            <radialGradient
              id="d"
              cx="-881.03"
              cy="597.44"
              fx="-881.03"
              fy="597.44"
              r="1"
              gradientTransform="translate(-42721.56 43852.54) rotate(90) scale(49.64 -71.6)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".45" stopColor="#004186" />
              <stop offset=".7" stopColor="#004186" />
            </radialGradient>
            <radialGradient id="e" r="1" />
            <linearGradient
              id="f"
              x1="65.93"
              y1="39.48"
              x2="65.93"
              y2="14.71"
              gradientTransform="translate(0 90) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#49b5e2" />
              <stop offset="1" stopColor="#91d8f6" />
            </linearGradient>
            <radialGradient id="g" r="1" />
            <linearGradient id="h" x1="79.59" x2="79.59" />
          </defs>
          <g id="c">
            <rect width="136" height="89" style={{ fill: 'none' }} />
            <g>
              <path
                d="M66.83,84.61c.6,.95,1.27,2.13,1.94,3.39h.06c-.67-1.26-1.34-2.44-1.95-3.39-2.3-3.64-8.66-10.52-16.56-14.26,.24-.16,.47-.31,.68-.47,4.5-3.36,5.19-12.91,5.48-20.45-.53-1.86-.88-5.01-1.1-7.9-1,.05-4.44-.08-4.26-4.49,.15-3.88,2.39-4.28,3.49-4.24-.93-5.07-.89-9.73,.44-12.83,1.52-3.53,5.52-7.04,7.9-8.48,3.45-2.09,10.57-1.78,12.87-.71,2.67,1.23,7.77,5.18,8.64,7.98,.86,2.8,1.23,6.54,1.07,9.13-.12,2.36-.56,4.34-.64,4.67,0,.03,0,.04,0,.04,0,0,0,.07,0,.19,1.11-.04,3.33,.38,3.48,4.24,.16,3.88-2.49,4.45-3.81,4.49-.22,3.39-.59,6.77-1.18,8.2-.37,.9-1.04,1.94-1.85,2.99-.59,4.82-2.12,17.99-1.95,19.57,.05,.39,.63,1.2,1.62,2.41,0,.02,0,.03,0,.05,2.68,3.21,11.12,7.39,17.79,12.94V7H35V74.38c6.34-1.61,12.29-1.98,15.26-4.03,7.9,3.77,14.26,10.62,16.56,14.26Z"
                style={{ fill: 'none' }}
              />
              <path
                d="M68.77,88c-.67-1.25-1.34-2.44-1.94-3.39-2.3-3.64-8.66-10.49-16.56-14.26-2.97,2.05-8.92,2.42-15.26,4.03v13.62h33.77Z"
                style={{ fill: 'url(#d)', isolation: 'isolate', opacity: 0.3 }}
              />
              <path
                d="M81.21,74.75c-.24,1.88-.68,4.35-1.41,7.48-.47,2.06-1.1,4.01-1.78,5.77h20.98v-.31c-6.67-5.55-15.1-9.74-17.79-12.94Z"
                style={{ fill: 'url(#e)', isolation: 'isolate', opacity: 0.3 }}
              />
              <path
                d="M79.75,82.23c.73-3.17,1.15-5.65,1.41-7.54,.01,.02,.03,.03,.05,.05,0-.02,0-.03,0-.05-.99-1.2-1.57-2.01-1.62-2.41-.17-1.58,1.36-14.74,1.95-19.57-2.14,2.81-5.22,5.73-6.21,6.51-1.36,1.07-5.6,.94-8.14,.5-2.51-.42-9.42-6.12-10.65-10.07-.02-.07-.04-.15-.07-.23-.29,7.54-.98,17.09-5.48,20.45-.21,.16-.44,.31-.68,.47,7.9,3.74,14.26,10.62,16.56,14.26,.6,.95,1.27,2.13,1.95,3.39h9.14c.68-1.76,1.31-3.7,1.78-5.77Z"
                style={{ fill: 'url(#f)' }}
              />
              <path
                d="M81.21,74.75s-.03-.03-.05-.05c-.26,1.88-.68,4.37-1.41,7.54-.47,2.06-1.1,4.01-1.78,5.77h.05c.68-1.76,1.31-3.7,1.78-5.77,.73-3.14,1.17-5.61,1.41-7.48Z"
                style={{ fill: 'url(#g)', isolation: 'isolate', opacity: 0.3 }}
              />
              <path
                d="M81.21,74.75s-.03-.03-.05-.05c-.26,1.88-.68,4.37-1.41,7.54-.47,2.06-1.1,4.01-1.78,5.77h.05c.68-1.76,1.31-3.7,1.78-5.77,.73-3.14,1.17-5.61,1.41-7.48Z"
                style={{ fill: 'url(#h)' }}
              />
              <path
                d="M88.38,37.05c-.15-3.86-2.37-4.27-3.48-4.24-.01,.88-.08,4.8-.33,8.73,1.32-.04,3.97-.61,3.81-4.49Z"
                style={{ fill: '#78caec' }}
              />
              <path
                d="M55.04,34.88c-.16-.69-.3-1.38-.43-2.06-1.1-.04-3.34,.36-3.49,4.24-.18,4.41,3.26,4.54,4.26,4.49-.27-3.51-.35-6.64-.35-6.64,0,0,0-.02,.01-.02Z"
                style={{ fill: '#78caec' }}
              />
              <path
                d="M55.28,34.31c.26-.71,.63-2.09,.68-4.3,.08-3.45-.5-5.39,.21-8.19,.76-2.75,4.29-7.35,7.01-8.58,0,0,3.66,1.86,6.7,1.57,3.01-.29,5.47-2.01,5.47-2.01,0,0,5.68,2.09,7.41,6.25,1.73,4.16,1.65,6.46,1.57,8.56-.07,1.95,.49,4.63,.57,4.98,.08-.33,.52-2.3,.64-4.67,.16-2.59-.21-6.33-1.07-9.13-.86-2.8-5.97-6.75-8.64-7.98-2.3-1.07-9.42-1.39-12.87,.71-2.38,1.44-6.38,4.95-7.9,8.48-1.33,3.1-1.37,7.76-.44,12.83,.36,.01,.6,.07,.6,.07l.07,1.42Z"
                style={{ fill: '#004186' }}
              />
              <path
                d="M55.28,34.31l-.07-1.42s-.24-.06-.6-.07c.12,.68,.27,1.37,.43,2.06,.02-.04,.12-.22,.25-.57Z"
                style={{ fill: '#004186' }}
              />
              <path
                d="M65.24,47.8c-1.22-.73-1.99-1.68-2.03-2.49-.13-2.3,2.88-.97,6.46-.97s6.65-1.36,6.57,.97c-.05,1.44-2.24,3.19-5.21,3.6l10.73,2.05s-.09,.66-.23,1.76c.8-1.05,1.47-2.09,1.85-2.99,.6-1.42,.96-4.81,1.18-8.2-.43,.01-.73-.03-.73-.03l.44-8.62s.25-.06,.62-.07c0-.12,0-.19,0-.19,0,0,0-.02,0-.04,0,.03-.02,.07-.02,.07l-29.57,2.28,.34,6.58s-.11,.01-.28,.02c.22,2.89,.57,6.04,1.1,7.9,.04-1.15,.08-2.25,.12-3.28l8.65,1.65Z"
                style={{ fill: '#91d8f6' }}
              />
              <path
                d="M67.19,59.73c2.54,.44,6.78,.58,8.14-.5,.99-.78,4.08-3.7,6.21-6.51,.13-1.1,.22-1.77,.23-1.76l-10.73-2.05c-.42,.06-.86,.09-1.3,.09-1.75,0-3.32-.5-4.49-1.2l-8.65-1.65c-.04,1.03-.07,2.13-.12,3.28,.02,.08,.04,.15,.07,.23,1.23,3.95,8.14,9.66,10.65,10.07Z"
                style={{ fill: '#91d8f6' }}
              />
              <path
                d="M84.29,32.88l-.44,8.62s.29,.04,.73,.03c.26-3.92,.32-7.84,.33-8.73-.37,.01-.62,.07-.62,.07Z"
                style={{ fill: '#91d8f6' }}
              />
              <path
                d="M55.32,34.93l-.26,.02s0-.05-.02-.07c0,0-.01,.02-.01,.02,0,0,.08,3.13,.35,6.64,.17,0,.28-.02,.28-.02l-.34-6.58Z"
                style={{ fill: '#91d8f6' }}
              />
              <path
                d="M84.33,27.6c.08-2.09,.16-4.4-1.57-8.56-1.73-4.16-7.41-6.25-7.41-6.25,0,0-2.46,1.73-5.47,2.01-3.04,.29-6.7-1.57-6.7-1.57-2.72,1.23-6.25,5.84-7.01,8.58-.71,2.8-.13,4.74-.21,8.19-.05,2.22-.42,3.59-.68,4.3l.03,.62,29.57-2.28s0-.04,.02-.07c-.08-.36-.64-3.03-.57-4.98Z"
                style={{ fill: '#91d8f6' }}
              />
              <path
                d="M55.04,34.88s0,.05,.02,.07l.26-.02-.03-.62c-.13,.35-.23,.53-.25,.57Z"
                style={{ fill: '#91d8f6' }}
              />
              <path
                d="M76.25,45.31c.08-2.33-2.96-.97-6.57-.97s-6.59-1.33-6.46,.97c.04,.82,.81,1.76,2.03,2.49l5.79,1.11c2.97-.41,5.17-2.16,5.21-3.6Z"
                style={{ fill: '#fff' }}
              />
              <path
                d="M69.73,49c.45,0,.88-.03,1.3-.09l-5.79-1.11c1.16,.7,2.74,1.2,4.49,1.2Z"
                style={{ fill: '#fff' }}
              />
            </g>
            <g>
              <path
                d="M43.23,4.59h-8.23V14.78"
                style={{ fill: 'none', stroke: '#bdbdbd' }}
              />
              <path
                d="M99.5,14.78V4.59h-8.23"
                style={{ fill: 'none', stroke: '#bdbdbd' }}
              />
              <path
                d="M91.27,88.59h8.23v-10.19"
                style={{ fill: 'none', stroke: '#bdbdbd' }}
              />
              <path
                d="M35,78.4v10.19h8.23"
                style={{ fill: 'none', stroke: '#bdbdbd' }}
              />
            </g>
          </g>
        </>
      );
    case 'photoSelf':
      return (
        <>
          <mask
            id="mask0_3065_17007"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="4"
            y="0"
            width="124"
            height="89"
          >
            <rect x="4.32617" width="122.746" height="88.6633" fill="#C4C4C4" />
          </mask>
          <g mask="url(#mask0_3065_17007)">
            <path
              opacity="0.3"
              d="M115.522 134.307C115.522 134.307 113.034 135.655 108.803 136.422C104.595 137.19 101.898 137.004 101.898 137.004L101.131 154.068H39.7778L40.1498 140.654C40.1498 140.654 32.1058 138.933 26.5261 136.632C20.9697 134.33 14.832 130.122 14.832 130.122C14.832 130.122 24.3972 90.2506 33.0224 78.5333C41.2989 67.3042 56.354 69.3966 61.4687 65.8628C68.4898 69.2106 74.1392 75.3017 76.1851 78.5333C78.4867 82.1833 81.9275 89.6461 81.9275 89.6461C81.9275 89.6461 85.9495 83.9037 87.6699 76.4177C88.3209 73.6046 88.6929 71.396 88.9254 69.7221C92.4359 73.9998 107.65 80.2537 111.648 89.6461C116.67 101.34 115.522 134.307 115.522 134.307Z"
              fill="url(#paint0_angular_3065_17007)"
            />
            <path
              d="M87.5308 67.5835C87.5773 67.9322 88.0888 68.653 88.9722 69.7224C88.763 71.3963 88.3678 73.6049 87.7168 76.418C85.9964 83.904 81.9744 89.6465 81.9744 89.6465C81.9744 89.6465 78.5336 82.1604 76.232 78.5336C74.1861 75.3021 68.5367 69.1877 61.5156 65.8631C61.7249 65.7236 61.9341 65.5841 62.1201 65.4446C66.7233 62.0038 66.8396 51.263 67.0953 44.3582L89.4605 48.6359C89.4372 48.5894 87.3448 65.8631 87.5308 67.5835Z"
              fill="url(#paint1_linear_3065_17007)"
            />
            <path
              d="M91.7 32.5729C91.7 32.5729 95.1618 31.6918 95.3349 36.2708C95.5237 40.8498 91.3066 40.2361 91.3066 40.2361L91.7 32.5729Z"
              fill="#78CAEC"
            />
            <path
              d="M65.8637 32.5729C65.8637 32.5729 62.4019 31.6918 62.2288 36.2708C62.04 40.8498 66.2571 40.2361 66.2571 40.2361L65.8637 32.5729Z"
              fill="#78CAEC"
            />
            <path
              d="M65.7234 34.4075C64.5145 29.1765 64.375 24.2478 65.7234 21.1093C67.0718 17.9707 70.6288 14.8554 72.7445 13.5767C75.8133 11.7168 82.1369 11.9958 84.1828 12.949C86.5541 14.0417 91.0876 17.5522 91.8548 20.0398C92.622 22.5274 92.9475 25.852 92.808 28.1536C92.6918 30.4552 92.2268 32.3616 92.2268 32.3616L65.7234 34.4075Z"
              fill="#004186"
            />
            <path
              d="M72.9528 15.1113C72.9528 15.1113 76.2076 16.7619 78.9044 16.5062C81.578 16.2505 83.7634 14.7161 83.7634 14.7161C83.7634 14.7161 88.8083 16.576 90.3427 20.2725C91.8772 23.969 91.8074 26.0149 91.7377 27.8748C91.6679 29.7347 92.2491 32.3385 92.2491 32.3385C92.2491 32.3385 92.1329 44.6138 90.9007 47.5431C89.6918 50.4724 84.9491 55.0292 83.7401 55.9824C82.5312 56.9355 78.7649 56.8193 76.5098 56.4241C74.278 56.0521 68.1403 50.9839 67.0476 47.4734C65.955 43.9628 65.6992 34.3611 65.6992 34.3611C65.6992 34.3611 66.4664 33.0825 66.5362 30.0137C66.6059 26.9448 66.0944 25.2244 66.7222 22.7368C67.3964 20.2957 70.5349 16.204 72.9528 15.1113Z"
              fill="#91D8F6"
            />
            <path
              d="M84.5541 43.6138C84.5076 45.0785 81.9735 46.8919 78.7652 46.8919C75.5802 46.8919 73.0461 45.032 72.9763 43.6138C72.8601 41.5679 75.5337 42.7536 78.7187 42.7536C81.927 42.7536 84.6239 41.5447 84.5541 43.6138Z"
              fill="white"
            />
            <path
              d="M27.3991 88.5627C27.3991 80.3456 28.368 74.1987 27.3991 71.7968L19.3729 69.1684L43.8407 67.901C46.0357 74.3687 51.3924 79.7876 54.5517 88.5627L27.3991 88.5627Z"
              fill="url(#paint2_angular_3065_17007)"
            />
            <path
              d="M27.3991 88.5627C27.3991 80.3456 28.368 74.1987 27.3991 71.7968L19.3729 69.1684L43.8407 67.901C46.0357 74.3687 51.3924 79.7876 54.5517 88.5627L27.3991 88.5627Z"
              fill="#F2F2F2"
              fillOpacity="0.54"
            />
            <ellipse
              cx="36.9746"
              cy="69.9053"
              rx="9.5351"
              ry="7.09739"
              fill="#91D8F6"
            />
            <rect
              x="14.0957"
              y="50.5131"
              width="39.839"
              height="21.1802"
              fill="#75BFBA"
            />
            <rect
              x="14.0957"
              y="50.5131"
              width="39.839"
              height="3.02575"
              fill="#628D8A"
            />
            <mask
              id="mask1_3065_17007"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="33"
              y="54"
              width="24"
              height="18"
            >
              <rect
                x="33.2246"
                y="54.5479"
                width="23.7369"
                height="17.1459"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#mask1_3065_17007)">
              <path
                d="M54.7275 80.5203C54.7275 80.5203 54.2464 80.781 53.4282 80.9294C52.6144 81.0778 52.0929 81.0418 52.0929 81.0418L51.9445 84.3418H40.0799L40.1519 81.7476C40.1519 81.7476 38.5963 81.415 37.5173 80.9699C36.4428 80.5248 35.2559 79.711 35.2559 79.711C35.2559 79.711 37.4454 73.6326 39.1133 71.3667C40.7139 69.1952 43.2855 67.9678 44.2746 67.2844C45.6323 67.9318 46.7248 69.1097 47.1205 69.7347C47.5656 70.4405 48.231 71.8837 48.231 71.8837C48.231 71.8837 49.0087 70.7732 49.3414 69.3256C49.4673 68.7816 49.5393 68.3544 49.5842 68.0307C50.2631 68.858 52.0165 70.6968 52.7898 72.5131C53.7609 74.7745 54.7275 80.5203 54.7275 80.5203Z"
                fill="#004186"
              />
              <path
                d="M49.316 67.6171C49.325 67.6845 49.4239 67.8239 49.5948 68.0307C49.5543 68.3544 49.4779 68.7815 49.352 69.3255C49.0193 70.7732 48.2415 71.8837 48.2415 71.8837C48.2415 71.8837 47.5761 70.436 47.131 69.7347C46.7354 69.1097 45.6429 67.9273 44.2852 67.2844C44.3256 67.2574 44.3661 67.2305 44.402 67.2035C45.2922 66.5381 45.3147 64.461 45.3642 63.1257L49.6892 63.953C49.6847 63.944 49.2801 67.2844 49.316 67.6171Z"
                fill="url(#paint3_linear_3065_17007)"
              />
              <path
                d="M50.121 60.8467C50.121 60.8467 50.7904 60.6763 50.8239 61.5618C50.8604 62.4473 50.0449 62.3286 50.0449 62.3286L50.121 60.8467Z"
                fill="#004186"
              />
              <path
                d="M45.126 60.8467C45.126 60.8467 44.4565 60.6763 44.4231 61.5618C44.3866 62.4473 45.2021 62.3286 45.2021 62.3286L45.126 60.8467Z"
                fill="#004186"
              />
              <path
                d="M45.0977 61.2015C44.8639 60.1899 44.8369 59.2368 45.0977 58.6299C45.3585 58.0229 46.0463 57.4205 46.4555 57.1732C47.0489 56.8135 48.2718 56.8675 48.6674 57.0518C49.126 57.2631 50.0027 57.942 50.1511 58.4231C50.2994 58.9041 50.3624 59.547 50.3354 59.9921C50.3129 60.4372 50.223 60.8059 50.223 60.8059L45.0977 61.2015Z"
                fill="#004186"
              />
              <path
                d="M46.4945 57.47C46.4945 57.47 47.1239 57.7892 47.6455 57.7397C48.1625 57.6903 48.5851 57.3936 48.5851 57.3936C48.5851 57.3936 49.5607 57.7532 49.8574 58.4681C50.1542 59.1829 50.1407 59.5785 50.1272 59.9382C50.1137 60.2979 50.2261 60.8014 50.2261 60.8014C50.2261 60.8014 50.2036 63.1752 49.9653 63.7417C49.7315 64.3082 48.8144 65.1894 48.5806 65.3737C48.3468 65.5581 47.6185 65.5356 47.1824 65.4592C46.7508 65.3872 45.5639 64.4071 45.3526 63.7282C45.1413 63.0494 45.0918 61.1926 45.0918 61.1926C45.0918 61.1926 45.2402 60.9453 45.2536 60.3518C45.2671 59.7584 45.1682 59.4257 45.2896 58.9446C45.42 58.4726 46.0269 57.6813 46.4945 57.47Z"
                fill="#91D8F6"
              />
            </g>
            <rect
              x="20.7969"
              y="44.9302"
              width="6.26857"
              height="7.09621"
              rx="3.13429"
              fill="#91D8F6"
            />
            <rect
              x="26.3164"
              y="43.3271"
              width="6.26857"
              height="8.69859"
              rx="3.13429"
              fill="#91D8F6"
            />
            <rect
              x="31.8379"
              y="43.3271"
              width="6.26857"
              height="8.69859"
              rx="3.13429"
              fill="#91D8F6"
            />
            <rect
              x="37.3164"
              y="43.3271"
              width="6.26857"
              height="8.69859"
              rx="3.13429"
              fill="#91D8F6"
            />
          </g>
          <path d="M11.1806 10.7162H1V20.8967" stroke="#BDBDBD" />
          <path
            d="M137.801 20.8967L137.801 10.7162L127.62 10.7162"
            stroke="#BDBDBD"
          />
          <path
            d="M127.62 82.6158L137.801 82.6158L137.801 72.4353"
            stroke="#BDBDBD"
          />
          <path d="M1 72.4354L1 82.616L11.1806 82.616" stroke="#BDBDBD" />
          <defs>
            <radialGradient
              id="paint0_angular_3065_17007"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(65.2334 109.965) rotate(90) scale(44.1026 63.614)"
            >
              <stop offset="0.447917" stopColor="#004186" />
              <stop offset="0.703125" stopColor="#004186" />
            </radialGradient>
            <linearGradient
              id="paint1_linear_3065_17007"
              x1="75.488"
              y1="48.2393"
              x2="75.488"
              y2="70.2455"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#49B5E2" />
              <stop offset="1" stopColor="#91D8F6" />
            </linearGradient>
            <radialGradient
              id="paint2_angular_3065_17007"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(37.0313 78.4937) rotate(-162.16) scale(10.2678 16.7914)"
            >
              <stop offset="0.0882496" stopColor="#004186" stopOpacity="0.19" />
              <stop offset="0.458333" stopColor="#004186" stopOpacity="0.19" />
              <stop offset="0.962556" stopColor="#004186" stopOpacity="0.77" />
            </radialGradient>
            <linearGradient
              id="paint3_linear_3065_17007"
              x1="46.9872"
              y1="63.8763"
              x2="46.9872"
              y2="68.1319"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#49B5E2" />
              <stop offset="1" stopColor="#91D8F6" />
            </linearGradient>
          </defs>
        </>
      );
    case 'iconPortalToKnow':
      return (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M 14.3757 0.950713 C 14.4734 0.92276 14.5771 0.922678 14.6749 0.950474 L 28.0444 4.74961 C 28.2791 4.8163 28.441 5.03066 28.441 5.27465 V 13.7234 C 28.441 14.0248 28.1966 14.2692 27.8952 14.2692 C 27.5937 14.2692 27.3493 14.0248 27.3493 13.7234 V 6.07237 L 14.6941 10.1765 C 14.5844 10.2121 14.4663 10.212 14.3566 10.1763 L 0.980907 5.81845 C 0.752733 5.74411 0.599881 5.52946 0.60426 5.28952 C 0.608639 5.04958 0.769221 4.84065 0.999956 4.77468 L 14.3757 0.950713 Z M 26.0967 5.33101 L 14.5262 2.04307 L 3.01653 5.33354 L 14.5261 9.08338 L 26.0967 5.33101 Z"
            fill="rgb(198, 180, 92)"
            stroke="rgb(198, 180, 92)"
            strokeWidth=".5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M 21.75 6.94507 C 22.0515 6.94507 22.2958 7.18944 22.2958 7.49089 V 13.6117 C 22.2958 13.7617 22.2342 13.905 22.1253 14.0081 C 20.3366 15.7016 17.5435 16.7586 14.5194 16.7586 C 11.4947 16.7586 8.70853 15.7012 6.91426 14.0088 C 6.80493 13.9057 6.74296 13.762 6.74296 13.6117 V 10.2657 C 6.74296 9.9643 6.98733 9.71993 7.28878 9.71993 C 7.59023 9.71993 7.8346 9.9643 7.8346 10.2657 V 13.3709 C 9.40504 14.757 11.8295 15.6669 14.5194 15.6669 C 17.2099 15.6669 19.6396 14.7566 21.2042 13.3715 V 7.49089 C 21.2042 7.18944 21.4486 6.94507 21.75 6.94507 Z"
            fill="rgb(198, 180, 92)"
            stroke="rgb(198, 180, 92)"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    case 'conversation':
      return (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.39079 6.4012C5.39079 6.54614 5.28208 6.69108 5.10091 6.69108C4.95597 6.69108 4.81104 6.58238 4.81104 6.4012C4.81104 6.25627 4.91974 6.11133 5.10091 6.11133C5.28208 6.11133 5.39079 6.25627 5.39079 6.4012Z"
            stroke="#004186"
            strokeMiterlimit="10"
          />
          <path
            d="M7.96248 6.69108C8.12258 6.69108 8.25236 6.5613 8.25236 6.4012C8.25236 6.24111 8.12258 6.11133 7.96248 6.11133C7.80239 6.11133 7.67261 6.24111 7.67261 6.4012C7.67261 6.5613 7.80239 6.69108 7.96248 6.69108Z"
            stroke="#004186"
            strokeMiterlimit="10"
          />
          <path
            d="M10.8241 6.69108C10.9842 6.69108 11.1139 6.5613 11.1139 6.4012C11.1139 6.24111 10.9842 6.11133 10.8241 6.11133C10.664 6.11133 10.5342 6.24111 10.5342 6.4012C10.5342 6.5613 10.664 6.69108 10.8241 6.69108Z"
            stroke="#004186"
            strokeMiterlimit="10"
          />
          <path
            d="M3.57919 16.3633V12.0524H2.56487C1.44187 12.0524 0.5 11.1106 0.5 9.98756V2.81487C0.5 1.69187 1.44187 0.75 2.56487 0.75H13.3601C14.4831 0.75 15.425 1.69187 15.425 2.81487V10.0238C15.425 11.1468 14.4831 12.0887 13.3601 12.0887H7.27421L3.57919 16.3633Z"
            stroke="#004186"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'questionMark':
      return (
        <>
          <path
            d="M6 16C6 10.4772 10.4772 6 16 6C21.5228 6 26 10.4772 26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 13.9431C13 12.3177 14.3431 11 16 11C17.6569 11 19 12.3177 19 13.9431C19 15.5686 17.6569 16.8863 16 16.8863V18.6522M16 22V21.5217"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
    default:
      return <path />;
  }
};

interface IconProps {
  name: string;
  id?: string;
  color?: string;
  style?: CSSProperties;
  fill?: string;
  viewBox?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  strokeWidth?: number;
  onClick?: () => void;
}

const Icon = (props: IconProps) => {
  const {
    name,
    id,
    style,
    viewBox,
    className,
    color,
    fill,
    width,
    height,
    strokeWidth,
    onClick,
  } = props;

  const handlerClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <svg
      id={id}
      style={style}
      width={width || 38}
      height={height || 38}
      className={className}
      onClick={handlerClick}
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox || getViewBox(name)}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {getPath(name, color || theme.colors.primary, strokeWidth, {
        fill: fill || 'none',
      })}
    </svg>
  );
};

export default Icon;
